(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("base64-js"), require("binary-search-bounds"), require("eventemitter3"), require("lodash"), require("prismjs"), require("quill-delta-enhanced"), require("unicode-trie"));
	else if(typeof define === 'function' && define.amd)
		define(["base64-js", "binary-search-bounds", "eventemitter3", "lodash", "prismjs", "quill-delta-enhanced", "unicode-trie"], factory);
	else if(typeof exports === 'object')
		exports["FastEditorCore"] = factory(require("base64-js"), require("binary-search-bounds"), require("eventemitter3"), require("lodash"), require("prismjs"), require("quill-delta-enhanced"), require("unicode-trie"));
	else
		root["FastEditorCore"] = factory(root["base64-js"], root["binary-search-bounds"], root["eventemitter3"], root["lodash"], root["prismjs"], root["quill-delta-enhanced"], root["unicode-trie"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE_base64_js__, __WEBPACK_EXTERNAL_MODULE_binary_search_bounds__, __WEBPACK_EXTERNAL_MODULE_eventemitter3__, __WEBPACK_EXTERNAL_MODULE_lodash__, __WEBPACK_EXTERNAL_MODULE_prismjs__, __WEBPACK_EXTERNAL_MODULE_quill_delta_enhanced__, __WEBPACK_EXTERNAL_MODULE_unicode_trie__) {
return /******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_DataView.js":
/*!********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_DataView.js ***!
  \********************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(/*! ./_getNative */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getNative.js"),
    root = __webpack_require__(/*! ./_root */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_root.js");

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Hash.js":
/*!****************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Hash.js ***!
  \****************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hashClear = __webpack_require__(/*! ./_hashClear */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hashClear.js"),
    hashDelete = __webpack_require__(/*! ./_hashDelete */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hashDelete.js"),
    hashGet = __webpack_require__(/*! ./_hashGet */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hashGet.js"),
    hashHas = __webpack_require__(/*! ./_hashHas */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hashHas.js"),
    hashSet = __webpack_require__(/*! ./_hashSet */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hashSet.js");

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_ListCache.js":
/*!*********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_ListCache.js ***!
  \*********************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var listCacheClear = __webpack_require__(/*! ./_listCacheClear */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_listCacheClear.js"),
    listCacheDelete = __webpack_require__(/*! ./_listCacheDelete */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_listCacheDelete.js"),
    listCacheGet = __webpack_require__(/*! ./_listCacheGet */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_listCacheGet.js"),
    listCacheHas = __webpack_require__(/*! ./_listCacheHas */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_listCacheHas.js"),
    listCacheSet = __webpack_require__(/*! ./_listCacheSet */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_listCacheSet.js");

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Map.js":
/*!***************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Map.js ***!
  \***************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(/*! ./_getNative */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getNative.js"),
    root = __webpack_require__(/*! ./_root */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_root.js");

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_MapCache.js":
/*!********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_MapCache.js ***!
  \********************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(/*! ./_mapCacheClear */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapCacheClear.js"),
    mapCacheDelete = __webpack_require__(/*! ./_mapCacheDelete */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapCacheDelete.js"),
    mapCacheGet = __webpack_require__(/*! ./_mapCacheGet */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapCacheGet.js"),
    mapCacheHas = __webpack_require__(/*! ./_mapCacheHas */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapCacheHas.js"),
    mapCacheSet = __webpack_require__(/*! ./_mapCacheSet */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapCacheSet.js");

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Promise.js":
/*!*******************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Promise.js ***!
  \*******************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(/*! ./_getNative */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getNative.js"),
    root = __webpack_require__(/*! ./_root */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_root.js");

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Set.js":
/*!***************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Set.js ***!
  \***************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(/*! ./_getNative */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getNative.js"),
    root = __webpack_require__(/*! ./_root */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_root.js");

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_SetCache.js":
/*!********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_SetCache.js ***!
  \********************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(/*! ./_MapCache */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_MapCache.js"),
    setCacheAdd = __webpack_require__(/*! ./_setCacheAdd */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_setCacheAdd.js"),
    setCacheHas = __webpack_require__(/*! ./_setCacheHas */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_setCacheHas.js");

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Stack.js":
/*!*****************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Stack.js ***!
  \*****************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(/*! ./_ListCache */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_ListCache.js"),
    stackClear = __webpack_require__(/*! ./_stackClear */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stackClear.js"),
    stackDelete = __webpack_require__(/*! ./_stackDelete */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stackDelete.js"),
    stackGet = __webpack_require__(/*! ./_stackGet */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stackGet.js"),
    stackHas = __webpack_require__(/*! ./_stackHas */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stackHas.js"),
    stackSet = __webpack_require__(/*! ./_stackSet */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stackSet.js");

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Symbol.js":
/*!******************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Symbol.js ***!
  \******************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(/*! ./_root */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_root.js");

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Uint8Array.js":
/*!**********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Uint8Array.js ***!
  \**********************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(/*! ./_root */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_root.js");

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_WeakMap.js":
/*!*******************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_WeakMap.js ***!
  \*******************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(/*! ./_getNative */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getNative.js"),
    root = __webpack_require__(/*! ./_root */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_root.js");

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayFilter.js":
/*!***********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayFilter.js ***!
  \***********************************************************************************/
/***/ (function(module) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayLikeKeys.js":
/*!*************************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayLikeKeys.js ***!
  \*************************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(/*! ./_baseTimes */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseTimes.js"),
    isArguments = __webpack_require__(/*! ./isArguments */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isArguments.js"),
    isArray = __webpack_require__(/*! ./isArray */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isArray.js"),
    isBuffer = __webpack_require__(/*! ./isBuffer */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isBuffer.js"),
    isIndex = __webpack_require__(/*! ./_isIndex */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isIndex.js"),
    isTypedArray = __webpack_require__(/*! ./isTypedArray */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isTypedArray.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayMap.js":
/*!********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayMap.js ***!
  \********************************************************************************/
/***/ (function(module) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayPush.js":
/*!*********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayPush.js ***!
  \*********************************************************************************/
/***/ (function(module) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arraySome.js":
/*!*********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arraySome.js ***!
  \*********************************************************************************/
/***/ (function(module) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_asciiToArray.js":
/*!************************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_asciiToArray.js ***!
  \************************************************************************************/
/***/ (function(module) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_assocIndexOf.js":
/*!************************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_assocIndexOf.js ***!
  \************************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(/*! ./eq */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/eq.js");

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseFindIndex.js":
/*!*************************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseFindIndex.js ***!
  \*************************************************************************************/
/***/ (function(module) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseGetAllKeys.js":
/*!**************************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseGetAllKeys.js ***!
  \**************************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(/*! ./_arrayPush */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayPush.js"),
    isArray = __webpack_require__(/*! ./isArray */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isArray.js");

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseGetTag.js":
/*!**********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseGetTag.js ***!
  \**********************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(/*! ./_Symbol */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Symbol.js"),
    getRawTag = __webpack_require__(/*! ./_getRawTag */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getRawTag.js"),
    objectToString = __webpack_require__(/*! ./_objectToString */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_objectToString.js");

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIndexOf.js":
/*!***********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIndexOf.js ***!
  \***********************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(/*! ./_baseFindIndex */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseFindIndex.js"),
    baseIsNaN = __webpack_require__(/*! ./_baseIsNaN */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsNaN.js"),
    strictIndexOf = __webpack_require__(/*! ./_strictIndexOf */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_strictIndexOf.js");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsArguments.js":
/*!***************************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsArguments.js ***!
  \***************************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(/*! ./_baseGetTag */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseGetTag.js"),
    isObjectLike = __webpack_require__(/*! ./isObjectLike */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isObjectLike.js");

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsEqual.js":
/*!***********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsEqual.js ***!
  \***********************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(/*! ./_baseIsEqualDeep */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsEqualDeep.js"),
    isObjectLike = __webpack_require__(/*! ./isObjectLike */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isObjectLike.js");

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsEqualDeep.js":
/*!***************************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsEqualDeep.js ***!
  \***************************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(/*! ./_Stack */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Stack.js"),
    equalArrays = __webpack_require__(/*! ./_equalArrays */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_equalArrays.js"),
    equalByTag = __webpack_require__(/*! ./_equalByTag */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_equalByTag.js"),
    equalObjects = __webpack_require__(/*! ./_equalObjects */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_equalObjects.js"),
    getTag = __webpack_require__(/*! ./_getTag */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getTag.js"),
    isArray = __webpack_require__(/*! ./isArray */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isArray.js"),
    isBuffer = __webpack_require__(/*! ./isBuffer */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isBuffer.js"),
    isTypedArray = __webpack_require__(/*! ./isTypedArray */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isTypedArray.js");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsNaN.js":
/*!*********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsNaN.js ***!
  \*********************************************************************************/
/***/ (function(module) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsNative.js":
/*!************************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsNative.js ***!
  \************************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(/*! ./isFunction */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isFunction.js"),
    isMasked = __webpack_require__(/*! ./_isMasked */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isMasked.js"),
    isObject = __webpack_require__(/*! ./isObject */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isObject.js"),
    toSource = __webpack_require__(/*! ./_toSource */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_toSource.js");

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsTypedArray.js":
/*!****************************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsTypedArray.js ***!
  \****************************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(/*! ./_baseGetTag */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseGetTag.js"),
    isLength = __webpack_require__(/*! ./isLength */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isLength.js"),
    isObjectLike = __webpack_require__(/*! ./isObjectLike */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isObjectLike.js");

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseKeys.js":
/*!********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseKeys.js ***!
  \********************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototype = __webpack_require__(/*! ./_isPrototype */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isPrototype.js"),
    nativeKeys = __webpack_require__(/*! ./_nativeKeys */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_nativeKeys.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseSlice.js":
/*!*********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseSlice.js ***!
  \*********************************************************************************/
/***/ (function(module) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseTimes.js":
/*!*********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseTimes.js ***!
  \*********************************************************************************/
/***/ (function(module) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseToString.js":
/*!************************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseToString.js ***!
  \************************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(/*! ./_Symbol */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Symbol.js"),
    arrayMap = __webpack_require__(/*! ./_arrayMap */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayMap.js"),
    isArray = __webpack_require__(/*! ./isArray */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isArray.js"),
    isSymbol = __webpack_require__(/*! ./isSymbol */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isSymbol.js");

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseUnary.js":
/*!*********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseUnary.js ***!
  \*********************************************************************************/
/***/ (function(module) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseValues.js":
/*!**********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseValues.js ***!
  \**********************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(/*! ./_arrayMap */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayMap.js");

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_cacheHas.js":
/*!********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_cacheHas.js ***!
  \********************************************************************************/
/***/ (function(module) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_castSlice.js":
/*!*********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_castSlice.js ***!
  \*********************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSlice = __webpack_require__(/*! ./_baseSlice */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseSlice.js");

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_charsStartIndex.js":
/*!***************************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_charsStartIndex.js ***!
  \***************************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(/*! ./_baseIndexOf */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIndexOf.js");

/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */
function charsStartIndex(strSymbols, chrSymbols) {
  var index = -1,
      length = strSymbols.length;

  while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

module.exports = charsStartIndex;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_copyArray.js":
/*!*********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_copyArray.js ***!
  \*********************************************************************************/
/***/ (function(module) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_coreJsData.js":
/*!**********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_coreJsData.js ***!
  \**********************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(/*! ./_root */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_root.js");

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_equalArrays.js":
/*!***********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_equalArrays.js ***!
  \***********************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(/*! ./_SetCache */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_SetCache.js"),
    arraySome = __webpack_require__(/*! ./_arraySome */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arraySome.js"),
    cacheHas = __webpack_require__(/*! ./_cacheHas */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_cacheHas.js");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_equalByTag.js":
/*!**********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_equalByTag.js ***!
  \**********************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(/*! ./_Symbol */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Symbol.js"),
    Uint8Array = __webpack_require__(/*! ./_Uint8Array */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Uint8Array.js"),
    eq = __webpack_require__(/*! ./eq */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/eq.js"),
    equalArrays = __webpack_require__(/*! ./_equalArrays */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_equalArrays.js"),
    mapToArray = __webpack_require__(/*! ./_mapToArray */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapToArray.js"),
    setToArray = __webpack_require__(/*! ./_setToArray */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_setToArray.js");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_equalObjects.js":
/*!************************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_equalObjects.js ***!
  \************************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getAllKeys = __webpack_require__(/*! ./_getAllKeys */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getAllKeys.js");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_freeGlobal.js":
/*!**********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_freeGlobal.js ***!
  \**********************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getAllKeys.js":
/*!**********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getAllKeys.js ***!
  \**********************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(/*! ./_baseGetAllKeys */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseGetAllKeys.js"),
    getSymbols = __webpack_require__(/*! ./_getSymbols */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getSymbols.js"),
    keys = __webpack_require__(/*! ./keys */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/keys.js");

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getMapData.js":
/*!**********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getMapData.js ***!
  \**********************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isKeyable = __webpack_require__(/*! ./_isKeyable */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isKeyable.js");

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getNative.js":
/*!*********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getNative.js ***!
  \*********************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsNative = __webpack_require__(/*! ./_baseIsNative */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsNative.js"),
    getValue = __webpack_require__(/*! ./_getValue */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getValue.js");

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getRawTag.js":
/*!*********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getRawTag.js ***!
  \*********************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(/*! ./_Symbol */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Symbol.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getSymbols.js":
/*!**********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getSymbols.js ***!
  \**********************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(/*! ./_arrayFilter */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayFilter.js"),
    stubArray = __webpack_require__(/*! ./stubArray */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/stubArray.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getTag.js":
/*!******************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getTag.js ***!
  \******************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DataView = __webpack_require__(/*! ./_DataView */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_DataView.js"),
    Map = __webpack_require__(/*! ./_Map */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Map.js"),
    Promise = __webpack_require__(/*! ./_Promise */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Promise.js"),
    Set = __webpack_require__(/*! ./_Set */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Set.js"),
    WeakMap = __webpack_require__(/*! ./_WeakMap */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_WeakMap.js"),
    baseGetTag = __webpack_require__(/*! ./_baseGetTag */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseGetTag.js"),
    toSource = __webpack_require__(/*! ./_toSource */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_toSource.js");

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getValue.js":
/*!********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getValue.js ***!
  \********************************************************************************/
/***/ (function(module) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hasUnicode.js":
/*!**********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hasUnicode.js ***!
  \**********************************************************************************/
/***/ (function(module) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hashClear.js":
/*!*********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hashClear.js ***!
  \*********************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(/*! ./_nativeCreate */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_nativeCreate.js");

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hashDelete.js":
/*!**********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hashDelete.js ***!
  \**********************************************************************************/
/***/ (function(module) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hashGet.js":
/*!*******************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hashGet.js ***!
  \*******************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(/*! ./_nativeCreate */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_nativeCreate.js");

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hashHas.js":
/*!*******************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hashHas.js ***!
  \*******************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(/*! ./_nativeCreate */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_nativeCreate.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hashSet.js":
/*!*******************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hashSet.js ***!
  \*******************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(/*! ./_nativeCreate */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_nativeCreate.js");

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isIndex.js":
/*!*******************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isIndex.js ***!
  \*******************************************************************************/
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isKeyable.js":
/*!*********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isKeyable.js ***!
  \*********************************************************************************/
/***/ (function(module) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isMasked.js":
/*!********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isMasked.js ***!
  \********************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var coreJsData = __webpack_require__(/*! ./_coreJsData */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_coreJsData.js");

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isPrototype.js":
/*!***********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isPrototype.js ***!
  \***********************************************************************************/
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_iteratorToArray.js":
/*!***************************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_iteratorToArray.js ***!
  \***************************************************************************************/
/***/ (function(module) {

/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */
function iteratorToArray(iterator) {
  var data,
      result = [];

  while (!(data = iterator.next()).done) {
    result.push(data.value);
  }
  return result;
}

module.exports = iteratorToArray;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_listCacheClear.js":
/*!**************************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_listCacheClear.js ***!
  \**************************************************************************************/
/***/ (function(module) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_listCacheDelete.js":
/*!***************************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_listCacheDelete.js ***!
  \***************************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(/*! ./_assocIndexOf */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_assocIndexOf.js");

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_listCacheGet.js":
/*!************************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_listCacheGet.js ***!
  \************************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(/*! ./_assocIndexOf */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_assocIndexOf.js");

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_listCacheHas.js":
/*!************************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_listCacheHas.js ***!
  \************************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(/*! ./_assocIndexOf */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_assocIndexOf.js");

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_listCacheSet.js":
/*!************************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_listCacheSet.js ***!
  \************************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(/*! ./_assocIndexOf */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_assocIndexOf.js");

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapCacheClear.js":
/*!*************************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapCacheClear.js ***!
  \*************************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Hash = __webpack_require__(/*! ./_Hash */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Hash.js"),
    ListCache = __webpack_require__(/*! ./_ListCache */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_ListCache.js"),
    Map = __webpack_require__(/*! ./_Map */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Map.js");

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapCacheDelete.js":
/*!**************************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapCacheDelete.js ***!
  \**************************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(/*! ./_getMapData */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getMapData.js");

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapCacheGet.js":
/*!***********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapCacheGet.js ***!
  \***********************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(/*! ./_getMapData */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getMapData.js");

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapCacheHas.js":
/*!***********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapCacheHas.js ***!
  \***********************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(/*! ./_getMapData */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getMapData.js");

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapCacheSet.js":
/*!***********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapCacheSet.js ***!
  \***********************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(/*! ./_getMapData */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getMapData.js");

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapToArray.js":
/*!**********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapToArray.js ***!
  \**********************************************************************************/
/***/ (function(module) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_nativeCreate.js":
/*!************************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_nativeCreate.js ***!
  \************************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(/*! ./_getNative */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getNative.js");

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_nativeKeys.js":
/*!**********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_nativeKeys.js ***!
  \**********************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(/*! ./_overArg */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_overArg.js");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_nodeUtil.js":
/*!********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_nodeUtil.js ***!
  \********************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(/*! ./_freeGlobal */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_freeGlobal.js");

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_objectToString.js":
/*!**************************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_objectToString.js ***!
  \**************************************************************************************/
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_overArg.js":
/*!*******************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_overArg.js ***!
  \*******************************************************************************/
/***/ (function(module) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_root.js":
/*!****************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_root.js ***!
  \****************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(/*! ./_freeGlobal */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_freeGlobal.js");

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_setCacheAdd.js":
/*!***********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_setCacheAdd.js ***!
  \***********************************************************************************/
/***/ (function(module) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_setCacheHas.js":
/*!***********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_setCacheHas.js ***!
  \***********************************************************************************/
/***/ (function(module) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_setToArray.js":
/*!**********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_setToArray.js ***!
  \**********************************************************************************/
/***/ (function(module) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stackClear.js":
/*!**********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stackClear.js ***!
  \**********************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(/*! ./_ListCache */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_ListCache.js");

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stackDelete.js":
/*!***********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stackDelete.js ***!
  \***********************************************************************************/
/***/ (function(module) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stackGet.js":
/*!********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stackGet.js ***!
  \********************************************************************************/
/***/ (function(module) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stackHas.js":
/*!********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stackHas.js ***!
  \********************************************************************************/
/***/ (function(module) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stackSet.js":
/*!********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stackSet.js ***!
  \********************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(/*! ./_ListCache */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_ListCache.js"),
    Map = __webpack_require__(/*! ./_Map */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Map.js"),
    MapCache = __webpack_require__(/*! ./_MapCache */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_MapCache.js");

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_strictIndexOf.js":
/*!*************************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_strictIndexOf.js ***!
  \*************************************************************************************/
/***/ (function(module) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stringToArray.js":
/*!*************************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stringToArray.js ***!
  \*************************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var asciiToArray = __webpack_require__(/*! ./_asciiToArray */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_asciiToArray.js"),
    hasUnicode = __webpack_require__(/*! ./_hasUnicode */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hasUnicode.js"),
    unicodeToArray = __webpack_require__(/*! ./_unicodeToArray */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_unicodeToArray.js");

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_toSource.js":
/*!********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_toSource.js ***!
  \********************************************************************************/
/***/ (function(module) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_unicodeToArray.js":
/*!**************************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_unicodeToArray.js ***!
  \**************************************************************************************/
/***/ (function(module) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/eq.js":
/*!*************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/eq.js ***!
  \*************************************************************************/
/***/ (function(module) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isArguments.js":
/*!**********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isArguments.js ***!
  \**********************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(/*! ./_baseIsArguments */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsArguments.js"),
    isObjectLike = __webpack_require__(/*! ./isObjectLike */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isObjectLike.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isArray.js":
/*!******************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isArray.js ***!
  \******************************************************************************/
/***/ (function(module) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isArrayLike.js":
/*!**********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isArrayLike.js ***!
  \**********************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(/*! ./isFunction */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isFunction.js"),
    isLength = __webpack_require__(/*! ./isLength */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isLength.js");

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isBuffer.js":
/*!*******************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isBuffer.js ***!
  \*******************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(/*! ./_root */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_root.js"),
    stubFalse = __webpack_require__(/*! ./stubFalse */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/stubFalse.js");

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isEqual.js":
/*!******************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isEqual.js ***!
  \******************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(/*! ./_baseIsEqual */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsEqual.js");

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isFunction.js":
/*!*********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isFunction.js ***!
  \*********************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(/*! ./_baseGetTag */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseGetTag.js"),
    isObject = __webpack_require__(/*! ./isObject */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isObject.js");

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isLength.js":
/*!*******************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isLength.js ***!
  \*******************************************************************************/
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isObject.js":
/*!*******************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isObject.js ***!
  \*******************************************************************************/
/***/ (function(module) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isObjectLike.js":
/*!***********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isObjectLike.js ***!
  \***********************************************************************************/
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isString.js":
/*!*******************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isString.js ***!
  \*******************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(/*! ./_baseGetTag */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseGetTag.js"),
    isArray = __webpack_require__(/*! ./isArray */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isArray.js"),
    isObjectLike = __webpack_require__(/*! ./isObjectLike */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isObjectLike.js");

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isSymbol.js":
/*!*******************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isSymbol.js ***!
  \*******************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(/*! ./_baseGetTag */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseGetTag.js"),
    isObjectLike = __webpack_require__(/*! ./isObjectLike */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isObjectLike.js");

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isTypedArray.js":
/*!***********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isTypedArray.js ***!
  \***********************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(/*! ./_baseIsTypedArray */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsTypedArray.js"),
    baseUnary = __webpack_require__(/*! ./_baseUnary */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseUnary.js"),
    nodeUtil = __webpack_require__(/*! ./_nodeUtil */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_nodeUtil.js");

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/keys.js":
/*!***************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/keys.js ***!
  \***************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(/*! ./_arrayLikeKeys */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayLikeKeys.js"),
    baseKeys = __webpack_require__(/*! ./_baseKeys */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseKeys.js"),
    isArrayLike = __webpack_require__(/*! ./isArrayLike */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isArrayLike.js");

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/replace.js":
/*!******************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/replace.js ***!
  \******************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toString = __webpack_require__(/*! ./toString */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/toString.js");

/**
 * Replaces matches for `pattern` in `string` with `replacement`.
 *
 * **Note:** This method is based on
 * [`String#replace`](https://mdn.io/String/replace).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to modify.
 * @param {RegExp|string} pattern The pattern to replace.
 * @param {Function|string} replacement The match replacement.
 * @returns {string} Returns the modified string.
 * @example
 *
 * _.replace('Hi Fred', 'Fred', 'Barney');
 * // => 'Hi Barney'
 */
function replace() {
  var args = arguments,
      string = toString(args[0]);

  return args.length < 3 ? string : string.replace(args[1], args[2]);
}

module.exports = replace;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/stubArray.js":
/*!********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/stubArray.js ***!
  \********************************************************************************/
/***/ (function(module) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/stubFalse.js":
/*!********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/stubFalse.js ***!
  \********************************************************************************/
/***/ (function(module) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/toArray.js":
/*!******************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/toArray.js ***!
  \******************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(/*! ./_Symbol */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Symbol.js"),
    copyArray = __webpack_require__(/*! ./_copyArray */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_copyArray.js"),
    getTag = __webpack_require__(/*! ./_getTag */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getTag.js"),
    isArrayLike = __webpack_require__(/*! ./isArrayLike */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isArrayLike.js"),
    isString = __webpack_require__(/*! ./isString */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isString.js"),
    iteratorToArray = __webpack_require__(/*! ./_iteratorToArray */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_iteratorToArray.js"),
    mapToArray = __webpack_require__(/*! ./_mapToArray */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapToArray.js"),
    setToArray = __webpack_require__(/*! ./_setToArray */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_setToArray.js"),
    stringToArray = __webpack_require__(/*! ./_stringToArray */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stringToArray.js"),
    values = __webpack_require__(/*! ./values */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/values.js");

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Built-in value references. */
var symIterator = Symbol ? Symbol.iterator : undefined;

/**
 * Converts `value` to an array.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Array} Returns the converted array.
 * @example
 *
 * _.toArray({ 'a': 1, 'b': 2 });
 * // => [1, 2]
 *
 * _.toArray('abc');
 * // => ['a', 'b', 'c']
 *
 * _.toArray(1);
 * // => []
 *
 * _.toArray(null);
 * // => []
 */
function toArray(value) {
  if (!value) {
    return [];
  }
  if (isArrayLike(value)) {
    return isString(value) ? stringToArray(value) : copyArray(value);
  }
  if (symIterator && value[symIterator]) {
    return iteratorToArray(value[symIterator]());
  }
  var tag = getTag(value),
      func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

  return func(value);
}

module.exports = toArray;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/toString.js":
/*!*******************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/toString.js ***!
  \*******************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseToString = __webpack_require__(/*! ./_baseToString */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseToString.js");

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/trimStart.js":
/*!********************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/trimStart.js ***!
  \********************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseToString = __webpack_require__(/*! ./_baseToString */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseToString.js"),
    castSlice = __webpack_require__(/*! ./_castSlice */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_castSlice.js"),
    charsStartIndex = __webpack_require__(/*! ./_charsStartIndex */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_charsStartIndex.js"),
    stringToArray = __webpack_require__(/*! ./_stringToArray */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stringToArray.js"),
    toString = __webpack_require__(/*! ./toString */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/toString.js");

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * Removes leading whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trimStart('  abc  ');
 * // => 'abc  '
 *
 * _.trimStart('-_-abc-_-', '_-');
 * // => 'abc-_-'
 */
function trimStart(string, chars, guard) {
  string = toString(string);
  if (string && (guard || chars === undefined)) {
    return string.replace(reTrimStart, '');
  }
  if (!string || !(chars = baseToString(chars))) {
    return string;
  }
  var strSymbols = stringToArray(string),
      start = charsStartIndex(strSymbols, stringToArray(chars));

  return castSlice(strSymbols, start).join('');
}

module.exports = trimStart;


/***/ }),

/***/ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/values.js":
/*!*****************************************************************************!*\
  !*** ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/values.js ***!
  \*****************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseValues = __webpack_require__(/*! ./_baseValues */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseValues.js"),
    keys = __webpack_require__(/*! ./keys */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/keys.js");

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),

/***/ "../../node_modules/.pnpm/quill-delta-enhanced@0.0.6/node_modules/quill-delta-enhanced/dist/Iterator.js":
/*!**************************************************************************************************************!*\
  !*** ../../node_modules/.pnpm/quill-delta-enhanced@0.0.6/node_modules/quill-delta-enhanced/dist/Iterator.js ***!
  \**************************************************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var Op_1 = __importDefault(__webpack_require__(/*! ./Op */ "../../node_modules/.pnpm/quill-delta-enhanced@0.0.6/node_modules/quill-delta-enhanced/dist/Op.js"));
var Iterator = /** @class */ (function () {
    function Iterator(ops) {
        this.ops = ops;
        this.index = 0;
        this.offset = 0;
    }
    Iterator.prototype.hasNext = function () {
        return this.peekLength() < Infinity;
    };
    Iterator.prototype.next = function (length) {
        if (!length) {
            length = Infinity;
        }
        var nextOp = this.ops[this.index];
        if (nextOp) {
            var offset = this.offset;
            var opLength = Op_1.default.length(nextOp);
            if (length >= opLength - offset) {
                length = opLength - offset;
                this.index += 1;
                this.offset = 0;
            }
            else {
                this.offset += length;
            }
            if (typeof nextOp.delete === 'number') {
                return { delete: length };
            }
            else {
                var retOp = {};
                if (nextOp.attributes) {
                    retOp.attributes = nextOp.attributes;
                }
                if (typeof nextOp.retain === 'number') {
                    retOp.retain = length;
                }
                else if (typeof nextOp.retain === 'object') {
                    retOp.retain = nextOp.retain;
                }
                else if (typeof nextOp.insert === 'string') {
                    retOp.insert = nextOp.insert.substr(offset, length);
                }
                else if (typeof nextOp.insert === 'number') {
                    retOp.insert = length;
                }
                else {
                    // offset should === 0, length should === 1
                    retOp.insert = nextOp.insert;
                }
                return retOp;
            }
        }
        else {
            return { retain: Infinity };
        }
    };
    Iterator.prototype.peek = function () {
        return this.ops[this.index];
    };
    Iterator.prototype.peekLength = function () {
        if (this.ops[this.index]) {
            // Should never return 0 if our index is being managed correctly
            return Op_1.default.length(this.ops[this.index]) - this.offset;
        }
        else {
            return Infinity;
        }
    };
    Iterator.prototype.peekType = function () {
        if (this.ops[this.index]) {
            if (typeof this.ops[this.index].delete === 'number') {
                return 'delete';
            }
            else if (typeof this.ops[this.index].retain === 'number' ||
                typeof this.ops[this.index].retain === 'object') {
                return 'retain';
            }
            else {
                return 'insert';
            }
        }
        return 'retain';
    };
    Iterator.prototype.rest = function () {
        if (!this.hasNext()) {
            return [];
        }
        else if (this.offset === 0) {
            return this.ops.slice(this.index);
        }
        else {
            var offset = this.offset;
            var index = this.index;
            var next = this.next();
            var rest = this.ops.slice(this.index);
            this.offset = offset;
            this.index = index;
            return [next].concat(rest);
        }
    };
    return Iterator;
}());
exports["default"] = Iterator;
//# sourceMappingURL=Iterator.js.map

/***/ }),

/***/ "../../node_modules/.pnpm/quill-delta-enhanced@0.0.6/node_modules/quill-delta-enhanced/dist/Op.js":
/*!********************************************************************************************************!*\
  !*** ../../node_modules/.pnpm/quill-delta-enhanced@0.0.6/node_modules/quill-delta-enhanced/dist/Op.js ***!
  \********************************************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var Iterator_1 = __importDefault(__webpack_require__(/*! ./Iterator */ "../../node_modules/.pnpm/quill-delta-enhanced@0.0.6/node_modules/quill-delta-enhanced/dist/Iterator.js"));
var Op;
(function (Op) {
    function iterator(ops) {
        return new Iterator_1.default(ops);
    }
    Op.iterator = iterator;
    function length(op) {
        if (typeof op.delete === 'number') {
            return op.delete;
        }
        else if (typeof op.retain === 'number') {
            return op.retain;
        }
        else if (typeof op.retain === 'object') {
            return 1;
        }
        else if (typeof op.insert === 'string') {
            return op.insert.length;
        }
        else if (typeof op.insert === 'number') {
            return op.insert;
        }
        {
            return 1;
        }
    }
    Op.length = length;
})(Op || (Op = {}));
exports["default"] = Op;
//# sourceMappingURL=Op.js.map

/***/ }),

/***/ "../../node_modules/.pnpm/quill-delta-enhanced@0.0.6/node_modules/quill-delta-enhanced/dist/diff.js":
/*!**********************************************************************************************************!*\
  !*** ../../node_modules/.pnpm/quill-delta-enhanced@0.0.6/node_modules/quill-delta-enhanced/dist/diff.js ***!
  \**********************************************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/**
 * This library modifies the diff-patch-match library by Neil Fraser
 * by removing the patch and match functionality and certain advanced
 * options in the diff function. The original license is as follows:
 *
 * ===
 *
 * Diff Match and Patch
 *
 * Copyright 2006 Google Inc.
 * http://code.google.com/p/google-diff-match-patch/
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var toArray_1 = __importDefault(__webpack_require__(/*! lodash/toArray */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/toArray.js"));
/**
 * The data structure representing a diff is an array of tuples:
 * [[DiffOp.DIFF_DELETE, 'Hello'], [DiffOp.DIFF_INSERT, 'Goodbye'], [DiffOp.DIFF_EQUAL, ' world.']]
 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
 */
var DiffOp;
(function (DiffOp) {
    DiffOp[DiffOp["DIFF_DELETE"] = -1] = "DIFF_DELETE";
    DiffOp[DiffOp["DIFF_INSERT"] = 1] = "DIFF_INSERT";
    DiffOp[DiffOp["DIFF_EQUAL"] = 0] = "DIFF_EQUAL";
})(DiffOp = exports.DiffOp || (exports.DiffOp = {}));
/**
 * Find the differences between two texts.  Simplifies the problem by stripping
 * any common prefix or suffix off the texts before diffing.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {Int|Object} [cursor_pos] Edit position in text1 or object with more info
 * @return {Array} Array of diff tuples.
 */
function diff_main(text1, text2, cursor_pos, _fix_unicode) {
    if (_fix_unicode === void 0) { _fix_unicode = false; }
    // Check for equality
    if (isSequenceEqual(text1, text2)) {
        if (text1.length > 0) {
            return [[DiffOp.DIFF_EQUAL, text1]];
        }
        return [];
    }
    if (cursor_pos != null) {
        var editDiff = find_cursor_edit_diff(text1, text2, cursor_pos);
        if (editDiff && editDiff.length > 0) {
            return editDiff;
        }
    }
    // Trim off common prefix (speedup).
    var commonLength = diff_commonPrefix(text1, text2);
    var commonPrefix = text1.slice(0, commonLength);
    text1 = text1.slice(commonLength);
    text2 = text2.slice(commonLength);
    // Trim off common suffix (speedup).
    commonLength = diff_commonSuffix(text1, text2);
    var commonSuffix = text1.slice(text1.length - commonLength);
    text1 = text1.slice(0, text1.length - commonLength);
    text2 = text2.slice(0, text2.length - commonLength);
    // Compute the diff on the middle block.
    var diffs = diff_compute_(text1, text2);
    // Restore the prefix and suffix.
    if (commonPrefix.length > 0) {
        diffs.unshift([DiffOp.DIFF_EQUAL, commonPrefix]);
    }
    if (commonSuffix.length > 0) {
        diffs.push([DiffOp.DIFF_EQUAL, commonSuffix]);
    }
    diff_cleanupMerge(diffs, _fix_unicode);
    return diffs;
}
;
/**
 * Find the differences between two texts.  Assumes that the texts do not
 * have any common prefix or suffix.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 */
function diff_compute_(text1, text2) {
    var diffs;
    if (text1.length === 0) {
        // Just add some text (speedup).
        return [[DiffOp.DIFF_INSERT, text2]];
    }
    if (text2.length === 0) {
        // Just delete some text (speedup).
        return [[DiffOp.DIFF_DELETE, text1]];
    }
    var longText = text1.length > text2.length ? text1 : text2;
    var shortText = text1.length > text2.length ? text2 : text1;
    var i = indexOfSequence(longText, shortText);
    if (i !== -1) {
        // Shorter text is inside the longer text (speedup).
        diffs = [
            [DiffOp.DIFF_INSERT, longText.slice(0, i)],
            [DiffOp.DIFF_EQUAL, shortText],
            [DiffOp.DIFF_INSERT, longText.slice(i + shortText.length)]
        ];
        // Swap insertions for deletions if diff is reversed.
        if (text1.length > text2.length) {
            diffs[0][0] = diffs[2][0] = DiffOp.DIFF_DELETE;
        }
        return diffs;
    }
    if (shortText.length === 1) {
        // Single character string.
        // After the previous speedup, the character can't be an equality.
        return [[DiffOp.DIFF_DELETE, text1], [DiffOp.DIFF_INSERT, text2]];
    }
    // Check to see if the problem can be split in two.
    var hm = diff_halfMatch_(text1, text2);
    if (hm && hm.length > 0) {
        // A half-match was found, sort out the return data.
        var text1_a = hm[0];
        var text1_b = hm[1];
        var text2_a = hm[2];
        var text2_b = hm[3];
        var mid_common = hm[4];
        // Send both pairs off for separate processing.
        var diffs_a = diff_main(text1_a, text2_a);
        var diffs_b = diff_main(text1_b, text2_b);
        // Merge the results.
        return diffs_a.concat([[DiffOp.DIFF_EQUAL, mid_common]], diffs_b);
    }
    return diff_bisect_(text1, text2);
}
;
/**
 * Find the 'middle snake' of a diff, split the problem in two
 * and return the recursively constructed diff.
 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 * @private
 */
function diff_bisect_(text1, text2) {
    // Cache the text lengths to prevent multiple calls.
    var text1_length = text1.length;
    var text2_length = text2.length;
    var max_d = Math.ceil((text1_length + text2_length) / 2);
    var v_offset = max_d;
    var v_length = 2 * max_d;
    var v1 = new Array(v_length);
    var v2 = new Array(v_length);
    // Setting all elements to -1 is faster in Chrome & Firefox than mixing
    // integers and undefined.
    for (var x = 0; x < v_length; x++) {
        v1[x] = -1;
        v2[x] = -1;
    }
    v1[v_offset + 1] = 0;
    v2[v_offset + 1] = 0;
    var delta = text1_length - text2_length;
    // If the total number of characters is odd, then the front path will collide
    // with the reverse path.
    var front = (delta % 2 !== 0);
    // Offsets for start and end of k loop.
    // Prevents mapping of space beyond the grid.
    var k1start = 0;
    var k1end = 0;
    var k2start = 0;
    var k2end = 0;
    for (var d = 0; d < max_d; d++) {
        // Walk the front path one step.
        for (var k1 = -d + k1start; k1 <= d - k1end; k1 += 2) {
            var k1_offset = v_offset + k1;
            var x1;
            if (k1 === -d || (k1 !== d && v1[k1_offset - 1] < v1[k1_offset + 1])) {
                x1 = v1[k1_offset + 1];
            }
            else {
                x1 = v1[k1_offset - 1] + 1;
            }
            var y1 = x1 - k1;
            while (x1 < text1_length && y1 < text2_length &&
                text1[x1] === text2[y1]) {
                x1++;
                y1++;
            }
            v1[k1_offset] = x1;
            if (x1 > text1_length) {
                // Ran off the right of the graph.
                k1end += 2;
            }
            else if (y1 > text2_length) {
                // Ran off the bottom of the graph.
                k1start += 2;
            }
            else if (front) {
                var k2_offset = v_offset + delta - k1;
                if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] !== -1) {
                    // Mirror x2 onto top-left coordinate system.
                    var x2 = text1_length - v2[k2_offset];
                    if (x1 >= x2) {
                        // Overlap detected.
                        return diff_bisectSplit_(text1, text2, x1, y1);
                    }
                }
            }
        }
        // Walk the reverse path one step.
        for (var k2 = -d + k2start; k2 <= d - k2end; k2 += 2) {
            var k2_offset = v_offset + k2;
            var x2;
            if (k2 === -d || (k2 !== d && v2[k2_offset - 1] < v2[k2_offset + 1])) {
                x2 = v2[k2_offset + 1];
            }
            else {
                x2 = v2[k2_offset - 1] + 1;
            }
            var y2 = x2 - k2;
            while (x2 < text1_length && y2 < text2_length &&
                text1[text1_length - x2 - 1] === text2[text2_length - y2 - 1]) {
                x2++;
                y2++;
            }
            v2[k2_offset] = x2;
            if (x2 > text1_length) {
                // Ran off the left of the graph.
                k2end += 2;
            }
            else if (y2 > text2_length) {
                // Ran off the top of the graph.
                k2start += 2;
            }
            else if (!front) {
                var k1_offset = v_offset + delta - k2;
                if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] !== -1) {
                    var x1 = v1[k1_offset];
                    var y1 = v_offset + x1 - k1_offset;
                    // Mirror x2 onto top-left coordinate system.
                    x2 = text1_length - x2;
                    if (x1 >= x2) {
                        // Overlap detected.
                        return diff_bisectSplit_(text1, text2, x1, y1);
                    }
                }
            }
        }
    }
    // Diff took too long and hit the deadline or
    // number of diffs equals number of characters, no commonality at all.
    return [[DiffOp.DIFF_DELETE, text1], [DiffOp.DIFF_INSERT, text2]];
}
;
/**
 * Given the location of the 'middle snake', split the diff in two parts
 * and recursive.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} x Index of split point in text1.
 * @param {number} y Index of split point in text2.
 * @return {Array} Array of diff tuples.
 */
function diff_bisectSplit_(text1, text2, x, y) {
    var text1a = text1.slice(0, x);
    var text2a = text2.slice(0, y);
    var text1b = text1.slice(x);
    var text2b = text2.slice(y);
    // Compute both diffs serially.
    var diffs = diff_main(text1a, text2a);
    var diffsB = diff_main(text1b, text2b);
    return diffs.concat(diffsB);
}
;
/**
 * Determine the common prefix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the start of each
 *     string.
 */
function diff_commonPrefix(text1, text2) {
    // Quick check for common null cases.
    if (text1.length === 0 || text2.length === 0 || text1[0] !== text2[0]) {
        return 0;
    }
    // Binary search.
    // Performance analysis: http://neil.fraser.name/news/2007/10/09/
    var pointerMin = 0;
    var pointerMax = Math.min(text1.length, text2.length);
    var pointerMid = pointerMax;
    var pointerStart = 0;
    while (pointerMin < pointerMid) {
        if (isSequenceEqual(text1.slice(pointerStart, pointerMid), text2.slice(pointerStart, pointerMid))) {
            pointerMin = pointerMid;
            pointerStart = pointerMin;
        }
        else {
            pointerMax = pointerMid;
        }
        pointerMid = Math.floor((pointerMax - pointerMin) / 2 + pointerMin);
    }
    var seqItem = text1[pointerMid - 1];
    if (typeof seqItem === 'string' && is_surrogate_pair_start(codePointAt(seqItem, 0))) {
        pointerMid--;
    }
    return pointerMid;
}
;
/**
 * Determine the common suffix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of each string.
 */
function diff_commonSuffix(text1, text2) {
    // Quick check for common null cases.
    if (text1.length === 0 || text2.length === 0 || !isSequenceEqual(text1.slice(-1), text2.slice(-1))) {
        return 0;
    }
    // Binary search.
    // Performance analysis: http://neil.fraser.name/news/2007/10/09/
    var pointerMin = 0;
    var pointerMax = Math.min(text1.length, text2.length);
    var pointerMid = pointerMax;
    var pointerEnd = 0;
    while (pointerMin < pointerMid) {
        if (isSequenceEqual(text1.slice(text1.length - pointerMid, text1.length - pointerEnd), text2.slice(text2.length - pointerMid, text2.length - pointerEnd))) {
            pointerMin = pointerMid;
            pointerEnd = pointerMin;
        }
        else {
            pointerMax = pointerMid;
        }
        pointerMid = Math.floor((pointerMax - pointerMin) / 2 + pointerMin);
    }
    var seqItem = text1[text1.length - pointerMid];
    if (typeof seqItem === 'string' && is_surrogate_pair_end(codePointAt(seqItem, 0))) {
        pointerMid--;
    }
    return pointerMid;
}
;
/**
 * Do the two texts share a substring which is at least half the length of the
 * longer text?
 * This speedup can produce non-minimal diffs.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {Array.<string>} Five element Array, containing the prefix of
 *     text1, the suffix of text1, the prefix of text2, the suffix of
 *     text2 and the common middle.  Or null if there was no match.
 */
function diff_halfMatch_(text1, text2) {
    var longText = text1.length > text2.length ? text1 : text2;
    var shortText = text1.length > text2.length ? text2 : text1;
    if (longText.length < 4 || shortText.length * 2 < longText.length) {
        return null; // Pointless.
    }
    /**
     * Does a substring of shortText exist within longText such that the substring
     * is at least half the length of longText?
     * Closure, but does not reference any external variables.
     * @param {string} longText Longer string.
     * @param {string} shortText Shorter string.
     * @param {number} i Start index of quarter length substring within longText.
     * @return {Array.<string>} Five element Array, containing the prefix of
     *     longText, the suffix of longText, the prefix of shortText, the suffix
     *     of shortText and the common middle.  Or null if there was no match.
     * @private
     */
    function diff_halfMatchI_(longText, shortText, i) {
        // Start with a 1/4 length substring at position i as a seed.
        var seed = longText.slice(i, i + Math.floor(longText.length / 4));
        var j = -1;
        var best_common = [];
        var bestLongTextA = [];
        var bestLongTextB = [];
        var bestShortTextA = [];
        var bestShortTextB = [];
        while ((j = indexOfSequence(shortText, seed, j + 1)) !== -1) {
            var prefixLength = diff_commonPrefix(longText.slice(i), shortText.slice(j));
            var suffixLength = diff_commonSuffix(longText.slice(0, i), shortText.slice(0, j));
            if (best_common.length < suffixLength + prefixLength) {
                best_common = shortText.slice(j - suffixLength, j).concat(shortText.slice(j, j + prefixLength));
                bestLongTextA = longText.slice(0, i - suffixLength);
                bestLongTextB = longText.slice(i + prefixLength);
                bestShortTextA = shortText.slice(0, j - suffixLength);
                bestShortTextB = shortText.slice(j + prefixLength);
            }
        }
        if (best_common.length * 2 >= longText.length) {
            return [
                bestLongTextA, bestLongTextB,
                bestShortTextA, bestShortTextB, best_common
            ];
        }
        else {
            return null;
        }
    }
    // First check if the second quarter is the seed for a half-match.
    var hm1 = diff_halfMatchI_(longText, shortText, Math.ceil(longText.length / 4));
    // Check again based on the third quarter.
    var hm2 = diff_halfMatchI_(longText, shortText, Math.ceil(longText.length / 2));
    var hm;
    if (!hm1 && !hm2) {
        return null;
    }
    else if (!hm2) {
        hm = hm1;
    }
    else if (!hm1) {
        hm = hm2;
    }
    else {
        // Both matched.  Select the longest.
        hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
    }
    // A half-match was found, sort out the return data.
    var text1_a, text1_b, text2_a, text2_b;
    if (text1.length > text2.length) {
        text1_a = hm[0];
        text1_b = hm[1];
        text2_a = hm[2];
        text2_b = hm[3];
    }
    else {
        text2_a = hm[0];
        text2_b = hm[1];
        text1_a = hm[2];
        text1_b = hm[3];
    }
    var mid_common = hm[4];
    return [text1_a, text1_b, text2_a, text2_b, mid_common];
}
;
/**
 * Reorder and merge like edit sections.  Merge equalities.
 * Any edit section can move as long as it doesn't cross an equality.
 * @param {Array} diffs Array of diff tuples.
 * @param {boolean} fix_unicode Whether to normalize to a unicode-correct diff
 */
function diff_cleanupMerge(diffs, fix_unicode) {
    diffs.push([DiffOp.DIFF_EQUAL, []]); // Add a dummy entry at the end.
    var pointer = 0;
    var count_delete = 0;
    var count_insert = 0;
    var text_delete = [];
    var text_insert = [];
    var commonLength;
    while (pointer < diffs.length) {
        if (pointer < diffs.length - 1 && !diffs[pointer][1]) {
            diffs.splice(pointer, 1);
            continue;
        }
        switch (diffs[pointer][0]) {
            case DiffOp.DIFF_INSERT:
                count_insert++;
                text_insert = text_insert.concat(diffs[pointer][1]);
                pointer++;
                break;
            case DiffOp.DIFF_DELETE:
                count_delete++;
                text_delete = text_delete.concat(diffs[pointer][1]);
                pointer++;
                break;
            case DiffOp.DIFF_EQUAL:
                var previous_equality = pointer - count_insert - count_delete - 1;
                if (fix_unicode) {
                    // prevent splitting of unicode surrogate pairs.  when fix_unicode is true,
                    // we assume that the old and new text in the diff are complete and correct
                    // unicode-encoded JS strings, but the tuple boundaries may fall between
                    // surrogate pairs.  we fix this by shaving off stray surrogates from the end
                    // of the previous equality and the beginning of this equality.  this may create
                    // empty equalities or a common prefix or suffix.  for example, if AB and AC are
                    // emojis, `[[0, 'A'], [-1, 'BA'], [0, 'C']]` would turn into deleting 'ABAC' and
                    // inserting 'AC', and then the common suffix 'AC' will be eliminated.  in this
                    // particular case, both equalities go away, we absorb any previous inequalities,
                    // and we keep scanning for the next equality before rewriting the tuples.
                    if (previous_equality >= 0 && ends_with_pair_start(diffs[previous_equality][1])) {
                        var stray1 = diffs[previous_equality][1].slice(-1);
                        diffs[previous_equality][1] = diffs[previous_equality][1].slice(0, -1);
                        text_delete = stray1.concat(text_delete);
                        text_insert = stray1.concat(text_insert);
                        if (diffs[previous_equality][1].length > 0) {
                            // emptied out previous equality, so delete it and include previous delete/insert
                            diffs.splice(previous_equality, 1);
                            pointer--;
                            var k = previous_equality - 1;
                            if (diffs[k] && diffs[k][0] === DiffOp.DIFF_INSERT) {
                                count_insert++;
                                text_insert = diffs[k][1].concat(text_insert);
                                k--;
                            }
                            if (diffs[k] && diffs[k][0] === DiffOp.DIFF_DELETE) {
                                count_delete++;
                                text_delete = diffs[k][1].concat(text_delete);
                                k--;
                            }
                            previous_equality = k;
                        }
                    }
                    if (starts_with_pair_end(diffs[pointer][1])) {
                        var stray2 = diffs[pointer][1][0];
                        diffs[pointer][1] = diffs[pointer][1].slice(1);
                        text_delete.push(stray2);
                        text_insert.push(stray2);
                    }
                }
                if (pointer < diffs.length - 1 && !diffs[pointer][1]) {
                    // for empty equality not at end, wait for next equality
                    diffs.splice(pointer, 1);
                    break;
                }
                if (text_delete.length > 0 || text_insert.length > 0) {
                    // note that diff_commonPrefix and diff_commonSuffix are unicode-aware
                    if (text_delete.length > 0 && text_insert.length > 0) {
                        // Factor out any common prefixes.
                        commonLength = diff_commonPrefix(text_insert, text_delete);
                        if (commonLength !== 0) {
                            if (previous_equality >= 0) {
                                diffs[previous_equality][1] = diffs[previous_equality][1].concat(text_insert.slice(0, commonLength));
                            }
                            else {
                                diffs.splice(0, 0, [DiffOp.DIFF_EQUAL, text_insert.slice(0, commonLength)]);
                                pointer++;
                            }
                            text_insert = text_insert.slice(commonLength);
                            text_delete = text_delete.slice(commonLength);
                        }
                        // Factor out any common suffixes.
                        commonLength = diff_commonSuffix(text_insert, text_delete);
                        if (commonLength !== 0) {
                            diffs[pointer][1] =
                                text_insert.slice(text_insert.length - commonLength).concat(diffs[pointer][1]);
                            text_insert = text_insert.slice(0, text_insert.length - commonLength);
                            text_delete = text_delete.slice(0, text_delete.length - commonLength);
                        }
                    }
                    // Delete the offending records and add the merged ones.
                    var n = count_insert + count_delete;
                    if (text_delete.length === 0 && text_insert.length === 0) {
                        diffs.splice(pointer - n, n);
                        pointer = pointer - n;
                    }
                    else if (text_delete.length === 0) {
                        diffs.splice(pointer - n, n, [DiffOp.DIFF_INSERT, text_insert]);
                        pointer = pointer - n + 1;
                    }
                    else if (text_insert.length === 0) {
                        diffs.splice(pointer - n, n, [DiffOp.DIFF_DELETE, text_delete]);
                        pointer = pointer - n + 1;
                    }
                    else {
                        diffs.splice(pointer - n, n, [DiffOp.DIFF_DELETE, text_delete], [DiffOp.DIFF_INSERT, text_insert]);
                        pointer = pointer - n + 2;
                    }
                }
                if (pointer !== 0 && diffs[pointer - 1][0] === DiffOp.DIFF_EQUAL) {
                    // Merge this equality with the previous one.
                    diffs[pointer - 1][1] = diffs[pointer - 1][1].concat(diffs[pointer][1]);
                    diffs.splice(pointer, 1);
                }
                else {
                    pointer++;
                }
                count_insert = 0;
                count_delete = 0;
                text_delete = [];
                text_insert = [];
                break;
        }
    }
    if (diffs[diffs.length - 1][1].length === 0) {
        diffs.pop(); // Remove the dummy entry at the end.
    }
    // Second pass: look for single edits surrounded on both sides by equalities
    // which can be shifted sideways to eliminate an equality.
    // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
    var changes = false;
    pointer = 1;
    // Intentionally ignore the first and last element (don't need checking).
    while (pointer < diffs.length - 1) {
        if (diffs[pointer - 1][0] === DiffOp.DIFF_EQUAL &&
            diffs[pointer + 1][0] === DiffOp.DIFF_EQUAL) {
            // This is a single edit surrounded by equalities.
            if (isSequenceEqual(diffs[pointer][1].slice(diffs[pointer][1].length - diffs[pointer - 1][1].length), diffs[pointer - 1][1])) {
                // Shift the edit over the previous equality.
                diffs[pointer][1] = diffs[pointer - 1][1].concat(diffs[pointer][1].slice(0, diffs[pointer][1].length - diffs[pointer - 1][1].length));
                diffs[pointer + 1][1] = diffs[pointer - 1][1].concat(diffs[pointer + 1][1]);
                diffs.splice(pointer - 1, 1);
                changes = true;
            }
            else if (isSequenceEqual(diffs[pointer][1].slice(0, diffs[pointer + 1][1].length), diffs[pointer + 1][1])) {
                // Shift the edit over the next equality.
                diffs[pointer - 1][1] = diffs[pointer - 1][1].concat(diffs[pointer + 1][1]);
                diffs[pointer][1] = diffs[pointer][1].slice(diffs[pointer + 1][1].length).concat(diffs[pointer + 1][1]);
                diffs.splice(pointer + 1, 1);
                changes = true;
            }
        }
        pointer++;
    }
    // If shifts were made, the diff needs reordering and another shift sweep.
    if (changes) {
        diff_cleanupMerge(diffs, fix_unicode);
    }
}
;
function is_surrogate_pair_start(charCode) {
    return charCode >= 0xD800 && charCode <= 0xDBFF;
}
function is_surrogate_pair_end(charCode) {
    return charCode >= 0xDC00 && charCode <= 0xDFFF;
}
function starts_with_pair_end(str) {
    var firstItem = str[0];
    return typeof firstItem === 'string' && is_surrogate_pair_end(codePointAt(firstItem, 0));
}
function ends_with_pair_start(str) {
    var lastItem = str[str.length - 1];
    return typeof lastItem === 'string' && is_surrogate_pair_start(codePointAt(lastItem, 0));
}
function remove_empty_tuples(tuples) {
    var ret = [];
    for (var i = 0; i < tuples.length; i++) {
        if (tuples[i][1].length > 0) {
            ret.push(tuples[i]);
        }
    }
    return ret;
}
function make_edit_splice(before, oldMiddle, newMiddle, after) {
    if (ends_with_pair_start(before) || starts_with_pair_end(after)) {
        return null;
    }
    return remove_empty_tuples([
        [DiffOp.DIFF_EQUAL, before],
        [DiffOp.DIFF_DELETE, oldMiddle],
        [DiffOp.DIFF_INSERT, newMiddle],
        [DiffOp.DIFF_EQUAL, after]
    ]);
}
function find_cursor_edit_diff(oldText, newText, cursor_pos) {
    // note: this runs after equality check has ruled out exact equality
    var oldRange = typeof cursor_pos === 'number' ?
        { index: cursor_pos, length: 0 } : cursor_pos.oldRange;
    var newRange = typeof cursor_pos === 'number' ?
        null : cursor_pos.newRange;
    // take into account the old and new selection to generate the best diff
    // possible for a text edit.  for example, a text change from "xxx" to "xx"
    // could be a delete or forwards-delete of any one of the x's, or the
    // result of selecting two of the x's and typing "x".
    var oldLength = oldText.length;
    var newLength = newText.length;
    if (oldRange.length === 0 && (newRange === null || newRange.length === 0)) {
        // see if we have an insert or delete before or after cursor
        var oldCursor = oldRange.index;
        var oldBefore = oldText.slice(0, oldCursor);
        var oldAfter = oldText.slice(oldCursor);
        var maybeNewCursor = newRange ? newRange.index : null;
        editBefore: {
            // is this an insert or delete right before oldCursor?
            var newCursor = oldCursor + newLength - oldLength;
            if (maybeNewCursor !== null && maybeNewCursor !== newCursor) {
                break editBefore;
            }
            if (newCursor < 0 || newCursor > newLength) {
                break editBefore;
            }
            var newBefore = newText.slice(0, newCursor);
            var newAfter = newText.slice(newCursor);
            if (!isSequenceEqual(newAfter, oldAfter)) {
                break editBefore;
            }
            var prefixLength = Math.min(oldCursor, newCursor);
            var oldPrefix = oldBefore.slice(0, prefixLength);
            var newPrefix = newBefore.slice(0, prefixLength);
            if (!isSequenceEqual(oldPrefix, newPrefix)) {
                break editBefore;
            }
            var oldMiddle = oldBefore.slice(prefixLength);
            var newMiddle = newBefore.slice(prefixLength);
            return make_edit_splice(oldPrefix, oldMiddle, newMiddle, oldAfter);
        }
        editAfter: {
            // is this an insert or delete right after oldCursor?
            if (maybeNewCursor !== null && maybeNewCursor !== oldCursor) {
                break editAfter;
            }
            var cursor = oldCursor;
            var newBefore = newText.slice(0, cursor);
            var newAfter = newText.slice(cursor);
            if (!isSequenceEqual(newBefore, oldBefore)) {
                break editAfter;
            }
            var suffixLength = Math.min(oldLength - cursor, newLength - cursor);
            var oldSuffix = oldAfter.slice(oldAfter.length - suffixLength);
            var newSuffix = newAfter.slice(newAfter.length - suffixLength);
            if (!isSequenceEqual(oldSuffix, newSuffix)) {
                break editAfter;
            }
            var oldMiddle = oldAfter.slice(0, oldAfter.length - suffixLength);
            var newMiddle = newAfter.slice(0, newAfter.length - suffixLength);
            return make_edit_splice(oldBefore, oldMiddle, newMiddle, oldSuffix);
        }
    }
    if (oldRange.length > 0 && newRange && newRange.length === 0) {
        replaceRange: {
            // see if diff could be a splice of the old selection range
            var oldPrefix = oldText.slice(0, oldRange.index);
            var oldSuffix = oldText.slice(oldRange.index + oldRange.length);
            var prefixLength = oldPrefix.length;
            var suffixLength = oldSuffix.length;
            if (newLength < prefixLength + suffixLength) {
                break replaceRange;
            }
            var newPrefix = newText.slice(0, prefixLength);
            var newSuffix = newText.slice(newLength - suffixLength);
            if (!isSequenceEqual(oldPrefix, newPrefix) ||
                !isSequenceEqual(oldSuffix, newSuffix)) {
                break replaceRange;
            }
            var oldMiddle = oldText.slice(prefixLength, oldLength - suffixLength);
            var newMiddle = newText.slice(prefixLength, newLength - suffixLength);
            return make_edit_splice(oldPrefix, oldMiddle, newMiddle, oldSuffix);
        }
    }
    return null;
}
/**
 * check if two sequences are absolutely equal
 */
function isSequenceEqual(s1, s2) {
    var res = s1.length === s2.length;
    if (res) {
        for (var index = 0; index < s1.length; index++) {
            res = s1[index] === s2[index];
            if (!res) {
                break;
            }
        }
    }
    return res;
}
/**
 * search position of shortSeq in longSeq
 */
function indexOfSequence(longSeq, shortSeq, fromIndex) {
    if (fromIndex === void 0) { fromIndex = 0; }
    var res = -1;
    for (var longSeqPos = fromIndex, longSeqLength = longSeq.length; longSeqPos < longSeqLength; longSeqPos++) {
        var find = true;
        for (var shortSeqPos = 0, shortSeqLength = shortSeq.length; shortSeqPos < shortSeqLength; shortSeqPos++) {
            var longSeqItem = longSeq[longSeqPos + shortSeqPos];
            var shortSeqItem = shortSeq[shortSeqPos];
            if (longSeqItem !== shortSeqItem) {
                find = false;
                break;
            }
        }
        if (find) {
            res = longSeqPos;
            break;
        }
    }
    return res;
}
function codePointAt(str, position) {
    var size = str.length;
    // 变成整数
    var index = position ? Number(position) : 0;
    if (index != index) { // better `isNaN`
        index = 0;
    }
    // 边界
    if (index < 0 || index >= size) {
        throw new Error('out of string size');
    }
    // 第一个编码单元
    var first = str.charCodeAt(index);
    var second;
    if ( // 检查是否开始 surrogate pair
    first >= 0xD800 && first <= 0xDBFF && // high surrogate
        size > index + 1 // 下一个编码单元
    ) {
        second = str.charCodeAt(index + 1);
        if (second >= 0xDC00 && second <= 0xDFFF) { // low surrogate
            // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
            return (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
        }
    }
    return first;
}
exports.diff = function (text1, text2, cursor_pos) {
    var seq1 = toArray_1.default(text1);
    var seq2 = toArray_1.default(text2);
    var diffs = exports.diffSequence(seq1, seq2, cursor_pos);
    var res = new Array(diffs.length);
    for (var index = 0; index < diffs.length; index++) {
        var diff_1 = diffs[index];
        res[index] = [diff_1[0], diff_1[1].join('')];
    }
    return res;
};
exports.diffSequence = function (s1, s2, cursor_pos) {
    // only pass fix_unicode=true at the top level, not when diff_main is
    // recursively invoked
    var diffs = diff_main(s1, s2, cursor_pos, true);
    return diffs;
};
//# sourceMappingURL=diff.js.map

/***/ }),

/***/ "./src/Block/Block.ts":
/*!****************************!*\
  !*** ./src/Block/Block.ts ***!
  \****************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Block": function() { return /* binding */ Block; }
/* harmony export */ });
/* harmony import */ var _Common_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Common/util */ "./src/Common/util.ts");
/* harmony import */ var _RenderStructure_LayoutFrame__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../RenderStructure/LayoutFrame */ "./src/RenderStructure/LayoutFrame.ts");
/* harmony import */ var _Common_EnumCursorType__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Common/EnumCursorType */ "./src/Common/EnumCursorType.ts");
/* harmony import */ var _Common_EnumBubbleMessage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Common/EnumBubbleMessage */ "./src/Common/EnumBubbleMessage.ts");
/* harmony import */ var _Common_IoC__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Common/IoC */ "./src/Common/IoC.ts");





class Block {
    constructor() {
        this.id = (0,_Common_util__WEBPACK_IMPORTED_MODULE_0__.increaseId)();
        this.prevSibling = null;
        this.nextSibling = null;
        this.start = 0;
        this.length = 0;
        this.x = 0;
        this.y = 0;
        this.width = 0;
        this.height = 0;
        this.needLayout = true;
        this.needMerge = false;
        this.isPointerHover = false;
    }
    destroy() { }
    /**
     * 绘制当前 block 到 canvas
     * @param ctx canvas 上下文
     * @param viewHeight 整个画布的高度
     * @returns 绘制过程中当前 block 高度是否发生变化
     */
    draw(ctx, x, y, viewHeight) {
        if (window.blockBorder) {
            ctx.save();
            ctx.strokeStyle = 'green';
            ctx.strokeRect(this.x + x, this.y + y, this.width, this.height);
            ctx.restore();
        }
    }
    /**
     * 设置当前 block 的 y 轴位置
     * @param pos 位置信息对象
     */
    setPositionY(y, recursive = true, force = false) {
        if (force === true || this.y !== y) {
            this.y = Math.floor(y);
            // 如果 needLayout 为 true 就不用设置后面的元素的 positionY 了，layout 的时候会设置的
            if (recursive && !this.needLayout) {
                let currentBlock = this;
                let nextSibling = this.nextSibling;
                while (nextSibling !== null) {
                    nextSibling.y = Math.floor(currentBlock.y + currentBlock.height);
                    currentBlock = nextSibling;
                    nextSibling = currentBlock.nextSibling;
                }
                this.bubbleUp(_Common_EnumBubbleMessage__WEBPACK_IMPORTED_MODULE_3__.BubbleMessage.UPDATE_CONTENT_HEIGHT, null);
            }
        }
    }
    /**
     * 设置当前 block 的 start
     * @param recursive 是否依次更新当前 block 后面的 block 的 start
     * @param force 是否强制更新（就算新设的值和目前的值相同也更新）
     * @param canBreak 是否允许中断，如果给某个 block  将要设置的 start 值与该 block 目前的 start 值相同，是否中断
     */
    setStart(index, recursive = false, force = false, canBreak = false) {
        if (force === true || this.start !== index) {
            this.start = index;
            if (recursive) {
                let currentBlock = this;
                let nextSibling = currentBlock.nextSibling;
                while (nextSibling !== null) {
                    if (canBreak && nextSibling.start === currentBlock.start + currentBlock.length) {
                        break;
                    }
                    nextSibling.start = currentBlock.start + currentBlock.length;
                    currentBlock = nextSibling;
                    nextSibling = currentBlock.nextSibling;
                }
                this.bubbleUp(_Common_EnumBubbleMessage__WEBPACK_IMPORTED_MODULE_3__.BubbleMessage.UPDATE_CONTENT_LENGTH, null);
            }
        }
    }
    setHeight(height) {
        if (this.height !== height) {
            this.height = height;
        }
        if (this.nextSibling === null) {
            this.bubbleUp(_Common_EnumBubbleMessage__WEBPACK_IMPORTED_MODULE_3__.BubbleMessage.UPDATE_CONTENT_HEIGHT, null);
        }
    }
    setWidth(width) {
        if (this.width !== width) {
            this.width = width;
        }
    }
    getCursorType() {
        return _Common_EnumCursorType__WEBPACK_IMPORTED_MODULE_2__.EnumCursorType.Default;
    }
    isHungry() {
        return false;
    }
    eat(block) {
        return false;
    }
    applyChanges(delta) {
        /* empty function, override if needed */
    }
    /**
     * 计算当前 block 的实际选区范围或选区端点范围
     *
     * 注意：如果参数 start、end 中某一个为 null，则返回数组长度必定是 1，且其中唯一元素的 start、end 也必定是 null
     */
    correctSelectionPos(start, end) {
        return [{ start, end }];
    }
    enterBuffer(ctx, x, y, viewHeight) { }
    leaveBuffer() { }
    enterViewport(ctx, x, y, viewHeight) { }
    leaveViewport() { }
    /**
     * 将 Op 读成 LayoutFrame
     * 这是一个给 block 的子类使用的工具方法
     */
    readOpsToLayoutFrame(ops) {
        var _a;
        const frames = [];
        const opCache = [];
        for (let index = 0; index < ops.length; index++) {
            const op = ops[index];
            if (((_a = op.attributes) === null || _a === void 0 ? void 0 : _a.frag) === 'end' && typeof op.insert === 'number') {
                // 下面要循环是因为如果 insert 不是 1，而是 2、3、4...就需要一次性插入多个 frame
                opCache.push({ insert: 1, attributes: Object.assign({}, op.attributes) });
                const frame = (0,_Common_IoC__WEBPACK_IMPORTED_MODULE_4__.create)(_RenderStructure_LayoutFrame__WEBPACK_IMPORTED_MODULE_1__.LayoutFrame.typeName);
                frame.readFromOps(opCache);
                frames.push(frame);
                for (let index = 0; index < op.insert - 1; index++) {
                    const frame = (0,_Common_IoC__WEBPACK_IMPORTED_MODULE_4__.create)(_RenderStructure_LayoutFrame__WEBPACK_IMPORTED_MODULE_1__.LayoutFrame.typeName);
                    frame.readFromOps([{ insert: 1, attributes: Object.assign({}, op.attributes) }]);
                    frames.push(frame);
                }
                opCache.length = 0;
            }
            else {
                opCache.push(op);
            }
        }
        return frames;
    }
    /**
     * 修改当前 block 的 attributes
     */
    formatSelf(attr, range) {
        /** empty function */
    }
    /**
     * 清除格式时重置当前 block 的格式到默认状态
     */
    clearSelfFormat(range) {
        /** empty function */
    }
    /**
     * 给最后一条 op 设置表示 block 类型的 attribute
     */
    setBlockOpAttribute(Ops, typeName) {
        if (Ops.length === 0) {
            return false;
        }
        Object.assign(Ops[Ops.length - 1].attributes, { block: typeName });
        return true;
    }
}
Block.typeName = 'block';


/***/ }),

/***/ "./src/Block/BlockCommon.ts":
/*!**********************************!*\
  !*** ./src/Block/BlockCommon.ts ***!
  \**********************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BlockCommon": function() { return /* binding */ BlockCommon; }
/* harmony export */ });
/* harmony import */ var _Common_LinkedList__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Common/LinkedList */ "./src/Common/LinkedList.ts");
/* harmony import */ var _RenderStructure_LayoutFrame__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../RenderStructure/LayoutFrame */ "./src/RenderStructure/LayoutFrame.ts");
/* harmony import */ var _Block__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Block */ "./src/Block/Block.ts");
/* harmony import */ var _Common_IPointerInteractive__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Common/IPointerInteractive */ "./src/Common/IPointerInteractive.ts");
/* harmony import */ var _Common_util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Common/util */ "./src/Common/util.ts");
/* harmony import */ var _Fragment_FragmentParaEnd__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../Fragment/FragmentParaEnd */ "./src/Fragment/FragmentParaEnd.ts");
/* harmony import */ var _Common_DocPos__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../Common/DocPos */ "./src/Common/DocPos.ts");
/* harmony import */ var _Common_IAttributable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../Common/IAttributable */ "./src/Common/IAttributable.ts");
/* harmony import */ var _Common_EnumBubbleMessage__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../Common/EnumBubbleMessage */ "./src/Common/EnumBubbleMessage.ts");
/* harmony import */ var _Common_IDocPosOperator__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../Common/IDocPosOperator */ "./src/Common/IDocPosOperator.ts");
/* harmony import */ var _Common_IBubbleUpable__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../Common/IBubbleUpable */ "./src/Common/IBubbleUpable.ts");
/* harmony import */ var _Common_ISelectedElementGettable__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../Common/ISelectedElementGettable */ "./src/Common/ISelectedElementGettable.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var BlockCommon_1;












function OverrideLinkedListDecorator(constructor) {
    return class extends constructor {
        /**
         * 清楚当前 block 中所有 layoutframe
         */
        removeAll() {
            this.length = 0;
            return super.removeAll();
        }
        /**
         * 从当前 block 删除一个 layoutframe
         * @param frame 要删除的 layoutframe
         */
        remove(frame) {
            if (frame.nextSibling !== null) {
                const start = frame.prevSibling === null ? 0 : frame.prevSibling.start + frame.prevSibling.length;
                frame.nextSibling.setStart(start, true, true);
            }
            super.remove(frame);
            this.length -= frame.length;
        }
        removeAllFrom(frame) {
            const removedFrames = super.removeAllFrom(frame);
            const removedLength = removedFrames.reduce((sum, frame) => sum + frame.length, 0);
            this.length -= removedLength;
            return removedFrames;
        }
        splice(start, deleteCount, nodes) {
            // const addLength = nodes ? nodes.reduce((sum, frame) => sum + frame.length, 0) : 0
            const removedFrames = super.splice(start, deleteCount, nodes);
            // const removedLength = removedFrames.reduce((sum, frame) => sum + frame.length, 0)
            // this.length = this.length + addLength - removedLength
            return removedFrames;
        }
    };
}
let BlockCommon = BlockCommon_1 = class BlockCommon extends _Block__WEBPACK_IMPORTED_MODULE_2__.Block {
    constructor() {
        super(...arguments);
        this.children = [];
        this.head = null;
        this.tail = null;
        this.defaultAttributes = {};
        this.overrideDefaultAttributes = null;
        this.originalAttributes = null;
        this.overrideAttributes = null;
        this.attributes = {};
        this.canMerge = true;
        this.canBeMerge = true;
        this.needMerge = true;
    }
    layout() {
        throw new Error('Method not implemented.');
    }
    getDocumentPos(x, y, start) {
        const targetX = x - this.x;
        const targetY = y - this.y;
        for (let index = 0; index < this.children.length; index++) {
            const frame = this.children[index];
            if ((frame.y <= targetY && targetY <= frame.y + frame.height) ||
                (index === 0 && targetY < frame.y) ||
                (index === this.children.length - 1 && targetY > frame.y + frame.height)) {
                const pos = frame.getDocumentPos(targetX - frame.x, targetY - frame.y, start);
                if (pos) {
                    pos.index += frame.start;
                }
                return pos;
            }
        }
        return null;
    }
    /**
     * 获取指定范围的矩形区域
     */
    getSelectionRectangles(start, end, correctByPosY) {
        const rects = [];
        let offset = start.index;
        const length = end.index - offset;
        const blockLength = offset < 0 ? length + offset : length;
        offset = Math.max(0, offset);
        for (let frameIndex = 0; frameIndex < this.children.length; frameIndex++) {
            const frame = this.children[frameIndex];
            if (frame.start + frame.length <= offset) {
                continue;
            }
            if (frame.start > offset + blockLength) {
                break;
            }
            const frameOffset = offset - frame.start;
            const frameLength = frameOffset < 0 ? blockLength + frameOffset : blockLength;
            const frameRects = frame.getSelectionRectangles({ index: Math.max(frameOffset, 0), inner: null }, { index: Math.max(frameOffset, 0) + frameLength, inner: null });
            for (let rectIndex = frameRects.length - 1; rectIndex >= 0; rectIndex--) {
                const rect = frameRects[rectIndex];
                rect.y += this.y;
                // 如果 correctByPosY 不在当前 rect 的纵向范围内，就过滤这条结果
                if (typeof correctByPosY === 'number' && (correctByPosY < rect.y || correctByPosY > rect.y + rect.height)) {
                    frameRects.splice(rectIndex, 1);
                    continue;
                }
                rect.x += this.x;
            }
            rects.push(...frameRects);
        }
        return rects;
    }
    toOp(withKey) {
        return [];
    }
    readFromOps(Ops) {
        throw new Error('Method not implemented.');
    }
    destroy() {
        for (let index = 0; index < this.children.length; index++) {
            const block = this.children[index];
            block.destroy();
        }
    }
    toHtml(range) {
        throw new Error('Method not implemented.');
    }
    toText(range) {
        return (0,_Common_util__WEBPACK_IMPORTED_MODULE_4__.toText)(this, range);
    }
    /**
     * 在指定位置插入文本内容
     * @param content 要插入的文本内容
     * @param index 插入的位置
     * @param hasDiffFormat 是否已独立 fragment 插入内容
     */
    insertText(content, pos, attr) {
        const targetPos = (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_6__.cloneDocPos)(pos);
        let res = false;
        const frame = (0,_Common_util__WEBPACK_IMPORTED_MODULE_4__.findChildInDocPos)(targetPos.index, this.children, true);
        if (frame) {
            res = frame.insertText(content, { index: targetPos.index - frame.start, inner: targetPos.inner }, attr);
        }
        if (this.head !== null) {
            this.head.setStart(0, true, true);
        }
        this.calLength();
        this.needLayout = true;
        return res;
    }
    insertEnter(pos, attr) {
        const frame = (0,_Common_util__WEBPACK_IMPORTED_MODULE_4__.findChildInDocPos)(pos.index, this.children, true);
        if (!frame) {
            return null;
        }
        const layoutframe = frame.insertEnter({ index: pos.index - frame.start, inner: pos.inner }, attr);
        this.needLayout = true;
        if (layoutframe) {
            this.addAfter(layoutframe, frame);
        }
        this.calLength();
        return null;
    }
    insertBlock(block, pos) {
        // 大概分为两种情况
        // 1、插在两个 layout frame 之间
        // 2、插入某个 layout frame
        const targetFrameIndex = (0,_Common_util__WEBPACK_IMPORTED_MODULE_4__.findChildIndexInDocPos)(pos.index, this.children, true);
        const targetFrame = this.children[targetFrameIndex];
        if (targetFrameIndex < 0) {
            return [];
        }
        if (targetFrame.start === pos.index && pos.inner === null) {
            // 把插入位置前后的 layout frame 分别分配到两个 block 中
            const removedFrames = this.removeAllFrom(targetFrame);
            const newBlockCommon = this.createSelf();
            newBlockCommon.addAll(removedFrames);
            newBlockCommon.setAttributes(this.originalAttributes);
            return [this, block, newBlockCommon];
        }
        else {
            // 如果是插入某个 frame，要看插入这个 frame 能不能正常插入 block，如果不行就要先把这个 frame 拆成两个 frame
            // 然后把 block 插入这两个 frame 之间
            const res = targetFrame.tryInsertBlock(block, (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_6__.getRelativeDocPos)(this.start, pos));
            if (!res) {
                // 说明此处无法正常插入 block，需要先切分 frame，然后再插入
                const frame = targetFrame.insertEnter(pos);
                if (frame) {
                    const newBlockCommon = this.createSelf();
                    newBlockCommon.addAll([frame]);
                    newBlockCommon.setAttributes(this.originalAttributes);
                    this.calLength();
                    this.needLayout = true;
                    return [this, block, newBlockCommon];
                }
            }
            return [];
        }
    }
    insertFragment(frag, pos) {
        const frame = (0,_Common_util__WEBPACK_IMPORTED_MODULE_4__.findChildInDocPos)(pos.index, this.children, true);
        if (!frame) {
            return;
        }
        frame.insertFragment(frag, (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_6__.getRelativeDocPos)(frame.start, pos));
        this.needLayout = true;
        this.calLength();
    }
    /**
     * 在指定位置删除指定长度的内容
     */
    delete(range, forward) {
        (0,_Common_util__WEBPACK_IMPORTED_MODULE_4__.deleteRange)(this, range, forward);
        this.mergeFrame();
        if (this.head !== null) {
            this.head.setStart(0, true, true);
        }
        this.calLength();
        this.needLayout = true;
    }
    /**
     * 设置缩进
     * @param increase true:  增加缩进 false: 减少缩进
     */
    setIndent(increase) {
        let hasChange = false;
        for (let i = 0; i < this.children.length; i++) {
            hasChange = this.children[i].setIndent(increase) || hasChange;
        }
        if (hasChange) {
            this.needLayout = true;
            this.bubbleUp(_Common_EnumBubbleMessage__WEBPACK_IMPORTED_MODULE_8__.BubbleMessage.CONTENT_CHANGE, null, [this]);
        }
    }
    /**
     * 在 QuoteBlock 里面找到设计到 range 范围的 layout frame
     * @param index range 的开始位置
     * @param length range 的长度
     */
    findLayoutFramesByRange(index, length, intersectionType) {
        const type = intersectionType !== null && intersectionType !== void 0 ? intersectionType : _Common_util__WEBPACK_IMPORTED_MODULE_4__.EnumIntersectionType.both;
        return (0,_Common_util__WEBPACK_IMPORTED_MODULE_4__.findChildrenByRange)(this.children, index, length, intersectionType);
    }
    /**
     * 为选区设置格式
     * @param attr 新的格式
     * @param selection 选区
     */
    format(attr, range) {
        this.formatSelf(attr, range);
        (0,_Common_util__WEBPACK_IMPORTED_MODULE_4__.format)(this, attr, range);
        this.needLayout = true;
    }
    /**
     * 清除选区范围内容的格式
     * @param index 需要清除格式的选区开始位置（相对当前 block 内容的位置）
     * @param length 需要清除格式的选区长度
     */
    clearFormat(range) {
        this.clearSelfFormat(range);
        (0,_Common_util__WEBPACK_IMPORTED_MODULE_4__.clearFormat)(this, range);
        this.needLayout = true;
    }
    /**
     * 判断当前 block 是否需要吃掉后面的 block 中的内容
     * 取决于当前 block 中最后一个 layoutframe 是有在结尾处有 FragmentParaEnd
     */
    isHungry() {
        return !(this.tail.tail instanceof _Fragment_FragmentParaEnd__WEBPACK_IMPORTED_MODULE_5__.FragmentParaEnd);
    }
    /**
     * 吃掉指定的 block
     * @param block 目标 block
     * @return true: 需要删除目标 block
     */
    eat(block) {
        if (block === this) {
            return false;
        }
        if (!(block instanceof BlockCommon_1)) {
            return false;
        }
        if (this.tail === null) {
            return false;
        }
        if (this.tail.tail instanceof _Fragment_FragmentParaEnd__WEBPACK_IMPORTED_MODULE_5__.FragmentParaEnd) {
            return false;
        }
        const res = block.head === block.tail;
        const targetFrame = block.head;
        if (targetFrame instanceof _RenderStructure_LayoutFrame__WEBPACK_IMPORTED_MODULE_1__.LayoutFrame) {
            // 先从 block 中把 targetFrame 删除
            block.remove(targetFrame);
            // 再把 targetFrame 的内容添加到 当前 block 中
            this.tail.addAll(targetFrame.children);
            this.tail.calLength();
            this.mergeFrame();
            this.calLength();
            this.needLayout = true;
        }
        return res;
    }
    /**
     * 获取某个范围内的内容格式
     */
    getFormat(range) {
        const res = range ? (0,_Common_util__WEBPACK_IMPORTED_MODULE_4__.getFormat)(this, [range]) : (0,_Common_util__WEBPACK_IMPORTED_MODULE_4__.getFormat)(this);
        (0,_Common_util__WEBPACK_IMPORTED_MODULE_4__.collectAttributes)(this.attributes, res);
        return res;
    }
    getAllLayoutFrames() {
        return this.children;
    }
    /**
     * 搜索
     */
    search(keywords) {
        const res = [];
        for (let index = 0; index < this.children.length; index++) {
            const frame = this.children[index];
            const searchResult = frame.search(keywords);
            if (searchResult.length > 0) {
                for (let i = 0; i < searchResult.length; i++) {
                    const searchResultItem = searchResult[i];
                    searchResultItem.pos.index += this.start + frame.start;
                    for (let j = 0; j < searchResultItem.rects.length; j++) {
                        const rect = searchResultItem.rects[j];
                        rect.x += this.x;
                        rect.y += this.y;
                    }
                }
                res.push(...searchResult);
            }
        }
        return res;
    }
    getChildrenStackByPos(x, y) {
        const child = (0,_Common_util__WEBPACK_IMPORTED_MODULE_4__.findRectChildInPos)(x, y, this.children);
        let res;
        if (child) {
            res = child.getChildrenStackByPos(x - child.x, y - child.y);
            res.unshift(this);
        }
        else {
            res = [this];
        }
        return res;
    }
    /**
     * 计算当前 block 的长度
     */
    calLength() {
        this.length = 0;
        for (let index = 0; index < this.children.length; index++) {
            this.length += this.children[index].length;
        }
    }
    merge(target) {
        const targetFrames = target.removeAll();
        this.addAll(targetFrames);
    }
    setWidth(width) {
        if (this.width !== width) {
            this.width = width;
            for (let index = 0; index < this.children.length; index++) {
                const frame = this.children[index];
                frame.setMaxWidth(width);
            }
        }
    }
    createSelf() {
        throw new Error('method not implemented');
    }
    enterBuffer(ctx, x, y, viewHeight) {
        for (let index = 0; index < this.children.length; index++) {
            const frame = this.children[index];
            frame.enterBuffer(ctx, this.x + x, this.y + y, viewHeight - this.head.y);
        }
    }
    leaveBuffer() {
        for (let index = 0; index < this.children.length; index++) {
            const frame = this.children[index];
            frame.leaveBuffer();
        }
    }
    enterViewport(ctx, x, y, viewHeight) {
        for (let index = 0; index < this.children.length; index++) {
            const frame = this.children[index];
            frame.enterViewport(ctx, this.x + x, this.y + y, viewHeight - this.head.y);
        }
    }
    leaveViewport() {
        for (let index = 0; index < this.children.length; index++) {
            const frame = this.children[index];
            frame.leaveViewport();
        }
    }
    // #region IBubbleUpable methods
    bubbleUp(type, data, stack) {
        throw new Error('this method should implemented in IBubbleUpableDecorator');
    }
    setBubbleHandler(handler) {
        throw new Error('this method should implemented in IBubbleUpableDecorator');
    }
    // #endregion
    // #region IDocPosOperator methods
    firstPos() {
        throw new Error('this method should implemented in IDosPosOperatorHDecorator');
    }
    lastPos() {
        throw new Error('this method should implemented in IDosPosOperatorHDecorator');
    }
    nextPos(pos) {
        throw new Error('this method should implemented in IDosPosOperatorHDecorator');
    }
    prevPos(pos) {
        throw new Error('this method should implemented in IDosPosOperatorHDecorator');
    }
    firstLinePos(x) {
        throw new Error('this method should implemented in IDosPosOperatorHDecorator');
    }
    lastLinePos(x) {
        throw new Error('this method should implemented in IDosPosOperatorHDecorator');
    }
    nextLinePos(pos, x) {
        throw new Error('this method should implemented in IDosPosOperatorVDecorator');
    }
    prevLinePos(pos, x) {
        throw new Error('this method should implemented in IDosPosOperatorVDecorator');
    }
    lineStartPos(pos, y) {
        throw new Error('this method should implemented in IDosPosOperatorVDecorator');
    }
    lineEndPos(pos, y) {
        throw new Error('this method should implemented in IDosPosOperatorVDecorator');
    }
    // #endregion
    // #region override LinkedList method
    beforeAdd(nodes) {
        nodes.forEach((node) => {
            node.setMinMetrics({ baseline: 0, bottom: 0 });
        });
    }
    afterAdd(nodes, index, prevNode, nextNode, array) {
        nodes.forEach((node) => {
            this.setChildrenMaxWidth(node);
            this.length += node.length;
            node.setBubbleHandler(this.bubbleUp.bind(this));
        });
        nodes[0].setStart(index === 0 ? 0 : array[index - 1].start + array[index - 1].length, true, true);
    }
    afterRemove(nodes, index, prevNode, nextNode, array) {
        nodes.forEach((node) => {
            node.setBubbleHandler(null);
        });
    }
    addLast(node) {
        throw new Error('Method not implemented.');
    }
    addAfter(node, target) {
        throw new Error('Method not implemented.');
    }
    addBefore(node, target) {
        throw new Error('Method not implemented.');
    }
    addAtIndex(node, index) {
        throw new Error('Method not implemented.');
    }
    addAll(nodes) {
        throw new Error('Method not implemented.');
    }
    removeAll() {
        throw new Error('Method not implemented.');
    }
    remove(node) {
        throw new Error('Method not implemented.');
    }
    removeAllFrom(node) {
        throw new Error('Method not implemented.');
    }
    splice(start, deleteCount, nodes) {
        throw new Error('Method not implemented.');
    }
    findIndex(node) {
        throw new Error('Method not implemented.');
    }
    // #endregion
    // #region override IPointerInteractiveDecorator method
    onPointerEnter(x, y, targetStack, currentTargetIndex) {
        // this method should be implemented in IPointerInteractiveDecorator
    }
    onPointerLeave() {
        // this method should be implemented in IPointerInteractiveDecorator
    }
    onPointerMove(x, y, targetStack, currentTargetIndex) {
        // this method should be implemented in IPointerInteractiveDecorator
    }
    onPointerDown(x, y) {
        // this method should be implemented in IPointerInteractiveDecorator
    }
    onPointerUp(x, y) {
        // this method should be implemented in IPointerInteractiveDecorator
    }
    onPointerTap(x, y) {
        // this method should be implemented in IPointerInteractiveDecorator
    }
    // #endregion
    // #region override IAttributableDecorator method
    setOverrideDefaultAttributes(attr) {
        throw new Error('Method not implemented.');
    }
    setOverrideAttributes(attr) {
        throw new Error('Method not implemented.');
    }
    setAttributes(attr) {
        throw new Error('Method not implemented.');
    }
    compileAttributes() {
        throw new Error('Method not implemented.');
    }
    // #endregion
    // #region getSelectedElement methods
    getSelectedElement(range) {
        throw new Error('Method not implemented.');
    }
    // #endregion
    /**
     * 设置 layoutframe 的位置索引
     */
    setFrameStart() {
        if (this.children.length > 0) {
            this.children[0].start = 0;
        }
        else {
            return;
        }
        for (let index = 1; index < this.children.length; index++) {
            this.children[index].start = this.children[index - 1].start + this.children[index - 1].length;
        }
    }
    setChildrenMaxWidth(frame) {
        frame.setMaxWidth(this.width);
    }
    /**
     * 合并没有结尾的 layoutframe
     */
    mergeFrame() {
        for (let frameIndex = 0; frameIndex < this.children.length - 1; frameIndex++) {
            const frame = this.children[frameIndex];
            if (!(frame.tail instanceof _Fragment_FragmentParaEnd__WEBPACK_IMPORTED_MODULE_5__.FragmentParaEnd)) {
                // 如果某个 frame 没有段落结尾且这个 frame 不是最后一个 frame 就 merge
                const target = this.children[frameIndex + 1];
                frame.eat(target);
                this.remove(target);
                break;
            }
        }
    }
};
BlockCommon.typeName = 'blockCommon';
BlockCommon = BlockCommon_1 = __decorate([
    _Common_ISelectedElementGettable__WEBPACK_IMPORTED_MODULE_11__.ISelectedElementGettableDecorator,
    _Common_IBubbleUpable__WEBPACK_IMPORTED_MODULE_10__.IBubbleUpableDecorator,
    OverrideLinkedListDecorator,
    _Common_LinkedList__WEBPACK_IMPORTED_MODULE_0__.ILinkedListDecorator,
    _Common_IPointerInteractive__WEBPACK_IMPORTED_MODULE_3__.IPointerInteractiveDecorator,
    _Common_IAttributable__WEBPACK_IMPORTED_MODULE_7__.IAttributableDecorator,
    _Common_IDocPosOperator__WEBPACK_IMPORTED_MODULE_9__.IDosPosOperatorHDecorator,
    _Common_IDocPosOperator__WEBPACK_IMPORTED_MODULE_9__.IDosPosOperatorVDecorator
], BlockCommon);



/***/ }),

/***/ "./src/Block/CodeBlock.ts":
/*!********************************!*\
  !*** ./src/Block/CodeBlock.ts ***!
  \********************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CodeBlock": function() { return /* binding */ CodeBlock; }
/* harmony export */ });
/* harmony import */ var prismjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! prismjs */ "prismjs");
/* harmony import */ var prismjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prismjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _BlockCommon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./BlockCommon */ "./src/Block/BlockCommon.ts");
/* harmony import */ var _CodeBlockAttributes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./CodeBlockAttributes */ "./src/Block/CodeBlockAttributes.ts");
/* harmony import */ var _RenderStructure_LayoutFrame__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../RenderStructure/LayoutFrame */ "./src/RenderStructure/LayoutFrame.ts");
/* harmony import */ var _CodeHighlightThemeRegistrar__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./CodeHighlightThemeRegistrar */ "./src/Block/CodeHighlightThemeRegistrar.ts");
/* harmony import */ var _Common_EnumTextStyle__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../Common/EnumTextStyle */ "./src/Common/EnumTextStyle.ts");
/* harmony import */ var _Fragment_FragmentParaEnd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../Fragment/FragmentParaEnd */ "./src/Fragment/FragmentParaEnd.ts");
/* harmony import */ var _Fragment_FragmentTextAttributes__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../Fragment/FragmentTextAttributes */ "./src/Fragment/FragmentTextAttributes.ts");
/* harmony import */ var _Common_EnumBubbleMessage__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../Common/EnumBubbleMessage */ "./src/Common/EnumBubbleMessage.ts");
/* harmony import */ var _Common_util__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../Common/util */ "./src/Common/util.ts");
/* harmony import */ var _Platform__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../Platform */ "./src/Platform.ts");
/* harmony import */ var _Common_IoC__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../Common/IoC */ "./src/Common/IoC.ts");












const LINE_NUM_MARGIN_RIGHT = 3;
const LINE_NUM_MARGIN_LEFT = 2;
const CODE_MARGIN_LEFT = 2;
class CodeBlock extends _BlockCommon__WEBPACK_IMPORTED_MODULE_1__.BlockCommon {
    constructor() {
        super(...arguments);
        this.attributes = Object.assign({}, _CodeBlockAttributes__WEBPACK_IMPORTED_MODULE_2__.CodeBlockDefaultAttributes);
        this.codeLines = [];
        this.theme = new _CodeHighlightThemeRegistrar__WEBPACK_IMPORTED_MODULE_4__.DefaultTheme();
        this.lineNumWidth = 0;
        this.idleColoring = ({ timeRemaining, didTimeout }) => {
            console.log('coloring');
            const frames = this.tokenize();
            this.removeAll();
            this.addAll(frames);
            this.layoutFrames();
            this.bubbleUp(_Common_EnumBubbleMessage__WEBPACK_IMPORTED_MODULE_8__.BubbleMessage.NEED_DRAW, null, [this]);
        };
    }
    readFromOps(Ops) {
        const frames = super.readOpsToLayoutFrame(Ops);
        // 给所有的 fragmentText 加上代码的字体
        for (let i = 0; i < frames.length; i++) {
            const frame = frames[i];
            for (let j = 0; j < frame.children.length; j++) {
                const frag = frame.children[j];
                frag.setAttributes({ font: _Common_EnumTextStyle__WEBPACK_IMPORTED_MODULE_5__.EnumFont.getFontValue('source') });
            }
        }
        this.addAll(frames);
        super.setFrameStart();
        this.setAttributes(Ops[Ops.length - 1].attributes);
    }
    setAttributes(attrs) {
        if (typeof attrs.language === 'string') {
            this.attributes.language = attrs.language;
        }
        if (typeof attrs.theme === 'string') {
            const theme = _CodeHighlightThemeRegistrar__WEBPACK_IMPORTED_MODULE_4__.codeHighlightThemeRegistrar.getThemeClass(attrs.theme);
            if (theme) {
                this.theme = theme;
            }
        }
    }
    layout() {
        // CodeBlock 在排版的时候，会直接对代码的文字内容进行排版，此时渲染出来的代码是没有高亮着色的
        // 然后在 idleCallback 里用 prism 对当前代码块中所有内容 tokenize
        // 再根据 tokenize 的结果生成 layoutframe 和 里面的 fragment
        // 再把生成的新 frame 替换掉未着色的 frame 并按照普通 BlockCommon 的逻辑对 layoutframe 进行排版
        if (this.needLayout) {
            this.layoutFrames();
            (0,_Platform__WEBPACK_IMPORTED_MODULE_10__.getPlatform)().requestIdleCallback(this.idleColoring);
        }
    }
    draw(ctx, x, y, viewHeight) {
        // 绘制背景色
        ctx.fillStyle = this.theme.codeBackground;
        ctx.fillRect(x + this.x + this.lineNumWidth, y + this.y, this.width - this.lineNumWidth, this.height);
        // 绘制行号背景色
        ctx.fillStyle = this.theme.lineNumBackground;
        ctx.fillRect(x + this.x, y + this.y, this.lineNumWidth, this.height);
        for (let index = 0; index < this.children.length; index++) {
            const currentFrame = this.children[index];
            const frameYPosStart = y + this.y + currentFrame.y;
            const frameYPosEnd = frameYPosStart + currentFrame.height;
            if (frameYPosStart >= viewHeight || frameYPosEnd <= 0) {
                continue;
            }
            currentFrame.draw(ctx, this.x + x, this.y + y, viewHeight);
            // 绘制行号
            ctx.textAlign = 'right';
            ctx.textBaseline = 'alphabetic';
            ctx.fillStyle = this.theme.lineNumColor;
            ctx.fillText((index + 1).toString(), x + this.x + currentFrame.x - CODE_MARGIN_LEFT - LINE_NUM_MARGIN_RIGHT, currentFrame.lines[0].y + currentFrame.lines[0].baseline + currentFrame.y + this.y + y);
            ctx.textAlign = 'start';
        }
        super.draw(ctx, x, y, viewHeight);
    }
    getFormat() {
        const res = {};
        (0,_Common_util__WEBPACK_IMPORTED_MODULE_9__.collectAttributes)(this.attributes, res);
        return res;
    }
    createSelf() {
        return new CodeBlock();
    }
    setChildrenMaxWidth(frame) {
        frame.setMaxWidth(this.width - this.lineNumWidth - CODE_MARGIN_LEFT);
    }
    layoutFrames() {
        // 然后计算行号需要的宽度，因为 code 用的是等宽字体，所以只用计算最大行号的宽度就行了
        this.lineNumWidth =
            (0,_Platform__WEBPACK_IMPORTED_MODULE_10__.getPlatform)().measureTextWidth(this.children.length.toString(), {
                font: _Common_EnumTextStyle__WEBPACK_IMPORTED_MODULE_5__.EnumFont.getFontValue('source'),
                italic: false,
                bold: false,
                size: _Fragment_FragmentTextAttributes__WEBPACK_IMPORTED_MODULE_7__.FragmentTextDefaultAttributes.size,
            }) +
                LINE_NUM_MARGIN_LEFT +
                LINE_NUM_MARGIN_RIGHT;
        let currentFrame = null;
        let newWidth = 0;
        for (let i = 0, l = this.children.length; i < l; i++) {
            currentFrame = this.children[i];
            currentFrame.layout();
            currentFrame.x = this.lineNumWidth + CODE_MARGIN_LEFT;
            newWidth = Math.max(newWidth, currentFrame.x + currentFrame.width);
        }
        if (this.head !== null) {
            this.head.setPositionY(0, true, true);
        }
        this.needLayout = false;
        let newHeight = 0;
        if (currentFrame !== null) {
            newHeight = currentFrame.y + currentFrame.height;
        }
        this.setHeight(newHeight);
        if (this.nextSibling !== null) {
            this.nextSibling.setPositionY(this.y + this.height);
        }
    }
    tokenize() {
        let stringContent = '';
        for (let i = 0; i < this.children.length; i++) {
            stringContent += this.children[i].toText();
        }
        const tokenStream = prismjs__WEBPACK_IMPORTED_MODULE_0___default().tokenize(stringContent, (prismjs__WEBPACK_IMPORTED_MODULE_0___default().languages.javascript));
        const frames = [];
        if (tokenStream.length > 0) {
            const currentFrame = (0,_Common_IoC__WEBPACK_IMPORTED_MODULE_11__.create)(_RenderStructure_LayoutFrame__WEBPACK_IMPORTED_MODULE_3__.LayoutFrame.typeName);
            this.parseTokenTree(tokenStream, frames, currentFrame, '');
        }
        return frames;
    }
    /**
     * 把 prism 解析代码的结果转成 frame 和 fragment
     */
    parseTokenTree(treeRoot, frames, currentFrame, currentTokenType) {
        for (let index = 0; index < treeRoot.length; index++) {
            const currentToken = treeRoot[index];
            if (typeof currentToken === 'string') {
                if (currentToken.indexOf('\n') >= 0) {
                    const pieces = currentToken.split('\n');
                    for (let pieceIndex = 0; pieceIndex < pieces.length; pieceIndex++) {
                        const piece = pieces[pieceIndex];
                        if (piece.length > 0) {
                            const frag = (0,_Common_IoC__WEBPACK_IMPORTED_MODULE_11__.create)('');
                            frag.setContent(piece);
                            const attr = this.theme.getStyle(currentTokenType);
                            const font = _Common_EnumTextStyle__WEBPACK_IMPORTED_MODULE_5__.EnumFont.getFontValue('source');
                            const fragAttr = Object.assign(Object.assign({}, attr), (typeof font === 'string' ? { font } : null));
                            frag.setAttributes(fragAttr);
                            frag.calMetrics();
                            currentFrame.addLast(frag);
                        }
                        if (pieceIndex !== pieces.length - 1) {
                            const fragEnd = (0,_Common_IoC__WEBPACK_IMPORTED_MODULE_11__.create)(_Fragment_FragmentParaEnd__WEBPACK_IMPORTED_MODULE_6__.FragmentParaEnd.typeName);
                            fragEnd.calMetrics();
                            currentFrame.addLast(fragEnd);
                            currentFrame.calLength();
                            frames.push(currentFrame);
                            currentFrame = (0,_Common_IoC__WEBPACK_IMPORTED_MODULE_11__.create)(_RenderStructure_LayoutFrame__WEBPACK_IMPORTED_MODULE_3__.LayoutFrame.typeName);
                        }
                    }
                }
                else {
                    const frag = (0,_Common_IoC__WEBPACK_IMPORTED_MODULE_11__.create)('');
                    frag.setContent(currentToken);
                    const attr = this.theme.getStyle(currentTokenType);
                    const font = _Common_EnumTextStyle__WEBPACK_IMPORTED_MODULE_5__.EnumFont.getFontValue('source');
                    const fragAttr = Object.assign(Object.assign({}, attr), (typeof font === 'string' ? { font } : null));
                    frag.setAttributes(fragAttr);
                    frag.calMetrics();
                    currentFrame.addLast(frag);
                }
            }
            else if (typeof currentToken.content === 'string') {
                currentFrame = this.parseTokenTree([currentToken.content], frames, currentFrame, currentToken.type);
            }
            else {
                currentFrame = this.parseTokenTree(currentToken.content, frames, currentFrame, currentToken.type);
            }
        }
        return currentFrame;
    }
}
CodeBlock.typeName = 'code';


/***/ }),

/***/ "./src/Block/CodeBlockAttributes.ts":
/*!******************************************!*\
  !*** ./src/Block/CodeBlockAttributes.ts ***!
  \******************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CodeBlockDefaultAttributes": function() { return /* binding */ codeBlockDefaultAttributes; }
/* harmony export */ });
const codeBlockDefaultAttributes = {
    language: '',
    theme: '',
};



/***/ }),

/***/ "./src/Block/CodeHighlightThemeRegistrar.ts":
/*!**************************************************!*\
  !*** ./src/Block/CodeHighlightThemeRegistrar.ts ***!
  \**************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CodeHighlightTheme": function() { return /* binding */ CodeHighlightTheme; },
/* harmony export */   "DefaultTheme": function() { return /* binding */ DefaultTheme; },
/* harmony export */   "codeHighlightThemeRegistrar": function() { return /* binding */ codeHighlightThemeRegistrar; }
/* harmony export */ });
class CodeHighlightTheme {
}
class DefaultTheme extends CodeHighlightTheme {
    constructor() {
        super(...arguments);
        this.codeBackground = '#f7f7f7';
        this.lineNumBackground = 'transparent';
        this.lineNumColor = '#d0d4d9';
    }
    getStyle(kind) {
        switch (kind) {
            case 'comment':
            case 'prolog':
            case 'doctype':
            case 'cdata':
                return { color: 'slategray' };
            case 'punctuation':
                return { color: '#999' };
            case 'property':
            case 'tag':
            case 'boolean':
            case 'number':
            case 'constant':
            case 'symbol':
            case 'deleted': {
                return { color: '#905' };
            }
            case 'selector':
            case 'attr-name':
            case 'string':
            case 'char':
            case 'builtin':
            case 'inserted': {
                return { color: '#690' };
            }
            case 'operator':
            case 'entity':
            case 'url':
                return {
                    color: '#9a6e3a',
                };
            case 'atrule':
            case 'attr-value':
            case 'keyword': {
                return { color: '#07a' };
            }
            case 'function':
            case 'class-name': {
                return { color: '#DD4A68' };
            }
            case 'regex':
            case 'important':
            case 'variable': {
                return { color: '#e90' };
            }
            case 'bold': {
                return { bold: true };
            }
            case 'italic': {
                return { italic: true };
            }
            default:
                return null;
        }
    }
}
class CodeHighlightThemeRegistrar {
    constructor() {
        this.registeredThemes = new Map();
    }
    registerTheme(themeType, ThemeClass) {
        this.registeredThemes.set(themeType, ThemeClass);
    }
    unregisterTheme(themeType) {
        this.registeredThemes.delete(themeType);
    }
    unregisterAllTheme() {
        this.registeredThemes.clear();
    }
    getThemeClass(themeType) {
        return this.registeredThemes.get(themeType);
    }
}
const codeHighlightThemeRegistrar = new CodeHighlightThemeRegistrar();


/***/ }),

/***/ "./src/Block/ListItem.ts":
/*!*******************************!*\
  !*** ./src/Block/ListItem.ts ***!
  \*******************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ListItem": function() { return /* binding */ ListItem; }
/* harmony export */ });
/* harmony import */ var _Common_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Common/util */ "./src/Common/util.ts");
/* harmony import */ var _Common_EnumListStyle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Common/EnumListStyle */ "./src/Common/EnumListStyle.ts");
/* harmony import */ var _Common_EnumTextStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Common/EnumTextStyle */ "./src/Common/EnumTextStyle.ts");
/* harmony import */ var _ListItemAttributes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./ListItemAttributes */ "./src/Block/ListItemAttributes.ts");
/* harmony import */ var _BlockCommon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./BlockCommon */ "./src/Block/BlockCommon.ts");
/* harmony import */ var _Platform__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../Platform */ "./src/Platform.ts");
/* harmony import */ var _Common_EnumBubbleMessage__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../Common/EnumBubbleMessage */ "./src/Common/EnumBubbleMessage.ts");







class ListItem extends _BlockCommon__WEBPACK_IMPORTED_MODULE_4__.BlockCommon {
    constructor() {
        super(...arguments);
        this.defaultAttributes = _ListItemAttributes__WEBPACK_IMPORTED_MODULE_3__.ListItemDefaultAttributes;
        this.attributes = Object.assign({}, _ListItemAttributes__WEBPACK_IMPORTED_MODULE_3__.ListItemDefaultAttributes);
        this.overrideDefaultAttributes = null;
        this.originalAttributes = null;
        this.overrideAttributes = null;
        this.titleContent = '';
        this.titleWidth = 0;
        this.titleBaseline = 0;
        this.titleIndex = 0;
        this.titleParent = '';
    }
    readFromOps(Ops) {
        const frames = super.readOpsToLayoutFrame(Ops);
        this.addAll(frames);
        this.setFrameStart();
        this.setAttributes(Ops[Ops.length - 1].attributes);
    }
    /**
     * 重新排版当前 ListItem
     */
    layout() {
        if (this.needLayout) {
            this.setTitleIndex();
            this.setTitleContent((0,_Common_util__WEBPACK_IMPORTED_MODULE_0__.calListItemTitle)(this.attributes.listType, this.attributes.liIndent, this.titleIndex, this.titleParent));
            // 先对列表项 title 文字排版，算出宽度、行高、baseline 位置
            this.titleWidth = (0,_Platform__WEBPACK_IMPORTED_MODULE_5__.getPlatform)().measureTextWidth(this.titleContent, {
                italic: false,
                bold: false,
                size: this.attributes.liSize,
                font: _Common_EnumTextStyle__WEBPACK_IMPORTED_MODULE_2__.EnumFont.getFontValue('Default'),
            });
            const titleMetrics = (0,_Platform__WEBPACK_IMPORTED_MODULE_5__.getPlatform)().measureTextMetrics({
                bold: false,
                size: this.attributes.liSize,
                font: _Common_EnumTextStyle__WEBPACK_IMPORTED_MODULE_2__.EnumFont.getFontValue('Default'),
            });
            const newMetricsBottom = (0,_Platform__WEBPACK_IMPORTED_MODULE_5__.getPlatform)().convertPt2Px[this.attributes.liSize] * this.attributes.liLinespacing;
            const newMetricsBaseline = (newMetricsBottom - titleMetrics.bottom) / 2 + titleMetrics.baseline;
            titleMetrics.bottom = newMetricsBottom;
            titleMetrics.baseline = newMetricsBaseline;
            // 再对 frame 内容排版
            this.children[0].setFirstIndent(Math.max(10 + this.titleWidth - (this.attributes.liIndent > 1 ? 20 : 26), 0));
            const offsetX = 26 * this.attributes.liIndent;
            const layoutMaxWidth = this.width - offsetX;
            let currentFrame;
            for (let i = 0, l = this.children.length; i < l; i++) {
                currentFrame = this.children[i];
                currentFrame.setMinMetrics({
                    baseline: titleMetrics.baseline,
                    bottom: titleMetrics.bottom,
                });
                currentFrame.setMaxWidth(layoutMaxWidth - 26);
                currentFrame.x = offsetX + 26;
                currentFrame.layout();
                if (i < l - 1) {
                    this.children[i + 1].y = Math.floor(currentFrame.y + currentFrame.height);
                }
                this.width = Math.max(this.width, currentFrame.x + currentFrame.width);
            }
            // 再比较 layoutFrame 中的行的 baseline 和 title 中的 baseline 及 line height，取较大值
            const newBaseline = Math.max(titleMetrics.baseline, this.children[0].lines[0].baseline);
            this.titleBaseline = newBaseline;
            if (this.head !== null) {
                this.head.setPositionY(0, true, true);
            }
            this.needLayout = false;
            const height = currentFrame.y + currentFrame.height;
            this.setHeight(height);
            if (this.nextSibling !== null) {
                this.nextSibling.setPositionY(this.y + this.height);
            }
        }
    }
    /**
     * 渲染当前 listitem
     * @param viewHeight 整个画布的高度
     */
    draw(ctx, x, y, viewHeight) {
        const offsetX = 26 * this.attributes.liIndent;
        ctx.font = (0,_Platform__WEBPACK_IMPORTED_MODULE_5__.getPlatform)().createTextFontString({
            italic: false,
            bold: false,
            size: this.attributes.liSize,
            font: _Common_EnumTextStyle__WEBPACK_IMPORTED_MODULE_2__.EnumFont.getFontValue('Default'),
        });
        ctx.fillStyle = this.attributes.liColor;
        ctx.fillText(this.titleContent, this.x + x + 6 + offsetX, this.y + y + this.titleBaseline);
        for (let i = 0, l = this.children.length; i < l; i++) {
            const currentFrame = this.children[i];
            currentFrame.draw(ctx, this.x + x, this.y + y, viewHeight - currentFrame.y);
        }
        super.draw(ctx, x, y, viewHeight);
    }
    setTitleContent(titleContent) {
        this.titleContent = titleContent;
    }
    /**
     * 设置缩进
     * @param increase true:  增加缩进 false: 减少缩进
     */
    setIndent(increase) {
        const currentIndent = this.attributes.liIndent;
        const step = increase ? 1 : -1;
        let newIndent = currentIndent + step;
        newIndent = Math.min(newIndent, 8);
        newIndent = Math.max(newIndent, 0);
        if (currentIndent !== newIndent) {
            this.setAttributes({
                indent: newIndent,
            });
            // 当前 listitem 的 indent 发生变化时，所有相同 listId 的 listitem 都需要重新排版，因为序号可能会发生变化
            this.bubbleUp(_Common_EnumBubbleMessage__WEBPACK_IMPORTED_MODULE_6__.BubbleMessage.NEED_LAYOUT_LISTITEM, this.attributes.listId);
        }
    }
    toOp(withKey) {
        const res = [];
        for (let index = 0; index < this.children.length; index++) {
            const element = this.children[index];
            const layoutOps = element.toOp(withKey);
            Object.assign(layoutOps[layoutOps.length - 1].attributes, this.getOriginAttrs());
            res.push(...layoutOps);
        }
        this.setBlockOpAttribute(res, ListItem.typeName);
        return res;
    }
    toHtml(range) {
        const contentHtml = (0,_Common_util__WEBPACK_IMPORTED_MODULE_0__.toHtml)(this, range);
        const style = '';
        return `<li style="${style}">${contentHtml}</li>`;
    }
    /**
     * 在指定位置插入一个换行符
     */
    insertEnter(pos, attr) {
        const frame = (0,_Common_util__WEBPACK_IMPORTED_MODULE_0__.findChildInDocPos)(pos.index, this.children, true);
        if (!frame) {
            return null;
        }
        const layoutframe = frame.insertEnter({ index: pos.index - frame.start, inner: pos.inner }, attr);
        this.calLength();
        this.needLayout = true;
        if (layoutframe) {
            const newList = new ListItem();
            newList.setHeight(this.width);
            newList.addLast(layoutframe);
            newList.setAttributes(this.getOriginAttrs());
            return newList;
        }
        return null;
    }
    setAttributes(attr) {
        if (attr) {
            const listType = attr['list-type'];
            if (typeof listType === 'string') {
                attr.listType = (0,_Common_util__WEBPACK_IMPORTED_MODULE_0__.calListTypeFromChangeData)(listType);
            }
        }
        super.setAttributes(attr);
        this.children.forEach((frame) => {
            this.setFrameOverrideAttributes(frame);
            this.setFrameOverrideDefaultAttributes(frame);
        });
    }
    afterAdd(nodes, index, prevNode, nextNode, array) {
        super.afterAdd(nodes, index, prevNode, nextNode, array);
        nodes.forEach((node) => {
            this.setFrameOverrideAttributes(node);
            this.setFrameOverrideDefaultAttributes(node);
        });
    }
    afterRemove(nodes, index, prevNode, nextNode, array) {
        super.afterRemove(nodes, index, prevNode, nextNode, array);
        nodes.forEach((node) => {
            this.removeFrameOverrideAttributes(node);
            this.removeFrameOverrideDefaultAttributes(node);
        });
    }
    format(attr, range) {
        super.format(attr, range);
        // 如果当前 listItem 的所有内容都被设置了某些格式，就还需要设置对应的 listItem 的格式
        if (!range ||
            (range.start.index === 0 &&
                range.start.inner === null &&
                range.end.index === this.start + this.length &&
                range.end.inner === null)) {
            const newAttr = {};
            if (attr.hasOwnProperty('color')) {
                newAttr.liColor = attr.color;
            }
            if (attr.hasOwnProperty('size')) {
                newAttr.liSize = attr.size;
            }
            if (attr.hasOwnProperty('linespacing')) {
                newAttr.liLinespacing = attr.linespacing;
            }
            if (attr.hasOwnProperty('indent')) {
                newAttr.liIndent = attr.indent;
            }
            this.setAttributes(newAttr);
        }
    }
    createSelf() {
        return new ListItem();
    }
    formatSelf(attr, range) {
        this.setAttributes(attr);
    }
    clearSelfFormat(range) {
        this.setAttributes(Object.assign({}, _ListItemAttributes__WEBPACK_IMPORTED_MODULE_3__.ListItemDefaultAttributes));
    }
    setTitleIndex() {
        let index = 0;
        let parentTitle = '';
        let findIndex = false;
        let findParentTitle = this.attributes.listType !== _Common_EnumListStyle__WEBPACK_IMPORTED_MODULE_1__.EnumListType.ol3;
        let currentListItem = this.prevSibling;
        while (currentListItem !== null) {
            if (currentListItem instanceof ListItem && currentListItem.attributes.listId === this.attributes.listId) {
                const levelOffset = this.attributes.liIndent - currentListItem.attributes.liIndent;
                if (levelOffset === 0) {
                    findIndex = true;
                    findParentTitle = true;
                    index = currentListItem.titleIndex + 1;
                    parentTitle = currentListItem.titleParent;
                }
                else if (levelOffset > 0) {
                    parentTitle = currentListItem.titleContent;
                    for (let i = 1; i < levelOffset; i++) {
                        parentTitle += '1.';
                    }
                    findParentTitle = true;
                    findIndex = true;
                }
                else if (levelOffset < 0) {
                    index = 1;
                }
            }
            if (findIndex && findParentTitle) {
                break;
            }
            else {
                currentListItem = currentListItem.prevSibling;
            }
        }
        this.titleIndex = index;
        this.titleParent = parentTitle;
    }
    getOriginAttrs() {
        let listTypeData;
        switch (this.attributes.listType) {
            case _Common_EnumListStyle__WEBPACK_IMPORTED_MODULE_1__.EnumListType.ol1:
                listTypeData = { 'list-type': 'decimal', listId: this.attributes.listId };
                break;
            case _Common_EnumListStyle__WEBPACK_IMPORTED_MODULE_1__.EnumListType.ol2:
                listTypeData = { 'list-type': 'ckj-decimal', listId: this.attributes.listId };
                break;
            case _Common_EnumListStyle__WEBPACK_IMPORTED_MODULE_1__.EnumListType.ol3:
                listTypeData = { 'list-type': 'upper-decimal', listId: this.attributes.listId };
                break;
            case _Common_EnumListStyle__WEBPACK_IMPORTED_MODULE_1__.EnumListType.ul1:
                listTypeData = { 'list-type': 'circle', listId: this.attributes.listId };
                break;
            case _Common_EnumListStyle__WEBPACK_IMPORTED_MODULE_1__.EnumListType.ul2:
                listTypeData = { 'list-type': 'ring', listId: this.attributes.listId };
                break;
            case _Common_EnumListStyle__WEBPACK_IMPORTED_MODULE_1__.EnumListType.ul3:
                listTypeData = { 'list-type': 'arrow', listId: this.attributes.listId };
                break;
        }
        return Object.assign(Object.assign({}, this.originalAttributes), listTypeData);
    }
    setFrameOverrideAttributes(frame) {
        const overrideAttributes = this.getOverrideAttributes();
        if (Object.keys(overrideAttributes).length > 0) {
            frame.setOverrideAttributes(overrideAttributes);
        }
    }
    removeFrameOverrideAttributes(frame) {
        const emptyAttr = this.getOverrideAttributes();
        Object.keys(emptyAttr).forEach((key) => {
            emptyAttr[key] = undefined;
        });
        frame.setOverrideAttributes(emptyAttr);
    }
    getOverrideAttributes() {
        const attr = {};
        switch (this.attributes.title) {
            case _Common_EnumTextStyle__WEBPACK_IMPORTED_MODULE_2__.EnumTitle.Title:
                attr.bold = true;
                attr.size = 20;
                break;
            case _Common_EnumTextStyle__WEBPACK_IMPORTED_MODULE_2__.EnumTitle.Subtitle:
                attr.bold = true;
                attr.size = 18;
                break;
            case _Common_EnumTextStyle__WEBPACK_IMPORTED_MODULE_2__.EnumTitle.H1:
                attr.bold = true;
                attr.size = 16;
                break;
            case _Common_EnumTextStyle__WEBPACK_IMPORTED_MODULE_2__.EnumTitle.H2:
                attr.bold = true;
                attr.size = 14;
                break;
            case _Common_EnumTextStyle__WEBPACK_IMPORTED_MODULE_2__.EnumTitle.H3:
                attr.bold = true;
                attr.size = 13;
                break;
            case _Common_EnumTextStyle__WEBPACK_IMPORTED_MODULE_2__.EnumTitle.H4:
                attr.bold = true;
                attr.size = 12;
                break;
        }
        attr.linespacing = this.attributes.liLinespacing;
        return attr;
    }
    setFrameOverrideDefaultAttributes(frame) {
        if (this.attributes.title === _Common_EnumTextStyle__WEBPACK_IMPORTED_MODULE_2__.EnumTitle.Subtitle) {
            frame.setOverrideDefaultAttributes({ color: '#888' });
        }
    }
    removeFrameOverrideDefaultAttributes(frame) {
        if (this.attributes.title === _Common_EnumTextStyle__WEBPACK_IMPORTED_MODULE_2__.EnumTitle.Subtitle) {
            frame.setOverrideDefaultAttributes({ color: undefined });
        }
    }
}
ListItem.typeName = 'list';


/***/ }),

/***/ "./src/Block/ListItemAttributes.ts":
/*!*****************************************!*\
  !*** ./src/Block/ListItemAttributes.ts ***!
  \*****************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ListItemDefaultAttributes": function() { return /* binding */ listItemDefaultAttributes; }
/* harmony export */ });
/* harmony import */ var _Common_EnumListStyle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Common/EnumListStyle */ "./src/Common/EnumListStyle.ts");
/* harmony import */ var _Common_EnumTextStyle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Common/EnumTextStyle */ "./src/Common/EnumTextStyle.ts");


const listItemDefaultAttributes = {
    listType: _Common_EnumListStyle__WEBPACK_IMPORTED_MODULE_0__.EnumListType.ol1,
    listId: 0,
    liColor: '#494949',
    liSize: 11,
    liLinespacing: 1.7,
    liIndent: 0,
    title: _Common_EnumTextStyle__WEBPACK_IMPORTED_MODULE_1__.EnumTitle.Text,
};



/***/ }),

/***/ "./src/Block/Paragraph.ts":
/*!********************************!*\
  !*** ./src/Block/Paragraph.ts ***!
  \********************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Paragraph": function() { return /* binding */ Paragraph; }
/* harmony export */ });
/* harmony import */ var _BlockCommon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./BlockCommon */ "./src/Block/BlockCommon.ts");
/* harmony import */ var _Common_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Common/util */ "./src/Common/util.ts");
/* harmony import */ var _ParagraphAttributes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./ParagraphAttributes */ "./src/Block/ParagraphAttributes.ts");
/* harmony import */ var _Common_EnumTextStyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Common/EnumTextStyle */ "./src/Common/EnumTextStyle.ts");




class Paragraph extends _BlockCommon__WEBPACK_IMPORTED_MODULE_0__.BlockCommon {
    constructor() {
        super(...arguments);
        this.defaultAttributes = _ParagraphAttributes__WEBPACK_IMPORTED_MODULE_2__.ParagraphDefaultAttributes;
        this.attributes = Object.assign({}, _ParagraphAttributes__WEBPACK_IMPORTED_MODULE_2__.ParagraphDefaultAttributes);
        this.originalAttributes = null;
        this.needMerge = false;
    }
    readFromOps(Ops) {
        this.setAttributes(Ops[Ops.length - 1].attributes);
        const frames = super.readOpsToLayoutFrame(Ops);
        this.addLast(frames[0]);
        this.length = frames[0].length;
    }
    /**
     * 对当前段落排版
     */
    layout() {
        if (this.needLayout && this.head) {
            this.head.layout();
            this.head.x = 0;
            this.head.y = 0;
            this.head.start = 0;
            this.needLayout = false;
            this.setHeight(this.head.height);
            if (this.nextSibling !== null) {
                this.nextSibling.setPositionY(this.y + this.height);
            }
        }
    }
    /**
     * 获取指定 x y 坐标所指向的文档位置
     */
    getDocumentPos(x, y, start) {
        return this.head.getDocumentPos(x - this.x, y - this.y, start);
    }
    /**
     * 计算指定范围在当前段落的矩形区域
     */
    getSelectionRectangles(start, end, correctByPosY) {
        const offset = start.index;
        const length = end.index - offset;
        const blockLength = offset < 0 ? length + offset : length;
        const rects = this.head.getSelectionRectangles({ index: Math.max(offset, 0), inner: null }, { index: Math.max(offset, 0) + blockLength, inner: null });
        for (let rectIndex = rects.length - 1; rectIndex >= 0; rectIndex--) {
            const rect = rects[rectIndex];
            rect.y += this.y;
            // 如果 correctByPosY 不在当前 rect 的纵向范围内，就过滤这条结果
            if (typeof correctByPosY === 'number' && (correctByPosY < rect.y || correctByPosY > rect.y + rect.height)) {
                rects.splice(rectIndex, 1);
                continue;
            }
            rect.x += this.x;
        }
        return rects;
    }
    /**
     * 删除指定范围的内容
     */
    delete(range, forward) {
        if (this.head) {
            this.head.delete(range, forward);
        }
        this.length = this.head.length;
        this.needLayout = true;
    }
    toOp(withKey) {
        const ops = this.head.toOp(withKey);
        Object.assign(ops[ops.length - 1].attributes, this.originalAttributes);
        this.setBlockOpAttribute(ops, Paragraph.typeName);
        return ops;
    }
    toHtml(range) {
        return `<p>${(0,_Common_util__WEBPACK_IMPORTED_MODULE_1__.toHtml)(this, range)}</p>`;
    }
    /**
     * 在指定位置插入一个换行符
     */
    insertEnter(pos, attr) {
        const frame = (0,_Common_util__WEBPACK_IMPORTED_MODULE_1__.findChildInDocPos)(pos.index, this.children, true);
        if (!frame) {
            return null;
        }
        const layoutframe = frame.insertEnter({ index: pos.index - frame.start, inner: pos.inner }, attr);
        this.needLayout = true;
        if (layoutframe) {
            const newParagraph = new Paragraph();
            newParagraph.setWidth(this.width);
            newParagraph.addLast(layoutframe);
            this.calLength();
            return newParagraph;
        }
        this.calLength();
        return null;
    }
    /**
     * 渲染当前段落
     * @param viewHeight 整个画布的高度
     */
    draw(ctx, x, y, viewHeight) {
        this.head.draw(ctx, this.x + x, this.y + y, viewHeight - this.head.y);
        super.draw(ctx, x, y, viewHeight);
    }
    setAttributes(attr) {
        super.setAttributes(attr);
        if (this.head) {
            this.setFrameOverrideAttributes(this.head);
            this.setFrameOverrideDefaultAttributes(this.head);
        }
    }
    afterAdd(nodes, index, prevNode, nextNode, array) {
        super.afterAdd(nodes, index, prevNode, nextNode, array);
        nodes.forEach((node) => {
            this.setFrameOverrideAttributes(node);
            this.setFrameOverrideDefaultAttributes(node);
        });
    }
    afterRemove(nodes, index, prevNode, nextNode, array) {
        super.afterRemove(nodes, index, prevNode, nextNode, array);
        nodes.forEach((node) => {
            this.removeFrameOverrideAttributes(node);
            this.removeFrameOverrideDefaultAttributes(node);
        });
    }
    createSelf() {
        return new Paragraph();
    }
    formatSelf(attr, range) {
        this.setAttributes(attr);
    }
    setFrameOverrideAttributes(frame) {
        const overrideAttributes = this.getOverrideAttributes();
        if (Object.keys(overrideAttributes).length > 0) {
            frame.setOverrideAttributes(overrideAttributes);
        }
    }
    removeFrameOverrideAttributes(frame) {
        const emptyAttr = this.getOverrideAttributes();
        Object.keys(emptyAttr).forEach((key) => {
            emptyAttr[key] = undefined;
        });
        frame.setOverrideAttributes(emptyAttr);
    }
    getOverrideAttributes() {
        const attr = {};
        switch (this.attributes.title) {
            case _Common_EnumTextStyle__WEBPACK_IMPORTED_MODULE_3__.EnumTitle.Text:
                attr.bold = undefined;
                attr.size = undefined;
                attr.linespacing = undefined;
                break;
            case _Common_EnumTextStyle__WEBPACK_IMPORTED_MODULE_3__.EnumTitle.Title:
                attr.bold = true;
                attr.size = 20;
                attr.linespacing = 2;
                break;
            case _Common_EnumTextStyle__WEBPACK_IMPORTED_MODULE_3__.EnumTitle.Subtitle:
                attr.bold = true;
                attr.size = 18;
                attr.linespacing = 2;
                break;
            case _Common_EnumTextStyle__WEBPACK_IMPORTED_MODULE_3__.EnumTitle.H1:
                attr.bold = true;
                attr.size = 16;
                break;
            case _Common_EnumTextStyle__WEBPACK_IMPORTED_MODULE_3__.EnumTitle.H2:
                attr.bold = true;
                attr.size = 14;
                break;
            case _Common_EnumTextStyle__WEBPACK_IMPORTED_MODULE_3__.EnumTitle.H3:
                attr.bold = true;
                attr.size = 13;
                break;
            case _Common_EnumTextStyle__WEBPACK_IMPORTED_MODULE_3__.EnumTitle.H4:
                attr.bold = true;
                attr.size = 12;
                break;
        }
        return attr;
    }
    setFrameOverrideDefaultAttributes(frame) {
        if (this.attributes.title === _Common_EnumTextStyle__WEBPACK_IMPORTED_MODULE_3__.EnumTitle.Subtitle) {
            frame.setOverrideDefaultAttributes({ color: '#888' });
        }
        else {
            frame.setOverrideDefaultAttributes({ color: undefined });
        }
    }
    removeFrameOverrideDefaultAttributes(frame) {
        if (this.attributes.title === _Common_EnumTextStyle__WEBPACK_IMPORTED_MODULE_3__.EnumTitle.Subtitle) {
            frame.setOverrideDefaultAttributes({ color: undefined });
        }
    }
}
Paragraph.typeName = 'para';


/***/ }),

/***/ "./src/Block/ParagraphAttributes.ts":
/*!******************************************!*\
  !*** ./src/Block/ParagraphAttributes.ts ***!
  \******************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ParagraphDefaultAttributes": function() { return /* binding */ paragraphDefaultAttributes; }
/* harmony export */ });
/* harmony import */ var _Common_EnumTextStyle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Common/EnumTextStyle */ "./src/Common/EnumTextStyle.ts");

const paragraphDefaultAttributes = {
    title: _Common_EnumTextStyle__WEBPACK_IMPORTED_MODULE_0__.EnumTitle.Text,
};



/***/ }),

/***/ "./src/Block/QuoteBlock.ts":
/*!*********************************!*\
  !*** ./src/Block/QuoteBlock.ts ***!
  \*********************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QUOTE_BLOCK_CONTENT_COLOR": function() { return /* binding */ QUOTE_BLOCK_CONTENT_COLOR; },
/* harmony export */   "QuoteBlock": function() { return /* binding */ QuoteBlock; }
/* harmony export */ });
/* harmony import */ var _BlockCommon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./BlockCommon */ "./src/Block/BlockCommon.ts");
/* harmony import */ var _Common_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Common/util */ "./src/Common/util.ts");


const QUOTE_BLOCK_CONTENT_COLOR = '#A5A5A5';
class QuoteBlock extends _BlockCommon__WEBPACK_IMPORTED_MODULE_0__.BlockCommon {
    constructor() {
        super(...arguments);
        this.needMerge = true;
        this.padding = 10;
    }
    readFromOps(Ops) {
        const frames = super.readOpsToLayoutFrame(Ops);
        this.addAll(frames);
        super.setFrameStart();
    }
    layout() {
        if (this.needLayout) {
            let currentFrame = null;
            let newWidth = 0;
            for (let i = 0, l = this.children.length; i < l; i++) {
                currentFrame = this.children[i];
                currentFrame.layout();
                currentFrame.x = 20;
                newWidth = Math.max(newWidth, currentFrame.x + currentFrame.width);
            }
            if (this.head !== null) {
                this.head.setPositionY(this.padding, true, true);
            }
            this.needLayout = false;
            let newHeight = 0;
            if (currentFrame !== null) {
                newHeight = currentFrame.y + currentFrame.height + this.padding;
            }
            this.setHeight(newHeight);
            if (this.nextSibling !== null) {
                this.nextSibling.setPositionY(this.y + this.height);
            }
        }
    }
    /**
     * 获取指定范围的矩形区域
     */
    getSelectionRectangles(start, end, correctByPosY) {
        let targetCorrectByPosY;
        if (typeof correctByPosY === 'number') {
            targetCorrectByPosY = Math.max(this.y + this.padding, correctByPosY);
            targetCorrectByPosY = Math.min(this.y + this.height - this.padding, targetCorrectByPosY);
        }
        const rects = super.getSelectionRectangles(start, end, targetCorrectByPosY);
        return rects;
    }
    toOp(withKey) {
        const res = [];
        for (let index = 0; index < this.children.length; index++) {
            const element = this.children[index];
            const layoutOps = element.toOp(withKey);
            res.push(...layoutOps);
        }
        this.setBlockOpAttribute(res, QuoteBlock.typeName);
        return res;
    }
    toHtml(range) {
        return `<blockquote>${(0,_Common_util__WEBPACK_IMPORTED_MODULE_1__.toHtml)(this, range)}</blockquote>`;
    }
    createSelf() {
        return new QuoteBlock();
    }
    afterAdd(nodes, index, prevNode, nextNode, array) {
        super.afterAdd(nodes, index, prevNode, nextNode, array);
        nodes.forEach((node) => {
            node.setOverrideDefaultAttributes({ color: QUOTE_BLOCK_CONTENT_COLOR });
        });
    }
    afterRemove(nodes, index, prevNode, nextNode, array) {
        super.afterRemove(nodes, index, prevNode, nextNode, array);
        nodes.forEach((node) => {
            node.setOverrideDefaultAttributes({ color: undefined });
        });
    }
    onPointerEnter(x, y, targetStack, currentTargetIndex) {
        super.onPointerEnter(x, y - this.padding, targetStack, currentTargetIndex);
    }
    onPointerMove(x, y, targetStack, currentTargetIndex) {
        super.onPointerMove(x, y - this.padding, targetStack, currentTargetIndex);
    }
    onPointerDown(x, y) {
        super.onPointerDown(x, y - this.padding);
    }
    onPointerUp(x, y) {
        super.onPointerUp(x, y - this.padding);
    }
    onPointerTap(x, y) {
        super.onPointerTap(x, y - this.padding);
    }
    /**
     * 渲染当前 quoteblock
     * @param viewHeight 整个画布的高度
     */
    draw(ctx, x, y, viewHeight) {
        for (let index = 0; index < this.children.length; index++) {
            const currentFrame = this.children[index];
            if (y + this.y + currentFrame.y + currentFrame.height >= 0 && currentFrame.y < viewHeight) {
                currentFrame.draw(ctx, this.x + x, this.y + y, viewHeight - currentFrame.y);
            }
        }
        ctx.fillStyle = '#f0f0f0';
        ctx.fillRect(this.x, this.y + this.padding + y, 5, this.height - this.padding * 2);
        super.draw(ctx, x, y, viewHeight);
    }
    /**
     * 给某个 layoutframe 设置最大宽度
     * @param node layoutframe
     */
    setChildrenMaxWidth(node) {
        node.setMaxWidth(this.width - 20);
    }
}
QuoteBlock.typeName = 'quote';


/***/ }),

/***/ "./src/Block/Table.ts":
/*!****************************!*\
  !*** ./src/Block/Table.ts ***!
  \****************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Table": function() { return /* binding */ Table; }
/* harmony export */ });
/* harmony import */ var _Block__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Block */ "./src/Block/Block.ts");
/* harmony import */ var _TableRow__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./TableRow */ "./src/Block/TableRow.ts");
/* harmony import */ var _Common_LinkedList__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Common/LinkedList */ "./src/Common/LinkedList.ts");
/* harmony import */ var _Common_IPointerInteractive__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Common/IPointerInteractive */ "./src/Common/IPointerInteractive.ts");
/* harmony import */ var quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! quill-delta-enhanced */ "quill-delta-enhanced");
/* harmony import */ var quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _TableAttributes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./TableAttributes */ "./src/Block/TableAttributes.ts");
/* harmony import */ var _Common_util__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../Common/util */ "./src/Common/util.ts");
/* harmony import */ var _TableCell__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./TableCell */ "./src/Block/TableCell.ts");
/* harmony import */ var _Common_EnumCursorType__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../Common/EnumCursorType */ "./src/Common/EnumCursorType.ts");
/* harmony import */ var _Common_DocPos__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../Common/DocPos */ "./src/Common/DocPos.ts");
/* harmony import */ var _Common_IAttributable__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../Common/IAttributable */ "./src/Common/IAttributable.ts");
/* harmony import */ var _Common_IBubbleUpable__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../Common/IBubbleUpable */ "./src/Common/IBubbleUpable.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var Table_1;












let Table = Table_1 = class Table extends _Block__WEBPACK_IMPORTED_MODULE_0__.Block {
    constructor() {
        super(...arguments);
        this.needCorrectSelectionPos = true;
        this.children = [];
        this.head = null;
        this.tail = null;
        this.attributes = Object.assign({}, _TableAttributes__WEBPACK_IMPORTED_MODULE_5__.TableDefaultAttributes);
        this.defaultAttributes = _TableAttributes__WEBPACK_IMPORTED_MODULE_5__.TableDefaultAttributes;
        this.overrideDefaultAttributes = null;
        this.originalAttributes = null;
        this.overrideAttributes = null;
        this.length = 1;
        this.canMerge = false;
        this.canBeMerge = false;
    }
    static create(rowCount, colCount, tableWidth) {
        const table = new Table_1();
        for (let i = 0; i < rowCount; i++) {
            const row = new _TableRow__WEBPACK_IMPORTED_MODULE_1__.TableRow();
            for (let j = 0; j < colCount; j++) {
                const cell = _TableCell__WEBPACK_IMPORTED_MODULE_7__.TableCell.create();
                row.addLast(cell);
                cell.parent = row;
            }
            table.addLast(row);
            row.parent = table;
        }
        const colWidth = Math.floor(tableWidth / colCount);
        table.setAttributes({
            width: tableWidth,
            colWidth: [...Array(colCount - 1).fill(colWidth), tableWidth - colWidth * (colCount - 1)],
        });
        return table;
    }
    readFromOps(Ops) {
        var _a;
        // table 的 op 只会有一条，所以直接取第一条
        const delta = Ops[0].insert;
        if ((_a = Ops[0]) === null || _a === void 0 ? void 0 : _a.attributes) {
            this.setAttributes(Ops[0].attributes);
        }
        const rows = delta.ops.map((op) => {
            const row = new _TableRow__WEBPACK_IMPORTED_MODULE_1__.TableRow();
            row.readFromOps([op]);
            return row;
        });
        this.addAll(rows);
        rows.forEach((row) => {
            row.parent = this;
        });
    }
    destroy() {
        for (let index = 0; index < this.children.length; index++) {
            const row = this.children[index];
            row.destroy();
        }
    }
    layout() {
        if (!this.needLayout) {
            return;
        }
        const currentColWidth = this.attributes.colWidth.map((width) => {
            return {
                width,
                span: 0,
            };
        });
        const rowSpanCell = new Map();
        for (let rowIndex = 0, l = this.children.length; rowIndex < l; rowIndex++) {
            let rowMinContentHeight = 0;
            const currentRow = this.children[rowIndex];
            currentRow.width = this.width;
            const minusCol = Array(currentColWidth.length).fill(0);
            let cellIndex = 0;
            let currentCellX = 0;
            if (currentRow.children.length > 0) {
                for (let i = 0, l = currentColWidth.length; i < l; i++) {
                    if (currentColWidth[i].span === 0) {
                        const currentCell = currentRow.children[cellIndex];
                        currentCell.GridRowPos = rowIndex;
                        currentCell.GridColPos = i;
                        currentCell.isLastCell = i + currentCell.attributes.colSpan === currentColWidth.length;
                        currentCell.isFirstCell = i === 0;
                        currentCell.isFirstLine = currentRow.prevSibling === null;
                        currentCell.isLastLine = rowIndex + currentCell.attributes.rowSpan === this.children.length;
                        currentCell.x = currentCellX;
                        let cellWidth = 0;
                        const widthIndex = i;
                        for (let j = 0; j < currentCell.attributes.colSpan; j++) {
                            cellWidth += currentColWidth[widthIndex + j].width;
                            i++;
                        }
                        i--;
                        currentCell.setWidth(cellWidth);
                        currentCell.layout();
                        if (currentCell.attributes.rowSpan > 1) {
                            for (let j = 0; j < currentCell.attributes.colSpan; j++) {
                                minusCol[widthIndex + j] += currentCell.attributes.rowSpan;
                            }
                            const targetRowSpanCollection = rowSpanCell.get(rowIndex + currentCell.attributes.rowSpan - 1);
                            if (!targetRowSpanCollection) {
                                rowSpanCell.set(rowIndex + currentCell.attributes.rowSpan - 1, [currentCell]);
                            }
                            else {
                                targetRowSpanCollection.push(currentCell);
                            }
                        }
                        else {
                            rowMinContentHeight = Math.max(rowMinContentHeight, currentCell.contentHeight);
                        }
                        currentCellX += cellWidth;
                        cellIndex++;
                    }
                    else {
                        currentCellX += currentColWidth[i].width;
                    }
                }
            }
            currentColWidth.forEach((colWidthItem, index) => {
                colWidthItem.span = Math.max(0, colWidthItem.span - 1 + minusCol[index]);
            });
            const spanCells = rowSpanCell.get(rowIndex);
            if (spanCells && spanCells.length > 0) {
                let offsetHeight = 0;
                spanCells.forEach((cell) => {
                    const cellOffsetHeight = cell.contentHeight -
                        this.sumRowHeight(rowIndex - cell.attributes.rowSpan + 1, rowIndex - 1) -
                        rowMinContentHeight;
                    if (cellOffsetHeight > offsetHeight) {
                        offsetHeight = cellOffsetHeight;
                    }
                });
                if (offsetHeight > 0) {
                    rowMinContentHeight += offsetHeight;
                }
            }
            currentRow.setContentMinHeight(rowMinContentHeight);
            const rowHeight = Math.max(rowMinContentHeight, currentRow.attributes.height);
            currentRow.setHeight(rowHeight);
            for (let i = 0; i < currentRow.children.length; i++) {
                const cell = currentRow.children[i];
                if (cell.attributes.rowSpan === 1) {
                    currentRow.children[i].setHeight(rowHeight);
                }
            }
            if (spanCells && spanCells.length > 0) {
                spanCells.forEach((cell) => {
                    cell.setHeight(this.sumRowHeight(rowIndex - cell.attributes.rowSpan + 1, rowIndex));
                });
            }
        }
        // 再设置每行的 y 坐标
        if (this.head) {
            this.head.setPositionY(0, true, true);
        }
        this.needLayout = false;
        if (this.tail !== null) {
            this.setHeight(this.tail.y + this.tail.height);
        }
        if (this.nextSibling !== null) {
            this.nextSibling.setPositionY(this.y + this.height);
        }
    }
    getCursorType() {
        return _Common_EnumCursorType__WEBPACK_IMPORTED_MODULE_8__.EnumCursorType.RowResize;
    }
    search(keywords) {
        const res = [];
        for (let rowIndex = 0; rowIndex < this.children.length; rowIndex++) {
            const row = this.children[rowIndex];
            for (let cellIndex = 0; cellIndex < row.children.length; cellIndex++) {
                const cell = row.children[cellIndex];
                const cellSearchRes = cell.search(keywords);
                for (let resIndex = 0; resIndex < cellSearchRes.length; resIndex++) {
                    const cellRes = cellSearchRes[resIndex];
                    res.push({
                        pos: {
                            index: this.start,
                            inner: {
                                index: rowIndex,
                                inner: {
                                    index: cellIndex,
                                    inner: cellRes.pos,
                                },
                            },
                        },
                        rects: cellRes.rects.map((rect) => {
                            return {
                                x: rect.x + cell.x + row.x + this.x,
                                y: rect.y + cell.y + row.y + this.y,
                                width: rect.width,
                                height: rect.height,
                            };
                        }),
                    });
                }
            }
        }
        return res;
    }
    correctSelectionPos(start, end) {
        // 注意传入的参数 start 和 end 在 delta 层面都是没有进入 table 的
        let targetStart = start;
        let targetEnd = end;
        const res = [];
        // start、end 分为四种情况，要分别处理
        if (targetStart !== null && targetEnd !== null) {
            if (targetStart.inner === null && targetEnd.inner === null) {
                res.push({
                    start: targetStart,
                    end: targetEnd,
                });
            }
            else if (targetStart.inner === null && targetEnd.inner !== null) {
                // 说明从表格最前面开始，到指定行结束，选中所有相关行
                res.push({
                    start: { index: 0, inner: null },
                    end: { index: targetEnd.index + (targetEnd.inner ? 1 : 0), inner: null },
                });
            }
            else if (targetStart.inner !== null && targetEnd.inner !== null) {
                targetStart = targetStart.inner;
                targetEnd = targetEnd.inner;
                // start 和 end 都有可能只到 row 这一层或者只到 cell 这一层，或者进入到 cell 内部，所以这里逻辑比较复杂
                const startRowPos = targetStart ? targetStart.index : 0;
                const endRowPos = targetEnd ? targetEnd.index : 0;
                // 在 row 这一层，如果 start 或 end 没有继续深入，就直接选中所有涉及的 row
                if (targetStart.inner === null || targetEnd.inner === null) {
                    if ((0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_9__.compareDocPos)(targetStart, targetEnd) === 0) {
                        const pos = {
                            index: 0,
                            inner: { index: startRowPos, inner: { index: 0, inner: { index: 0, inner: null } } },
                        };
                        res.push({
                            start: pos,
                            end: pos,
                        });
                    }
                    else {
                        res.push({
                            start: { index: 0, inner: { index: startRowPos, inner: null } },
                            end: { index: 0, inner: { index: endRowPos + (targetEnd.inner ? 1 : 0), inner: null } },
                        });
                    }
                }
                else {
                    // 进入这个分支，说明 start 和 end 都深入到了 cell 这一层
                    const startRowData = targetStart.inner;
                    const endRowData = targetEnd.inner;
                    // 都不是 null，表示选取的开始位置和结束位置都在表格内部
                    // 这时又分为 3 种情况：跨行、同行跨单元格、单元格内
                    // 注意这里还要考虑起始点在表格的内边框上的场景
                    const startCellPos = startRowData.index;
                    const endCellPos = endRowData.index;
                    if (startRowPos !== endRowPos) {
                        // 跨行，这种情况最复杂
                        // 比如选区从第 1 行第 1 个单元格开始，到第 2 行第 2 个单元格结束
                        // 则实际选中 4 个单元格，第 1 行的第 1、2 两个单元格和第 2 行的第 1、2 两个单元格
                        // 计算的大致逻辑是，先根据 startRowPos、endRowPos、startCellPos、endCellPos 计算出选区的 grid 范围
                        // 然后根据 grid 范围分别计算每一行的选区用 DocPos 表示的范围
                        // 先计算 grid 范围
                        const startRow = this.children[startRowPos];
                        const endRow = this.children[endRowPos];
                        const startCellGridColPosTemp = startRow.children[Math.min(startCellPos, startRow.children.length - 1)].GridColPos;
                        const endCellGridColPosTemp = endRow.children[Math.min(endCellPos, endRow.children.length - 1)].GridColPos;
                        const startCellGridColPos = Math.min(startCellGridColPosTemp, endCellGridColPosTemp);
                        const endCellGridColPos = Math.max(startCellGridColPosTemp, endCellGridColPosTemp);
                        for (let i = startRowPos; i <= endRowPos; i++) {
                            const currentRow = this.children[i];
                            let startCellIndex = null;
                            let endCellIndex = null;
                            for (let j = 0; j < currentRow.children.length; j++) {
                                const currentCell = currentRow.children[j];
                                const currentCellGridColEndPos = currentCell.GridColPos + currentCell.attributes.colSpan - 1;
                                if ((currentCell.GridColPos <= startCellGridColPos && startCellGridColPos <= currentCellGridColEndPos) ||
                                    (currentCell.GridColPos <= endCellGridColPos && endCellGridColPos <= currentCellGridColEndPos) ||
                                    (startCellGridColPos <= currentCell.GridColPos && currentCellGridColEndPos <= endCellGridColPos)) {
                                    if (startCellIndex === null) {
                                        startCellIndex = j;
                                    }
                                    endCellIndex = j;
                                }
                                else if (startCellIndex !== null && endCellIndex !== null) {
                                    break;
                                }
                            }
                            if (startCellIndex !== null && endCellIndex !== null) {
                                res.push({
                                    start: { index: 0, inner: { index: i, inner: { index: startCellIndex, inner: null } } },
                                    end: {
                                        index: 0,
                                        inner: {
                                            index: i,
                                            inner: { index: (endRowData === null || endRowData === void 0 ? void 0 : endRowData.inner) ? endCellIndex + 1 : endCellIndex, inner: null },
                                        },
                                    },
                                });
                            }
                        }
                    }
                    else {
                        // 如果是同一行就看是直接选中涉及的单元格还是选中单元格中的内容
                        const finalCellPos = endCellPos + (endRowData.inner ? 1 : 0);
                        if ((0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_9__.compareDocPos)(targetStart, targetEnd) === 0 && targetStart.inner === null) {
                            const pos = {
                                index: 0,
                                inner: { index: startRowPos, inner: { index: startCellPos, inner: { index: 0, inner: null } } },
                            };
                            res.push({
                                start: pos,
                                end: pos,
                            });
                        }
                        else if (startCellPos !== endCellPos) {
                            // 跨单元格，选中 startCellPos 到 endCellPos 的所有单元格
                            if (startCellPos === 0 && finalCellPos === this.children[startRowPos].children.length) {
                                // 如果选中了这一行的所有单元格就直接选中这一行
                                res.push({
                                    start: { index: 0, inner: { index: startRowPos, inner: null } },
                                    end: { index: 0, inner: { index: startRowPos + 1, inner: null } },
                                });
                            }
                            else {
                                res.push({
                                    start: { index: 0, inner: { index: startRowPos, inner: { index: startCellPos, inner: null } } },
                                    end: { index: 0, inner: { index: startRowPos, inner: { index: finalCellPos, inner: null } } },
                                });
                            }
                        }
                        else {
                            // 同一单元格内则不需要做什么改动，直接原样返回
                            res.push({
                                start: { index: 0, inner: targetStart },
                                end: { index: 0, inner: targetEnd },
                            });
                        }
                    }
                }
            }
            else {
                // 进入这个分支表示 start 不是 null 而 end 是 null，按理说不会出现这个场景，因为 start 和 end 是排序过的
                console.warn('end should not be null while start is null');
                res.push({
                    start: { index: 0, inner: null },
                    end: { index: 0, inner: null },
                });
            }
        }
        else if (targetEnd !== null) {
            // start 是 null，end 不是 null，说明选区是从当前表格之前开始的，则直接选中 end 所在的整行
            targetEnd = targetEnd.inner;
            if (targetEnd !== null) {
                const rowPos = targetEnd.index;
                const finalRowPos = targetEnd.inner ? rowPos + 1 : rowPos;
                if (finalRowPos >= this.children.length) {
                    res.push({
                        start: null,
                        end: { index: 1, inner: null },
                    });
                }
                else {
                    res.push({
                        start: null,
                        end: {
                            index: 0,
                            inner: {
                                index: finalRowPos,
                                inner: null,
                            },
                        },
                    });
                }
            }
            else {
                // 如果此时 end === null，就不选中任何一行
                res.push({
                    start: null,
                    end: { index: 0, inner: null },
                });
            }
        }
        else if (targetStart !== null) {
            targetStart = targetStart.inner;
            // end 是 null，start 不是 null，说明选区是从当前表格开始，切结束位置在当前表格之后，则需要选中 start 所在的行
            if (targetStart !== null) {
                const rowPos = targetStart.index;
                if (rowPos <= 0) {
                    res.push({
                        start: { index: 0, inner: null },
                        end: null,
                    });
                }
                else {
                    res.push({
                        start: { index: 0, inner: { index: rowPos, inner: null } },
                        end: null,
                    });
                }
            }
            else {
                // 如果此时 start === null，就是从表格的第一行开始选择
                res.push({
                    start: { index: 0, inner: null },
                    end: null,
                });
            }
        }
        else {
            // start、end 都是 null，理论上来说不应该进入这个分支
            console.warn('start and end should not be null at same time');
        }
        return res;
    }
    getDocumentPos(x, y, start) {
        // 注意 start 参数为 true 的时候表示即将要开始建立选区，而如果当前鼠标正指向表格的边框
        // 是不可以开始建立选区的，因为这时用户按下鼠标是要调整边框位置，比如调整行高或列宽
        // 所以这个时候要返回 null，以避免开始建立选区
        const targetX = x - this.x;
        const targetY = y - this.y;
        // 这个方法和下面的 getChildrenStackByPos 方法实现很类似
        let res = null;
        let findRow = null;
        let findCell = null;
        let rowIndex = 0;
        let cellIndex = 0;
        for (; rowIndex < this.children.length; rowIndex++) {
            cellIndex = 0;
            const row = this.children[rowIndex];
            for (; cellIndex < row.children.length; cellIndex++) {
                const cell = row.children[cellIndex];
                if ((0,_Common_util__WEBPACK_IMPORTED_MODULE_6__.isPointInRectangle)(targetX - row.x, targetY - row.y, cell)) {
                    findRow = row;
                    findCell = cell;
                    break;
                }
            }
            if (findCell) {
                break;
            }
            else if ((0,_Common_util__WEBPACK_IMPORTED_MODULE_6__.isPointInRectangle)(targetX, targetY, Object.assign(Object.assign({}, row), { height: row.height }))) {
                findRow = row;
                break;
            }
        }
        if (findCell && findRow) {
            const cellInnerPos = findCell.getDocumentPos(targetX - findRow.x - findCell.x, targetY - findRow.y - findCell.y);
            const rowInnerPos = {
                index: cellIndex,
                inner: cellInnerPos,
            };
            const tableInnerPos = {
                index: rowIndex,
                inner: rowInnerPos,
            };
            res = {
                index: 0,
                inner: tableInnerPos,
            };
        }
        else if (findRow && !start) {
            // 只找到了行，还要看当前位置是在哪个单元格的后面
            let findCellIndex = findRow.children.length - 1;
            for (; findCellIndex >= 0; findCellIndex--) {
                const cell = findRow.children[findCellIndex];
                if (targetX >= cell.x + cell.width) {
                    break;
                }
            }
            res = {
                index: 0,
                inner: {
                    index: rowIndex,
                    inner: {
                        index: findCellIndex + 1,
                        inner: null,
                    },
                },
            };
        }
        else if (!start) {
            // 只找到了 table，还要看当前是在哪一行后面
            let findRowIndex = this.children.length - 1;
            for (; findRowIndex >= 0; findRowIndex--) {
                const row = this.children[findRowIndex];
                if (targetY >= row.y + row.height) {
                    break;
                }
            }
            res = { index: 0, inner: { index: findRowIndex + 1, inner: null } };
        }
        return res;
    }
    getSelectionRectangles(start, end, correctByPosY) {
        if (start.index === 0 && start.inner === null) {
            // 如果开始位置是从表格前面开始
            if (end.index >= 1) {
                // 如果结束位置在表格后面
                // 选中整个表格
                return [
                    {
                        x: this.x,
                        y: this.y,
                        width: this.width,
                        height: this.height,
                    },
                ];
            }
            else if (end.index === 0 && end.inner !== null) {
                // 如果结束位置在表格中间
                // 就看结束位置在第几行，这种情况下只能只能整行选中
                let rowCount = end.inner.index;
                if (end.inner.inner !== null) {
                    rowCount += 1;
                }
                if (rowCount === this.children.length) {
                    return [
                        {
                            x: this.x,
                            y: this.y,
                            width: this.width,
                            height: this.height,
                        },
                    ];
                }
                else {
                    const res = [];
                    for (let rowIndex = 0; rowIndex < rowCount; rowIndex++) {
                        const row = this.children[rowIndex];
                        for (let cellIndex = 0; cellIndex < row.children.length; cellIndex++) {
                            const cell = row.children[cellIndex];
                            res.push({
                                x: this.x + row.x + cell.x,
                                y: this.y + row.y + cell.y,
                                width: cell.width,
                                height: cell.height,
                            });
                        }
                    }
                    return res;
                }
            }
        }
        else if (start.index === 0 && start.inner !== null) {
            // 如果开始位置是从表格中间
            if (end.index >= 1) {
                // 如果结束位置在表格后面
                // 就看开始位置在第几行，这种情况下只能只能整行选中
                const rowStartIndex = start.inner.index;
                if (rowStartIndex === 0) {
                    return [
                        {
                            x: this.x,
                            y: this.y,
                            width: this.width,
                            height: this.height,
                        },
                    ];
                }
                else {
                    const res = [];
                    for (let rowIndex = rowStartIndex; rowIndex < this.children.length; rowIndex++) {
                        const row = this.children[rowIndex];
                        for (let cellIndex = 0; cellIndex < row.children.length; cellIndex++) {
                            const cell = row.children[cellIndex];
                            res.push({
                                x: this.x + row.x + cell.x,
                                y: this.y + row.y + cell.y,
                                width: cell.width,
                                height: cell.height,
                            });
                        }
                    }
                    return res;
                }
            }
            else if (end.index === 0 && end.inner !== null) {
                // 这里要么是整行选中，要么是选中若干个单元格，要么是在单元格内部选中部分内容
                // 所以 start 和 end 的数据结构层级深度应该是一样的
                const startRowPos = start.inner.index;
                const endRowPos = end.inner.index;
                const res = [];
                if (start.inner.inner === null && end.inner.inner === null) {
                    // 如果是整行选中
                    for (let rowIndex = startRowPos; rowIndex < endRowPos; rowIndex++) {
                        const row = this.children[rowIndex];
                        for (let cellIndex = 0; cellIndex < row.children.length; cellIndex++) {
                            const cell = row.children[cellIndex];
                            res.push({
                                x: this.x + row.x + cell.x,
                                y: this.y + row.y + cell.y,
                                width: cell.width,
                                height: cell.height,
                            });
                        }
                    }
                }
                else if (start.inner.inner !== null &&
                    end.inner.inner !== null &&
                    start.inner.inner.inner === null &&
                    end.inner.inner.inner === null) {
                    // 如果是选中若干个单元格
                    const startCellPos = start.inner.inner.index;
                    const endCellPos = end.inner.inner.index;
                    for (let rowIndex = startRowPos; rowIndex <= endRowPos; rowIndex++) {
                        const row = this.children[rowIndex];
                        for (let cellIndex = startCellPos; cellIndex < endCellPos; cellIndex++) {
                            const cell = row.children[cellIndex];
                            res.push({
                                x: this.x + row.x + cell.x,
                                y: this.y + row.y + cell.y,
                                width: cell.width,
                                height: cell.height,
                            });
                        }
                    }
                }
                else if (start.inner.inner !== null &&
                    end.inner.inner !== null &&
                    start.inner.inner.inner !== null &&
                    end.inner.inner.inner !== null) {
                    // 选中单元格中的某段内容
                    // 这个时候 start 的 cell index 和 end 的 cell index 肯定是一样的
                    const cellPos = start.inner.inner.index;
                    const startCellContentPos = start.inner.inner.inner;
                    const endCellContentPos = end.inner.inner.inner;
                    const row = this.children[startRowPos];
                    const cell = row.children[cellPos];
                    const rects = cell
                        .getSelectionRectangles(startCellContentPos, endCellContentPos, correctByPosY)
                        .map((rect) => {
                        return {
                            x: rect.x + cell.x + row.x + this.x,
                            y: rect.y + cell.y + row.y + this.y,
                            width: rect.width,
                            height: rect.height,
                        };
                    });
                    res.push(...rects);
                }
                return res;
            }
        }
        return [];
    }
    getChildrenStackByPos(x, y) {
        // 表格这里的实现和其他类有很大的区别，因为表格的 cell 会跨行，所以不能按照层级先在行里面找再在列里面找
        // 而要直接遍历所有的 cell，看命中哪个 cell，再反推出 row
        let findRow = null;
        let findCell = null;
        for (let rowIndex = 0; rowIndex < this.children.length; rowIndex++) {
            const row = this.children[rowIndex];
            for (let cellIndex = 0; cellIndex < row.children.length; cellIndex++) {
                const cell = row.children[cellIndex];
                if ((0,_Common_util__WEBPACK_IMPORTED_MODULE_6__.isPointInRectangle)(x - row.x, y - row.y, cell)) {
                    findRow = row;
                    findCell = cell;
                    break;
                }
            }
            if (findCell) {
                break;
            }
            else if ((0,_Common_util__WEBPACK_IMPORTED_MODULE_6__.isPointInRectangle)(x, y, row)) {
                findRow = row;
            }
        }
        let res = [];
        if (findCell && findRow) {
            res = findCell.getChildrenStackByPos(x - findRow.x - findCell.x, y - findRow.y - findCell.y);
        }
        if (findRow) {
            res.unshift(findRow);
        }
        res.unshift(this);
        return res;
    }
    toOp(withKey) {
        const rowOps = this.children.map((row) => row.toOp(withKey));
        const res = {
            insert: new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_4___default())(rowOps),
            attributes: { block: 'table' },
        };
        if (withKey) {
            res.key = this.id;
        }
        if (this.originalAttributes && Object.keys(this.originalAttributes).length > 0) {
            Object.assign(res.attributes, this.originalAttributes);
        }
        return [res];
    }
    toHtml(selection) {
        console.log('toHtml not implement');
        return '';
    }
    toText(selection) {
        return '';
    }
    insertText(content, pos, attr) {
        // 先看 pos 能不能落在某个单元格内，如果可以就调用这个单元格的 insertText 方法，否则就什么都不做并返回 false
        const posElement = this.getPosElement(pos);
        if (posElement.cell && posElement.posInCell) {
            posElement.cell.insertText(content, posElement.posInCell, attr);
            posElement.cell.setNeedToLayout();
            this.needLayout = true;
            return true;
        }
        else {
            return false;
        }
    }
    insertEnter(pos, attr) {
        const posElement = this.getPosElement(pos);
        if (posElement.cell) {
            posElement.cell.insertEnter(posElement.posInCell, attr);
        }
        this.needLayout = true;
        return null;
    }
    insertBlock(block, pos) {
        const posElement = this.getPosElement(pos);
        if (posElement.cell) {
            posElement.cell.insertBlock(block, posElement.posInCell);
        }
        this.needLayout = true;
        return [];
    }
    insertFragment(frag, pos) {
        const posElement = this.getPosElement(pos);
        if (posElement.cell) {
            posElement.cell.insertFragment(frag, posElement.posInCell);
        }
        this.needLayout = true;
    }
    getFormat(range) {
        var _a, _b;
        let res = {};
        if (!range) {
            res = (0,_Common_util__WEBPACK_IMPORTED_MODULE_6__.getFormat)(this);
        }
        else if (((_a = range.start) === null || _a === void 0 ? void 0 : _a.inner) && ((_b = range.end) === null || _b === void 0 ? void 0 : _b.inner)) {
            res = (0,_Common_util__WEBPACK_IMPORTED_MODULE_6__.getFormat)(this, [
                {
                    start: range.start.inner,
                    end: range.end.inner,
                },
            ]);
        }
        else {
            res = {};
        }
        (0,_Common_util__WEBPACK_IMPORTED_MODULE_6__.collectAttributes)(this.attributes, res);
        return res;
    }
    format(attr, range) {
        let rangeInRow;
        if (range) {
            if (range.start.inner && range.end.inner) {
                // 如果 range 存在，range 的 start 的 inner 和 end 的 inner 一定不能是 null
                rangeInRow = { start: range.start.inner, end: range.end.inner };
            }
            else {
                return;
            }
        }
        (0,_Common_util__WEBPACK_IMPORTED_MODULE_6__.format)(this, attr, rangeInRow);
        this.needLayout = true;
    }
    clearFormat(range) {
        let rangeInRow;
        if (range) {
            if (range.start.inner && range.end.inner) {
                // 如果 range 存在，range 的 start 的 inner 和 end 的 inner 一定不能是 null
                rangeInRow = { start: range.start.inner, end: range.end.inner };
            }
            else {
                return;
            }
        }
        (0,_Common_util__WEBPACK_IMPORTED_MODULE_6__.clearFormat)(this, rangeInRow);
        this.needLayout = true;
    }
    delete(range, forward) {
        var _a, _b;
        const { start, end } = range;
        // 如果 是光标模式，就调用光标所在单元格的 delete 方法
        // 如果是选择范围的模式，就要判断这个范围是不是落在同一个单元格内，如果是就还是调用单元格的 delete 方法，否则就删除范围内所有单元格的内容
        // 先看 pos 能不能落在某个单元格内，如果可以就调用这个单元格的 delete 方法，否则就什么都不做并返回 false
        const startPosElement = this.getPosElement(start);
        const endPosElement = this.getPosElement(end);
        // 分 同行同格，同行不同格，选中整行 3 种情况
        if (startPosElement.row === endPosElement.row && startPosElement.cell !== null && endPosElement.cell === null) {
            // 选中整行，清空这些行中的内容
            (_a = startPosElement.row) === null || _a === void 0 ? void 0 : _a.children.forEach((c) => c.clearContent());
        }
        else if (startPosElement.cell === endPosElement.cell && startPosElement.cell !== null) {
            // 如果删除区域在同一个单元格内走 DocContent 的删除逻辑
            const rangeInRow = { start: start.inner, end: end.inner };
            const rangeInCell = { start: rangeInRow.start.inner, end: rangeInRow.end.inner };
            const rangeInDocContent = { start: rangeInCell.start.inner, end: rangeInCell.end.inner };
            const targetCell = endPosElement.cell;
            targetCell.delete([rangeInDocContent], forward);
        }
        else {
            // 如果删除区域垮单元格，则清空所有区域内单元格的内容
            let currentCell = startPosElement.cell;
            while (currentCell) {
                currentCell.clearContent();
                if (currentCell !== ((_b = endPosElement.cell) === null || _b === void 0 ? void 0 : _b.prevSibling)) {
                    currentCell = currentCell.nextSibling;
                }
                else {
                    break;
                }
            }
        }
        this.needLayout = true;
    }
    getAllLayoutFrames() {
        console.log('getAllLayoutFrames not implement');
        return [];
    }
    merge(target) {
        console.log('merge not implement');
    }
    setColWidth(width, index) {
        var _a;
        if (Array.isArray(width)) {
            this.setAttributes({ colWidth: width });
        }
        else if (typeof width === 'number' && typeof index === 'number') {
            const oldColWidth = ((_a = this.originalAttributes) === null || _a === void 0 ? void 0 : _a.colWidth) || [];
            oldColWidth[index] = width;
            this.setAttributes({ colWidth: [...oldColWidth] });
        }
    }
    draw(ctx, x, y, viewHeight) {
        for (let index = 0; index < this.children.length; index++) {
            const row = this.children[index];
            // row 里面可能有单元格会跨行，所以就算 row 超过了屏幕上沿也要绘制
            if (row.y < viewHeight) {
                row.draw(ctx, this.x + x, this.y + y, viewHeight - row.y);
                row.drawBorder(ctx, this.x + x, this.y + y);
            }
        }
        // 绘制表格外边框
        const borderX = (0,_Common_util__WEBPACK_IMPORTED_MODULE_6__.findHalf)(this.x + x, 1);
        const borderY = (0,_Common_util__WEBPACK_IMPORTED_MODULE_6__.findHalf)(this.y + y, 1);
        ctx.strokeRect(borderX, borderY, Math.floor(this.width - (borderX - this.x - x)), Math.round(this.height));
        super.draw(ctx, x, y, viewHeight);
    }
    /**
     * 判断选区中的单元格能不能合并
     */
    canMergeCells(selection) {
        // 判断依据是选中的单元格的 GridRowPos 和 GridColPos 能不能构成一个矩形区域
        const selectedCells = [];
        for (let index = 0; index < selection.length; index++) {
            const range = selection[index];
            selectedCells.push(...this.getSelectedCell(range));
        }
        if (selectedCells.length <= 1) {
            return null;
        }
        // 判断选中的单元格是否组成一个矩形，如果是就可以合并
        let cornerCell = selectedCells[0];
        const cellMatrix = [];
        selectedCells.forEach((cell) => {
            var _a;
            for (let rowIndex = cell.GridRowPos; rowIndex < cell.GridRowPos + cell.attributes.rowSpan; rowIndex++) {
                for (let cellIndex = cell.GridColPos; cellIndex < cell.GridColPos + cell.attributes.colSpan; cellIndex++) {
                    cellMatrix[rowIndex] = (_a = cellMatrix[rowIndex]) !== null && _a !== void 0 ? _a : [];
                    cellMatrix[rowIndex][cellIndex] = 1;
                    // 同时找出最左上角的 cell
                    if (cornerCell.GridRowPos > cell.GridRowPos ||
                        (cornerCell.GridRowPos === cell.GridRowPos && cornerCell.GridColPos > cell.GridColPos)) {
                        cornerCell = cell;
                    }
                }
            }
        });
        let firstRow = null;
        for (let rowIndex = 0; rowIndex < cellMatrix.length; rowIndex++) {
            if (firstRow === null) {
                if (Array.isArray(cellMatrix[rowIndex])) {
                    firstRow = cellMatrix[rowIndex];
                }
                continue;
            }
            const row = cellMatrix[rowIndex];
            let match = row.length === firstRow.length;
            if (!match) {
                return null;
            }
            for (let cellIndex = 0; cellIndex < row.length; cellIndex++) {
                match = match && row[cellIndex] === firstRow[cellIndex];
                if (!match) {
                    break;
                }
            }
            if (!match) {
                return null;
            }
        }
        return { cornerCell, cells: selectedCells };
    }
    /**
     * 合并单元格
     */
    mergeCells(selection) {
        var _a;
        // 先获取所有选中的单元格，判断这些单元格能不能合并
        const data = this.canMergeCells(selection);
        let newRowSpan = 0;
        let newColSpan = 0;
        if (data) {
            const { cornerCell, cells } = data;
            for (let index = 0; index < cells.length; index++) {
                const cell = cells[index];
                if (cell !== cornerCell) {
                    newRowSpan = Math.max(newRowSpan, cell.GridRowPos + cell.attributes.rowSpan - cornerCell.GridRowPos);
                    newColSpan = Math.max(newColSpan, cell.GridColPos + cell.attributes.colSpan - cornerCell.GridColPos);
                    (_a = cell.parent) === null || _a === void 0 ? void 0 : _a.remove(cell);
                }
            }
            cornerCell.setAttributes({ rowSpan: newRowSpan, colSpan: newColSpan });
            this.needLayout = true;
            cornerCell.setNeedToLayout();
            return true;
        }
        else {
            return false;
        }
    }
    /**
     * 判断选区中的单元格能不能取消合并
     */
    canUnmergeCells(selection) {
        // 判断依据是选中的单元格只有一个，且该单元格是一个合并的单元格
        let targetCell;
        for (let index = 0; index < selection.length; index++) {
            const range = selection[index];
            const elementAtPosStart = this.getPosElement(range.start);
            const elementAtPosEnd = this.getPosElement(range.end);
            if (targetCell === undefined) {
                targetCell = elementAtPosStart.cell;
            }
            if (elementAtPosStart.cell === null || targetCell !== elementAtPosStart.cell) {
                return null;
            }
            if (elementAtPosEnd.cell === null || targetCell !== elementAtPosEnd.cell) {
                return null;
            }
        }
        return targetCell.attributes.colSpan > 1 || targetCell.attributes.rowSpan > 1 ? targetCell : null;
    }
    /**
     * 取消合并单元格
     */
    unmergeCells(selection) {
        const targetCell = this.canUnmergeCells(selection);
        if (!targetCell) {
            return false;
        }
        else {
            // 把所有内容都放到 target cell 范围最左上角的单元格中
            const rowStartIndex = targetCell.GridRowPos;
            const rowEndIndex = rowStartIndex + targetCell.attributes.rowSpan;
            const gridColPosStart = targetCell.GridColPos;
            const gridColPosEnd = gridColPosStart + targetCell.attributes.colSpan;
            for (let rowIndex = rowStartIndex; rowIndex < rowEndIndex; rowIndex++) {
                const currentRow = this.children[rowIndex];
                for (let gridColPos = gridColPosStart; gridColPos < gridColPosEnd; gridColPos++) {
                    if (rowIndex === rowStartIndex && gridColPos === gridColPosStart) {
                        targetCell.setAttributes({ colSpan: 1, rowSpan: 1 });
                        continue;
                    }
                    // 创建一个空 TableCell 并插入当前行的指定位置
                    const cell = _TableCell__WEBPACK_IMPORTED_MODULE_7__.TableCell.create();
                    currentRow.splice(currentRow.head ? Math.max(0, gridColPos - currentRow.head.GridColPos) : 0, 0, [cell]);
                }
            }
            this.needLayout = true;
            return true;
        }
    }
    getSelectedCell(range) {
        const elementAtPosStart = this.getPosElement(range.start);
        const elementAtPosEnd = this.getPosElement(range.end);
        // 这里 elementAtPosStart 有三种情况，row === null、cell === null、posInCell === null
        if (elementAtPosStart.row === null &&
            elementAtPosEnd.row === null &&
            range.start.index === 0 &&
            range.end.index === 1) {
            // 选中整个表格
            return this.children.reduce((allCells, row) => {
                allCells.push(...row.children);
                return allCells;
            }, []);
        }
        else if (elementAtPosStart.cell === null && elementAtPosEnd.cell === null) {
            // 选中了若干行
            const res = [];
            let currentRow = elementAtPosStart.row;
            while (currentRow) {
                res.push(...currentRow.children);
                if (currentRow.nextSibling === elementAtPosEnd.row) {
                    break;
                }
                currentRow = currentRow.nextSibling;
            }
            return res;
        }
        else if (elementAtPosStart.posInCell === null && elementAtPosEnd.posInCell === null) {
            // 选中了行中的若干单元格
            const res = [];
            let currentCell = elementAtPosStart.cell;
            while (currentCell) {
                res.push(currentCell);
                if (currentCell.nextSibling === elementAtPosEnd.cell) {
                    break;
                }
                currentCell = currentCell.nextSibling;
            }
            return res;
        }
        return [];
    }
    createSelf() {
        return new Table_1();
    }
    // #region IBubbleUpable methods
    bubbleUp(type, data, stack) {
        throw new Error('this method should implemented in IBubbleUpableDecorator');
    }
    setBubbleHandler(handler) {
        throw new Error('this method should implemented in IBubbleUpableDecorator');
    }
    // #endregion
    // #region override IDocPosOperator methods
    firstPos() {
        return { index: 0, inner: { index: 0, inner: { index: 0, inner: this.children[0].children[0].firstPos() } } };
    }
    lastPos() {
        // 最后一行不一定有 cell
        let res = null;
        let rowRetain = 0;
        let cellRetain = 0;
        for (let rowIndex = this.children.length - 1; rowIndex >= 0; rowIndex--) {
            const row = this.children[rowIndex];
            if (row.tail) {
                res = row.tail.lastPos();
                rowRetain = rowIndex;
                cellRetain = row.children.length - 1;
                break;
            }
        }
        if (res) {
            return { index: 0, inner: { index: rowRetain, inner: { index: cellRetain, inner: res } } };
        }
        else {
            throw new Error('table should not be empty.');
        }
    }
    nextPos(pos) {
        let res = null;
        let targetRowIndex = 0;
        let targetCellIndex = 0;
        const rowPos = pos.inner;
        if (rowPos) {
            targetRowIndex = (0,_Common_util__WEBPACK_IMPORTED_MODULE_6__.findChildIndexInDocPos)(rowPos.index, this.children);
            if (targetRowIndex >= 0) {
                const cellPos = rowPos.inner;
                if (cellPos) {
                    const targetRow = this.children[targetRowIndex];
                    targetCellIndex = (0,_Common_util__WEBPACK_IMPORTED_MODULE_6__.findChildIndexInDocPos)(cellPos.index, targetRow.children);
                    if (targetCellIndex >= 0) {
                        const targetCell = targetRow.children[targetCellIndex];
                        const docContentPos = cellPos.inner;
                        if (docContentPos) {
                            res = targetCell.nextPos(docContentPos);
                        }
                        if (!res && targetCell.nextSibling) {
                            res = targetCell.nextSibling.firstPos();
                            targetCellIndex++;
                        }
                    }
                    if (!res && targetRow.nextSibling) {
                        let currentRow = targetRow.nextSibling;
                        while (currentRow) {
                            targetRowIndex++;
                            if (currentRow.children.length > 0) {
                                res = currentRow.children[0].firstPos();
                                targetCellIndex = 0;
                                break;
                            }
                            else {
                                currentRow = currentRow.nextSibling;
                            }
                        }
                    }
                }
            }
        }
        return res
            ? {
                index: 0,
                inner: { index: targetRowIndex, inner: { index: targetCellIndex, inner: res } },
            }
            : null;
    }
    prevPos(pos) {
        let res = null;
        let targetRowIndex = 0;
        let targetCellIndex = 0;
        const rowPos = pos.inner;
        if (rowPos) {
            targetRowIndex = (0,_Common_util__WEBPACK_IMPORTED_MODULE_6__.findChildIndexInDocPos)(rowPos.index, this.children);
            if (targetRowIndex >= 0) {
                const cellPos = rowPos.inner;
                if (cellPos) {
                    const targetRow = this.children[targetRowIndex];
                    targetCellIndex = (0,_Common_util__WEBPACK_IMPORTED_MODULE_6__.findChildIndexInDocPos)(cellPos.index, targetRow.children);
                    if (targetCellIndex >= 0) {
                        const targetCell = targetRow.children[targetCellIndex];
                        const docContentPos = cellPos.inner;
                        if (docContentPos) {
                            res = targetCell.prevPos(docContentPos);
                        }
                        if (!res && targetCell.prevSibling) {
                            res = targetCell.prevSibling.lastPos();
                            targetCellIndex--;
                        }
                    }
                    if (!res && targetRow.prevSibling) {
                        let currentRow = targetRow.prevSibling;
                        while (currentRow) {
                            targetRowIndex--;
                            if (currentRow.children.length > 0) {
                                res = currentRow.children[currentRow.children.length - 1].lastPos();
                                targetCellIndex = targetRow.prevSibling.children.length - 1;
                                break;
                            }
                            else {
                                currentRow = currentRow.prevSibling;
                            }
                        }
                    }
                }
            }
        }
        return res
            ? {
                index: 0,
                inner: { index: targetRowIndex, inner: { index: targetCellIndex, inner: res } },
            }
            : null;
    }
    firstLinePos(x) {
        const targetRow = this.children[0];
        const xPosInRow = x - targetRow.x;
        const res = targetRow.firstLinePos(xPosInRow);
        return res
            ? {
                index: 0,
                inner: { index: 0, inner: res },
            }
            : null;
    }
    lastLinePos(x) {
        let targetRowIndex = 0;
        let targetRow = null;
        for (let rowIndex = 0; rowIndex < this.children.length; rowIndex++) {
            const row = this.children[rowIndex];
            if (row.children.length > 0) {
                targetRow = row;
                targetRowIndex = rowIndex;
            }
        }
        if (targetRow) {
            const xPosInRow = x - targetRow.x;
            const res = targetRow.lastLinePos(xPosInRow);
            return res
                ? {
                    index: 0,
                    inner: { index: targetRowIndex, inner: res },
                }
                : null;
        }
        return null;
    }
    nextLinePos(pos, x) {
        let res = null;
        const rowPos = pos.inner;
        let targetRowIndex = 0;
        let targetCellIndex = 0;
        if (rowPos) {
            targetRowIndex = rowPos.index;
            const targetRow = this.children[targetRowIndex];
            const xPosInRow = x - targetRow.x;
            if (targetRow) {
                const cellPos = rowPos.inner;
                if (cellPos) {
                    targetCellIndex = cellPos.index;
                    const targetCell = targetRow.children[targetCellIndex];
                    if (targetCell && cellPos.inner) {
                        const xPosInCell = xPosInRow - targetCell.x;
                        const resInCell = targetCell.nextLinePos(cellPos.inner, xPosInCell);
                        if (resInCell) {
                            res = { index: targetCellIndex, inner: resInCell };
                        }
                    }
                    if (!res && targetRow.nextSibling) {
                        let currentRow = targetRow.nextSibling;
                        while (currentRow) {
                            targetRowIndex++;
                            if (currentRow.children.length > 0) {
                                res = currentRow.firstLinePos(xPosInRow);
                                break;
                            }
                            else {
                                currentRow = currentRow.nextSibling;
                            }
                        }
                    }
                }
            }
        }
        return res
            ? {
                index: 0,
                inner: { index: targetRowIndex, inner: res },
            }
            : null;
    }
    prevLinePos(pos, x) {
        console.log('x', x);
        let res = null;
        const rowPos = pos.inner;
        let targetRowIndex = 0;
        let targetCellIndex = 0;
        if (rowPos) {
            targetRowIndex = rowPos.index;
            const targetRow = this.children[targetRowIndex];
            if (targetRow) {
                const cellPos = rowPos.inner;
                if (cellPos) {
                    targetCellIndex = cellPos.index;
                    const targetCell = targetRow.children[targetCellIndex];
                    if (targetCell && cellPos.inner) {
                        const xPosInCell = x - targetRow.x - targetCell.x;
                        const resInCell = targetCell.prevLinePos(cellPos.inner, xPosInCell);
                        if (resInCell) {
                            res = { index: targetCellIndex, inner: resInCell };
                        }
                    }
                    if (!res && targetRow.prevSibling) {
                        let currentRow = targetRow.prevSibling;
                        while (currentRow) {
                            targetRowIndex--;
                            if (currentRow.children.length > 0) {
                                res = currentRow.lastLinePos(x - currentRow.x);
                                break;
                            }
                            else {
                                currentRow = currentRow.prevSibling;
                            }
                        }
                    }
                }
            }
        }
        return res
            ? {
                index: 0,
                inner: { index: targetRowIndex, inner: res },
            }
            : null;
    }
    lineStartPos(pos, y) {
        let res = null;
        const rowPos = pos.inner;
        let targetRowIndex = 0;
        let targetCellIndex = 0;
        if (rowPos) {
            targetRowIndex = rowPos.index;
            const targetRow = this.children[targetRowIndex];
            const yPosInRow = y - targetRow.y;
            if (targetRow) {
                const cellPos = rowPos.inner;
                if (cellPos) {
                    targetCellIndex = cellPos.index;
                    const targetCell = targetRow.children[targetCellIndex];
                    if (targetCell && cellPos.inner) {
                        const yPosInCell = yPosInRow - targetCell.y;
                        res = targetCell.lineStartPos(cellPos.inner, yPosInCell);
                    }
                }
            }
        }
        return res
            ? {
                index: 0,
                inner: { index: targetRowIndex, inner: { index: targetCellIndex, inner: res } },
            }
            : null;
    }
    lineEndPos(pos, y) {
        let res = null;
        const rowPos = pos.inner;
        let targetRowIndex = 0;
        let targetCellIndex = 0;
        if (rowPos) {
            targetRowIndex = rowPos.index;
            const targetRow = this.children[targetRowIndex];
            const yPosInRow = y - targetRow.y;
            if (targetRow) {
                const cellPos = rowPos.inner;
                if (cellPos) {
                    targetCellIndex = cellPos.index;
                    const targetCell = targetRow.children[targetCellIndex];
                    if (targetCell && cellPos.inner) {
                        const yPosInCell = yPosInRow - targetCell.y;
                        res = targetCell.lineEndPos(cellPos.inner, yPosInCell);
                    }
                }
            }
        }
        return res
            ? {
                index: 0,
                inner: { index: targetRowIndex, inner: { index: targetCellIndex, inner: res } },
            }
            : null;
    }
    // #endregion
    // #region override Table method
    onPointerEnter(x, y, targetStack, currentTargetIndex) {
        // this method should be implemented in IPointerInteractiveDecorator
    }
    onPointerLeave() {
        // this method should be implemented in IPointerInteractiveDecorator
    }
    onPointerMove(x, y, targetStack, currentTargetIndex) {
        // this method should be implemented in IPointerInteractiveDecorator
    }
    onPointerDown(x, y) {
        // this method should be implemented in IPointerInteractiveDecorator
    }
    onPointerUp(x, y) {
        // this method should be implemented in IPointerInteractiveDecorator
    }
    onPointerTap(x, y) {
        // this method should be implemented in IPointerInteractiveDecorator
    }
    // #endregion
    // #region override LinkedList method
    afterAdd(nodes) {
        nodes.forEach((node) => {
            node.setBubbleHandler(this.bubbleUp.bind(this));
        });
    }
    afterRemove(nodes) {
        nodes.forEach((node) => {
            node.setBubbleHandler(null);
        });
    }
    addLast(node) {
        throw new Error('this method should be implemented in ILinkedListDecorator');
    }
    addAfter(node, target) {
        throw new Error('this method should be implemented in ILinkedListDecorator');
    }
    addBefore(node, target) {
        throw new Error('this method should be implemented in ILinkedListDecorator');
    }
    addAtIndex(node, index) {
        throw new Error('this method should be implemented in ILinkedListDecorator');
    }
    addAll(nodes) {
        throw new Error('this method should be implemented in ILinkedListDecorator');
    }
    removeAll() {
        throw new Error('this method should be implemented in ILinkedListDecorator');
    }
    remove(node) {
        throw new Error('this method should be implemented in ILinkedListDecorator');
    }
    removeAllFrom(node) {
        throw new Error('this method should be implemented in ILinkedListDecorator');
    }
    splice(start, deleteCount, nodes) {
        throw new Error('this method should be implemented in ILinkedListDecorator');
    }
    findIndex(node) {
        throw new Error('this method should be implemented in ILinkedListDecorator');
    }
    // #endregion
    // #region override IAttributable method
    setOverrideDefaultAttributes(attr) {
        throw new Error('Method not implemented.');
    }
    setOverrideAttributes(attr) {
        throw new Error('Method not implemented.');
    }
    setAttributes(attr) {
        throw new Error('Method not implemented.');
    }
    compileAttributes() {
        throw new Error('Method not implemented.');
    }
    // #endregion
    // #region getSelectedElement methods
    getSelectedElement(range) {
        const res = [];
        res.push([this]);
        if (range.start.inner && range.end.inner) {
            const startRow = (0,_Common_util__WEBPACK_IMPORTED_MODULE_6__.findChildInDocPos)(range.start.inner.index, this.children, true);
            const endRow = (0,_Common_util__WEBPACK_IMPORTED_MODULE_6__.findChildInDocPos)(range.end.inner.index, this.children, true);
            if (startRow && endRow) {
                if (startRow === endRow) {
                    res.push(...startRow.getSelectedElement({
                        start: (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_9__.getRelativeDocPos)(startRow.start, range.start.inner),
                        end: (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_9__.getRelativeDocPos)(startRow.start, range.end.inner),
                    }));
                }
                else {
                    const span = [];
                    let currentRow = startRow;
                    while (currentRow) {
                        span.push(currentRow);
                        currentRow = currentRow.nextSibling;
                    }
                    res.push([span]);
                }
            }
        }
        return res;
    }
    // #endregion
    sumRowHeight(startIndex, endIndex) {
        let sum = 0;
        for (let index = startIndex; index <= endIndex; index++) {
            sum += this.children[index].height;
        }
        return sum;
    }
    getPosElement(pos, direction = 'right') {
        const res = {
            row: null,
            cell: null,
            posInCell: null,
        };
        const tableInnerPos = pos.inner;
        if (!tableInnerPos) {
            return res;
        }
        const rowIndex = tableInnerPos.index;
        if (rowIndex >= this.children.length) {
            return res;
        }
        res.row = this.children[rowIndex];
        const rowInnerPos = tableInnerPos.inner;
        if (!rowInnerPos) {
            return res;
        }
        const cellIndex = rowInnerPos.index;
        if (cellIndex >= res.row.children.length) {
            return res;
        }
        res.cell = res.row.children[cellIndex];
        const cellInnerPos = rowInnerPos.inner;
        if (!cellInnerPos) {
            return res;
        }
        res.posInCell = cellInnerPos;
        return res;
    }
    getWholeRowAttributes(row, res) {
        for (let i = 0; i < row.children.length; i++) {
            const cell = row === null || row === void 0 ? void 0 : row.children[i];
            (0,_Common_util__WEBPACK_IMPORTED_MODULE_6__.collectAttributes)(cell.getFormat([{ start: { index: 0, inner: null }, end: { index: cell.length, inner: null } }]), res);
            (0,_Common_util__WEBPACK_IMPORTED_MODULE_6__.collectAttributes)(cell.attributes, res);
        }
    }
};
Table.typeName = 'table';
Table = Table_1 = __decorate([
    _Common_IBubbleUpable__WEBPACK_IMPORTED_MODULE_11__.IBubbleUpableDecorator,
    _Common_LinkedList__WEBPACK_IMPORTED_MODULE_2__.ILinkedListDecorator,
    _Common_IPointerInteractive__WEBPACK_IMPORTED_MODULE_3__.IPointerInteractiveDecorator,
    _Common_IAttributable__WEBPACK_IMPORTED_MODULE_10__.IAttributableDecorator
], Table);



/***/ }),

/***/ "./src/Block/TableAttributes.ts":
/*!**************************************!*\
  !*** ./src/Block/TableAttributes.ts ***!
  \**************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TableDefaultAttributes": function() { return /* binding */ tableDefaultAttributes; }
/* harmony export */ });
const tableDefaultAttributes = {
    width: 0,
    colWidth: [0],
};



/***/ }),

/***/ "./src/Block/TableCell.ts":
/*!********************************!*\
  !*** ./src/Block/TableCell.ts ***!
  \********************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TableCell": function() { return /* binding */ TableCell; },
/* harmony export */   "TableCellBubbleMessage": function() { return /* binding */ TableCellBubbleMessage; }
/* harmony export */ });
/* harmony import */ var _Document_DocContent__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Document/DocContent */ "./src/Document/DocContent.ts");
/* harmony import */ var quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! quill-delta-enhanced */ "quill-delta-enhanced");
/* harmony import */ var quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _TableCellAttributes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./TableCellAttributes */ "./src/Block/TableCellAttributes.ts");
/* harmony import */ var _Common_util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Common/util */ "./src/Common/util.ts");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lodash */ "lodash");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Common_IAttributable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../Common/IAttributable */ "./src/Common/IAttributable.ts");
/* harmony import */ var _Common_EnumTableStyle__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../Common/EnumTableStyle */ "./src/Common/EnumTableStyle.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var TableCell_1;







var TableCellBubbleMessage;
(function (TableCellBubbleMessage) {
    TableCellBubbleMessage["POINTER_ENTER_TABLE_CELL"] = "POINTER_ENTER_TABLE_CELL";
    TableCellBubbleMessage["POINTER_LEAVE_TABLE_CELL"] = "POINTER_LEAVE_TABLE_CELL";
})(TableCellBubbleMessage || (TableCellBubbleMessage = {}));
let TableCell = TableCell_1 = class TableCell extends _Document_DocContent__WEBPACK_IMPORTED_MODULE_0__.DocContent {
    constructor() {
        super(...arguments);
        this.x = 0;
        this.y = 0;
        this.width = 0;
        this.height = 0;
        this.prevSibling = null;
        this.nextSibling = null;
        this.parent = null;
        this.attributes = Object.assign({}, _TableCellAttributes__WEBPACK_IMPORTED_MODULE_2__.TableCellDefaultAttributes);
        this.defaultAttributes = _TableCellAttributes__WEBPACK_IMPORTED_MODULE_2__.TableCellDefaultAttributes;
        this.overrideDefaultAttributes = null;
        this.originalAttributes = null;
        this.overrideAttributes = null;
        this.paddingLeft = 5;
        this.paddingRight = 5;
        this.paddingTop = 5;
        this.paddingBottom = 5;
        this.isFirstLine = false;
        this.isLastLine = false;
        this.isFirstCell = false;
        this.isLastCell = false;
        this.GridRowPos = 0;
        this.GridColPos = 0;
        // #endregion
    }
    static create() {
        const tc = new TableCell_1();
        tc.readFromChanges(super.createDefaultEmptyDocContent().toDelta());
        return tc;
    }
    get start() {
        return this.prevSibling === null ? 0 : this.prevSibling.start + 1;
    }
    readFromOps(Ops) {
        var _a;
        const delta = Ops[0].insert;
        super.readFromChanges(delta);
        this.setAttributes((_a = Ops[0]) === null || _a === void 0 ? void 0 : _a.attributes);
    }
    toOp(withKey) {
        const res = {
            insert: this.toDelta(withKey),
        };
        if (withKey) {
            res.key = this.id;
        }
        if (this.originalAttributes && Object.keys(this.originalAttributes).length > 0) {
            res.attributes = Object.assign({}, this.originalAttributes);
        }
        return res;
    }
    setAttributes(attrs) {
        const colSpan = attrs === null || attrs === void 0 ? void 0 : attrs.colSpan;
        if (typeof colSpan === 'number') {
            this.attributes.colSpan = colSpan;
        }
        const rowSpan = attrs === null || attrs === void 0 ? void 0 : attrs.rowSpan;
        if (typeof rowSpan === 'number') {
            this.attributes.rowSpan = rowSpan;
        }
        const vertAlign = attrs === null || attrs === void 0 ? void 0 : attrs.vertAlign;
        if (typeof vertAlign === 'number') {
            this.attributes.vertAlign = vertAlign;
        }
    }
    /**
     * 设置单元格的宽度，同时给单元格内所有 block 设置新的宽度
     */
    setWidth(width) {
        if (width !== this.width) {
            this.width = width;
            for (let index = 0; index < this.children.length; index++) {
                const block = this.children[index];
                block.setWidth(this.width - this.paddingLeft - this.paddingRight);
            }
        }
    }
    /**
     * 绘制单元格边框
     * @param firstLine 是否在第一行
     * @param lastLine 是否在最后一行
     * @param firstCell 是否是行中的第一个 cell
     * @param lastCell 是否是行中的最后一个 cell
     */
    drawBorder(ctx, x, y) {
        // 每个单元格都只绘制自己的右边框和下边框，但如果当前单元格在表格的最外圈，边框绘制的长度和位置会有变化
        ctx.strokeStyle = '#000';
        const startX = this.x + x;
        const startY = this.y + y;
        ctx.beginPath();
        // 先绘制右边框
        if (!this.isLastCell) {
            const x = (0,_Common_util__WEBPACK_IMPORTED_MODULE_3__.findHalf)(startX + this.width, -1);
            const y1 = (0,_Common_util__WEBPACK_IMPORTED_MODULE_3__.findHalf)(startY, -1);
            const y2 = (0,_Common_util__WEBPACK_IMPORTED_MODULE_3__.findHalf)(startY + this.height, 1);
            ctx.moveTo(x, y1);
            ctx.lineTo(x, y2);
        }
        // 再绘制下边框
        if (!this.isLastLine) {
            const y = (0,_Common_util__WEBPACK_IMPORTED_MODULE_3__.findHalf)(startY + this.height, -1);
            const x1 = (0,_Common_util__WEBPACK_IMPORTED_MODULE_3__.findHalf)(startX, -1);
            const x2 = (0,_Common_util__WEBPACK_IMPORTED_MODULE_3__.findHalf)(startX + this.width, 1);
            ctx.moveTo(x1, y);
            ctx.lineTo(x2, y);
        }
        ctx.stroke();
    }
    onPointerEnter(x, y, targetStack, currentTargetIndex) {
        super.onPointerEnter(x, y, targetStack, currentTargetIndex);
        this.bubbleUp(TableCellBubbleMessage.POINTER_ENTER_TABLE_CELL, null, []);
    }
    onPointerLeave() {
        super.onPointerLeave();
        this.bubbleUp(TableCellBubbleMessage.POINTER_LEAVE_TABLE_CELL, null, []);
    }
    format(attr, ranges) {
        var _a, _b;
        this.setAttributes(attr);
        if (ranges === undefined) {
            return super.format(attr);
        }
        else {
            let res = new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_1___default())();
            const targetRanges = (0,lodash__WEBPACK_IMPORTED_MODULE_4__.isArray)(ranges) ? ranges : [ranges];
            for (let i = 0; i < targetRanges.length; i++) {
                const range = targetRanges[i];
                // 这里 range 的第一层是 cell，所以要向下取一层才能拿到 DocContent 内部的 pos
                if (range.start.inner || range.end.inner) {
                    const rangeInCell = {
                        start: (_a = range.start.inner) !== null && _a !== void 0 ? _a : { index: 0, inner: null },
                        end: (_b = range.end.inner) !== null && _b !== void 0 ? _b : { index: this.children.length, inner: null },
                    };
                    const formatRes = super.format(attr, rangeInCell);
                    if (formatRes) {
                        res = res.compose(formatRes);
                    }
                }
                else {
                    const formatRes = super.format(attr);
                    if (formatRes) {
                        res = res.compose(formatRes);
                    }
                }
            }
            return res;
        }
    }
    clearFormat(ranges) {
        var _a, _b;
        this.setAttributes({ vertAlign: _Common_EnumTableStyle__WEBPACK_IMPORTED_MODULE_6__.EnumCellVerticalAlign.Top });
        if (ranges === undefined) {
            return super.clearFormat();
        }
        else {
            let res = new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_1___default())();
            const targetRanges = (0,lodash__WEBPACK_IMPORTED_MODULE_4__.isArray)(ranges) ? ranges : [ranges];
            for (let i = 0; i < targetRanges.length; i++) {
                const range = targetRanges[i];
                // 这里 range 的第一层是 cell，所以要向下取一层才能拿到 DocContent 内部的 pos
                if (range.start.inner || range.end.inner) {
                    const rangeInCell = {
                        start: (_a = range.start.inner) !== null && _a !== void 0 ? _a : { index: 0, inner: null },
                        end: (_b = range.end.inner) !== null && _b !== void 0 ? _b : { index: this.children.length, inner: null },
                    };
                    const formatRes = super.clearFormat(rangeInCell);
                    if (formatRes) {
                        res = res.compose(formatRes);
                    }
                }
                else {
                    const formatRes = super.clearFormat();
                    if (formatRes) {
                        res = res.compose(formatRes);
                    }
                }
            }
            return res;
        }
    }
    getFormat(ranges) {
        var _a, _b;
        let res = {};
        if (ranges === undefined) {
            res = (0,_Common_util__WEBPACK_IMPORTED_MODULE_3__.getFormat)(this);
        }
        else {
            const targetRanges = (0,lodash__WEBPACK_IMPORTED_MODULE_4__.isArray)(ranges) ? ranges : [ranges];
            for (let i = 0; i < targetRanges.length; i++) {
                const range = targetRanges[i];
                if (((_a = range.start) === null || _a === void 0 ? void 0 : _a.inner) && ((_b = range.end) === null || _b === void 0 ? void 0 : _b.inner)) {
                    (0,_Common_util__WEBPACK_IMPORTED_MODULE_3__.collectAttributes)(super.getFormat([
                        {
                            start: range.start.inner,
                            end: range.end.inner,
                        },
                    ]), res);
                }
                else {
                    (0,_Common_util__WEBPACK_IMPORTED_MODULE_3__.collectAttributes)(super.getFormat(), res);
                }
            }
        }
        (0,_Common_util__WEBPACK_IMPORTED_MODULE_3__.collectAttributes)(this.attributes, res);
        return res;
    }
    // #region IBubbleUpable methods
    // #endregion
    // #region override IAttributableDecorator method
    setOverrideDefaultAttributes(attr) {
        throw new Error('Method not implemented.');
    }
    setOverrideAttributes(attr) {
        throw new Error('Method not implemented.');
    }
    compileAttributes() {
        throw new Error('Method not implemented.');
    }
};
TableCell = TableCell_1 = __decorate([
    _Common_IAttributable__WEBPACK_IMPORTED_MODULE_5__.IAttributableDecorator
], TableCell);



/***/ }),

/***/ "./src/Block/TableCellAttributes.ts":
/*!******************************************!*\
  !*** ./src/Block/TableCellAttributes.ts ***!
  \******************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TableCellDefaultAttributes": function() { return /* binding */ tableCellDefaultAttributes; }
/* harmony export */ });
/* harmony import */ var _Common_EnumTableStyle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Common/EnumTableStyle */ "./src/Common/EnumTableStyle.ts");

const tableCellDefaultAttributes = {
    vertAlign: _Common_EnumTableStyle__WEBPACK_IMPORTED_MODULE_0__.EnumCellVerticalAlign.Top,
    colSpan: 1,
    rowSpan: 1,
};



/***/ }),

/***/ "./src/Block/TableRow.ts":
/*!*******************************!*\
  !*** ./src/Block/TableRow.ts ***!
  \*******************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TableRow": function() { return /* binding */ TableRow; }
/* harmony export */ });
/* harmony import */ var _Common_IBubbleUpable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Common/IBubbleUpable */ "./src/Common/IBubbleUpable.ts");
/* harmony import */ var _Common_EnumCursorType__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Common/EnumCursorType */ "./src/Common/EnumCursorType.ts");
/* harmony import */ var _Common_LinkedList__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Common/LinkedList */ "./src/Common/LinkedList.ts");
/* harmony import */ var _Common_IPointerInteractive__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Common/IPointerInteractive */ "./src/Common/IPointerInteractive.ts");
/* harmony import */ var _TableRowAttributes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./TableRowAttributes */ "./src/Block/TableRowAttributes.ts");
/* harmony import */ var quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! quill-delta-enhanced */ "quill-delta-enhanced");
/* harmony import */ var quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _TableCell__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./TableCell */ "./src/Block/TableCell.ts");
/* harmony import */ var _Common_util__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../Common/util */ "./src/Common/util.ts");
/* harmony import */ var _Common_IAttributable__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../Common/IAttributable */ "./src/Common/IAttributable.ts");
/* harmony import */ var _Common_DocPos__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../Common/DocPos */ "./src/Common/DocPos.ts");
/* harmony import */ var _Common_ISelectedElementGettable__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../Common/ISelectedElementGettable */ "./src/Common/ISelectedElementGettable.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};











let TableRow = class TableRow {
    constructor() {
        this.id = (0,_Common_util__WEBPACK_IMPORTED_MODULE_7__.increaseId)();
        this.children = [];
        this.head = null;
        this.tail = null;
        this.prevSibling = null;
        this.nextSibling = null;
        this.parent = null;
        this.x = 0;
        this.y = 0;
        this.width = 0;
        this.height = 0;
        this.attributes = Object.assign({}, _TableRowAttributes__WEBPACK_IMPORTED_MODULE_4__.TableRowDefaultAttributes);
        this.defaultAttributes = _TableRowAttributes__WEBPACK_IMPORTED_MODULE_4__.TableRowDefaultAttributes;
        this.overrideDefaultAttributes = null;
        this.originalAttributes = null;
        this.overrideAttributes = null;
        /**
         * 最小内容高度，指综合计算当前行所有单元格的 contentHeight 和所有在此行结束的跨行单元格的 contentHeight
         * 之后得出的，能放下上述所有单元格的行高
         * 当前行的实际高度小于 contentMinHeight 时就会有单元格的内容超出此行
         */
        this.contentMinHeight = 0;
        // #endregion
    }
    get start() {
        return this.prevSibling === null ? 0 : this.prevSibling.start + 1;
    }
    get length() {
        return this.children.length;
    }
    readFromOps(Ops) {
        var _a, _b;
        // tableRow 的 op 只会有一条，所以直接取第一条
        const delta = Ops[0].insert;
        const height = (_b = (_a = Ops[0]) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b.height;
        if (typeof height === 'number') {
            this.attributes.height = height;
        }
        const cells = delta.ops.map((op) => {
            const cell = new _TableCell__WEBPACK_IMPORTED_MODULE_6__.TableCell();
            cell.readFromOps([op]);
            return cell;
        });
        this.addAll(cells);
        cells.forEach((cell) => {
            cell.parent = this;
        });
    }
    destroy() {
        for (let index = 0; index < this.children.length; index++) {
            const cell = this.children[index];
            cell.destroy();
        }
    }
    toOp(withKey) {
        const cellOps = this.children.map((cell) => cell.toOp(withKey));
        const res = {
            insert: new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_5___default())(cellOps),
        };
        if (withKey) {
            res.key = this.id;
        }
        if (this.originalAttributes && Object.keys(this.originalAttributes).length > 0) {
            res.attributes = Object.assign({}, this.originalAttributes);
        }
        return res;
    }
    /**
     * 设置当前行的高度
     */
    setHeight(height) {
        if (height >= this.contentMinHeight) {
            this.height = height;
        }
    }
    /**
     * 设置当前行 attributes 中的 height
     */
    setHeightAttribute(height) {
        this.setAttributes({ height });
    }
    /**
     * 设置当前行的最小内容高度
     */
    setContentMinHeight(height) {
        this.contentMinHeight = height;
    }
    /**
     * 设置当前 row 的 y 轴位置
     * @param pos 位置信息对象
     */
    setPositionY(y, recursive = true, force = false) {
        if (force === true || this.y !== y) {
            this.y = Math.floor(y);
            if (recursive) {
                let currentRow = this;
                let nextSibling = this.nextSibling;
                while (nextSibling !== null) {
                    nextSibling.y = Math.floor(currentRow.y + currentRow.height);
                    currentRow = nextSibling;
                    nextSibling = currentRow.nextSibling;
                }
            }
        }
    }
    draw(ctx, x, y, viewHeight) {
        for (let index = 0; index < this.children.length; index++) {
            const cell = this.children[index];
            cell.draw(ctx, this.x + x, this.y + y, viewHeight);
        }
    }
    drawBorder(ctx, x, y) {
        for (let index = 0; index < this.children.length; index++) {
            const cell = this.children[index];
            cell.drawBorder(ctx, this.x + x, this.y + y);
        }
    }
    getCursorType() {
        return _Common_EnumCursorType__WEBPACK_IMPORTED_MODULE_1__.EnumCursorType.ColResize;
    }
    format(attr, range) {
        var _a, _b;
        this.setAttributes(attr);
        if (range && (range.start.inner || range.end.inner)) {
            // 说明是部分单元格被 format
            // 如果 range 存在，range 的 start 的 inner 和 end 的 inner 一定不能是 null
            const rangeInRow = {
                start: (_a = range.start.inner) !== null && _a !== void 0 ? _a : { index: 0, inner: null },
                end: (_b = range.end.inner) !== null && _b !== void 0 ? _b : { index: this.children.length, inner: null },
            };
            // 这里要注意，因为 table cell 的 length 其实是 DocContent 的 length，所以它的 length 不是 1，也就不能用 util 中的 format 方法
            // 只能在这里单独写一个由 util.format 改编的逻辑
            if (rangeInRow) {
                const startChild = (0,_Common_util__WEBPACK_IMPORTED_MODULE_7__.findChildInDocPos)(rangeInRow.start.index, this.children, true);
                let endChild = (0,_Common_util__WEBPACK_IMPORTED_MODULE_7__.findChildInDocPos)(rangeInRow.end.index, this.children, true);
                if (!startChild || !endChild) {
                    return;
                }
                endChild =
                    endChild.start === rangeInRow.end.index && rangeInRow.end.inner === null ? endChild.prevSibling : endChild;
                if (!startChild || !endChild) {
                    return;
                }
                if (startChild === endChild) {
                    startChild.format(attr, {
                        start: (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_9__.getRelativeDocPos)(startChild.start, rangeInRow.start),
                        end: (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_9__.getRelativeDocPos)(endChild.start, rangeInRow.end),
                    });
                }
                else {
                    let currentCell = endChild;
                    while (currentCell) {
                        if (currentCell === startChild) {
                            if (currentCell.start === rangeInRow.start.index && rangeInRow.start.inner === null) {
                                currentCell.format(attr);
                            }
                            else {
                                currentCell.format(attr, {
                                    start: { index: rangeInRow.start.index - currentCell.start, inner: rangeInRow.start.inner },
                                    end: { index: currentCell.start + 1, inner: null },
                                });
                            }
                            break;
                        }
                        else if (currentCell === endChild) {
                            if (currentCell.start + 1 === rangeInRow.end.index && rangeInRow.end.inner === null) {
                                currentCell.format(attr);
                            }
                            else {
                                currentCell.format(attr, {
                                    start: { index: 0, inner: null },
                                    end: { index: rangeInRow.end.index - currentCell.start, inner: rangeInRow.end.inner },
                                });
                            }
                        }
                        else {
                            currentCell.format(attr);
                        }
                        currentCell = currentCell.prevSibling;
                    }
                }
            }
            else {
                for (let index = 0; index < this.children.length; index++) {
                    const frag = this.children[index];
                    frag.format(attr);
                }
            }
        }
        else {
            // 说明所有单元格都要被 format
            for (let index = 0; index < this.children.length; index++) {
                const cell = this.children[index];
                cell.format(attr);
            }
        }
    }
    clearFormat(range) {
        var _a, _b;
        this.setAttributes(Object.assign({}, _TableRowAttributes__WEBPACK_IMPORTED_MODULE_4__.TableRowDefaultAttributes));
        if (range && (range.start.inner || range.end.inner)) {
            // 说明是部分单元格被 format
            // 如果 range 存在，range 的 start 的 inner 和 end 的 inner 一定不能是 null
            const rangeInRow = {
                start: (_a = range.start.inner) !== null && _a !== void 0 ? _a : { index: 0, inner: null },
                end: (_b = range.end.inner) !== null && _b !== void 0 ? _b : { index: this.children.length, inner: null },
            };
            // 这里要注意，因为 table cell 的 length 其实是 DocContent 的 length，所以它的 length 不是 1，也就不能用 util 中的 format 方法
            // 只能在这里单独写一个由 util.format 改编的逻辑
            if (rangeInRow) {
                const startChild = (0,_Common_util__WEBPACK_IMPORTED_MODULE_7__.findChildInDocPos)(rangeInRow.start.index, this.children, true);
                let endChild = (0,_Common_util__WEBPACK_IMPORTED_MODULE_7__.findChildInDocPos)(rangeInRow.end.index, this.children, true);
                if (!startChild || !endChild) {
                    return;
                }
                endChild =
                    endChild.start === rangeInRow.end.index && rangeInRow.end.inner === null ? endChild.prevSibling : endChild;
                if (!startChild || !endChild) {
                    return;
                }
                if (startChild === endChild) {
                    startChild.clearFormat({
                        start: (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_9__.getRelativeDocPos)(startChild.start, rangeInRow.start),
                        end: (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_9__.getRelativeDocPos)(endChild.start, rangeInRow.end),
                    });
                }
                else {
                    let currentCell = endChild;
                    while (currentCell) {
                        if (currentCell === startChild) {
                            if (currentCell.start === rangeInRow.start.index && rangeInRow.start.inner === null) {
                                currentCell.clearFormat();
                            }
                            else {
                                currentCell.clearFormat({
                                    start: { index: rangeInRow.start.index - currentCell.start, inner: rangeInRow.start.inner },
                                    end: { index: currentCell.start + 1, inner: null },
                                });
                            }
                            break;
                        }
                        else if (currentCell === endChild) {
                            if (currentCell.start + 1 === rangeInRow.end.index && rangeInRow.end.inner === null) {
                                currentCell.clearFormat();
                            }
                            else {
                                currentCell.clearFormat({
                                    start: { index: 0, inner: null },
                                    end: { index: rangeInRow.end.index - currentCell.start, inner: rangeInRow.end.inner },
                                });
                            }
                        }
                        else {
                            currentCell.clearFormat();
                        }
                        currentCell = currentCell.prevSibling;
                    }
                }
            }
            else {
                for (let index = 0; index < this.children.length; index++) {
                    const frag = this.children[index];
                    frag.clearFormat();
                }
            }
        }
        else {
            // 说明所有单元格都要被 format
            for (let index = 0; index < this.children.length; index++) {
                const cell = this.children[index];
                cell.clearFormat();
            }
        }
    }
    getFormat(range) {
        var _a, _b;
        let res = {};
        if (!range) {
            res = (0,_Common_util__WEBPACK_IMPORTED_MODULE_7__.getFormat)(this);
        }
        else if (((_a = range.start) === null || _a === void 0 ? void 0 : _a.inner) && ((_b = range.end) === null || _b === void 0 ? void 0 : _b.inner)) {
            res = (0,_Common_util__WEBPACK_IMPORTED_MODULE_7__.getFormat)(this, [
                {
                    start: range.start.inner,
                    end: range.end.inner,
                },
            ]);
        }
        else {
            res = {};
        }
        (0,_Common_util__WEBPACK_IMPORTED_MODULE_7__.collectAttributes)(this.attributes, res);
        return res;
    }
    lastLinePos(x) {
        let targetCellIndex = 0;
        let targetCell = this.children[targetCellIndex];
        for (let cellIndex = 0; cellIndex < this.children.length; cellIndex++) {
            const cell = this.children[cellIndex];
            if ((cellIndex === 0 && x <= cell.x) ||
                (0,_Common_util__WEBPACK_IMPORTED_MODULE_7__.hasIntersection)(cell.x, cell.x + cell.width, x, x) ||
                (cellIndex === this.children.length - 1 && x >= cell.x + cell.width)) {
                targetCellIndex = cellIndex;
                targetCell = cell;
                break;
            }
        }
        const xPosInCell = x - targetCell.x;
        const res = targetCell.lastLinePos(xPosInCell);
        return res
            ? {
                index: targetCellIndex,
                inner: res,
            }
            : null;
    }
    firstLinePos(x) {
        let targetCellIndex = 0;
        let targetCell = this.children[targetCellIndex];
        for (let cellIndex = 0; cellIndex < this.children.length; cellIndex++) {
            const cell = this.children[cellIndex];
            if ((cellIndex === 0 && x <= cell.x) ||
                (0,_Common_util__WEBPACK_IMPORTED_MODULE_7__.hasIntersection)(cell.x, cell.x + cell.width, x, x) ||
                (cellIndex === this.children.length - 1 && x >= cell.x + cell.width)) {
                targetCellIndex = cellIndex;
                targetCell = cell;
                break;
            }
        }
        const xPosInCell = x - targetCell.x;
        const res = targetCell.firstLinePos(xPosInCell);
        return res
            ? {
                index: targetCellIndex,
                inner: res,
            }
            : null;
    }
    // #region IBubbleUpable methods
    bubbleUp(type, data, stack) {
        throw new Error('this method should implemented in IBubbleUpableDecorator');
    }
    setBubbleHandler(handler) {
        throw new Error('this method should implemented in IBubbleUpableDecorator');
    }
    // #endregion
    // #region IPointerInteractive methods
    onPointerEnter(x, y, targetStack, currentTargetIndex) {
        throw new Error('Need IPointerInteractiveDecorator to implement.');
    }
    onPointerLeave() {
        throw new Error('Need IPointerInteractiveDecorator to implement.');
    }
    onPointerMove(x, y, targetStack, currentTargetIndex) {
        throw new Error('Need IPointerInteractiveDecorator to implement.');
    }
    onPointerDown(x, y) {
        throw new Error('Need IPointerInteractiveDecorator to implement.');
    }
    onPointerUp(x, y) {
        throw new Error('Need IPointerInteractiveDecorator to implement.');
    }
    onPointerTap(x, y) {
        throw new Error('Need IPointerInteractiveDecorator to implement.');
    }
    // #endregion
    // #region override LinkedList method
    afterAdd(nodes) {
        nodes.forEach((node) => {
            node.setBubbleHandler(this.bubbleUp.bind(this));
        });
    }
    afterRemove(nodes) {
        nodes.forEach((node) => {
            node.setBubbleHandler(null);
        });
    }
    addLast(node) {
        throw new Error('this method should be implemented in ILinkedListDecorator');
    }
    addAfter(node, target) {
        throw new Error('this method should be implemented in ILinkedListDecorator');
    }
    addBefore(node, target) {
        throw new Error('this method should be implemented in ILinkedListDecorator');
    }
    addAtIndex(node, index) {
        throw new Error('this method should be implemented in ILinkedListDecorator');
    }
    addAll(nodes) {
        throw new Error('this method should be implemented in ILinkedListDecorator');
    }
    removeAll() {
        throw new Error('this method should be implemented in ILinkedListDecorator');
    }
    remove(node) {
        throw new Error('this method should be implemented in ILinkedListDecorator');
    }
    removeAllFrom(node) {
        throw new Error('this method should be implemented in ILinkedListDecorator');
    }
    splice(start, deleteCount, nodes) {
        throw new Error('this method should be implemented in ILinkedListDecorator');
    }
    findIndex(node) {
        throw new Error('this method should be implemented in ILinkedListDecorator');
    }
    // #endregion
    // #region override IAttributableDecorator method
    setAttributes(attr) {
        throw new Error('Method not implemented.');
    }
    setOverrideDefaultAttributes(attr) {
        throw new Error('Method not implemented.');
    }
    setOverrideAttributes(attr) {
        throw new Error('Method not implemented.');
    }
    compileAttributes() {
        throw new Error('Method not implemented.');
    }
    // #endregion
    // #region getSelectedElement methods
    getSelectedElement(range) {
        const res = [];
        res.push([this]);
        if (range.start.inner && range.end.inner) {
            const startRow = (0,_Common_util__WEBPACK_IMPORTED_MODULE_7__.findChildInDocPos)(range.start.inner.index, this.children, true);
            const endRow = (0,_Common_util__WEBPACK_IMPORTED_MODULE_7__.findChildInDocPos)(range.end.inner.index, this.children, true);
            if (startRow && endRow) {
                if (startRow === endRow) {
                    res.push(...startRow.getSelectedElement({
                        start: (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_9__.getRelativeDocPos)(startRow.start, range.start.inner),
                        end: (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_9__.getRelativeDocPos)(startRow.start, range.end.inner),
                    }));
                }
                else {
                    const span = [];
                    let currentCell = startRow;
                    while (currentCell) {
                        span.push(currentCell);
                        currentCell = currentCell.nextSibling;
                    }
                    res.push([span]);
                }
            }
        }
        return res;
    }
};
TableRow = __decorate([
    _Common_ISelectedElementGettable__WEBPACK_IMPORTED_MODULE_10__.ISelectedElementGettableDecorator,
    _Common_IBubbleUpable__WEBPACK_IMPORTED_MODULE_0__.IBubbleUpableDecorator,
    _Common_LinkedList__WEBPACK_IMPORTED_MODULE_2__.ILinkedListDecorator,
    _Common_IPointerInteractive__WEBPACK_IMPORTED_MODULE_3__.IPointerInteractiveDecorator,
    _Common_IAttributable__WEBPACK_IMPORTED_MODULE_8__.IAttributableDecorator
], TableRow);



/***/ }),

/***/ "./src/Block/TableRowAttributes.ts":
/*!*****************************************!*\
  !*** ./src/Block/TableRowAttributes.ts ***!
  \*****************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TableRowDefaultAttributes": function() { return /* binding */ tableRowDefaultAttributes; }
/* harmony export */ });
const tableRowDefaultAttributes = {
    height: 0,
};



/***/ }),

/***/ "./src/Block/index.ts":
/*!****************************!*\
  !*** ./src/Block/index.ts ***!
  \****************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Block": function() { return /* reexport safe */ _Block__WEBPACK_IMPORTED_MODULE_0__.Block; },
/* harmony export */   "BlockCommon": function() { return /* reexport safe */ _BlockCommon__WEBPACK_IMPORTED_MODULE_1__.BlockCommon; },
/* harmony export */   "CodeBlock": function() { return /* reexport safe */ _CodeBlock__WEBPACK_IMPORTED_MODULE_2__.CodeBlock; },
/* harmony export */   "CodeBlockDefaultAttributes": function() { return /* reexport safe */ _CodeBlockAttributes__WEBPACK_IMPORTED_MODULE_3__.CodeBlockDefaultAttributes; },
/* harmony export */   "CodeHighlightTheme": function() { return /* reexport safe */ _CodeHighlightThemeRegistrar__WEBPACK_IMPORTED_MODULE_4__.CodeHighlightTheme; },
/* harmony export */   "DefaultTheme": function() { return /* reexport safe */ _CodeHighlightThemeRegistrar__WEBPACK_IMPORTED_MODULE_4__.DefaultTheme; },
/* harmony export */   "ListItem": function() { return /* reexport safe */ _ListItem__WEBPACK_IMPORTED_MODULE_5__.ListItem; },
/* harmony export */   "ListItemDefaultAttributes": function() { return /* reexport safe */ _ListItemAttributes__WEBPACK_IMPORTED_MODULE_6__.ListItemDefaultAttributes; },
/* harmony export */   "Paragraph": function() { return /* reexport safe */ _Paragraph__WEBPACK_IMPORTED_MODULE_7__.Paragraph; },
/* harmony export */   "ParagraphDefaultAttributes": function() { return /* reexport safe */ _ParagraphAttributes__WEBPACK_IMPORTED_MODULE_8__.ParagraphDefaultAttributes; },
/* harmony export */   "QUOTE_BLOCK_CONTENT_COLOR": function() { return /* reexport safe */ _QuoteBlock__WEBPACK_IMPORTED_MODULE_9__.QUOTE_BLOCK_CONTENT_COLOR; },
/* harmony export */   "QuoteBlock": function() { return /* reexport safe */ _QuoteBlock__WEBPACK_IMPORTED_MODULE_9__.QuoteBlock; },
/* harmony export */   "Table": function() { return /* reexport safe */ _Table__WEBPACK_IMPORTED_MODULE_10__.Table; },
/* harmony export */   "TableCell": function() { return /* reexport safe */ _TableCell__WEBPACK_IMPORTED_MODULE_12__.TableCell; },
/* harmony export */   "TableCellBubbleMessage": function() { return /* reexport safe */ _TableCell__WEBPACK_IMPORTED_MODULE_12__.TableCellBubbleMessage; },
/* harmony export */   "TableCellDefaultAttributes": function() { return /* reexport safe */ _TableCellAttributes__WEBPACK_IMPORTED_MODULE_13__.TableCellDefaultAttributes; },
/* harmony export */   "TableDefaultAttributes": function() { return /* reexport safe */ _TableAttributes__WEBPACK_IMPORTED_MODULE_11__.TableDefaultAttributes; },
/* harmony export */   "TableRow": function() { return /* reexport safe */ _TableRow__WEBPACK_IMPORTED_MODULE_14__.TableRow; },
/* harmony export */   "TableRowDefaultAttributes": function() { return /* reexport safe */ _TableRowAttributes__WEBPACK_IMPORTED_MODULE_15__.TableRowDefaultAttributes; },
/* harmony export */   "codeHighlightThemeRegistrar": function() { return /* reexport safe */ _CodeHighlightThemeRegistrar__WEBPACK_IMPORTED_MODULE_4__.codeHighlightThemeRegistrar; }
/* harmony export */ });
/* harmony import */ var _Block__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Block */ "./src/Block/Block.ts");
/* harmony import */ var _BlockCommon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./BlockCommon */ "./src/Block/BlockCommon.ts");
/* harmony import */ var _CodeBlock__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./CodeBlock */ "./src/Block/CodeBlock.ts");
/* harmony import */ var _CodeBlockAttributes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./CodeBlockAttributes */ "./src/Block/CodeBlockAttributes.ts");
/* harmony import */ var _CodeHighlightThemeRegistrar__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./CodeHighlightThemeRegistrar */ "./src/Block/CodeHighlightThemeRegistrar.ts");
/* harmony import */ var _ListItem__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./ListItem */ "./src/Block/ListItem.ts");
/* harmony import */ var _ListItemAttributes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./ListItemAttributes */ "./src/Block/ListItemAttributes.ts");
/* harmony import */ var _Paragraph__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./Paragraph */ "./src/Block/Paragraph.ts");
/* harmony import */ var _ParagraphAttributes__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./ParagraphAttributes */ "./src/Block/ParagraphAttributes.ts");
/* harmony import */ var _QuoteBlock__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./QuoteBlock */ "./src/Block/QuoteBlock.ts");
/* harmony import */ var _Table__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./Table */ "./src/Block/Table.ts");
/* harmony import */ var _TableAttributes__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./TableAttributes */ "./src/Block/TableAttributes.ts");
/* harmony import */ var _TableCell__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./TableCell */ "./src/Block/TableCell.ts");
/* harmony import */ var _TableCellAttributes__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./TableCellAttributes */ "./src/Block/TableCellAttributes.ts");
/* harmony import */ var _TableRow__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./TableRow */ "./src/Block/TableRow.ts");
/* harmony import */ var _TableRowAttributes__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./TableRowAttributes */ "./src/Block/TableRowAttributes.ts");


















/***/ }),

/***/ "./src/Common/Constant.ts":
/*!********************************!*\
  !*** ./src/Common/Constant.ts ***!
  \********************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getDefaultDocContentDelta": function() { return /* binding */ getDefaultDocContentDelta; },
/* harmony export */   "setDefaultDocContentDelta": function() { return /* binding */ setDefaultDocContentDelta; }
/* harmony export */ });
/* harmony import */ var quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! quill-delta-enhanced */ "quill-delta-enhanced");
/* harmony import */ var quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0__);

let defaultDocContentDelta = new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())([{ insert: 1, attributes: { frag: 'end', block: 'para' } }]);
const getDefaultDocContentDelta = () => {
    return defaultDocContentDelta;
};
const setDefaultDocContentDelta = (delta) => {
    defaultDocContentDelta = delta;
};


/***/ }),

/***/ "./src/Common/DocPos.ts":
/*!******************************!*\
  !*** ./src/Common/DocPos.ts ***!
  \******************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cloneDocPos": function() { return /* binding */ cloneDocPos; },
/* harmony export */   "compareDocPos": function() { return /* binding */ compareDocPos; },
/* harmony export */   "documentPosToJSON": function() { return /* binding */ documentPosToJSON; },
/* harmony export */   "getRelativeDocPos": function() { return /* binding */ getRelativeDocPos; },
/* harmony export */   "jsonToDocumentPos": function() { return /* binding */ jsonToDocumentPos; },
/* harmony export */   "moveDocPos": function() { return /* binding */ moveDocPos; },
/* harmony export */   "moveRight": function() { return /* binding */ moveRight; },
/* harmony export */   "transformDocPos": function() { return /* binding */ transformDocPos; }
/* harmony export */ });
/* harmony import */ var quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! quill-delta-enhanced */ "quill-delta-enhanced");
/* harmony import */ var quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var quill_delta_enhanced_dist_Op__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! quill-delta-enhanced/dist/Op */ "../../node_modules/.pnpm/quill-delta-enhanced@0.0.6/node_modules/quill-delta-enhanced/dist/Op.js");
/* harmony import */ var quill_delta_enhanced_dist_Op__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(quill_delta_enhanced_dist_Op__WEBPACK_IMPORTED_MODULE_1__);


const jsonToDocumentPos = (jsonObj) => {
    if (jsonObj.ops.length === 1) {
        if (typeof jsonObj.ops[0].retain === 'number') {
            return {
                index: jsonObj.ops[0].retain,
                inner: null,
            };
        }
        else {
            const inner = jsonToDocumentPos(jsonObj.ops[0].retain);
            if (inner !== null) {
                return {
                    index: 0,
                    inner,
                };
            }
            else {
                return null;
            }
        }
    }
    else if (jsonObj.ops.length === 2) {
        const index = jsonObj.ops[0].retain;
        const inner = typeof jsonObj.ops[1].retain === 'object' ? jsonToDocumentPos(jsonObj.ops[1].retain) : null;
        if (typeof index === 'number' && inner !== null) {
            return { index, inner };
        }
        else {
            return null;
        }
    }
    else {
        return null;
    }
};
const documentPosToJSON = (docPos) => {
    const res = { ops: [] };
    if (docPos.index > 0) {
        res.ops.push({ retain: docPos.index });
    }
    if (docPos.inner !== null) {
        res.ops.push({ retain: documentPosToJSON(docPos.inner) });
    }
    if (res.ops.length > 0) {
        return res;
    }
    else {
        return null;
    }
};
const moveRight = (docPos, offset) => {
    if (docPos.inner === null) {
        return { index: docPos.index + offset, inner: null };
    }
    else {
        return { index: docPos.index, inner: moveRight(docPos.inner, offset) };
    }
};
function cloneDocPos(pos) {
    if (pos !== null) {
        const targetPos = {
            index: pos.index,
            inner: pos.inner === null ? null : cloneDocPos(pos.inner),
        };
        return targetPos;
    }
    return null;
}
const getRelativeDocPos = (start, pos) => {
    if (pos.index >= start) {
        const { inner } = pos;
        const newInner = cloneDocPos(inner);
        return {
            index: pos.index - start,
            inner: newInner,
        };
    }
    else {
        return {
            index: 0,
            inner: null,
        };
    }
};
/**
 * 比较两个文档位置，如果 posA 在 posB 后面，就返回 true 否则返回 false
 */
const compareDocPos = (posA, posB) => {
    if (posA.index > posB.index) {
        return 1;
    }
    if (posA.index < posB.index) {
        return -1;
    }
    if (posA.inner === null && posB.inner !== null) {
        return -1;
    }
    if (posA.inner !== null && posB.inner === null) {
        return 1;
    }
    if (posA.inner !== null && posB.inner !== null) {
        return compareDocPos(posA.inner, posB.inner);
    }
    return 0;
};
const moveDocPos = (pos, step) => {
    const targetPos = pos.inner === null
        ? {
            index: pos.index + step,
            inner: null,
        }
        : {
            index: pos.index,
            inner: moveDocPos(pos.inner, step),
        };
    return targetPos;
};
const transformDocPos = (pos, delta) => {
    const newPos = cloneDocPos(pos);
    let thisPos = 0;
    const otherIter = quill_delta_enhanced_dist_Op__WEBPACK_IMPORTED_MODULE_1___default().iterator(delta.ops);
    while (otherIter.hasNext()) {
        if (otherIter.peekType() === 'insert') {
            const peekLength = otherIter.peekLength();
            newPos.index += peekLength;
            thisPos += peekLength;
            otherIter.next();
        }
        else if (otherIter.peekType() === 'delete') {
            const peekLength = otherIter.peekLength();
            if (peekLength > newPos.index - thisPos) {
                newPos.index = thisPos;
                newPos.inner = null;
                return newPos;
            }
            else {
                newPos.index -= peekLength;
                otherIter.next();
            }
        }
        else {
            // peekType === 'retain'
            const peekLength = otherIter.peekLength();
            const op = otherIter.next();
            if (peekLength === 1 && op.retain instanceof (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default()) && thisPos === newPos.index && newPos.inner !== null) {
                return {
                    index: newPos.index,
                    inner: transformDocPos(newPos.inner, op.retain),
                };
            }
            else if (peekLength > newPos.index - thisPos) {
                return newPos;
            }
            else {
                thisPos += peekLength;
            }
        }
    }
    return newPos;
};


/***/ }),

/***/ "./src/Common/EnumBubbleMessage.ts":
/*!*****************************************!*\
  !*** ./src/Common/EnumBubbleMessage.ts ***!
  \*****************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BubbleMessage": function() { return /* binding */ BubbleMessage; }
/* harmony export */ });
/**
 * 冒泡消息
 */
var BubbleMessage;
(function (BubbleMessage) {
    BubbleMessage["OPEN_LINK"] = "OPEN_LINK";
    BubbleMessage["LINE_CHANGE_SIZE"] = "LINE_CHANGE_SIZE";
    BubbleMessage["NEED_DRAW"] = "NEED_DRAW";
    BubbleMessage["NEED_LAYOUT"] = "NEED_LAYOUT";
    BubbleMessage["CONTENT_CHANGE"] = "CONTENT_CHANGE";
    BubbleMessage["NEED_LAYOUT_LISTITEM"] = "NEED_LAYOUT_LISTITEM";
    BubbleMessage["UPDATE_CONTENT_HEIGHT"] = "UPDATE_CONTENT_HEIGHT";
    BubbleMessage["UPDATE_CONTENT_LENGTH"] = "UPDATE_CONTENT_LENGTH";
})(BubbleMessage || (BubbleMessage = {}));


/***/ }),

/***/ "./src/Common/EnumCursorType.ts":
/*!**************************************!*\
  !*** ./src/Common/EnumCursorType.ts ***!
  \**************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EnumCursorType": function() { return /* binding */ EnumCursorType; }
/* harmony export */ });
var EnumCursorType;
(function (EnumCursorType) {
    EnumCursorType["Default"] = "default";
    EnumCursorType["Help"] = "help";
    EnumCursorType["Pointer"] = "pointer";
    EnumCursorType["Wait"] = "wait";
    EnumCursorType["Text"] = "text";
    EnumCursorType["ColResize"] = "col-resize";
    EnumCursorType["RowResize"] = "row-resize";
})(EnumCursorType || (EnumCursorType = {}));


/***/ }),

/***/ "./src/Common/EnumListStyle.ts":
/*!*************************************!*\
  !*** ./src/Common/EnumListStyle.ts ***!
  \*************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EnumListType": function() { return /* binding */ EnumListType; }
/* harmony export */ });
var EnumListType;
(function (EnumListType) {
    EnumListType[EnumListType["ol1"] = 0] = "ol1";
    EnumListType[EnumListType["ol2"] = 1] = "ol2";
    EnumListType[EnumListType["ol3"] = 2] = "ol3";
    EnumListType[EnumListType["ul1"] = 3] = "ul1";
    EnumListType[EnumListType["ul2"] = 4] = "ul2";
    EnumListType[EnumListType["ul3"] = 5] = "ul3";
})(EnumListType || (EnumListType = {}));


/***/ }),

/***/ "./src/Common/EnumParagraphStyle.ts":
/*!******************************************!*\
  !*** ./src/Common/EnumParagraphStyle.ts ***!
  \******************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EnumAlign": function() { return /* binding */ EnumAlign; }
/* harmony export */ });
/**
 * 对齐方式枚举
 */
var EnumAlign;
(function (EnumAlign) {
    EnumAlign["left"] = "left";
    EnumAlign["center"] = "center";
    EnumAlign["right"] = "right";
    EnumAlign["justify"] = "justify";
    EnumAlign["scattered"] = "scattered";
})(EnumAlign || (EnumAlign = {}));



/***/ }),

/***/ "./src/Common/EnumTableStyle.ts":
/*!**************************************!*\
  !*** ./src/Common/EnumTableStyle.ts ***!
  \**************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EnumCellVerticalAlign": function() { return /* binding */ EnumCellVerticalAlign; }
/* harmony export */ });
var EnumCellVerticalAlign;
(function (EnumCellVerticalAlign) {
    EnumCellVerticalAlign[EnumCellVerticalAlign["Top"] = 0] = "Top";
    EnumCellVerticalAlign[EnumCellVerticalAlign["Middle"] = 1] = "Middle";
    EnumCellVerticalAlign[EnumCellVerticalAlign["Bottom"] = 2] = "Bottom";
})(EnumCellVerticalAlign || (EnumCellVerticalAlign = {}));


/***/ }),

/***/ "./src/Common/EnumTextStyle.ts":
/*!*************************************!*\
  !*** ./src/Common/EnumTextStyle.ts ***!
  \*************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EnumFont": function() { return /* binding */ EnumFont; },
/* harmony export */   "EnumTitle": function() { return /* binding */ EnumTitle; }
/* harmony export */ });
/* harmony import */ var binary_search_bounds__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! binary-search-bounds */ "binary-search-bounds");
/* harmony import */ var binary_search_bounds__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(binary_search_bounds__WEBPACK_IMPORTED_MODULE_0__);

/**
 * 格式类型枚举
 */
var EnumTitle;
(function (EnumTitle) {
    EnumTitle[EnumTitle["Text"] = -1] = "Text";
    EnumTitle[EnumTitle["Title"] = 0] = "Title";
    EnumTitle[EnumTitle["Subtitle"] = 1] = "Subtitle";
    EnumTitle[EnumTitle["H1"] = 2] = "H1";
    EnumTitle[EnumTitle["H2"] = 3] = "H2";
    EnumTitle[EnumTitle["H3"] = 4] = "H3";
    EnumTitle[EnumTitle["H4"] = 5] = "H4";
})(EnumTitle || (EnumTitle = {}));
let fontList = [
    {
        name: 'Default',
        value: 'BlinkMacSystemFont,"PingFang SC",Helvetica,Tahoma,Arial,"Hiragino Sans GB","Microsoft YaHei","\\5FAE\\8F6F\\96C5\\9ED1",sans-serif',
    },
    { name: 'simsun', value: 'SimSun,STSong,sans-serif' },
    { name: 'simhei', value: 'SimHei,STHeiti,sans-serif' },
    { name: 'Weiruanyahei', value: 'Weiruanyahei' },
    { name: 'fangsong', value: 'FangSong,STFangsong,sans-serif' },
    { name: 'kaiti', value: 'KaiTi,STKaiti,sans-serif' },
    { name: 'arial', value: 'Arial,sans-serif' },
    { name: 'droid', value: '"Droid Serif",sans-serif' },
    { name: 'source', value: '"Source Code Pro",sans-serif' },
];
let fontNameToValueMap = [...fontList].sort((a, b) => {
    return a.name > b.name ? 1 : -1;
});
let fontValueToNameMap = [...fontList].sort((a, b) => {
    return a.value > b.value ? 1 : -1;
});
const EnumFont = {
    setFontList(fonts) {
        fontList = fonts;
        fontNameToValueMap = [...fonts].sort((a, b) => {
            return a.name > b.name ? 1 : -1;
        });
        fontValueToNameMap = [...fonts].sort((a, b) => {
            return a.value > b.value ? 1 : -1;
        });
    },
    getFontValue(fontName) {
        const resIndex = binary_search_bounds__WEBPACK_IMPORTED_MODULE_0___default().eq(fontNameToValueMap, { name: fontName, value: '' }, (a, b) => {
            return a.name > b.name ? 1 : a.name < b.name ? -1 : 0;
        });
        if (resIndex >= 0 && resIndex < fontList.length) {
            return fontNameToValueMap[resIndex].value;
        }
        else {
            return fontList[0].value;
        }
    },
    getFontName(fontValue) {
        const resIndex = binary_search_bounds__WEBPACK_IMPORTED_MODULE_0___default().eq(fontValueToNameMap, { name: '', value: fontValue }, (a, b) => {
            return a.value > b.value ? 1 : a.value < b.value ? -1 : 0;
        });
        if (resIndex >= 0 && resIndex < fontList.length) {
            return fontValueToNameMap[resIndex].name;
        }
        else {
            return fontList[0].name;
        }
    },
};



/***/ }),

/***/ "./src/Common/IAttributable.ts":
/*!*************************************!*\
  !*** ./src/Common/IAttributable.ts ***!
  \*************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IAttributableDecorator": function() { return /* binding */ IAttributableDecorator; }
/* harmony export */ });
function IAttributableDecorator(constructor) {
    return class extends constructor {
        setOverrideDefaultAttributes(attr) {
            var _a;
            let needCompileAttributes = false;
            if (!attr) {
                if (this.overrideDefaultAttributes !== null) {
                    this.overrideDefaultAttributes = null;
                    needCompileAttributes = true;
                }
            }
            else {
                const keys = Object.keys(attr);
                for (let i = 0, l = keys.length; i < l; i++) {
                    const key = keys[i];
                    if (attr.hasOwnProperty(key)) {
                        if (attr[key] === undefined && this.overrideDefaultAttributes) {
                            delete this.overrideDefaultAttributes[key];
                            needCompileAttributes = true;
                        }
                        else if (attr[key] !== undefined) {
                            this.overrideDefaultAttributes = (_a = this.overrideDefaultAttributes) !== null && _a !== void 0 ? _a : {};
                            this.overrideDefaultAttributes[key] = attr[key];
                            needCompileAttributes = true;
                        }
                    }
                }
            }
            if (needCompileAttributes) {
                this.compileAttributes();
            }
        }
        setOverrideAttributes(attr) {
            var _a;
            let needCompileAttributes = false;
            if (!attr) {
                if (this.overrideAttributes !== null) {
                    this.overrideAttributes = null;
                    needCompileAttributes = true;
                }
            }
            else {
                const keys = Object.keys(attr);
                for (let i = 0, l = keys.length; i < l; i++) {
                    const key = keys[i];
                    if (attr.hasOwnProperty(key)) {
                        if (attr[key] === undefined && this.overrideAttributes) {
                            delete this.overrideAttributes[key];
                            needCompileAttributes = true;
                        }
                        else if (attr[key] !== undefined) {
                            this.overrideAttributes = (_a = this.overrideAttributes) !== null && _a !== void 0 ? _a : {};
                            this.overrideAttributes[key] = attr[key];
                            needCompileAttributes = true;
                        }
                    }
                }
            }
            if (needCompileAttributes) {
                this.compileAttributes();
            }
        }
        setAttributes(attr) {
            var _a;
            let needCompileAttributes = false;
            if (!attr) {
                if (this.originalAttributes !== null) {
                    this.originalAttributes = null;
                    needCompileAttributes = true;
                }
            }
            else {
                const keys = Object.keys(this.defaultAttributes);
                for (let i = 0, l = keys.length; i < l; i++) {
                    const key = keys[i];
                    if (attr.hasOwnProperty(key)) {
                        if (attr[key] === undefined && this.originalAttributes && this.originalAttributes.hasOwnProperty(key)) {
                            delete this.originalAttributes[key];
                            needCompileAttributes = true;
                        }
                        else if (attr[key] !== this.defaultAttributes[key] &&
                            (this.originalAttributes === null || attr[key] !== this.originalAttributes[key])) {
                            this.originalAttributes = (_a = this.originalAttributes) !== null && _a !== void 0 ? _a : {};
                            this.originalAttributes[key] = attr[key];
                            needCompileAttributes = true;
                        }
                        else if (attr[key] === this.defaultAttributes[key] &&
                            this.originalAttributes &&
                            this.originalAttributes.hasOwnProperty(key)) {
                            delete this.originalAttributes[key];
                            needCompileAttributes = true;
                            if (Object.keys(this.originalAttributes).length === 0) {
                                this.originalAttributes = null;
                            }
                        }
                    }
                }
            }
            if (needCompileAttributes) {
                this.compileAttributes();
            }
        }
        compileAttributes() {
            var _a, _b, _c;
            const keys = Object.keys(this.defaultAttributes);
            for (let i = 0, l = keys.length; i < l; i++) {
                const key = keys[i];
                if ((_a = this.overrideAttributes) === null || _a === void 0 ? void 0 : _a.hasOwnProperty(key)) {
                    this.attributes[key] = this.overrideAttributes[key];
                }
                else if ((_b = this.originalAttributes) === null || _b === void 0 ? void 0 : _b.hasOwnProperty(key)) {
                    this.attributes[key] = this.originalAttributes[key];
                }
                else if ((_c = this.overrideDefaultAttributes) === null || _c === void 0 ? void 0 : _c.hasOwnProperty(key)) {
                    this.attributes[key] = this.overrideDefaultAttributes[key];
                }
                else if (this.defaultAttributes.hasOwnProperty(key)) {
                    this.attributes[key] = this.defaultAttributes[key];
                }
            }
        }
    };
}


/***/ }),

/***/ "./src/Common/IBubbleUpable.ts":
/*!*************************************!*\
  !*** ./src/Common/IBubbleUpable.ts ***!
  \*************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IBubbleUpableDecorator": function() { return /* binding */ IBubbleUpableDecorator; }
/* harmony export */ });
function IBubbleUpableDecorator(constructor) {
    return class extends constructor {
        constructor() {
            super(...arguments);
            this.bubbleHandler = null;
        }
        bubbleUp(type, data, stack) {
            if (typeof this.bubbleHandler === 'function') {
                let newStack;
                if (Array.isArray(stack)) {
                    stack.push(this);
                }
                else {
                    newStack = [this];
                }
                this.bubbleHandler(type, data, newStack !== null && newStack !== void 0 ? newStack : stack);
            }
        }
        setBubbleHandler(handler) {
            if (typeof handler === 'function') {
                this.bubbleHandler = handler;
            }
            else {
                this.bubbleHandler = null;
            }
        }
    };
}


/***/ }),

/***/ "./src/Common/ICanvasContext.ts":
/*!**************************************!*\
  !*** ./src/Common/ICanvasContext.ts ***!
  \**************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);



/***/ }),

/***/ "./src/Common/ICommand.ts":
/*!********************************!*\
  !*** ./src/Common/ICommand.ts ***!
  \********************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);



/***/ }),

/***/ "./src/Common/ICoordinatePos.ts":
/*!**************************************!*\
  !*** ./src/Common/ICoordinatePos.ts ***!
  \**************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);



/***/ }),

/***/ "./src/Common/IDocPosOperator.ts":
/*!***************************************!*\
  !*** ./src/Common/IDocPosOperator.ts ***!
  \***************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IDosPosOperatorHDecorator": function() { return /* binding */ IDosPosOperatorHDecorator; },
/* harmony export */   "IDosPosOperatorVDecorator": function() { return /* binding */ IDosPosOperatorVDecorator; }
/* harmony export */ });
/* harmony import */ var _DocPos__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./DocPos */ "./src/Common/DocPos.ts");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./util */ "./src/Common/util.ts");


function IDosPosOperatorHDecorator(constructor) {
    return class extends constructor {
        firstPos() {
            if (!this.head) {
                throw new Error('layout frame should not be empty while getting firstPos');
            }
            return { index: 0, inner: null };
        }
        lastPos() {
            if (!this.tail) {
                throw new Error('layout frame should not be empty while getting lastPos');
            }
            const endPos = this.tail.lastPos();
            return { index: endPos.index + this.tail.start, inner: endPos.inner };
        }
        nextPos(pos) {
            const targetChild = (0,_util__WEBPACK_IMPORTED_MODULE_1__.findChildInDocPos)(pos.index, this.children);
            let res = null;
            if (targetChild) {
                res = targetChild.nextPos((0,_DocPos__WEBPACK_IMPORTED_MODULE_0__.getRelativeDocPos)(targetChild.start, pos));
                if (!res) {
                    if (targetChild.nextSibling) {
                        res = targetChild.nextSibling.firstPos();
                        res = { index: res.index + targetChild.nextSibling.start, inner: res.inner };
                    }
                }
                else {
                    res = { index: res.index + targetChild.start, inner: res.inner };
                }
            }
            return res;
        }
        prevPos(pos) {
            const targetChild = (0,_util__WEBPACK_IMPORTED_MODULE_1__.findChildInDocPos)(pos.index, this.children);
            let res = null;
            if (targetChild) {
                res = targetChild.prevPos((0,_DocPos__WEBPACK_IMPORTED_MODULE_0__.getRelativeDocPos)(targetChild.start, pos));
                if (!res) {
                    if (targetChild.prevSibling) {
                        res = targetChild.prevSibling.lastPos();
                        res = { index: res.index + targetChild.prevSibling.start, inner: res.inner };
                    }
                }
                else {
                    res = { index: res.index + targetChild.start, inner: res.inner };
                }
            }
            return res;
        }
    };
}
function IDosPosOperatorVDecorator(constructor) {
    return class extends constructor {
        firstLinePos(x) {
            var _a, _b;
            return (_b = (_a = this.head) === null || _a === void 0 ? void 0 : _a.firstLinePos(x)) !== null && _b !== void 0 ? _b : null;
        }
        lastLinePos(x) {
            const targetChild = this.children[this.children.length - 1];
            const res = targetChild.lastLinePos(x);
            return res ? { index: res.index + targetChild.start, inner: res.inner } : null;
        }
        nextLinePos(pos, x) {
            const targetChild = (0,_util__WEBPACK_IMPORTED_MODULE_1__.findChildInDocPos)(pos.index, this.children);
            let res = null;
            if (targetChild) {
                res = targetChild.nextLinePos((0,_DocPos__WEBPACK_IMPORTED_MODULE_0__.getRelativeDocPos)(targetChild.start, pos), x - targetChild.x);
                if (!res) {
                    if (targetChild.nextSibling) {
                        res = targetChild.nextSibling.firstLinePos(x);
                        if (res) {
                            res = { index: res.index + targetChild.nextSibling.start, inner: res.inner };
                        }
                    }
                }
                else {
                    res = { index: res.index + targetChild.start, inner: res.inner };
                }
            }
            return res;
        }
        prevLinePos(pos, x) {
            const targetChild = (0,_util__WEBPACK_IMPORTED_MODULE_1__.findChildInDocPos)(pos.index, this.children);
            let res = null;
            if (targetChild) {
                res = targetChild.prevLinePos((0,_DocPos__WEBPACK_IMPORTED_MODULE_0__.getRelativeDocPos)(targetChild.start, pos), x - targetChild.x);
                if (!res) {
                    if (targetChild.prevSibling) {
                        res = targetChild.prevSibling.lastLinePos(x);
                        if (res) {
                            res = { index: res.index + targetChild.prevSibling.start, inner: res.inner };
                        }
                    }
                }
                else {
                    res = { index: res.index + targetChild.start, inner: res.inner };
                }
            }
            return res;
        }
        lineStartPos(pos, y) {
            const targetChild = (0,_util__WEBPACK_IMPORTED_MODULE_1__.findChildInDocPos)(pos.index, this.children);
            let res = null;
            if (targetChild) {
                res = targetChild.lineStartPos((0,_DocPos__WEBPACK_IMPORTED_MODULE_0__.getRelativeDocPos)(targetChild.start, pos), y - targetChild.y);
                if (res) {
                    res = { index: res.index + targetChild.start, inner: res.inner };
                }
            }
            return res;
        }
        lineEndPos(pos, y) {
            const targetChild = (0,_util__WEBPACK_IMPORTED_MODULE_1__.findChildInDocPos)(pos.index, this.children);
            let res = null;
            if (targetChild) {
                res = targetChild.lineEndPos((0,_DocPos__WEBPACK_IMPORTED_MODULE_0__.getRelativeDocPos)(targetChild.start, pos), y - targetChild.y);
                if (res) {
                    res = { index: res.index + targetChild.start, inner: res.inner };
                }
            }
            return res;
        }
    };
}


/***/ }),

/***/ "./src/Common/IDrawable.ts":
/*!*********************************!*\
  !*** ./src/Common/IDrawable.ts ***!
  \*********************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);



/***/ }),

/***/ "./src/Common/IFragmentMetrics.ts":
/*!****************************************!*\
  !*** ./src/Common/IFragmentMetrics.ts ***!
  \****************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);



/***/ }),

/***/ "./src/Common/IPointerInteractive.ts":
/*!*******************************************!*\
  !*** ./src/Common/IPointerInteractive.ts ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IPointerInteractiveDecorator": function() { return /* binding */ IPointerInteractiveDecorator; }
/* harmony export */ });
function IPointerInteractiveDecorator(constructor) {
    return class extends constructor {
        constructor() {
            super(...arguments);
            this.currentHoverElement = null;
        }
        onPointerEnter(x, y, targetStack, currentTargetIndex) {
            if (this.currentHoverElement) {
                // 按说在 enter 的时候，不可能有 currentHoverElement
                console.trace('strange');
            }
            else {
                const hoverBlock = targetStack[currentTargetIndex + 1];
                if (hoverBlock) {
                    hoverBlock.onPointerEnter(x - hoverBlock.x, y - hoverBlock.y, targetStack, currentTargetIndex + 1);
                    this.currentHoverElement = hoverBlock;
                }
            }
        }
        onPointerLeave() {
            if (this.currentHoverElement) {
                this.currentHoverElement.onPointerLeave();
                this.currentHoverElement = null;
            }
        }
        onPointerMove(x, y, targetStack, currentTargetIndex) {
            if (this.currentHoverElement) {
                if (this.currentHoverElement === targetStack[currentTargetIndex + 1]) {
                    this.currentHoverElement.onPointerMove(x - this.currentHoverElement.x, y - this.currentHoverElement.y, targetStack, currentTargetIndex + 1);
                    return;
                }
                else {
                    this.currentHoverElement.onPointerLeave();
                    this.currentHoverElement = null;
                }
            }
            const hoverBlock = targetStack[currentTargetIndex + 1];
            if (hoverBlock) {
                hoverBlock.onPointerEnter(x - hoverBlock.x, y - hoverBlock.y, targetStack, currentTargetIndex + 1);
                this.currentHoverElement = hoverBlock;
            }
        }
        onPointerDown(x, y) {
            if (this.currentHoverElement) {
                this.currentHoverElement.onPointerDown(x - this.currentHoverElement.x, y - this.currentHoverElement.y);
            }
        }
        onPointerUp(x, y) {
            if (this.currentHoverElement) {
                this.currentHoverElement.onPointerUp(x - this.currentHoverElement.x, y - this.currentHoverElement.y);
            }
        }
        onPointerTap(x, y) {
            if (this.currentHoverElement) {
                this.currentHoverElement.onPointerTap(x - this.currentHoverElement.x, y - this.currentHoverElement.y);
            }
        }
    };
}


/***/ }),

/***/ "./src/Common/IRange.ts":
/*!******************************!*\
  !*** ./src/Common/IRange.ts ***!
  \******************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);



/***/ }),

/***/ "./src/Common/IRectangle.ts":
/*!**********************************!*\
  !*** ./src/Common/IRectangle.ts ***!
  \**********************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);



/***/ }),

/***/ "./src/Common/IRenderStructure.ts":
/*!****************************************!*\
  !*** ./src/Common/IRenderStructure.ts ***!
  \****************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);



/***/ }),

/***/ "./src/Common/ISearchResult.ts":
/*!*************************************!*\
  !*** ./src/Common/ISearchResult.ts ***!
  \*************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);



/***/ }),

/***/ "./src/Common/ISelectedElementGettable.ts":
/*!************************************************!*\
  !*** ./src/Common/ISelectedElementGettable.ts ***!
  \************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ISelectedElementGettableDecorator": function() { return /* binding */ ISelectedElementGettableDecorator; }
/* harmony export */ });
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./util */ "./src/Common/util.ts");

function ISelectedElementGettableDecorator(constructor) {
    return class extends constructor {
        getSelectedElement(range) {
            return (0,_util__WEBPACK_IMPORTED_MODULE_0__.getSelectedElement)(range, this, this.children);
        }
    };
}


/***/ }),

/***/ "./src/Common/IoC.ts":
/*!***************************!*\
  !*** ./src/Common/IoC.ts ***!
  \***************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bind": function() { return /* binding */ bind; },
/* harmony export */   "create": function() { return /* binding */ create; },
/* harmony export */   "createRunByFragment": function() { return /* binding */ createRunByFragment; },
/* harmony export */   "get": function() { return /* binding */ get; },
/* harmony export */   "mapRunToFragment": function() { return /* binding */ mapRunToFragment; }
/* harmony export */ });
const classMap = new Map();
const bind = (type, constructorFunction) => {
    if (classMap.has(type)) {
        throw new Error(`can not bind twice: ${type}`);
    }
    classMap.set(type, constructorFunction);
};
const get = (type) => {
    if (!classMap.has(type)) {
        throw new Error(`can not find constructor: ${type}`);
    }
    return classMap.get(type);
};
const create = (type, ...args) => {
    const ConstructorFunction = classMap.get(type);
    if (!ConstructorFunction) {
        throw new Error(`can not find constructor: ${type}`);
    }
    else {
        return new ConstructorFunction(...args);
    }
};
const fragmentRunMap = new Map();
const mapRunToFragment = (fragTypeName, runTypeName) => {
    fragmentRunMap.set(fragTypeName, runTypeName);
};
const createRunByFragment = (frag) => {
    const fragType = frag.typeName;
    const runType = fragmentRunMap.get(fragType);
    if (runType) {
        return create(runType, frag);
    }
    throw new Error(`can not find run constructor: ${frag}`);
};


/***/ }),

/***/ "./src/Common/LayoutPiece.ts":
/*!***********************************!*\
  !*** ./src/Common/LayoutPiece.ts ***!
  \***********************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LayoutPiece": function() { return /* binding */ LayoutPiece; }
/* harmony export */ });
/* harmony import */ var _Platform__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Platform */ "./src/Platform.ts");

class LayoutPiece {
    constructor(isHolder) {
        this.frags = [];
        this.isSpace = false;
        this.text = '';
        this.totalWidth = 0;
        this.fragWidth = [];
        this.isHolder = isHolder;
    }
    calTotalWidth() {
        if (this.isHolder) {
            this.totalWidth = this.frags[0].frag.calTotalWidth();
            this.fragWidth = [this.totalWidth];
            return;
        }
        let width;
        if (this.frags.length === 1) {
            width = (0,_Platform__WEBPACK_IMPORTED_MODULE_0__.getPlatform)().measureTextWidth(this.text, this.frags[0].frag.attributes);
            this.fragWidth = [width];
        }
        else {
            if (this.fragWidth === undefined || !this.fragWidth.length) {
                this.calFragWidth();
            }
            width = this.fragWidth.reduce((sum, cur) => {
                return sum + cur;
            }, 0);
        }
        this.totalWidth = width;
    }
    calFragWidth() {
        if (this.frags.length === 1) {
            this.fragWidth = [this.totalWidth];
        }
        else {
            this.fragWidth = this.frags.map((frag) => {
                return (0,_Platform__WEBPACK_IMPORTED_MODULE_0__.getPlatform)().measureTextWidth(this.text.substring(frag.start, frag.end), frag.frag.attributes);
            });
        }
    }
    calCharWidthByFrag(fragIndex) {
        const frag = this.frags[fragIndex];
        return this.text
            .substr(frag.start, frag.end)
            .split('')
            .map((char) => {
            return (0,_Platform__WEBPACK_IMPORTED_MODULE_0__.getPlatform)().measureTextWidth(char, frag.frag.attributes);
        });
    }
}


/***/ }),

/***/ "./src/Common/LinkedList.ts":
/*!**********************************!*\
  !*** ./src/Common/LinkedList.ts ***!
  \**********************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ILinkedListDecorator": function() { return /* binding */ ILinkedListDecorator; }
/* harmony export */ });
function ILinkedListDecorator(constructor) {
    return class extends constructor {
        constructor() {
            super(...arguments);
            this.children = [];
            this.head = null;
            this.tail = null;
        }
        /**
         * 在当前链式列表末尾插入一个子元素
         * @param node 子元素实例
         */
        addLast(node) {
            if (this.beforeAdd) {
                this.beforeAdd([node], this.children.length, this.tail, null, this.children);
            }
            if (this.tail === null) {
                this.head = node;
            }
            else {
                this.tail.nextSibling = node;
            }
            node.prevSibling = this.tail;
            this.tail = node;
            this.children.push(node);
            if (this.afterAdd) {
                this.afterAdd([node], this.children.length - 1, this.tail, null, this.children);
            }
        }
        /**
         * 在目标子元素实例后插入一个子元素
         * @param node 要插入的子元素实例
         * @param target 目标子元素实例
         */
        addAfter(node, target) {
            const index = this.findIndex(target);
            if (index > -1) {
                if (this.beforeAdd) {
                    this.beforeAdd([node], index + 1, target, target.nextSibling, this.children);
                }
                this.children.splice(index + 1, 0, node);
                if (target.nextSibling !== null) {
                    target.nextSibling.prevSibling = node;
                    node.nextSibling = target.nextSibling;
                }
                else {
                    this.tail = node;
                }
                node.prevSibling = target;
                target.nextSibling = node;
                if (this.afterAdd) {
                    this.afterAdd([node], index + 1, target, target.nextSibling, this.children);
                }
            }
            else {
                throw new Error('target not exist in this list');
            }
        }
        /**
         * 在目标子元素实例前插入一个子元素
         * @param node 要插入的子元素实例
         * @param target 目标子元素实例
         */
        addBefore(node, target) {
            const index = this.findIndex(target);
            if (index > -1) {
                if (this.beforeAdd) {
                    this.beforeAdd([node], index, target.prevSibling, target, this.children);
                }
                this.children.splice(index, 0, node);
                if (target.prevSibling !== null) {
                    target.prevSibling.nextSibling = node;
                    node.prevSibling = target.prevSibling;
                }
                else {
                    this.head = node;
                }
                node.nextSibling = target;
                target.prevSibling = node;
                if (this.afterAdd) {
                    this.afterAdd([node], index, node.prevSibling, target, this.children);
                }
            }
            else {
                throw new Error('target not exist in this list');
            }
        }
        /**
         * 在指定索引位置插入一个子元素实例
         * @param node 子元素实例
         * @param index 索引位置
         */
        addAtIndex(node, index) {
            if (index > this.children.length || index < 0) {
                throw new Error('invalid insert position');
            }
            else {
                if (this.children.length === index) {
                    if (this.beforeAdd) {
                        this.beforeAdd([node], index, this.tail, null, this.children);
                    }
                    if (this.tail === null) {
                        this.head = node;
                    }
                    else {
                        this.tail.nextSibling = node;
                    }
                    node.prevSibling = this.tail;
                    this.tail = node;
                    this.children.push(node);
                }
                else {
                    const target = this.children[index];
                    if (this.beforeAdd) {
                        this.beforeAdd([node], index, target.prevSibling, target, this.children);
                    }
                    this.children.splice(index, 0, node);
                    if (target.prevSibling !== null) {
                        target.prevSibling.nextSibling = node;
                        node.prevSibling = target.prevSibling;
                    }
                    else {
                        this.head = node;
                    }
                    node.nextSibling = target;
                    target.prevSibling = node;
                }
                if (this.afterAdd) {
                    this.afterAdd([node], index, node.prevSibling, node.nextSibling, this.children);
                }
            }
        }
        /**
         * 将一组子元素实例插入当前链式列表末尾
         * @param nodes 子元素数组
         */
        addAll(nodes) {
            if (nodes.length === 0) {
                return;
            }
            if (this.beforeAdd) {
                this.beforeAdd(nodes, this.children.length, this.tail, null, this.children);
            }
            for (let index = 0, l = nodes.length; index < l; index++) {
                const current = nodes[index];
                if (index > 0) {
                    current.prevSibling = nodes[index - 1];
                    nodes[index - 1].nextSibling = current;
                }
            }
            if (this.children.length > 0) {
                const lastChild = this.children[this.children.length - 1];
                lastChild.nextSibling = nodes[0];
                nodes[0].prevSibling = lastChild;
            }
            else {
                this.head = nodes[0];
            }
            this.tail = nodes[nodes.length - 1];
            // push 方法的参数数量是有限制的，不同浏览器不同，限制在 65535 个参数是比较稳妥的
            if (nodes.length <= 65535) {
                this.children.push(...nodes);
            }
            else {
                let currentIndex = 0;
                while (currentIndex < nodes.length) {
                    this.children.push(...nodes.slice(currentIndex, currentIndex + 65535));
                    currentIndex += 65535;
                }
            }
            if (this.afterAdd) {
                this.afterAdd(nodes, this.children.length - nodes.length, nodes[0].prevSibling, null, this.children);
            }
        }
        /**
         * 清楚当前链式列表中所有子元素
         */
        removeAll() {
            if (this.beforeRemove) {
                this.beforeRemove(this.children, 0, null, null, this.children);
            }
            for (let i = this.children.length - 1; i >= 0; i--) {
                this.children[i].destroy();
                this.children[i].prevSibling = null;
                this.children[i].nextSibling = null;
            }
            this.head = null;
            this.tail = null;
            const res = [...this.children];
            this.children.length = 0;
            if (this.afterRemove) {
                this.afterRemove(res, 0, null, null, res);
            }
            return res;
        }
        /**
         * 从当前链式列表删除一个子元素
         * @param node 要删除的子元素
         */
        remove(node) {
            const index = this.findIndex(node);
            if (index > -1) {
                const prevNode = node.prevSibling;
                const nextNode = node.nextSibling;
                if (this.beforeRemove) {
                    this.beforeRemove([node], index, prevNode, nextNode, this.children);
                }
                this.children.splice(index, 1);
                if (node === this.tail) {
                    this.tail = node.prevSibling;
                }
                if (node === this.head) {
                    this.head = node.nextSibling;
                }
                if (node.nextSibling !== null) {
                    node.nextSibling.prevSibling = node.prevSibling;
                }
                if (node.prevSibling !== null) {
                    node.prevSibling.nextSibling = node.nextSibling;
                }
                node.nextSibling = null;
                node.prevSibling = null;
                if (this.afterRemove) {
                    this.afterRemove([node], index, prevNode, nextNode, this.children);
                }
            }
            else {
                throw new Error('can not remove node which is not in children list');
            }
        }
        /**
         * 删除指定子元素及其后的所有子元素
         * @returns 以数组形式返回所有被删除的子元素
         */
        removeAllFrom(node) {
            const index = this.findIndex(node);
            if (index > -1) {
                const prevNode = node.prevSibling;
                if (this.beforeRemove) {
                    this.beforeRemove(this.children.slice(index), index, prevNode, null, this.children);
                }
                const res = this.children.splice(index);
                if (node === this.head) {
                    this.head = null;
                    this.tail = null;
                }
                else {
                    this.tail = node.prevSibling;
                    this.tail.nextSibling = null;
                    node.prevSibling = null;
                }
                if (res.length > 0) {
                    for (let itemIndex = 0; itemIndex < res.length; itemIndex++) {
                        const item = res[itemIndex];
                        item.nextSibling = null;
                        item.prevSibling = null;
                    }
                }
                if (this.afterRemove) {
                    this.afterRemove(res, index, prevNode, null, this.children);
                }
                return res;
            }
            else {
                throw new Error('can not remove node which is not in children list');
            }
        }
        /**
         * splice children
         */
        splice(start, deleteCount, nodes = []) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
            const removedNodes = deleteCount > 0 ? this.children.slice(start, start + deleteCount) : [];
            if (deleteCount > 0 && this.beforeRemove) {
                this.beforeRemove(removedNodes, start, (_b = (_a = this.children[start]) === null || _a === void 0 ? void 0 : _a.prevSibling) !== null && _b !== void 0 ? _b : null, (_d = (_c = this.children[start + deleteCount - 1]) === null || _c === void 0 ? void 0 : _c.nextSibling) !== null && _d !== void 0 ? _d : null, this.children);
            }
            if (nodes.length > 0 && this.beforeAdd) {
                this.beforeAdd(nodes, start, (_f = (_e = this.children[start]) === null || _e === void 0 ? void 0 : _e.prevSibling) !== null && _f !== void 0 ? _f : null, (_h = (_g = this.children[start + deleteCount - 1]) === null || _g === void 0 ? void 0 : _g.nextSibling) !== null && _h !== void 0 ? _h : null, this.children);
            }
            if (deleteCount > 0) {
                for (let index = 0; index < removedNodes.length; index++) {
                    const element = removedNodes[index];
                    if (index === 0 && element.prevSibling !== null) {
                        element.prevSibling.nextSibling = null;
                    }
                    if (index === removedNodes.length - 1 && element.nextSibling !== null) {
                        element.nextSibling.prevSibling = null;
                    }
                    element.nextSibling = null;
                    element.prevSibling = null;
                }
            }
            if (nodes.length > 0) {
                for (let index = 0; index < nodes.length - 1; index++) {
                    const currentElement = nodes[index];
                    const nextElement = nodes[index + 1];
                    currentElement.nextSibling = nextElement;
                    nextElement.prevSibling = currentElement;
                }
                nodes[0].prevSibling = null;
                nodes[nodes.length - 1].nextSibling = null;
            }
            const actuallyInsertIndex = Math.min(start, this.children.length - 1);
            this.children.splice(actuallyInsertIndex, deleteCount, ...nodes);
            if (nodes.length > 0) {
                if (actuallyInsertIndex > 0) {
                    this.children[actuallyInsertIndex - 1].nextSibling = nodes[0];
                    nodes[0].prevSibling = this.children[actuallyInsertIndex - 1];
                }
                if (actuallyInsertIndex + nodes.length < this.children.length) {
                    const actuallyInsertEndIndex = actuallyInsertIndex + nodes.length - 1;
                    this.children[actuallyInsertEndIndex].nextSibling = this.children[actuallyInsertEndIndex + 1];
                    this.children[actuallyInsertEndIndex + 1].prevSibling = this.children[actuallyInsertEndIndex];
                }
            }
            if (this.children.length > 0) {
                this.head = this.children[0];
                this.tail = this.children[this.children.length - 1];
            }
            else {
                this.head = null;
                this.tail = null;
            }
            if (deleteCount > 0 && this.afterRemove) {
                this.afterRemove(removedNodes, start, (_k = (_j = this.children[start]) === null || _j === void 0 ? void 0 : _j.prevSibling) !== null && _k !== void 0 ? _k : null, (_m = (_l = this.children[start + deleteCount - 1]) === null || _l === void 0 ? void 0 : _l.nextSibling) !== null && _m !== void 0 ? _m : null, this.children);
            }
            if (nodes.length > 0 && this.afterAdd) {
                this.afterAdd(nodes, start, (_p = (_o = this.children[start]) === null || _o === void 0 ? void 0 : _o.prevSibling) !== null && _p !== void 0 ? _p : null, (_r = (_q = this.children[start + deleteCount - 1]) === null || _q === void 0 ? void 0 : _q.nextSibling) !== null && _r !== void 0 ? _r : null, this.children);
            }
            return removedNodes;
        }
        /**
         * 查找元素在当前链式列表中的索引位置，如果找不到返回 -1
         * @param node 子元素实例
         */
        findIndex(node) {
            let res = -1;
            for (let i = this.children.length - 1; i >= 0; i--) {
                if (this.children[i] === node) {
                    res = i;
                }
            }
            return res;
        }
    };
}


/***/ }),

/***/ "./src/Common/index.ts":
/*!*****************************!*\
  !*** ./src/Common/index.ts ***!
  \*****************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BubbleMessage": function() { return /* reexport safe */ _EnumBubbleMessage__WEBPACK_IMPORTED_MODULE_2__.BubbleMessage; },
/* harmony export */   "EnumAlign": function() { return /* reexport safe */ _EnumParagraphStyle__WEBPACK_IMPORTED_MODULE_5__.EnumAlign; },
/* harmony export */   "EnumCellVerticalAlign": function() { return /* reexport safe */ _EnumTableStyle__WEBPACK_IMPORTED_MODULE_6__.EnumCellVerticalAlign; },
/* harmony export */   "EnumCursorType": function() { return /* reexport safe */ _EnumCursorType__WEBPACK_IMPORTED_MODULE_3__.EnumCursorType; },
/* harmony export */   "EnumFont": function() { return /* reexport safe */ _EnumTextStyle__WEBPACK_IMPORTED_MODULE_7__.EnumFont; },
/* harmony export */   "EnumIntersectionType": function() { return /* reexport safe */ _util__WEBPACK_IMPORTED_MODULE_25__.EnumIntersectionType; },
/* harmony export */   "EnumListType": function() { return /* reexport safe */ _EnumListStyle__WEBPACK_IMPORTED_MODULE_4__.EnumListType; },
/* harmony export */   "EnumTitle": function() { return /* reexport safe */ _EnumTextStyle__WEBPACK_IMPORTED_MODULE_7__.EnumTitle; },
/* harmony export */   "IAttributableDecorator": function() { return /* reexport safe */ _IAttributable__WEBPACK_IMPORTED_MODULE_8__.IAttributableDecorator; },
/* harmony export */   "IBubbleUpableDecorator": function() { return /* reexport safe */ _IBubbleUpable__WEBPACK_IMPORTED_MODULE_9__.IBubbleUpableDecorator; },
/* harmony export */   "IDosPosOperatorHDecorator": function() { return /* reexport safe */ _IDocPosOperator__WEBPACK_IMPORTED_MODULE_13__.IDosPosOperatorHDecorator; },
/* harmony export */   "IDosPosOperatorVDecorator": function() { return /* reexport safe */ _IDocPosOperator__WEBPACK_IMPORTED_MODULE_13__.IDosPosOperatorVDecorator; },
/* harmony export */   "ILinkedListDecorator": function() { return /* reexport safe */ _LinkedList__WEBPACK_IMPORTED_MODULE_24__.ILinkedListDecorator; },
/* harmony export */   "IPointerInteractiveDecorator": function() { return /* reexport safe */ _IPointerInteractive__WEBPACK_IMPORTED_MODULE_16__.IPointerInteractiveDecorator; },
/* harmony export */   "ISelectedElementGettableDecorator": function() { return /* reexport safe */ _ISelectedElementGettable__WEBPACK_IMPORTED_MODULE_21__.ISelectedElementGettableDecorator; },
/* harmony export */   "LayoutPiece": function() { return /* reexport safe */ _LayoutPiece__WEBPACK_IMPORTED_MODULE_23__.LayoutPiece; },
/* harmony export */   "bind": function() { return /* reexport safe */ _IoC__WEBPACK_IMPORTED_MODULE_22__.bind; },
/* harmony export */   "calListItemTitle": function() { return /* reexport safe */ _util__WEBPACK_IMPORTED_MODULE_25__.calListItemTitle; },
/* harmony export */   "calListTypeFromChangeData": function() { return /* reexport safe */ _util__WEBPACK_IMPORTED_MODULE_25__.calListTypeFromChangeData; },
/* harmony export */   "clearFormat": function() { return /* reexport safe */ _util__WEBPACK_IMPORTED_MODULE_25__.clearFormat; },
/* harmony export */   "cloneDocPos": function() { return /* reexport safe */ _DocPos__WEBPACK_IMPORTED_MODULE_1__.cloneDocPos; },
/* harmony export */   "collectAttributes": function() { return /* reexport safe */ _util__WEBPACK_IMPORTED_MODULE_25__.collectAttributes; },
/* harmony export */   "compareDocPos": function() { return /* reexport safe */ _DocPos__WEBPACK_IMPORTED_MODULE_1__.compareDocPos; },
/* harmony export */   "convertFragmentAttributesToCssStyleText": function() { return /* reexport safe */ _util__WEBPACK_IMPORTED_MODULE_25__.convertFragmentAttributesToCssStyleText; },
/* harmony export */   "convertTo26": function() { return /* reexport safe */ _util__WEBPACK_IMPORTED_MODULE_25__.convertTo26; },
/* harmony export */   "convertToRoman": function() { return /* reexport safe */ _util__WEBPACK_IMPORTED_MODULE_25__.convertToRoman; },
/* harmony export */   "create": function() { return /* reexport safe */ _IoC__WEBPACK_IMPORTED_MODULE_22__.create; },
/* harmony export */   "createRunByFragment": function() { return /* reexport safe */ _IoC__WEBPACK_IMPORTED_MODULE_22__.createRunByFragment; },
/* harmony export */   "deleteRange": function() { return /* reexport safe */ _util__WEBPACK_IMPORTED_MODULE_25__.deleteRange; },
/* harmony export */   "documentPosToJSON": function() { return /* reexport safe */ _DocPos__WEBPACK_IMPORTED_MODULE_1__.documentPosToJSON; },
/* harmony export */   "findChildInDocPos": function() { return /* reexport safe */ _util__WEBPACK_IMPORTED_MODULE_25__.findChildInDocPos; },
/* harmony export */   "findChildIndexInDocPos": function() { return /* reexport safe */ _util__WEBPACK_IMPORTED_MODULE_25__.findChildIndexInDocPos; },
/* harmony export */   "findChildrenByRange": function() { return /* reexport safe */ _util__WEBPACK_IMPORTED_MODULE_25__.findChildrenByRange; },
/* harmony export */   "findHalf": function() { return /* reexport safe */ _util__WEBPACK_IMPORTED_MODULE_25__.findHalf; },
/* harmony export */   "findRectChildInPos": function() { return /* reexport safe */ _util__WEBPACK_IMPORTED_MODULE_25__.findRectChildInPos; },
/* harmony export */   "findRectChildInPosY": function() { return /* reexport safe */ _util__WEBPACK_IMPORTED_MODULE_25__.findRectChildInPosY; },
/* harmony export */   "format": function() { return /* reexport safe */ _util__WEBPACK_IMPORTED_MODULE_25__.format; },
/* harmony export */   "get": function() { return /* reexport safe */ _IoC__WEBPACK_IMPORTED_MODULE_22__.get; },
/* harmony export */   "getDefaultDocContentDelta": function() { return /* reexport safe */ _Constant__WEBPACK_IMPORTED_MODULE_0__.getDefaultDocContentDelta; },
/* harmony export */   "getFormat": function() { return /* reexport safe */ _util__WEBPACK_IMPORTED_MODULE_25__.getFormat; },
/* harmony export */   "getRelativeDocPos": function() { return /* reexport safe */ _DocPos__WEBPACK_IMPORTED_MODULE_1__.getRelativeDocPos; },
/* harmony export */   "getSelectedElement": function() { return /* reexport safe */ _util__WEBPACK_IMPORTED_MODULE_25__.getSelectedElement; },
/* harmony export */   "hasIntersection": function() { return /* reexport safe */ _util__WEBPACK_IMPORTED_MODULE_25__.hasIntersection; },
/* harmony export */   "hasModify": function() { return /* reexport safe */ _util__WEBPACK_IMPORTED_MODULE_25__.hasModify; },
/* harmony export */   "increaseId": function() { return /* reexport safe */ _util__WEBPACK_IMPORTED_MODULE_25__.increaseId; },
/* harmony export */   "isChinese": function() { return /* reexport safe */ _util__WEBPACK_IMPORTED_MODULE_25__.isChinese; },
/* harmony export */   "isPointInRectangle": function() { return /* reexport safe */ _util__WEBPACK_IMPORTED_MODULE_25__.isPointInRectangle; },
/* harmony export */   "jsonToDocumentPos": function() { return /* reexport safe */ _DocPos__WEBPACK_IMPORTED_MODULE_1__.jsonToDocumentPos; },
/* harmony export */   "mapRunToFragment": function() { return /* reexport safe */ _IoC__WEBPACK_IMPORTED_MODULE_22__.mapRunToFragment; },
/* harmony export */   "moveDocPos": function() { return /* reexport safe */ _DocPos__WEBPACK_IMPORTED_MODULE_1__.moveDocPos; },
/* harmony export */   "moveRight": function() { return /* reexport safe */ _DocPos__WEBPACK_IMPORTED_MODULE_1__.moveRight; },
/* harmony export */   "numberToChinese": function() { return /* reexport safe */ _util__WEBPACK_IMPORTED_MODULE_25__.numberToChinese; },
/* harmony export */   "searchTextString": function() { return /* reexport safe */ _util__WEBPACK_IMPORTED_MODULE_25__.searchTextString; },
/* harmony export */   "setDefaultDocContentDelta": function() { return /* reexport safe */ _Constant__WEBPACK_IMPORTED_MODULE_0__.setDefaultDocContentDelta; },
/* harmony export */   "toHtml": function() { return /* reexport safe */ _util__WEBPACK_IMPORTED_MODULE_25__.toHtml; },
/* harmony export */   "toText": function() { return /* reexport safe */ _util__WEBPACK_IMPORTED_MODULE_25__.toText; },
/* harmony export */   "transformDocPos": function() { return /* reexport safe */ _DocPos__WEBPACK_IMPORTED_MODULE_1__.transformDocPos; }
/* harmony export */ });
/* harmony import */ var _Constant__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Constant */ "./src/Common/Constant.ts");
/* harmony import */ var _DocPos__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./DocPos */ "./src/Common/DocPos.ts");
/* harmony import */ var _EnumBubbleMessage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./EnumBubbleMessage */ "./src/Common/EnumBubbleMessage.ts");
/* harmony import */ var _EnumCursorType__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./EnumCursorType */ "./src/Common/EnumCursorType.ts");
/* harmony import */ var _EnumListStyle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./EnumListStyle */ "./src/Common/EnumListStyle.ts");
/* harmony import */ var _EnumParagraphStyle__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./EnumParagraphStyle */ "./src/Common/EnumParagraphStyle.ts");
/* harmony import */ var _EnumTableStyle__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./EnumTableStyle */ "./src/Common/EnumTableStyle.ts");
/* harmony import */ var _EnumTextStyle__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./EnumTextStyle */ "./src/Common/EnumTextStyle.ts");
/* harmony import */ var _IAttributable__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./IAttributable */ "./src/Common/IAttributable.ts");
/* harmony import */ var _IBubbleUpable__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./IBubbleUpable */ "./src/Common/IBubbleUpable.ts");
/* harmony import */ var _ICanvasContext__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./ICanvasContext */ "./src/Common/ICanvasContext.ts");
/* harmony import */ var _ICommand__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./ICommand */ "./src/Common/ICommand.ts");
/* harmony import */ var _ICoordinatePos__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./ICoordinatePos */ "./src/Common/ICoordinatePos.ts");
/* harmony import */ var _IDocPosOperator__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./IDocPosOperator */ "./src/Common/IDocPosOperator.ts");
/* harmony import */ var _IDrawable__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./IDrawable */ "./src/Common/IDrawable.ts");
/* harmony import */ var _IFragmentMetrics__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./IFragmentMetrics */ "./src/Common/IFragmentMetrics.ts");
/* harmony import */ var _IPointerInteractive__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./IPointerInteractive */ "./src/Common/IPointerInteractive.ts");
/* harmony import */ var _IRange__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./IRange */ "./src/Common/IRange.ts");
/* harmony import */ var _IRectangle__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./IRectangle */ "./src/Common/IRectangle.ts");
/* harmony import */ var _IRenderStructure__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./IRenderStructure */ "./src/Common/IRenderStructure.ts");
/* harmony import */ var _ISearchResult__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./ISearchResult */ "./src/Common/ISearchResult.ts");
/* harmony import */ var _ISelectedElementGettable__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./ISelectedElementGettable */ "./src/Common/ISelectedElementGettable.ts");
/* harmony import */ var _IoC__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./IoC */ "./src/Common/IoC.ts");
/* harmony import */ var _LayoutPiece__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./LayoutPiece */ "./src/Common/LayoutPiece.ts");
/* harmony import */ var _LinkedList__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./LinkedList */ "./src/Common/LinkedList.ts");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./util */ "./src/Common/util.ts");




























/***/ }),

/***/ "./src/Common/util.ts":
/*!****************************!*\
  !*** ./src/Common/util.ts ***!
  \****************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EnumIntersectionType": function() { return /* binding */ EnumIntersectionType; },
/* harmony export */   "calListItemTitle": function() { return /* binding */ calListItemTitle; },
/* harmony export */   "calListTypeFromChangeData": function() { return /* binding */ calListTypeFromChangeData; },
/* harmony export */   "clearFormat": function() { return /* binding */ clearFormat; },
/* harmony export */   "collectAttributes": function() { return /* binding */ collectAttributes; },
/* harmony export */   "convertFragmentAttributesToCssStyleText": function() { return /* binding */ convertFragmentAttributesToCssStyleText; },
/* harmony export */   "convertTo26": function() { return /* binding */ convertTo26; },
/* harmony export */   "convertToRoman": function() { return /* binding */ convertToRoman; },
/* harmony export */   "deleteRange": function() { return /* binding */ deleteRange; },
/* harmony export */   "findChildInDocPos": function() { return /* binding */ findChildInDocPos; },
/* harmony export */   "findChildIndexInDocPos": function() { return /* binding */ findChildIndexInDocPos; },
/* harmony export */   "findChildrenByRange": function() { return /* binding */ findChildrenByRange; },
/* harmony export */   "findHalf": function() { return /* binding */ findHalf; },
/* harmony export */   "findRectChildInPos": function() { return /* binding */ findRectChildInPos; },
/* harmony export */   "findRectChildInPosY": function() { return /* binding */ findRectChildInPosY; },
/* harmony export */   "format": function() { return /* binding */ format; },
/* harmony export */   "getFormat": function() { return /* binding */ getFormat; },
/* harmony export */   "getSelectedElement": function() { return /* binding */ getSelectedElement; },
/* harmony export */   "hasIntersection": function() { return /* binding */ hasIntersection; },
/* harmony export */   "hasModify": function() { return /* binding */ hasModify; },
/* harmony export */   "increaseId": function() { return /* binding */ increaseId; },
/* harmony export */   "isChinese": function() { return /* binding */ isChinese; },
/* harmony export */   "isPointInRectangle": function() { return /* binding */ isPointInRectangle; },
/* harmony export */   "numberToChinese": function() { return /* binding */ numberToChinese; },
/* harmony export */   "searchTextString": function() { return /* binding */ searchTextString; },
/* harmony export */   "toHtml": function() { return /* binding */ toHtml; },
/* harmony export */   "toText": function() { return /* binding */ toText; }
/* harmony export */ });
/* harmony import */ var binary_search_bounds__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! binary-search-bounds */ "binary-search-bounds");
/* harmony import */ var binary_search_bounds__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(binary_search_bounds__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _EnumListStyle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./EnumListStyle */ "./src/Common/EnumListStyle.ts");
/* harmony import */ var _DocPos__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./DocPos */ "./src/Common/DocPos.ts");
/* harmony import */ var quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! quill-delta-enhanced */ "quill-delta-enhanced");
/* harmony import */ var quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_3__);




const increaseId = (() => {
    let currentId = 0;
    return () => {
        return currentId++;
    };
})();
const isChinese = (word) => {
    const charCode = word.charCodeAt(0);
    return ((0x4e00 <= charCode && charCode <= 0x9fa5) || // 基本汉字	20902字
        (0x9fa6 <= charCode && charCode <= 0x9fef) || // 基本汉字补充	74字
        (0x3400 <= charCode && charCode <= 0x4db5) || // 扩展A	6582字
        (0x20000 <= charCode && charCode <= 0x2a6d6) || // 扩展B	42711字
        (0x2a700 <= charCode && charCode <= 0x2b734) || // 扩展C	4149字
        (0x2b740 <= charCode && charCode <= 0x2b81d) || // 扩展D	222字
        (0x2b820 <= charCode && charCode <= 0x2cea1) || // 扩展E	5762字
        (0x2ceb0 <= charCode && charCode <= 0x2ebe0) || // 扩展F	7473字
        (0x2f00 <= charCode && charCode <= 0x2fd5) || // 康熙部首	214字
        (0x2e80 <= charCode && charCode <= 0x2ef3) || // 部首扩展	115字
        (0xf900 <= charCode && charCode <= 0xfad9) || // 兼容汉字	477字
        (0x2f800 <= charCode && charCode <= 0x2fa1d) || // 兼容扩展	542字
        (0xe815 <= charCode && charCode <= 0xe86f) || // PUA(GBK)部件	81字
        (0xe400 <= charCode && charCode <= 0xe5e8) || // 部件扩展	452字
        (0xe600 <= charCode && charCode <= 0xe6cf) || // PUA增补	207字
        (0x31c0 <= charCode && charCode <= 0x31e3) || // 汉字笔画	36字
        (0x2ff0 <= charCode && charCode <= 0x2ffb) || // 汉字结构	12字
        (0x3105 <= charCode && charCode <= 0x312f) || // 汉语注音	43字
        (0x31a0 <= charCode && charCode <= 0x31ba) || // 注音扩展	22字
        (0xff01 <= charCode && charCode <= 0xff5e) || // 全角符号
        (0x3007 <= charCode && charCode <= 0x3011) || // 全角符号
        charCode === 0x2013 || // –  连接号
        charCode === 0x2014 || // —  破折号
        // 有些字体引号宽度和文字宽度不一致，所以这里引号不算中文字
        // charCode === 0x2018 ||      // ‘  引号
        // charCode === 0x2019 ||      // ’
        // charCode === 0x201C ||      // “  引号
        // charCode === 0x201D ||      // ”
        charCode === 0x2026 || // …  省略号
        charCode === 0x3000 || // 全角空格
        charCode === 0x3001 || // 、  顿号
        charCode === 0x3002 || // 。  句号
        charCode === 0x3014 || // 〔  括号
        charCode === 0x3015); // 〕
};
const calListTypeFromChangeData = (changeData) => {
    switch (changeData) {
        case 'decimal':
            return _EnumListStyle__WEBPACK_IMPORTED_MODULE_1__.EnumListType.ol1;
        case 'ckj-decimal':
            return _EnumListStyle__WEBPACK_IMPORTED_MODULE_1__.EnumListType.ol2;
        case 'upper-decimal':
            return _EnumListStyle__WEBPACK_IMPORTED_MODULE_1__.EnumListType.ol3;
        case 'circle':
            return _EnumListStyle__WEBPACK_IMPORTED_MODULE_1__.EnumListType.ul1;
        case 'ring':
            return _EnumListStyle__WEBPACK_IMPORTED_MODULE_1__.EnumListType.ul2;
        case 'arrow':
            return _EnumListStyle__WEBPACK_IMPORTED_MODULE_1__.EnumListType.ul3;
        default:
            throw new Error('unknown list type');
    }
};
const convertTo26 = (num, upperCase = false) => {
    const offset = upperCase ? 64 : 96;
    let str = '';
    let currentNum = num;
    while (currentNum > 0) {
        let m = currentNum % 26;
        if (m === 0) {
            m = 26;
        }
        str = String.fromCharCode(m + offset) + str;
        currentNum = (currentNum - m) / 26;
    }
    return str;
};
/**
 * 阿拉伯数字转中文汉字
 */
const numberToChinese = (() => {
    const chnNumChar = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
    const chnUnitSection = ['', '万', '亿', '万亿', '亿亿'];
    const chnUnitChar = ['', '十', '百', '千'];
    const sectionToChinese = (section) => {
        let strIns = '';
        let chnStr = '';
        let unitPos = 0;
        let zero = true;
        let currentSection = section;
        while (currentSection > 0) {
            const v = currentSection % 10;
            if (v === 0) {
                if (!zero) {
                    zero = true;
                    chnStr = chnNumChar[v] + chnStr;
                }
            }
            else {
                zero = false;
                strIns = chnNumChar[v];
                strIns = strIns + chnUnitChar[unitPos];
                chnStr = strIns + chnStr;
            }
            unitPos++;
            currentSection = Math.floor(currentSection / 10);
        }
        return chnStr;
    };
    return (num) => {
        let unitPos = 0;
        let strIns = '';
        let chnStr = '';
        let needZero = false;
        if (num === 0) {
            return chnNumChar[0];
        }
        let currentNum = num;
        while (currentNum > 0) {
            const section = currentNum % 10000;
            if (needZero) {
                chnStr = chnNumChar[0] + chnStr;
            }
            strIns = sectionToChinese(section);
            strIns += section !== 0 ? chnUnitSection[unitPos] : chnUnitSection[0];
            chnStr = strIns + chnStr;
            needZero = section < 1000 && section > 0;
            currentNum = Math.floor(currentNum / 10000);
            unitPos++;
        }
        return chnStr;
    };
})();
const convertToRoman = (() => {
    const aArray = [1000, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1];
    const upperArray = ['M', 'CM', 'D', 'CD', 'C', 'XC', 'L', 'XL', 'X', 'IX', 'V', 'IV', 'I'];
    const lowerArray = ['m', 'cm', 'd', 'cd', 'c', 'xc', 'l', 'xl', 'x', 'ix', 'v', 'iv', 'i'];
    return (num, upperCase = false) => {
        const strArray = upperCase ? upperArray : lowerArray;
        let str = '';
        let currentNum = num;
        for (let i = 0; i < aArray.length; i++) {
            while (currentNum >= aArray[i]) {
                str += strArray[i];
                currentNum -= aArray[i];
            }
        }
        return str;
    };
})();
const calOl1title = (indent, index) => {
    const currentIndex = index + 1;
    switch (indent % 3) {
        case 0:
            return `${currentIndex}.`;
        case 1:
            return `${convertTo26(currentIndex)}.`;
        case 2:
            return `${convertToRoman(currentIndex)}.`;
        default:
            return '';
    }
};
const calOl2title = (indent, index) => {
    if (indent === 0) {
        return `${numberToChinese(index + 1)}、`;
    }
    switch (indent % 3) {
        case 1:
            return `${convertTo26(index + 1)})`;
        case 2:
            return `${convertToRoman(index + 1)}.`;
        case 0:
            return `${index + 1}.`;
        default:
            return '';
    }
};
const calOl3title = (index, parentTitle) => {
    return `${parentTitle + (index + 1)}.`;
};
const calUl1title = (indent) => {
    if (indent === 0) {
        return '•';
    }
    switch (indent % 3) {
        case 1:
            return '◦';
        case 2:
            return '▪';
        case 0:
            return '▫';
        default:
            return '';
    }
};
const calUl3title = (indent) => {
    if (indent === 0) {
        return '→';
    }
    switch (indent % 3) {
        case 1:
            return '▴';
        case 2:
            return '▪';
        case 0:
            return '•';
        default:
            return '';
    }
};
const calListItemTitle = (type, indent, index, parentTitle) => {
    switch (type) {
        case _EnumListStyle__WEBPACK_IMPORTED_MODULE_1__.EnumListType.ol1:
            return calOl1title(indent, index);
        case _EnumListStyle__WEBPACK_IMPORTED_MODULE_1__.EnumListType.ol2:
            return calOl2title(indent, index);
        case _EnumListStyle__WEBPACK_IMPORTED_MODULE_1__.EnumListType.ol3:
            return calOl3title(index, parentTitle);
        case _EnumListStyle__WEBPACK_IMPORTED_MODULE_1__.EnumListType.ul1:
            return calUl1title(indent);
        case _EnumListStyle__WEBPACK_IMPORTED_MODULE_1__.EnumListType.ul2:
            return '⦿';
        case _EnumListStyle__WEBPACK_IMPORTED_MODULE_1__.EnumListType.ul3:
            return calUl3title(indent);
    }
};
var EnumIntersectionType;
(function (EnumIntersectionType) {
    // left = 0b001,         // 只取左边
    // right = 0b010,        // 只取右边
    EnumIntersectionType[EnumIntersectionType["both"] = 3] = "both";
    EnumIntersectionType[EnumIntersectionType["leftFirst"] = 5] = "leftFirst";
    EnumIntersectionType[EnumIntersectionType["rightFirst"] = 6] = "rightFirst";
})(EnumIntersectionType || (EnumIntersectionType = {}));
/**
 * 判断两个范围是否存在交集
 * @param start1 范围 1 的开始位置
 * @param end1 范围 1 的结束位置
 * @param start2 范围 2 的开始位置
 * @param end2 范围 2 的结束位置
 */
const hasIntersection = (start1, end1, start2, end2) => {
    const length = end2 - start2;
    if (length === 0) {
        return (start1 <= start2 && start2 <= end1) || (start1 <= end2 && end2 <= end1) || (start2 < start1 && end1 <= end2);
    }
    else {
        return (start1 <= start2 && start2 < end1) || (start1 < end2 && end2 <= end1) || (start2 <= start1 && end1 <= end2);
    }
};
/**
 * 用于将各种属性合并到一个 {[key:string]:Set<any>} 对象中，
 * 主要是用于在当文档内容或选区变化时， 通知编辑器外部当前选区的格式变化情况
 * @param attrs 需要合并的属性对象
 * @param target 合并目标对象
 */
const collectAttributes = (attrs, target) => {
    const keys = Object.keys(attrs);
    for (let keyIndex = 0; keyIndex < keys.length; keyIndex++) {
        const key = keys[keyIndex];
        if (target[key] === undefined) {
            target[key] = new Set();
        }
        if (attrs[key] instanceof Set) {
            const attrSet = attrs[key];
            attrSet.forEach((attrValue) => {
                target[key].add(attrValue);
            });
        }
        else {
            target[key].add(attrs[key]);
        }
    }
};
const findChildrenByRange = (children, index, length, intersectionType = EnumIntersectionType.both) => {
    let low = 0;
    let high = children.length - 1;
    let mid = Math.floor((low + high) / 2);
    while (high > low + 1) {
        const midValue = children[mid].start;
        if (midValue < index) {
            low = mid;
        }
        else if (midValue > index) {
            high = mid;
        }
        else if (midValue === index) {
            break;
        }
        mid = Math.floor((low + high) / 2);
    }
    if (children[high].start <= index) {
        mid = high;
    }
    for (; mid >= 0; mid--) {
        if (children[mid].start <= index) {
            break;
        }
    }
    mid = Math.max(mid, 0);
    const res = [];
    if (length > 0) {
        res.push(children[mid]);
        mid++;
        for (; mid < children.length; mid++) {
            if (children[mid].start < index + length) {
                res.push(children[mid]);
            }
            else {
                break;
            }
        }
    }
    else {
        if (children[mid].start === index && mid > 0) {
            res.push(children[mid - 1]);
        }
        res.push(children[mid]);
        if (intersectionType !== EnumIntersectionType.both && res.length > 1) {
            const removeTarget = intersectionType === EnumIntersectionType.rightFirst ? 0 : 1;
            res.splice(removeTarget, 1);
        }
    }
    return res;
};
/**
 * 把 fragment 的 attributes 转换成 css 样式
 */
const convertFragmentAttributesToCssStyleText = (attr) => {
    var _a, _b;
    const cssStyle = {};
    if (typeof attr.background === 'string') {
        cssStyle['background-color'] = attr.background;
    }
    if (typeof attr.color === 'string') {
        cssStyle.color = attr.color;
    }
    if (attr.strike) {
        cssStyle['text-decoration'] = `${(_a = cssStyle['text-decoration']) !== null && _a !== void 0 ? _a : ''} line-through`;
    }
    if (attr.underline) {
        cssStyle['text-decoration'] = `${(_b = cssStyle['text-decoration']) !== null && _b !== void 0 ? _b : ''} underline`;
    }
    if (typeof attr.font === 'string') {
        cssStyle['font-family'] = attr.font;
    }
    if (typeof attr.size === 'number') {
        cssStyle['font-size'] = `${attr.size}pt`;
    }
    if (attr.bold) {
        cssStyle['font-weight'] = 'bold';
    }
    if (attr.italic) {
        cssStyle['font-style'] = 'italic';
    }
    if (typeof attr.width === 'number') {
        cssStyle.width = attr.width;
    }
    if (typeof attr.height === 'number') {
        cssStyle.height = attr.height;
    }
    let res = '';
    const keys = Object.keys(cssStyle);
    for (let index = 0; index < keys.length; index++) {
        res += `${keys[index]}:${cssStyle[keys[index]]};`;
    }
    return res;
};
/**
 * 在 str 字符串中查找 searchTarget
 * @param searchTarget
 * @param str
 * @param caseSensitive
 */
const searchTextString = (searchTarget, str, caseSensitive = false) => {
    const searchStrLen = searchTarget.length;
    if (searchStrLen === 0) {
        return [];
    }
    let startIndex = 0;
    const indices = [];
    let targetStr = str;
    let targetSearchTarget = searchTarget;
    if (!caseSensitive) {
        targetStr = str.toLowerCase();
        targetSearchTarget = searchTarget.toLowerCase();
    }
    let index = targetStr.indexOf(targetSearchTarget, startIndex);
    while (index > -1) {
        indices.push(index);
        startIndex = index + searchStrLen;
        index = targetStr.indexOf(targetSearchTarget, startIndex);
    }
    return indices;
};
/**
 * 判断一个点是否在某个矩形区域内
 */
const isPointInRectangle = (x, y, rect) => {
    return rect.x <= x && x <= rect.x + rect.width && rect.y <= y && y <= rect.y + rect.height;
};
/**
 * 在一个 IRectangle 数组中找到 pos 所在的元素
 * @param {boolean} yOrdered children 是否按 y 正序排列，false 则表示 children 按 x 正序排列
 */
const findRectChildInPos = (x, y, children, yOrdered = true) => {
    // 如果 children 按 y 正序排列则先用二分法查找 y，再看 x 是否在范围内
    // 如果 children 按 x 正序排列则先用二分法查找 x，再看 y 是否在范围内
    let resIndex;
    const fakeTarget = {
        x: 0,
        y: 0,
        width: 0,
        height: 0,
    };
    if (yOrdered) {
        fakeTarget.y = y;
        resIndex = binary_search_bounds__WEBPACK_IMPORTED_MODULE_0___default().le(children, fakeTarget, (a, b) => {
            return a.y - b.y;
        });
    }
    else {
        fakeTarget.x = x;
        resIndex = binary_search_bounds__WEBPACK_IMPORTED_MODULE_0___default().le(children, fakeTarget, (a, b) => {
            return a.x - b.x;
        });
    }
    if (resIndex >= 0) {
        const res = children[resIndex];
        if (yOrdered) {
            return res.x <= x && res.x + res.width >= x && res.y + res.height >= y ? res : null;
        }
        else {
            return res.y <= y && res.y + res.height >= y && res.x + res.width >= x ? res : null;
        }
    }
    else {
        return null;
    }
};
/**
 * 在一个 IRectangle 数组中找到 posY 所在的元素
 * @param {dichotomy} boolean 是否使用二分法查找
 */
const findRectChildInPosY = (y, children, dichotomy = true) => {
    const fakeTarget = {
        x: 0,
        y: 0,
        width: 0,
        height: 0,
    };
    fakeTarget.y = y;
    if (!dichotomy) {
        // 不用二分法查找就顺序遍历
        let res = null;
        if (children.length === 0 || children[0].y > fakeTarget.y) {
            return res;
        }
        for (let index = 0; index < children.length; index++) {
            if (children[index].y <= fakeTarget.y) {
                res = children[index];
            }
            else {
                break;
            }
        }
        return res;
    }
    else {
        // 用二分法查找
        const resIndex = binary_search_bounds__WEBPACK_IMPORTED_MODULE_0___default().le(children, fakeTarget, (a, b) => {
            return a.y - b.y;
        });
        if (resIndex >= 0) {
            return children[resIndex];
        }
        else {
            return null;
        }
    }
};
const findChildInDocPos = (start, children, dichotomy = true) => {
    const index = findChildIndexInDocPos(start, children, dichotomy);
    if (index >= 0) {
        return children[index];
    }
    else {
        return null;
    }
};
const findChildIndexInDocPos = (start, children, dichotomy = true) => {
    const fakeTarget = {
        start: 0,
    };
    fakeTarget.start = start;
    if (dichotomy) {
        const resIndex = binary_search_bounds__WEBPACK_IMPORTED_MODULE_0___default().le(children, fakeTarget, (a, b) => {
            return a.start - b.start;
        });
        if (resIndex >= 0) {
            return resIndex;
        }
        else {
            return -1;
        }
    }
    else {
        let res = -1;
        if (children.length === 0 || children[0].start > fakeTarget.start) {
            return res;
        }
        for (let index = 0; index < children.length; index++) {
            if (children[index].start <= fakeTarget.start) {
                res = index;
            }
            else {
                break;
            }
        }
        return res;
    }
};
const hasModify = (delta) => {
    for (let index = 0; index < delta.ops.length; index++) {
        const op = delta.ops[index];
        if ((op.insert !== undefined && op.insert !== 0) ||
            (op.delete !== undefined && op.delete !== 0) ||
            (op.attributes !== undefined && Object.keys(op.attributes).length > 0) ||
            (op.retain instanceof (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_3___default()) && hasModify(op.retain))) {
            return true;
        }
    }
    return false;
};
/**
 * web 中 canvas 绘制水平和垂直线条的时候，如果坐标是整数，在高分屏上绘制出来的线条非常细
 * 所以用这个方法可以把这类坐标值改为一个离他最近的 x.5 的值
 */
const findHalf = (origin, direction) => {
    return (Math.floor(origin) * 2 + direction) / 2;
};
/**
 * 获取指定范围内元素的 attributes
 * @param priority 当 ranges 中某个 range 的 start 和 end 相同时，left 表示优先取 range.start 左边元素的 attributes，否则优先取右边元素的 attributes
 */
const getFormat = (target, ranges, priority = 'right') => {
    var _a;
    const res = {};
    if (ranges) {
        for (let rangeIndex = 0; rangeIndex < ranges.length; rangeIndex++) {
            // 如果 range 的 start 和 end 相同，就直接找到所在的 block 然后 getFormat
            const range = ranges[rangeIndex];
            if ((0,_DocPos__WEBPACK_IMPORTED_MODULE_2__.compareDocPos)(range.start, range.end) === 0) {
                let targetChild = findChildInDocPos(range.start.index, target.children, true);
                if ((targetChild === null || targetChild === void 0 ? void 0 : targetChild.start) === range.start.index && range.start.inner === null) {
                    if (priority === 'left' && targetChild.prevSibling !== null) {
                        targetChild = targetChild.prevSibling;
                    }
                }
                if (targetChild) {
                    collectAttributes(targetChild.getFormat({
                        start: (0,_DocPos__WEBPACK_IMPORTED_MODULE_2__.getRelativeDocPos)(targetChild.start, range.start),
                        end: (0,_DocPos__WEBPACK_IMPORTED_MODULE_2__.getRelativeDocPos)(targetChild.start, range.end),
                    }), res);
                }
            }
            else {
                // 2、有选择内容的时候
                const startChild = findChildInDocPos(range.start.index, target.children, true);
                let endChild = findChildInDocPos(range.end.index, target.children, true);
                if (!startChild || !endChild) {
                    continue;
                }
                // 如果 range.end 在 endChild 的开始位置，endChild 就要取前一个元素
                if (range.end.index === endChild.start && range.end.inner === null) {
                    endChild = (_a = endChild.prevSibling) !== null && _a !== void 0 ? _a : endChild;
                }
                // 然后开始取格式，分开始和结束在同一个 block 和 在不同的 block 两种情况
                if (startChild === endChild) {
                    collectAttributes(startChild.getFormat({
                        start: (0,_DocPos__WEBPACK_IMPORTED_MODULE_2__.getRelativeDocPos)(startChild.start, range.start),
                        end: (0,_DocPos__WEBPACK_IMPORTED_MODULE_2__.getRelativeDocPos)(startChild.start, range.end),
                    }), res);
                }
                else {
                    let currentChild = endChild;
                    while (currentChild) {
                        if (currentChild === endChild || currentChild === startChild) {
                            collectAttributes(currentChild.getFormat({
                                start: (0,_DocPos__WEBPACK_IMPORTED_MODULE_2__.getRelativeDocPos)(currentChild.start, range.start),
                                end: (0,_DocPos__WEBPACK_IMPORTED_MODULE_2__.getRelativeDocPos)(currentChild.start, range.end),
                            }), res);
                        }
                        else {
                            collectAttributes(currentChild.getFormat(), res);
                        }
                        if (currentChild !== startChild) {
                            currentChild = currentChild.prevSibling;
                        }
                        else {
                            break;
                        }
                    }
                }
            }
        }
    }
    else {
        for (let i = 0; i < target.children.length; i++) {
            collectAttributes(target.children[i].getFormat(), res);
        }
    }
    return res;
};
const format = (target, attr, range) => {
    let returnStart = null;
    let returnEnd = null;
    if (range) {
        const startChild = findChildInDocPos(range.start.index, target.children, true);
        let endChild = findChildInDocPos(range.end.index, target.children, true);
        if (!startChild || !endChild) {
            return null;
        }
        if (startChild !== endChild &&
            endChild.prevSibling &&
            endChild.start === range.end.index &&
            range.end.inner === null) {
            endChild = endChild.prevSibling;
        }
        // 尝试合并属性相同的 child
        returnStart = startChild.prevSibling || target.head;
        returnEnd = endChild.nextSibling || target.tail;
        if (startChild === endChild) {
            startChild.format(attr, {
                start: (0,_DocPos__WEBPACK_IMPORTED_MODULE_2__.getRelativeDocPos)(startChild.start, range.start),
                end: (0,_DocPos__WEBPACK_IMPORTED_MODULE_2__.getRelativeDocPos)(endChild.start, range.end),
            });
        }
        else {
            let currentFrag = endChild;
            while (currentFrag) {
                if (currentFrag === startChild) {
                    if (currentFrag.start === range.start.index && range.start.inner === null) {
                        currentFrag.format(attr);
                    }
                    else {
                        currentFrag.format(attr, {
                            start: { index: range.start.index - currentFrag.start, inner: range.start.inner },
                            end: { index: currentFrag.start + currentFrag.length, inner: null },
                        });
                    }
                    break;
                }
                else if (currentFrag === endChild) {
                    if (currentFrag.start + currentFrag.length === range.end.index && range.end.inner === null) {
                        currentFrag.format(attr);
                    }
                    else {
                        currentFrag.format(attr, {
                            start: { index: 0, inner: null },
                            end: { index: range.end.index - currentFrag.start, inner: range.end.inner },
                        });
                    }
                }
                else {
                    currentFrag.format(attr);
                }
                currentFrag = currentFrag.prevSibling;
            }
        }
    }
    else {
        returnStart = target.head;
        returnEnd = target.tail;
        for (let index = 0; index < target.children.length; index++) {
            const frag = target.children[index];
            frag.format(attr);
        }
    }
    if (returnStart && returnEnd) {
        return {
            start: returnStart,
            end: returnEnd,
        };
    }
    else {
        return null;
    }
};
const clearFormat = (target, range) => {
    let returnStart = null;
    let returnEnd = null;
    if (range) {
        const startChild = findChildInDocPos(range.start.index, target.children, true);
        const endChild = findChildInDocPos(range.end.index, target.children, true);
        if (!startChild || !endChild) {
            return null;
        }
        // 尝试合并属性相同的 child
        returnStart = startChild.prevSibling || target.head;
        returnEnd = endChild.nextSibling || target.tail;
        if (startChild === endChild) {
            startChild.clearFormat({
                start: (0,_DocPos__WEBPACK_IMPORTED_MODULE_2__.getRelativeDocPos)(startChild.start, range.start),
                end: (0,_DocPos__WEBPACK_IMPORTED_MODULE_2__.getRelativeDocPos)(endChild.start, range.end),
            });
        }
        else {
            let currentFrag = endChild;
            while (currentFrag) {
                if (currentFrag === startChild) {
                    if (currentFrag.start === range.start.index && range.start.inner === null) {
                        currentFrag.clearFormat();
                    }
                    else {
                        currentFrag.clearFormat({
                            start: { index: range.start.index - currentFrag.start, inner: range.start.inner },
                            end: { index: currentFrag.start + currentFrag.length, inner: null },
                        });
                    }
                    break;
                }
                else if (currentFrag === endChild) {
                    if (currentFrag.start + currentFrag.length === range.end.index && range.end.inner === null) {
                        currentFrag.clearFormat();
                    }
                    else {
                        currentFrag.clearFormat({
                            start: { index: 0, inner: null },
                            end: { index: range.end.index - currentFrag.start, inner: range.end.inner },
                        });
                    }
                }
                else {
                    currentFrag.clearFormat();
                }
                currentFrag = currentFrag.prevSibling;
            }
        }
    }
    else {
        returnStart = target.head;
        returnEnd = target.tail;
        for (let index = 0; index < target.children.length; index++) {
            const frag = target.children[index];
            frag.clearFormat();
        }
    }
    if (returnStart && returnEnd) {
        return {
            start: returnStart,
            end: returnEnd,
        };
    }
    else {
        return null;
    }
};
const deleteRange = (target, range, forward) => {
    const targetStart = range.start;
    const targetEnd = range.end;
    if ((0,_DocPos__WEBPACK_IMPORTED_MODULE_2__.compareDocPos)(targetStart, targetEnd) === 0) {
        const currentItem = findChildInDocPos(targetStart.index, target.children, true);
        if (!currentItem) {
            return;
        } // 说明选区数据有问题
        if (forward) {
            let targetItem = null;
            if (currentItem.start < targetStart.index) {
                targetItem = currentItem;
            }
            else if (currentItem.prevSibling) {
                targetItem = currentItem.prevSibling;
            }
            else {
                return;
            }
            if (targetStart.inner === null && targetItem.length === 1) {
                target.remove(targetItem);
            }
            else {
                const newPos = (0,_DocPos__WEBPACK_IMPORTED_MODULE_2__.getRelativeDocPos)(targetItem.start, range.start);
                targetItem.delete({
                    start: newPos,
                    end: newPos,
                }, true);
            }
        }
        else if (currentItem.length === 1) {
            target.remove(currentItem);
        }
        else {
            const newPos = (0,_DocPos__WEBPACK_IMPORTED_MODULE_2__.getRelativeDocPos)(currentItem.start, range.start);
            currentItem.delete({
                start: newPos,
                end: newPos,
            }, false);
        }
    }
    else {
        const startChild = findChildInDocPos(targetStart.index, target.children, true);
        const endChild = findChildInDocPos(targetEnd.index, target.children, true);
        if (!startChild || !endChild) {
            return;
        }
        if (startChild === endChild) {
            if (startChild.start === targetStart.index &&
                targetStart.inner === null &&
                startChild.start + startChild.length === targetEnd.index &&
                targetEnd.inner === null) {
                target.remove(startChild);
            }
            else {
                startChild.delete({
                    start: (0,_DocPos__WEBPACK_IMPORTED_MODULE_2__.getRelativeDocPos)(startChild.start, range.start),
                    end: (0,_DocPos__WEBPACK_IMPORTED_MODULE_2__.getRelativeDocPos)(startChild.start, range.end),
                }, forward);
            }
        }
        else {
            let currentChild = endChild;
            while (currentChild) {
                const prevChild = currentChild.prevSibling;
                if (currentChild === startChild) {
                    if (currentChild.start === targetStart.index && targetStart.inner === null) {
                        // 说明要直接删除第一个 frame
                        target.remove(currentChild);
                    }
                    else {
                        currentChild.delete({
                            start: (0,_DocPos__WEBPACK_IMPORTED_MODULE_2__.getRelativeDocPos)(currentChild.start, range.start),
                            end: { index: currentChild.start + currentChild.length, inner: null },
                        }, forward);
                    }
                    break;
                }
                else if (currentChild === endChild) {
                    if (currentChild.start + currentChild.length === targetEnd.index && targetEnd.inner === null) {
                        // 说明要直接删除最后一个 frame
                        target.remove(currentChild);
                    }
                    else {
                        currentChild.delete({
                            start: { index: 0, inner: null },
                            end: (0,_DocPos__WEBPACK_IMPORTED_MODULE_2__.getRelativeDocPos)(currentChild.start, range.end),
                        }, forward);
                    }
                }
                else {
                    // 既不是第一个 frame 也不是最后一个 frame 则直接删除这个 frame
                    target.remove(currentChild);
                }
                currentChild = prevChild;
            }
        }
    }
};
const toHtml = (target, range) => {
    if (range) {
        const startChild = findChildInDocPos(range.start.index, target.children, true);
        let endChild = findChildInDocPos(range.end.index, target.children, true);
        if (!startChild || !endChild) {
            return '';
        }
        if (startChild !== endChild &&
            endChild.prevSibling &&
            endChild.start === range.end.index &&
            range.end.inner === null) {
            endChild = endChild.prevSibling;
        }
        if (startChild === endChild) {
            return startChild.toHtml({
                start: (0,_DocPos__WEBPACK_IMPORTED_MODULE_2__.getRelativeDocPos)(startChild.start, range.start),
                end: (0,_DocPos__WEBPACK_IMPORTED_MODULE_2__.getRelativeDocPos)(endChild.start, range.end),
            });
        }
        else {
            let res = '';
            let currentChild = startChild;
            while (currentChild) {
                if (currentChild === startChild) {
                    if (currentChild.start === range.start.index && range.start.inner === null) {
                        res += currentChild.toHtml();
                    }
                    else {
                        res += currentChild.toHtml({
                            start: { index: range.start.index - currentChild.start, inner: range.start.inner },
                            end: { index: currentChild.start + currentChild.length, inner: null },
                        });
                    }
                    break;
                }
                else if (currentChild === endChild) {
                    if (currentChild.start + currentChild.length === range.end.index && range.end.inner === null) {
                        res += currentChild.toHtml();
                    }
                    else {
                        res += currentChild.toHtml({
                            start: { index: 0, inner: null },
                            end: { index: range.end.index - currentChild.start, inner: range.end.inner },
                        });
                    }
                }
                else {
                    res += currentChild.toHtml();
                }
                currentChild = currentChild.nextSibling;
            }
            return res;
        }
    }
    else {
        return target.children.map((frag) => frag.toHtml()).join('');
    }
};
const toText = (target, range) => {
    if (range) {
        const startChild = findChildInDocPos(range.start.index, target.children, true);
        let endChild = findChildInDocPos(range.end.index, target.children, true);
        if (!startChild || !endChild) {
            return '';
        }
        if (startChild !== endChild &&
            endChild.prevSibling &&
            endChild.start === range.end.index &&
            range.end.inner === null) {
            endChild = endChild.prevSibling;
        }
        if (startChild === endChild) {
            return startChild.toText({
                start: (0,_DocPos__WEBPACK_IMPORTED_MODULE_2__.getRelativeDocPos)(startChild.start, range.start),
                end: (0,_DocPos__WEBPACK_IMPORTED_MODULE_2__.getRelativeDocPos)(endChild.start, range.end),
            });
        }
        else {
            let res = '';
            let currentChild = startChild;
            while (currentChild) {
                if (currentChild === startChild) {
                    if (currentChild.start === range.start.index && range.start.inner === null) {
                        res += currentChild.toText();
                    }
                    else {
                        res += currentChild.toText({
                            start: { index: range.start.index - currentChild.start, inner: range.start.inner },
                            end: { index: currentChild.start + currentChild.length, inner: null },
                        });
                    }
                    break;
                }
                else if (currentChild === endChild) {
                    if (currentChild.start + currentChild.length === range.end.index && range.end.inner === null) {
                        res += currentChild.toText();
                    }
                    else {
                        res += currentChild.toText({
                            start: { index: 0, inner: null },
                            end: { index: range.end.index - currentChild.start, inner: range.end.inner },
                        });
                    }
                }
                else {
                    res += currentChild.toText();
                }
                currentChild = currentChild.nextSibling;
            }
            return res;
        }
    }
    else {
        return target.children.map((frag) => frag.toText()).join('');
    }
};
const getSelectedElement = (range, self, children) => {
    const res = [];
    res.push([self]);
    const startChild = findChildInDocPos(range.start.index, children, true);
    const endChild = findChildInDocPos(range.end.index, children, true);
    if (startChild && endChild) {
        if (startChild === endChild) {
            res.push(...startChild.getSelectedElement({
                start: (0,_DocPos__WEBPACK_IMPORTED_MODULE_2__.getRelativeDocPos)(startChild.start, range.start),
                end: (0,_DocPos__WEBPACK_IMPORTED_MODULE_2__.getRelativeDocPos)(startChild.start, range.end),
            }));
        }
        else {
            const span = [];
            let currentFrag = startChild;
            while (currentFrag) {
                span.push(currentFrag);
                currentFrag = currentFrag.nextSibling;
            }
            res.push([span]);
        }
    }
    return res;
};


/***/ }),

/***/ "./src/Document/DocContent.ts":
/*!************************************!*\
  !*** ./src/Document/DocContent.ts ***!
  \************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DocContent": function() { return /* binding */ DocContent; }
/* harmony export */ });
/* harmony import */ var quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! quill-delta-enhanced */ "quill-delta-enhanced");
/* harmony import */ var quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_replace__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lodash/replace */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/replace.js");
/* harmony import */ var lodash_replace__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_replace__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Common_LinkedList__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Common/LinkedList */ "./src/Common/LinkedList.ts");
/* harmony import */ var _Common_util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Common/util */ "./src/Common/util.ts");
/* harmony import */ var _Common_EnumCursorType__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Common/EnumCursorType */ "./src/Common/EnumCursorType.ts");
/* harmony import */ var _Common_IBubbleUpable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../Common/IBubbleUpable */ "./src/Common/IBubbleUpable.ts");
/* harmony import */ var _Common_IPointerInteractive__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../Common/IPointerInteractive */ "./src/Common/IPointerInteractive.ts");
/* harmony import */ var _Common_DocPos__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../Common/DocPos */ "./src/Common/DocPos.ts");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! lodash */ "lodash");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _Common_IDocPosOperator__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../Common/IDocPosOperator */ "./src/Common/IDocPosOperator.ts");
/* harmony import */ var _Common_EnumBubbleMessage__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../Common/EnumBubbleMessage */ "./src/Common/EnumBubbleMessage.ts");
/* harmony import */ var _Common_ISelectedElementGettable__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../Common/ISelectedElementGettable */ "./src/Common/ISelectedElementGettable.ts");
/* harmony import */ var _Common_IoC__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../Common/IoC */ "./src/Common/IoC.ts");
/* harmony import */ var _Common_Constant__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../Common/Constant */ "./src/Common/Constant.ts");
/* harmony import */ var quill_delta_enhanced_dist_diff__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! quill-delta-enhanced/dist/diff */ "../../node_modules/.pnpm/quill-delta-enhanced@0.0.6/node_modules/quill-delta-enhanced/dist/diff.js");
/* harmony import */ var quill_delta_enhanced_dist_diff__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(quill_delta_enhanced_dist_diff__WEBPACK_IMPORTED_MODULE_14__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var DocContent_1;















function OverrideIBubbleUpableDecorator(constructor) {
    return class extends constructor {
        bubbleUp(type, data, stack) {
            if (type === _Common_EnumBubbleMessage__WEBPACK_IMPORTED_MODULE_10__.BubbleMessage.UPDATE_CONTENT_HEIGHT) {
                if (this.tail) {
                    this.setContentHeight(this.tail.y + this.tail.height);
                }
                else {
                    this.setContentHeight(0);
                }
            }
            else if (type === _Common_EnumBubbleMessage__WEBPACK_IMPORTED_MODULE_10__.BubbleMessage.UPDATE_CONTENT_LENGTH) {
                if (this.tail) {
                    this.length = this.tail.start + this.tail.length;
                }
                else {
                    this.length = 0;
                }
            }
            else {
                super.bubbleUp(type, data, stack);
            }
        }
    };
}
let DocContent = DocContent_1 = class DocContent {
    constructor() {
        this.id = (0,_Common_util__WEBPACK_IMPORTED_MODULE_3__.increaseId)();
        this.head = null;
        this.tail = null;
        this.needLayout = true;
        this.x = 0;
        this.y = 0;
        this.width = 0;
        this.height = 0;
        this.contentHeight = 0;
        this.paddingTop = 0;
        this.paddingBottom = 0;
        this.paddingLeft = 0;
        this.paddingRight = 0;
        this.length = 0;
        this.children = [];
    }
    static createDefaultEmptyDocContent() {
        const res = new DocContent_1();
        res.readFromChanges((0,_Common_Constant__WEBPACK_IMPORTED_MODULE_13__.getDefaultDocContentDelta)());
        return res;
    }
    readFromChanges(delta) {
        const blocks = this.readDeltaToBlocks(delta);
        this.addAll(blocks);
        if (this.head !== null) {
            this.head.setStart(0, true, true);
        }
    }
    /**
     * 清除当前文档中的所有数据
     */
    destroy() {
        for (let i = 0, l = this.children.length; i < l; i++) {
            const block = this.children[i];
            block.destroy();
        }
        this.removeAll();
        this.head = null;
        this.tail = null;
        this.needLayout = true;
        this.x = 0;
        this.y = 0;
        this.height = 0;
        this.contentHeight = 0;
        this.paddingTop = 0;
        this.paddingBottom = 0;
        this.paddingLeft = 0;
        this.paddingRight = 0;
        this.length = 0;
    }
    /**
     * 绘制当前文档
     * @param ctx canvas context
     * @param scrollTop 文档滚动位置
     * @param viewHeight 可视区域高度
     */
    draw(ctx, x, y, viewHeight) {
        for (let index = 0; index < this.children.length; index++) {
            const block = this.children[index];
            if (block.y + y + block.height > 0 && block.y < viewHeight) {
                block.draw(ctx, this.x + x, this.y + y, viewHeight - block.y);
            }
        }
    }
    /**
     * 获取文档内容长度
     */
    getLength() {
        return this.children.reduce((sum, currentBlock) => {
            return sum + currentBlock.length;
        }, 0);
    }
    setHeight(height) {
        const targetHeight = Math.ceil(height);
        if (targetHeight >= this.contentHeight && targetHeight !== this.height) {
            this.height = targetHeight;
        }
    }
    setContentHeight(height) {
        const targetHeight = Math.ceil(height);
        if (this.contentHeight !== targetHeight) {
            this.contentHeight = targetHeight + this.paddingBottom;
            this.setHeight(targetHeight + this.paddingBottom);
        }
    }
    setWidth(width) {
        if (width !== this.width) {
            this.width = width;
            for (let index = 0; index < this.children.length; index++) {
                const block = this.children[index];
                block.needLayout = true;
            }
        }
    }
    getChildrenStackByPos(x, y) {
        const child = (0,_Common_util__WEBPACK_IMPORTED_MODULE_3__.findRectChildInPos)(x, y, this.children);
        let res;
        if (child) {
            res = child.getChildrenStackByPos(x - child.x, y - child.y);
            res.unshift(this);
        }
        else {
            res = [this];
        }
        return res;
    }
    /**
     * 将当前文档输出为 delta
     */
    toDelta(withKey = false) {
        const res = [];
        for (let index = 0; index < this.children.length; index++) {
            const element = this.children[index];
            res.push(...element.toOp(withKey));
        }
        return new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())(res);
    }
    /**
     * 将当前文档输出为 HTML
     */
    toHtml(range) {
        return (0,_Common_util__WEBPACK_IMPORTED_MODULE_3__.toHtml)(this, range);
    }
    search(keywords) {
        const res = [];
        for (let blockIndex = 0; blockIndex < this.children.length; blockIndex++) {
            const block = this.children[blockIndex];
            const searchResult = block.search(keywords);
            if (searchResult.length > 0) {
                res.push(...searchResult);
            }
        }
        return res;
    }
    /**
     * 替换
     */
    replace(searchResults, searchKeywordsLength, replaceWords) {
        // 遍历 searchResults 里的每一项，针对每个 block 做替换和计算 diff，然后把所有 diff 结果 compose 到一起
        let res = new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())();
        for (let index = searchResults.length - 1; index >= 0; index--) {
            const element = searchResults[index];
            const targetBlock = (0,_Common_util__WEBPACK_IMPORTED_MODULE_3__.findChildInDocPos)(element.pos.index, this.children, true);
            if (targetBlock === null) {
                continue;
            }
            const staticRetain = targetBlock.start > 0 ? { retain: targetBlock.start } : null;
            const oldOps = targetBlock.toOp(true);
            // 插入新内容，删除旧内容
            targetBlock.delete({
                start: (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_7__.getRelativeDocPos)(targetBlock.start, element.pos),
                end: (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_7__.getRelativeDocPos)(targetBlock.start, (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_7__.moveDocPos)(element.pos, searchKeywordsLength)),
            }, false);
            const newPos = (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_7__.cloneDocPos)(element.pos);
            targetBlock.insertText(replaceWords, { index: newPos.index - targetBlock.start, inner: newPos.inner });
            const newOps = targetBlock.toOp(true);
            const diffBase = staticRetain ? new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())([staticRetain]) : new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())();
            const originalDiff = new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())(oldOps).diff(new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())(newOps));
            const diff = diffBase.concat(originalDiff);
            res = res.compose(diff);
        }
        this.bubbleUp(_Common_EnumBubbleMessage__WEBPACK_IMPORTED_MODULE_10__.BubbleMessage.CONTENT_CHANGE, null, [this]);
        return res;
    }
    /**
     * 给指定范围设置新的文档格式
     * @param attr 新格式数据
     * @param range 需要设置格式的范围
     */
    format(attr, ranges) {
        const theRanges = (0,lodash__WEBPACK_IMPORTED_MODULE_8__.isArray)(ranges)
            ? ranges
            : ranges
                ? [ranges]
                : [{ start: { index: 0, inner: null }, end: { index: this.length, inner: null } }];
        let res = new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())();
        for (let rangeIndex = 0; rangeIndex < theRanges.length; rangeIndex++) {
            let batRes = new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())();
            const range = theRanges[rangeIndex];
            const startBlock = (0,_Common_util__WEBPACK_IMPORTED_MODULE_3__.findChildInDocPos)(range.start.index, this.children, true);
            let endBlock = (0,_Common_util__WEBPACK_IMPORTED_MODULE_3__.findChildInDocPos)(range.end.index, this.children, true);
            if (!startBlock || !endBlock) {
                continue;
            }
            if (endBlock.start === range.end.index && range.end.inner === null && endBlock.start !== 0) {
                endBlock = endBlock.prevSibling;
            }
            const oldOps = this.getOpFromLinkedBlocks(startBlock, endBlock);
            if (startBlock === endBlock) {
                startBlock.format(attr, {
                    start: (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_7__.getRelativeDocPos)(startBlock.start, range.start),
                    end: (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_7__.getRelativeDocPos)(endBlock.start, range.end),
                });
            }
            else {
                let currentBlock = endBlock;
                while (currentBlock) {
                    const prev = currentBlock.prevSibling;
                    if (currentBlock === startBlock) {
                        if (currentBlock.start === range.start.index && range.start.inner === null) {
                            currentBlock.format(attr);
                        }
                        else {
                            currentBlock.format(attr, {
                                start: (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_7__.getRelativeDocPos)(startBlock.start, range.start),
                                end: { index: currentBlock.length, inner: null },
                            });
                        }
                        break;
                    }
                    else if (currentBlock === endBlock) {
                        if (currentBlock.start + currentBlock.length === range.end.index && range.end.inner === null) {
                            currentBlock.format(attr);
                        }
                        else {
                            currentBlock.format(attr, {
                                start: { index: 0, inner: null },
                                end: (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_7__.getRelativeDocPos)(endBlock.start, range.end),
                            });
                        }
                    }
                    else {
                        currentBlock.format(attr);
                    }
                    currentBlock = prev;
                }
            }
            const newOps = this.getOpFromLinkedBlocks(startBlock, endBlock);
            // 最后把新老 op 做 diff
            const diff = new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())(oldOps).diff(new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())(newOps));
            if (startBlock.start > 0) {
                batRes.retain(startBlock.start);
            }
            batRes = batRes.concat(diff);
            res = res.compose(batRes);
        }
        if ((0,_Common_util__WEBPACK_IMPORTED_MODULE_3__.hasModify)(res)) {
            this.bubbleUp(_Common_EnumBubbleMessage__WEBPACK_IMPORTED_MODULE_10__.BubbleMessage.CONTENT_CHANGE, null, [this]);
            this.needLayout = true;
            return res;
        }
        else {
            return null;
        }
    }
    /**
     * 清除选区范围内容的格式
     * @param ranges 需要清除格式的选区范围
     */
    clearFormat(ranges) {
        const theRanges = (0,lodash__WEBPACK_IMPORTED_MODULE_8__.isArray)(ranges)
            ? ranges
            : ranges
                ? [ranges]
                : [{ start: { index: 0, inner: null }, end: { index: this.length, inner: null } }];
        let res = new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())();
        for (let rangeIndex = 0; rangeIndex < theRanges.length; rangeIndex++) {
            let batRes = new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())();
            const range = theRanges[rangeIndex];
            const startBlock = (0,_Common_util__WEBPACK_IMPORTED_MODULE_3__.findChildInDocPos)(range.start.index, this.children, true);
            let endBlock = (0,_Common_util__WEBPACK_IMPORTED_MODULE_3__.findChildInDocPos)(range.end.index, this.children, true);
            if (!startBlock || !endBlock) {
                continue;
            }
            if (endBlock.start === range.end.index && range.end.inner === null) {
                endBlock = endBlock.prevSibling;
            }
            const oldOps = this.getOpFromLinkedBlocks(startBlock, endBlock);
            if (startBlock === endBlock) {
                startBlock.clearFormat({
                    start: (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_7__.getRelativeDocPos)(startBlock.start, range.start),
                    end: (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_7__.getRelativeDocPos)(endBlock.start, range.end),
                });
            }
            else {
                let currentBlock = endBlock;
                while (currentBlock) {
                    const prev = currentBlock.prevSibling;
                    if (currentBlock === startBlock) {
                        if (currentBlock.start === range.start.index && range.start.inner === null) {
                            currentBlock.clearFormat();
                        }
                        else {
                            currentBlock.clearFormat({
                                start: range.start,
                                end: { index: currentBlock.start + currentBlock.length, inner: null },
                            });
                        }
                        break;
                    }
                    else if (currentBlock === endBlock) {
                        if (currentBlock.start + currentBlock.length === range.end.index && range.end.inner === null) {
                            currentBlock.clearFormat();
                        }
                        else {
                            currentBlock.clearFormat({ start: { index: currentBlock.start, inner: null }, end: range.end });
                        }
                    }
                    else {
                        currentBlock.clearFormat();
                    }
                    currentBlock = prev;
                }
            }
            const newOps = this.getOpFromLinkedBlocks(startBlock, endBlock);
            // 最后把新老 op 做 diff
            const diff = new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())(oldOps).diff(new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())(newOps));
            if (startBlock.start > 0) {
                batRes.retain(startBlock.start);
            }
            batRes = batRes.concat(diff);
            res = res.compose(batRes);
        }
        if ((0,_Common_util__WEBPACK_IMPORTED_MODULE_3__.hasModify)(res)) {
            this.bubbleUp(_Common_EnumBubbleMessage__WEBPACK_IMPORTED_MODULE_10__.BubbleMessage.CONTENT_CHANGE, null, [this]);
            this.needLayout = true;
            return res;
        }
        else {
            return null;
        }
    }
    /**
     * 获取指定范围的文档内容格式信息
     * @param index 范围开始位置
     * @param length 范围长度
     */
    getFormat(ranges) {
        if ((0,lodash__WEBPACK_IMPORTED_MODULE_8__.isArray)(ranges)) {
            return (0,_Common_util__WEBPACK_IMPORTED_MODULE_3__.getFormat)(this, ranges);
        }
        else if (ranges === undefined) {
            return (0,_Common_util__WEBPACK_IMPORTED_MODULE_3__.getFormat)(this);
        }
        else {
            return (0,_Common_util__WEBPACK_IMPORTED_MODULE_3__.getFormat)(this, [ranges]);
        }
    }
    /**
     * 删除指定范围内的内容
     * @param selection 要删除的内容范围
     * @param forward 是否为向前删除，true: 向前删除，相当于光标模式下按退格键； false：向后删除，相当于 win 上的 del 键
     */
    delete(selection, forward = true) {
        var _a, _b;
        let res = new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())();
        // 大致分为两种场景，1、没有选中内容，即处于光标模式下向前或向后删除  2、有选择内容的时候删除
        for (let selectionIndex = 0; selectionIndex < selection.length; selectionIndex++) {
            const range = selection[selectionIndex];
            if ((0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_7__.compareDocPos)(range.start, range.end) === 0) {
                // 先排除一个特殊情况，在文档的最前面向前删除
                if (range.start.index === 0 && forward) {
                    continue;
                }
                // 1、没有选中内容，即处于光标模式下向前或向后删除
                // 这里又要区分 rang.start 的 inner 是否为 null，如果是 null 说明是 BlockCommon，走一般流程
                // 如果不是 null 说明是特殊的 block，比如 Table，就要调用 Block 自己的 delete 方法
                // 如果要删除的内容是目标 block 的最后一个元素，就属于特殊情况，要特别处理，否则就按普通规则处理或交给 block 自行处理
                // 因为要删除 block 的最后一个元素往往涉及到 block 内容的合并等操作
                const currentBlock = (0,_Common_util__WEBPACK_IMPORTED_MODULE_3__.findChildInDocPos)(range.start.index, this.children, true);
                if (!currentBlock) {
                    continue;
                } // 说明选区数据有问题
                const diffStartBlock = forward && currentBlock.start === range.start.index && range.start.inner === null
                    ? currentBlock.prevSibling
                    : currentBlock;
                const diffEndBlock = currentBlock;
                if (diffStartBlock === null || diffEndBlock === null) {
                    continue;
                }
                const diffRetainStart = (diffStartBlock === null || diffStartBlock === void 0 ? void 0 : diffStartBlock.start) || 0;
                const oldOps = this.getOpFromLinkedBlocks(diffStartBlock, diffEndBlock);
                if (forward) {
                    if (currentBlock.start < range.start.index || range.start.inner !== null) {
                        currentBlock.delete({
                            start: (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_7__.getRelativeDocPos)(currentBlock.start, range.start),
                            end: (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_7__.getRelativeDocPos)(currentBlock.start, range.end),
                        }, true);
                    }
                    else if (currentBlock.prevSibling) {
                        currentBlock.prevSibling.delete({
                            start: (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_7__.getRelativeDocPos)(currentBlock.prevSibling.start, range.start),
                            end: (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_7__.getRelativeDocPos)(currentBlock.prevSibling.start, range.end),
                        }, true);
                    }
                    else {
                        continue;
                    }
                }
                else {
                    currentBlock.delete({
                        start: (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_7__.getRelativeDocPos)(currentBlock.start, range.start),
                        end: (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_7__.getRelativeDocPos)(currentBlock.start, range.end),
                    }, false);
                }
                // 尝试合并
                this.tryEat(diffStartBlock, diffEndBlock);
                const newOps = this.getOpFromLinkedBlocks(diffStartBlock, diffEndBlock);
                // 最后把新老 op 做 diff
                const diff = new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())(oldOps).diff(new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())(newOps));
                res = res.compose(new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())().retain(diffRetainStart).concat(diff));
            }
            else {
                // 2、有选择内容的时候删除
                const startBlock = (0,_Common_util__WEBPACK_IMPORTED_MODULE_3__.findChildInDocPos)(range.start.index, this.children, true);
                const endBlock = (0,_Common_util__WEBPACK_IMPORTED_MODULE_3__.findChildInDocPos)(range.end.index, this.children, true);
                if (!startBlock || !endBlock) {
                    continue;
                }
                const diffStartBlock = startBlock.start === range.start.index && range.start.inner === null ? startBlock.prevSibling : startBlock;
                const diffEndBlock = endBlock.nextSibling;
                const diffRetainStart = (diffStartBlock === null || diffStartBlock === void 0 ? void 0 : diffStartBlock.start) || 0;
                let needTryMerge = diffStartBlock === startBlock;
                // 先计算删除操作之前的 op
                const oldOps = this.getOpFromLinkedBlocks(diffStartBlock, diffEndBlock);
                // 然后开始删除，分开始和结束在同一个 block 和 在不同的 block 两种情况
                if (startBlock === endBlock) {
                    if (startBlock.start === range.start.index &&
                        range.start.inner === null &&
                        startBlock.start + startBlock.length === range.end.index &&
                        range.end.inner === null) {
                        this.remove(startBlock);
                    }
                    else {
                        startBlock.delete({
                            start: (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_7__.getRelativeDocPos)(startBlock.start, range.start),
                            end: (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_7__.getRelativeDocPos)(startBlock.start, range.end),
                        }, forward);
                    }
                    needTryMerge = true;
                }
                else {
                    let currentBlock = endBlock;
                    let beEatBlock = null;
                    while (currentBlock) {
                        const prev = currentBlock.prevSibling;
                        if (currentBlock === startBlock) {
                            if (currentBlock.start === range.start.index && range.start.inner === null) {
                                // 说明要直接删除第一个 block
                                this.remove(currentBlock);
                            }
                            else {
                                currentBlock.delete({
                                    start: (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_7__.getRelativeDocPos)(currentBlock.start, range.start),
                                    end: (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_7__.getRelativeDocPos)(currentBlock.start, {
                                        index: currentBlock.start + currentBlock.length,
                                        inner: null,
                                    }),
                                }, forward);
                            }
                            break;
                        }
                        else if (currentBlock === endBlock) {
                            if (currentBlock.start + currentBlock.length === range.end.index && range.end.inner === null) {
                                // 说明要直接删除最后一个 block
                                this.remove(currentBlock);
                                beEatBlock = diffEndBlock;
                            }
                            else if (range.end.index === currentBlock.start && range.end.inner === null) {
                                // 说明删除结束位置落在 currentBlock 的最开始位置，这时什么都不用做
                                beEatBlock = currentBlock;
                            }
                            else {
                                currentBlock.delete({
                                    start: { index: 0, inner: null },
                                    end: (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_7__.getRelativeDocPos)(currentBlock.start, range.end),
                                }, forward);
                                beEatBlock = endBlock;
                            }
                        }
                        else {
                            // 既不是第一个 block 也不是最后一个 block 则直接删除这个 block
                            this.remove(currentBlock);
                        }
                        currentBlock = prev;
                    }
                    if (needTryMerge) {
                        // 然后尝试合并
                        if (startBlock.eat(beEatBlock)) {
                            this.remove(beEatBlock);
                        }
                    }
                }
                // 再计算新的 op
                const newOps = this.getOpFromLinkedBlocks(diffStartBlock, diffEndBlock);
                // 最后把新老 op 做 diff
                const diff = new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())(oldOps).diff(new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())(newOps));
                res = res.compose(new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())().retain(diffRetainStart).concat(diff));
                if (diffStartBlock) {
                    diffStartBlock.setStart(diffStartBlock.start, true, true);
                    diffStartBlock.setPositionY(diffStartBlock.y, true, true);
                }
                else {
                    (_a = this.head) === null || _a === void 0 ? void 0 : _a.setStart(0, true, true);
                    (_b = this.head) === null || _b === void 0 ? void 0 : _b.setPositionY(0, true, true);
                }
            }
        }
        this.needLayout = true;
        this.bubbleUp(_Common_EnumBubbleMessage__WEBPACK_IMPORTED_MODULE_10__.BubbleMessage.CONTENT_CHANGE, null, [this]);
        return res;
    }
    clearContent() {
        const oldDelta = this.toDelta(true);
        const newDelta = DocContent_1.createDefaultEmptyDocContent().toDelta();
        this.removeAll();
        this.readFromChanges(newDelta);
        this.needLayout = true;
        return oldDelta.diff(newDelta);
    }
    getCursorType() {
        return _Common_EnumCursorType__WEBPACK_IMPORTED_MODULE_4__.EnumCursorType.Default;
    }
    // #region IPointerInteractive methods
    onPointerEnter(x, y, targetStack, currentTargetIndex) {
        throw new Error('Need IPointerInteractiveDecorator to implement.');
    }
    onPointerLeave() {
        throw new Error('Need IPointerInteractiveDecorator to implement.');
    }
    onPointerMove(x, y, targetStack, currentTargetIndex) {
        throw new Error('Need IPointerInteractiveDecorator to implement.');
    }
    onPointerDown(x, y) {
        throw new Error('Need IPointerInteractiveDecorator to implement.');
    }
    onPointerUp(x, y) {
        throw new Error('Need IPointerInteractiveDecorator to implement.');
    }
    onPointerTap(x, y) {
        throw new Error('Need IPointerInteractiveDecorator to implement.');
    }
    // #endregion
    /**
     * 插入操作
     * @param content 要插入的内容
     * @param composing 是否是输入法输入状态，输入法输入状态下不需要生成 delta
     */
    insertText(content, pos, attr) {
        let res = new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())();
        // 开始插入逻辑之前，先把受影响的 block 的 delta 记录下来
        const startBlock = (0,_Common_util__WEBPACK_IMPORTED_MODULE_3__.findChildInDocPos)(pos.index, this.children, true);
        if (!startBlock || startBlock.start + startBlock.length < pos.index) {
            return res;
        }
        const insertStartDelta = new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())(startBlock.toOp(true));
        let { index } = pos;
        const insertBat = lodash_replace__WEBPACK_IMPORTED_MODULE_1___default()(content, /\r/g, '').split('\n'); // 先把回车处理掉，去掉所有的 \r,只保留 \n，然后分割
        for (let batIndex = 0; batIndex < insertBat.length; batIndex++) {
            const batContent = insertBat[batIndex];
            const block = (0,_Common_util__WEBPACK_IMPORTED_MODULE_3__.findChildInDocPos)(index, this.children, true);
            if (!block) {
                return new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())();
            } // 如果这里 return 了说明逻辑出现了问题
            let lengthChanged = false;
            if (batContent.length > 0) {
                if (block.insertText(batContent, { index: pos.index - block.start, inner: pos.inner }, attr)) {
                    index += batContent.length;
                    lengthChanged = true;
                }
            }
            // 插入一个换行符
            if (batIndex < insertBat.length - 1) {
                if (this.insertEnter({ index, inner: pos.inner }, attr)) {
                    index++;
                    lengthChanged = true;
                }
            }
            if (lengthChanged) {
                startBlock.setStart(startBlock.start, true, true);
            }
        }
        // 这里要先触发 change 事件，然后在设置新的 pos
        // 因为触发 change 之后才能计算文档的新结构和长度，在这之前设置 pos 可能会导致错误
        this.bubbleUp(_Common_EnumBubbleMessage__WEBPACK_IMPORTED_MODULE_10__.BubbleMessage.CONTENT_CHANGE, null, [this]);
        this.needLayout = true;
        // 插入逻辑完成后，将受影响的 block 的新的 delta 记录下来和之前的 delta 进行 diff
        const endBlock = (0,_Common_util__WEBPACK_IMPORTED_MODULE_3__.findChildInDocPos)(index, this.children, true);
        const endOps = this.getOpFromLinkedBlocks(startBlock, endBlock);
        const insertEndDelta = new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())(endOps);
        const change = insertStartDelta.diff(insertEndDelta).ops;
        if (startBlock.start > 0) {
            change.unshift({ retain: startBlock.start });
        }
        res = res.compose(new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())(change));
        return res;
    }
    /**
     * 在指定位置插入一个换行符
     * @returns true: 成功插入且当前 docContent 长度要加 1，false: 没有成功插入，或虽然插入成功但当前 docContent 长度不变
     */
    insertEnter(pos, attr) {
        const targetBlock = (0,_Common_util__WEBPACK_IMPORTED_MODULE_3__.findChildInDocPos)(pos.index, this.children, true);
        if (!targetBlock) {
            return null;
        }
        const oldOps = targetBlock.toOp(true);
        const newBlock = targetBlock.insertEnter({ index: pos.index - targetBlock.start, inner: pos.inner }, attr);
        const newOps = targetBlock.toOp(true);
        if (newBlock) {
            this.addAfter(newBlock, targetBlock);
            newBlock.setStart(targetBlock.start + targetBlock.length, true);
            newOps.push(...newBlock.toOp(true));
        }
        const res = new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())();
        if (targetBlock.start > 0) {
            res.retain(targetBlock.start);
        }
        this.needLayout = true;
        return res.concat(new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())(oldOps).diff(new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())(newOps)));
    }
    insertFragment(frag, pos) {
        const block = (0,_Common_util__WEBPACK_IMPORTED_MODULE_3__.findChildInDocPos)(pos.index, this.children, true);
        if (!block) {
            return null;
        }
        const oldDelta = new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())(block.toOp(true));
        block.insertFragment(frag, (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_7__.getRelativeDocPos)(block.start, pos));
        this.bubbleUp(_Common_EnumBubbleMessage__WEBPACK_IMPORTED_MODULE_10__.BubbleMessage.CONTENT_CHANGE, null, [this]);
        this.needLayout = true;
        const newDelta = new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())(block.toOp(true));
        const changeOps = oldDelta.diff(newDelta).ops;
        if (block.start > 0) {
            changeOps.unshift({ retain: block.start });
        }
        return new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())(changeOps);
    }
    insertBlock(block, pos) {
        // 大概分为两种情况
        // 1、插在两个 block 之间
        // 2、插入某个 block
        const targetBlockIndex = (0,_Common_util__WEBPACK_IMPORTED_MODULE_3__.findChildIndexInDocPos)(pos.index, this.children, true);
        const targetBlock = this.children[targetBlockIndex];
        if (targetBlockIndex < 0) {
            return null;
        }
        let res;
        if (targetBlock.start === pos.index && pos.inner === null) {
            const ops = [];
            const targetStart = targetBlock.start;
            const targetY = targetBlock.y;
            if (targetStart > 0) {
                ops.push({ retain: targetStart });
            }
            // 说明是插在两个 block 之间
            this.addBefore(block, targetBlock);
            block.setStart(targetStart, true, true);
            block.setPositionY(targetY, true, true);
            ops.push(...block.toOp(false));
            res = new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())(ops);
        }
        else {
            // 插入某个 block
            const oldDelta = new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())(targetBlock.toOp(true));
            const newBlocks = targetBlock.insertBlock(block, (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_7__.getRelativeDocPos)(targetBlock.start, pos));
            if (newBlocks.length) {
                this.splice(targetBlockIndex, 1, newBlocks);
            }
            const newOps = [];
            for (let index = 0; index < newBlocks.length; index++) {
                const element = newBlocks[index];
                newOps.push(...element.toOp(true));
            }
            const newDelta = new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())(newOps);
            const diff = oldDelta.diff(newDelta);
            const ops = [];
            if (block.start > 0) {
                ops.push({ retain: targetBlock.start });
            }
            ops.push(...diff.ops);
            res = new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())(ops);
        }
        return res;
    }
    /**
     * 在 document 里面找到设计到 range 范围的 block
     * @param index range 的开始位置
     * @param length range 的长度
     */
    findBlocksByRange(index, length, intersectionType) {
        const type = intersectionType !== null && intersectionType !== void 0 ? intersectionType : _Common_util__WEBPACK_IMPORTED_MODULE_3__.EnumIntersectionType.both;
        return (0,_Common_util__WEBPACK_IMPORTED_MODULE_3__.findChildrenByRange)(this.children, index, length, type);
    }
    /**
     * 排版
     */
    layout(start = 0) {
        if (!this.needLayout) {
            return;
        }
        for (let index = start; index < this.children.length; index++) {
            if (this.children[index].needLayout) {
                const child = this.children[index];
                child.x = this.paddingLeft;
                if (index === 0) {
                    child.y = this.paddingTop;
                }
                child.setWidth(this.width - this.paddingLeft - this.paddingRight);
                child.layout();
            }
        }
        this.needLayout = false;
    }
    /**
     * 获取一系列 block 的 Op
     */
    getBlocksOps(blocks) {
        const res = [];
        for (let index = 0; index < blocks.length; index++) {
            const element = blocks[index];
            res.push(...element.toOp(true));
        }
        return res;
    }
    /**
     * 将所有 block 设置为需要排版
     */
    setNeedToLayout() {
        this.needLayout = true;
        for (let index = 0; index < this.children.length; index++) {
            this.children[index].needLayout = true;
        }
    }
    readDeltaToBlocks(delta) {
        var _a;
        const blocks = [];
        const opCache = [];
        // 顺序遍历所有的 op，如果遇到某个 op 的 attributes 上有 block 属性就创建对应的 block
        for (let index = 0; index < delta.ops.length; index++) {
            const op = delta.ops[index];
            if (typeof ((_a = op.attributes) === null || _a === void 0 ? void 0 : _a.block) === 'string') {
                const BlockClass = (0,_Common_IoC__WEBPACK_IMPORTED_MODULE_12__.get)(op.attributes.block);
                if (BlockClass) {
                    if (typeof op.insert === 'number') {
                        opCache.push({ insert: 1, attributes: Object.assign({}, op.attributes) });
                        const block = new BlockClass();
                        block.setWidth(this.width - this.paddingLeft - this.paddingRight);
                        block.readFromOps(opCache);
                        blocks.push(block);
                        // 还要处理 insert > 1 的情况
                        if (op.insert > 1) {
                            for (let i = 0; i < op.insert - 1; i++) {
                                const block = new BlockClass();
                                block.setWidth(this.width - this.paddingLeft - this.paddingRight);
                                block.readFromOps([{ insert: 1, attributes: Object.assign({}, op.attributes) }]);
                                blocks.push(block);
                            }
                        }
                    }
                    else {
                        opCache.push(op);
                        const block = new BlockClass();
                        block.setWidth(this.width - this.paddingLeft - this.paddingRight);
                        block.readFromOps(opCache);
                        blocks.push(block);
                    }
                }
                else {
                    console.warn('unknown block type: ', op.attributes.block);
                }
                opCache.length = 0;
            }
            else {
                opCache.push(op);
            }
        }
        return blocks;
    }
    /**
     * 从 end 位置开始尝试合并相邻的 block
     */
    tryMerge(start, end) {
        let canStop = false;
        let current = start;
        while (current === null || current === void 0 ? void 0 : current.nextSibling) {
            if (current === end) {
                canStop = true;
            }
            if (current.needMerge && current.constructor === current.nextSibling.constructor) {
                current.merge(current.nextSibling);
                current.needLayout = true;
                this.remove(current.nextSibling);
            }
            else if (canStop) {
                break;
            }
            else {
                current = current.nextSibling;
            }
        }
    }
    tryEat(start, end) {
        let currentBlock = start;
        while (currentBlock === null || currentBlock === void 0 ? void 0 : currentBlock.nextSibling) {
            const eatRes = currentBlock.eat(currentBlock.nextSibling);
            if (eatRes) {
                this.remove(currentBlock.nextSibling);
                if (currentBlock.nextSibling !== end) {
                    continue;
                }
                else {
                    break;
                }
            }
            else if (currentBlock.nextSibling !== end) {
                currentBlock = currentBlock.nextSibling;
                continue;
            }
            else {
                break;
            }
        }
    }
    /**
     * 计算指定的 x、y 坐标所指向的文档位置
     */
    getDocumentPos(x, y, start = false) {
        let targetChild;
        if (y < 0) {
            targetChild = this.head;
        }
        else if (y > this.height) {
            targetChild = this.tail;
        }
        else {
            // 如果在异步排版过程中，就不能用二分查找
            targetChild = (0,_Common_util__WEBPACK_IMPORTED_MODULE_3__.findRectChildInPosY)(y, this.children, true);
        }
        if (targetChild === null) {
            return null;
        }
        const childPos = targetChild.getDocumentPos(x, y, start);
        if (childPos !== null) {
            childPos.index += targetChild.start;
        }
        return childPos;
    }
    /**
     * 根据选区获取选区矩形区域
     * @param start 选区相对当前 block 的开始位置
     * @param end 选区相对当前 block 的结束位置
     * @param {number | undefined} correctByPosY 用实际鼠标 y 坐标修正结果，在选区长度为 0 计算光标位置的时候要用这个参数
     */
    getSelectionRectangles(start, end, correctByPosY) {
        const selectionRectangles = [];
        let currentBlock = this.head;
        const startRetain = start.index;
        const endRetain = end.index;
        while (currentBlock) {
            if ((0,_Common_util__WEBPACK_IMPORTED_MODULE_3__.hasIntersection)(currentBlock.start, currentBlock.start + currentBlock.length, startRetain, endRetain + 1)) {
                selectionRectangles.push(...currentBlock.getSelectionRectangles((0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_7__.getRelativeDocPos)(currentBlock.start, start), (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_7__.getRelativeDocPos)(currentBlock.start, end), correctByPosY));
            }
            if (currentBlock !== this.tail) {
                currentBlock = currentBlock.nextSibling;
            }
            else {
                currentBlock = null;
            }
        }
        return selectionRectangles;
    }
    // #region IBubbleUpable methods
    bubbleUp(type, data, stack) {
        throw new Error('this method should implemented in IGetAbsolutePosDecorator');
    }
    setBubbleHandler(handler) {
        throw new Error('this method should implemented in IBubbleUpableDecorator');
    }
    // #endregion
    // #region IDocPosOperator methods
    firstPos() {
        throw new Error('this method should implemented in IDosPosOperatorHDecorator');
    }
    lastPos() {
        throw new Error('this method should implemented in IDosPosOperatorHDecorator');
    }
    nextPos(pos) {
        throw new Error('this method should implemented in IDosPosOperatorHDecorator');
    }
    firstLinePos(x) {
        throw new Error('this method should implemented in IDosPosOperatorHDecorator');
    }
    lastLinePos(x) {
        throw new Error('this method should implemented in IDosPosOperatorHDecorator');
    }
    prevPos(pos) {
        throw new Error('this method should implemented in IDosPosOperatorHDecorator');
    }
    nextLinePos(pos, x) {
        throw new Error('this method should implemented in IDosPosOperatorVDecorator');
    }
    prevLinePos(pos, x) {
        throw new Error('this method should implemented in IDosPosOperatorVDecorator');
    }
    lineStartPos(pos, y) {
        throw new Error('this method should implemented in IDosPosOperatorVDecorator');
    }
    lineEndPos(pos, y) {
        throw new Error('this method should implemented in IDosPosOperatorVDecorator');
    }
    // #endregion
    // #region override LinkedList method
    afterAdd(nodes, index, prevNode, nextNode, array) {
        nodes.forEach((node) => {
            node.x = this.paddingLeft;
            node.setWidth(this.width - this.paddingLeft - this.paddingRight);
            this.length += node.length;
            node.setBubbleHandler(this.bubbleUp.bind(this));
        });
        const start = nodes[0].prevSibling === null ? 0 : nodes[0].prevSibling.start + nodes[0].prevSibling.length;
        nodes[0].setStart(start, true, true);
    }
    beforeRemove(nodes, index, prevNode, nextNode, array) {
        nodes.forEach((node) => {
            this.length -= node.length;
            node.setBubbleHandler(null);
        });
        if (nextNode) {
            nextNode.setStart(prevNode ? prevNode.start + prevNode.length : 0, true, true);
        }
    }
    afterRemove(nodes) {
        nodes.forEach((node) => {
            this.length -= node.length;
            node.setBubbleHandler(null);
        });
    }
    addLast(node) {
        throw new Error('this method should be implemented in ILinkedListDecorator');
    }
    addAfter(node, target) {
        throw new Error('this method should be implemented in ILinkedListDecorator');
    }
    addBefore(node, target) {
        throw new Error('this method should be implemented in ILinkedListDecorator');
    }
    addAtIndex(node, index) {
        throw new Error('this method should be implemented in ILinkedListDecorator');
    }
    addAll(nodes) {
        throw new Error('this method should be implemented in ILinkedListDecorator');
    }
    removeAll() {
        throw new Error('this method should be implemented in ILinkedListDecorator');
    }
    remove(node) {
        throw new Error('this method should be implemented in ILinkedListDecorator');
    }
    removeAllFrom(node) {
        throw new Error('this method should be implemented in ILinkedListDecorator');
    }
    splice(start, deleteCount, nodes) {
        throw new Error('this method should be implemented in ILinkedListDecorator');
    }
    findIndex(node) {
        throw new Error('this method should be implemented in ILinkedListDecorator');
    }
    // #endregion
    // #region getSelectedElement methods
    getSelectedElement(range) {
        throw new Error('Method not implemented.');
    }
    // #endregion
    /**
     * 获取从 startBlock 到 endBlock 之间所有 block 的 Op
     * @param startBlock 如果 startBlock 为 null，说明从文档开头开始
     */
    getOpFromLinkedBlocks(startBlock, endBlock) {
        const res = [];
        let currentOldBlock = startBlock === null ? this.children[0] : startBlock;
        while (currentOldBlock) {
            res.push(...currentOldBlock.toOp(true));
            if (currentOldBlock !== endBlock) {
                currentOldBlock = currentOldBlock.nextSibling;
            }
            else {
                break;
            }
        }
        return res;
    }
};
DocContent = DocContent_1 = __decorate([
    _Common_ISelectedElementGettable__WEBPACK_IMPORTED_MODULE_11__.ISelectedElementGettableDecorator,
    OverrideIBubbleUpableDecorator,
    _Common_IBubbleUpable__WEBPACK_IMPORTED_MODULE_5__.IBubbleUpableDecorator,
    _Common_LinkedList__WEBPACK_IMPORTED_MODULE_2__.ILinkedListDecorator,
    _Common_IPointerInteractive__WEBPACK_IMPORTED_MODULE_6__.IPointerInteractiveDecorator,
    _Common_IDocPosOperator__WEBPACK_IMPORTED_MODULE_9__.IDosPosOperatorHDecorator,
    _Common_IDocPosOperator__WEBPACK_IMPORTED_MODULE_9__.IDosPosOperatorVDecorator
], DocContent);



/***/ }),

/***/ "./src/Document/Document.ts":
/*!**********************************!*\
  !*** ./src/Document/Document.ts ***!
  \**********************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Document": function() { return /* binding */ Document; },
/* harmony export */   "DocumentEvent": function() { return /* binding */ DocumentEvent; }
/* harmony export */ });
/* harmony import */ var eventemitter3__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! eventemitter3 */ "eventemitter3");
/* harmony import */ var eventemitter3__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(eventemitter3__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _DocContent__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./DocContent */ "./src/Document/DocContent.ts");
/* harmony import */ var _Common_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Common/util */ "./src/Common/util.ts");
/* harmony import */ var _Common_EnumBubbleMessage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Common/EnumBubbleMessage */ "./src/Common/EnumBubbleMessage.ts");
/* harmony import */ var _Platform__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Platform */ "./src/Platform.ts");





var DocumentEvent;
(function (DocumentEvent) {
    DocumentEvent["DOCUMENT_CHANGE_CONTENT"] = "DOCUMENT_CHANGE_CONTENT";
    DocumentEvent["DOCUMENT_CHANGE_SIZE"] = "DOCUMENT_CHANGE_SIZE";
    DocumentEvent["DOCUMENT_NEED_LAYOUT"] = "DOCUMENT_NEED_LAYOUT";
    DocumentEvent["DOCUMENT_NEED_DRAW"] = "DOCUMENT_NEED_DRAW";
    DocumentEvent["DOCUMENT_FIRST_RENDERED"] = "DOCUMENT_FIRST_RENDERED";
    DocumentEvent["DOCUMENT_FIRST_LAYOUT"] = "DOCUMENT_FIRST_LAYOUT";
    DocumentEvent["DOCUMENT_AFTER_LAYOUT"] = "DOCUMENT_AFTER_LAYOUT";
    DocumentEvent["DOCUMENT_AFTER_DRAW"] = "DOCUMENT_AFTER_DRAW";
    DocumentEvent["DOCUMENT_AFTER_IDLE_LAYOUT"] = "DOCUMENT_AFTER_IDLE_LAYOUT";
    DocumentEvent["DOCUMENT_LAYOUT_FINISH"] = "DOCUMENT_LAYOUT_FINISH";
})(DocumentEvent || (DocumentEvent = {}));
class Document extends _DocContent__WEBPACK_IMPORTED_MODULE_1__.DocContent {
    constructor() {
        super(...arguments);
        this.em = new (eventemitter3__WEBPACK_IMPORTED_MODULE_0___default())();
        this.firstScreenRendered = false;
        this.firstLayout = false;
        this.initLayout = false;
        this.idleLayoutStartBlock = null;
        this.idleLayoutRunning = false;
        this.startDrawingBlock = null;
        this.drawingBuffer = new Set();
        this.viewportBuffer = new Set();
        this.runIdleLayout = (deadline) => {
            if (this.idleLayoutStartBlock) {
                this.idleLayoutRunning = true;
                let hasLayout = false; // 这个变量用来几个当前这个 idleLayout 过程中是否有 block 排过版
                while (deadline.timeRemaining() > 3 && this.idleLayoutStartBlock) {
                    if (this.idleLayoutStartBlock.needLayout) {
                        hasLayout = hasLayout || this.idleLayoutStartBlock.needLayout;
                        this.idleLayoutStartBlock.layout();
                    }
                    this.idleLayoutStartBlock = this.idleLayoutStartBlock.nextSibling;
                }
                this.em.emit(DocumentEvent.DOCUMENT_AFTER_IDLE_LAYOUT, {
                    hasLayout,
                    needIdleLayout: this.idleLayoutStartBlock !== null,
                });
                if (this.idleLayoutStartBlock) {
                    // 说明还没有排版完成
                    // 如果初次排版都没有完成，就要更新一次文档高度
                    if (this.initLayout === false) {
                        this.setContentHeight(this.idleLayoutStartBlock.y);
                    }
                    (0,_Platform__WEBPACK_IMPORTED_MODULE_4__.getPlatform)().requestIdleCallback(this.runIdleLayout);
                }
                else {
                    this.idleLayoutRunning = false;
                    this.initLayout = true;
                    if (!this.firstLayout) {
                        this.firstLayout = true;
                        this.em.emit(DocumentEvent.DOCUMENT_FIRST_LAYOUT);
                    }
                    // 说明全文排版完成
                    this.em.emit(DocumentEvent.DOCUMENT_LAYOUT_FINISH, { hasLayout });
                }
            }
        };
    }
    readFromChanges(delta) {
        this.firstScreenRendered = false;
        this.firstLayout = false;
        super.readFromChanges(delta);
    }
    draw(ctx, scrollTop, viewHeight) {
        this.startDrawingBlock = null;
        const lastDrawingBuffer = this.drawingBuffer;
        this.drawingBuffer = new Set();
        const lastViewportBuffer = this.viewportBuffer;
        this.viewportBuffer = new Set();
        ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
        ctx.save();
        let current = this.head;
        if (current) {
            current.setPositionY(this.paddingTop);
        }
        const drawingBufferPosStart = Math.max(scrollTop - viewHeight, 0);
        const viewportPosEnd = scrollTop + viewHeight;
        const drawingBufferPosEnd = viewportPosEnd + viewHeight;
        let needIdleLayout = false;
        let hasLayout = false; // 这个变量用来记录整个绘制过程中是否有 block 需要排版
        // 绘制的主要逻辑是，当前视口前面的内容只用排版不用绘制
        // 当前视口中的内容排版并绘制
        // 当前视口后面的内容，放到空闲队列里面排版
        // 当前视口前后各一屏内的内容进 buffer
        // buffer 内的元素都需要 layout
        while (current !== null) {
            if ((0,_Common_util__WEBPACK_IMPORTED_MODULE_2__.hasIntersection)(current.y, current.y + current.height, drawingBufferPosStart, drawingBufferPosEnd)) {
                // in buffer, need layout
                hasLayout = hasLayout || current.needLayout;
                current.layout();
                // new in buffer need call enterBuffer
                this.drawingBuffer.add(current);
                if (!lastDrawingBuffer.has(current)) {
                    current.enterBuffer(ctx, 0, -scrollTop, viewHeight - current.y + scrollTop);
                }
                if ((0,_Common_util__WEBPACK_IMPORTED_MODULE_2__.hasIntersection)(current.y, current.y + current.height, scrollTop, viewportPosEnd)) {
                    // in viewport, need call enterViewport and draw
                    this.viewportBuffer.add(current);
                    if (!lastViewportBuffer.has(current)) {
                        current.enterViewport(ctx, 0, -scrollTop, viewHeight - current.y + scrollTop);
                    }
                    current.draw(ctx, 0, -scrollTop, viewHeight - current.y + scrollTop);
                    if (this.startDrawingBlock === null) {
                        this.startDrawingBlock = current;
                    }
                }
            }
            else if (current.y < drawingBufferPosStart) {
                // only need layout
                hasLayout = hasLayout || current.needLayout;
                current.layout();
            }
            else if (current.needLayout) {
                // 当前视口后面的内容，放到空闲队列里面排版
                needIdleLayout = true;
                this.startIdleLayout(current);
                break;
            }
            current = current.nextSibling;
        }
        // call leaveViewport
        lastViewportBuffer.forEach((block) => {
            if (!this.viewportBuffer.has(block)) {
                block.leaveViewport();
            }
        });
        // call leaveBuffer
        lastDrawingBuffer.forEach((block) => {
            if (!this.drawingBuffer.has(block)) {
                block.leaveBuffer();
            }
        });
        ctx.restore();
        if (!this.firstScreenRendered) {
            this.firstScreenRendered = true;
            this.em.emit(DocumentEvent.DOCUMENT_FIRST_RENDERED);
        }
        if (!this.firstLayout && !needIdleLayout) {
            this.firstLayout = true;
            this.em.emit(DocumentEvent.DOCUMENT_FIRST_LAYOUT);
        }
        this.em.emit(DocumentEvent.DOCUMENT_AFTER_LAYOUT, { hasLayout, needIdleLayout, ctx, scrollTop, viewHeight });
        if (!needIdleLayout) {
            this.em.emit(DocumentEvent.DOCUMENT_LAYOUT_FINISH, { hasLayout, ctx, scrollTop, viewHeight });
        }
    }
    /**
     * 快速绘制，不包括排版等逻辑
     */
    fastDraw(ctx, scrollTop, viewHeight) {
        this.startDrawingBlock = null;
        ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
        ctx.save();
        const lastDrawingBuffer = this.drawingBuffer;
        this.drawingBuffer = new Set();
        const lastViewportBuffer = this.viewportBuffer;
        this.viewportBuffer = new Set();
        const bufferPosStart = Math.max(scrollTop - viewHeight, 0);
        const viewportPosEnd = scrollTop + viewHeight;
        const bufferPosEnd = viewportPosEnd + viewHeight;
        let current = null;
        // 如果 idleLayout 在执行过程中，说明有的 block 还没有被正确设置 y 坐标，此时不能直接用二分法查找目标 block，
        // 否可可能会拿到错误的 block，需要降级为从头遍历找目标 block
        // 这里应该不需要担心绘制的内容在需要排版的 block 后面，因为可视区域如果在需要排版的元素后面不会走 fastDraw 的逻辑
        if (this.idleLayoutRunning) {
            for (let childIndex = 0; childIndex < this.children.length; childIndex++) {
                const element = this.children[childIndex];
                if ((0,_Common_util__WEBPACK_IMPORTED_MODULE_2__.hasIntersection)(element.y, element.y + element.height, bufferPosStart, bufferPosEnd)) {
                    current = element;
                    break;
                }
            }
        }
        else {
            current = (0,_Common_util__WEBPACK_IMPORTED_MODULE_2__.findRectChildInPosY)(bufferPosStart, this.children);
            // 如果这里 current 没有找到有可能是因为 document 有 paddingTop，导致第一个元素的 y < scrollTop
            if (!current) {
                current = this.head;
            }
        }
        if (current) {
            while (current) {
                if (current.y >= bufferPosEnd) {
                    break;
                }
                // new in buffer need call enterBuffer
                this.drawingBuffer.add(current);
                if (!lastDrawingBuffer.has(current)) {
                    current.enterBuffer(ctx, 0, -scrollTop, viewHeight - current.y + scrollTop);
                }
                if ((0,_Common_util__WEBPACK_IMPORTED_MODULE_2__.hasIntersection)(current.y, current.y + current.height, scrollTop, viewportPosEnd)) {
                    this.viewportBuffer.add(current);
                    if (!lastViewportBuffer.has(current)) {
                        current.enterViewport(ctx, 0, -scrollTop, viewHeight - current.y + scrollTop);
                    }
                    this.startDrawingBlock = this.startDrawingBlock || current;
                    current.draw(ctx, 0, -scrollTop, viewHeight - current.y + scrollTop);
                }
                current = current.nextSibling;
            }
            lastViewportBuffer.forEach((block) => {
                if (!this.viewportBuffer.has(block)) {
                    block.leaveViewport();
                }
            });
            lastDrawingBuffer.forEach((block) => {
                if (!this.drawingBuffer.has(block)) {
                    block.leaveBuffer();
                }
            });
        }
        ctx.restore();
        this.em.emit(DocumentEvent.DOCUMENT_AFTER_DRAW, { ctx, scrollTop, viewHeight });
    }
    afterRemove(nodes) {
        super.afterRemove(nodes);
        for (let index = 0; index < nodes.length; index++) {
            const node = nodes[index];
            if (this.drawingBuffer.has(node)) {
                node.leaveBuffer();
                this.drawingBuffer.delete(node);
            }
            if (this.viewportBuffer.has(node)) {
                node.leaveViewport();
                this.viewportBuffer.delete(node);
            }
        }
    }
    getDocumentPos(x, y, start = false) {
        let targetChild;
        if (y < 0) {
            targetChild = this.head;
        }
        else if (y > this.height) {
            targetChild = this.tail;
        }
        else {
            // 如果在异步排版过程中，就不能用二分查找
            targetChild = (0,_Common_util__WEBPACK_IMPORTED_MODULE_2__.findRectChildInPosY)(y, this.children, this.idleLayoutStartBlock === null);
        }
        if (targetChild === null) {
            return null;
        }
        const childPos = targetChild.getDocumentPos(x, y, start);
        if (childPos !== null) {
            childPos.index += targetChild.start;
        }
        return childPos;
    }
    setHeight(height) {
        const targetHeight = Math.ceil(height);
        if (targetHeight >= this.contentHeight && targetHeight !== this.height) {
            this.height = targetHeight;
            this.em.emit(DocumentEvent.DOCUMENT_CHANGE_SIZE, { width: this.width, height: this.height });
        }
    }
    setWidth(width) {
        super.setWidth(width);
        this.em.emit(DocumentEvent.DOCUMENT_CHANGE_SIZE, { width: this.width, height: this.height });
        this.em.emit(DocumentEvent.DOCUMENT_NEED_LAYOUT);
    }
    bubbleUp(type, data, stack) {
        super.bubbleUp(type, data, stack);
        switch (type) {
            case _Common_EnumBubbleMessage__WEBPACK_IMPORTED_MODULE_3__.BubbleMessage.NEED_LAYOUT: {
                // 如果子元素声明需要重新排版，那么 stack 中最后一个元素就肯定是需要排版的 block
                const target = Array.isArray(stack) ? stack[stack.length - 1] : null;
                if (target && (!this.idleLayoutStartBlock || this.idleLayoutStartBlock.start > target.start)) {
                    this.idleLayoutStartBlock = target;
                    this.em.emit(DocumentEvent.DOCUMENT_NEED_LAYOUT);
                }
                return;
            }
            case _Common_EnumBubbleMessage__WEBPACK_IMPORTED_MODULE_3__.BubbleMessage.CONTENT_CHANGE: {
                this.em.emit(DocumentEvent.DOCUMENT_CHANGE_CONTENT);
                return;
            }
            case _Common_EnumBubbleMessage__WEBPACK_IMPORTED_MODULE_3__.BubbleMessage.NEED_DRAW: {
                this.em.emit(DocumentEvent.DOCUMENT_NEED_DRAW);
                return;
            }
            default: {
                const bubbleStack = stack instanceof Array ? [...stack, this] : [this];
                this.em.emit(type, data, bubbleStack);
            }
        }
    }
    /**
     * 开始 idle layout
     * @param block layout 起始 block
     */
    startIdleLayout(block) {
        if (!this.idleLayoutStartBlock || block.start < this.idleLayoutStartBlock.start) {
            this.idleLayoutStartBlock = block;
            if (!this.idleLayoutRunning) {
                (0,_Platform__WEBPACK_IMPORTED_MODULE_4__.getPlatform)().requestIdleCallback(this.runIdleLayout);
            }
        }
    }
}


/***/ }),

/***/ "./src/Document/index.ts":
/*!*******************************!*\
  !*** ./src/Document/index.ts ***!
  \*******************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DocContent": function() { return /* reexport safe */ _DocContent__WEBPACK_IMPORTED_MODULE_1__.DocContent; },
/* harmony export */   "Document": function() { return /* reexport safe */ _Document__WEBPACK_IMPORTED_MODULE_0__.Document; },
/* harmony export */   "DocumentEvent": function() { return /* reexport safe */ _Document__WEBPACK_IMPORTED_MODULE_0__.DocumentEvent; }
/* harmony export */ });
/* harmony import */ var _Document__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Document */ "./src/Document/Document.ts");
/* harmony import */ var _DocContent__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./DocContent */ "./src/Document/DocContent.ts");




/***/ }),

/***/ "./src/Fragment/Fragment.ts":
/*!**********************************!*\
  !*** ./src/Fragment/Fragment.ts ***!
  \**********************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fragment": function() { return /* binding */ Fragment; }
/* harmony export */ });
/* harmony import */ var _Common_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Common/util */ "./src/Common/util.ts");
/* harmony import */ var _FragmentAttributes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./FragmentAttributes */ "./src/Fragment/FragmentAttributes.ts");
/* harmony import */ var _Common_IBubbleUpable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Common/IBubbleUpable */ "./src/Common/IBubbleUpable.ts");
/* harmony import */ var _Common_DocPos__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Common/DocPos */ "./src/Common/DocPos.ts");
/* harmony import */ var _Common_IAttributable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Common/IAttributable */ "./src/Common/IAttributable.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var Fragment_1;





let Fragment = Fragment_1 = class Fragment {
    constructor() {
        this.defaultAttributes = _FragmentAttributes__WEBPACK_IMPORTED_MODULE_1__.FragmentDefaultAttributes;
        this.overrideDefaultAttributes = null;
        this.originalAttributes = null;
        this.overrideAttributes = null;
        this.attributes = _FragmentAttributes__WEBPACK_IMPORTED_MODULE_1__.FragmentDefaultAttributes;
        this.prevSibling = null;
        this.nextSibling = null;
        this.metrics = { baseline: 0, bottom: 0, xTop: 0 };
        this.id = (0,_Common_util__WEBPACK_IMPORTED_MODULE_0__.increaseId)();
        this.isPointerHover = false;
        // #endregion
    }
    get typeName() {
        return Fragment_1.typeName;
    }
    get start() {
        return this.prevSibling === null ? 0 : this.prevSibling.start + this.prevSibling.length;
    }
    // eslint-disable-next-line @typescript-eslint/class-literal-property-style
    get length() {
        return 1;
    }
    destroy() {
        // todo
    }
    readFromOps(Op) {
        /** */
    }
    /**
     * 计算当前 fragment 的宽度和高度
     */
    calTotalWidth() {
        return 0;
    }
    /**
     * 计算当前 fragment 的 metrics
     */
    calMetrics() {
        /** */
    }
    toOp(withKey) {
        return { retain: 0 };
    }
    toHtml(selection) {
        return '';
    }
    toText(selection) {
        return '';
    }
    /**
     * 为选区设置格式
     * @param attr 新的格式
     * @param range 选区
     */
    format(attr, range) {
        if (!range) {
            this.setAttributes(attr);
            return [this];
        }
        return [];
    }
    clearFormat(range) {
        return this.format(this.defaultAttributes, range);
    }
    getFormat() {
        return this.attributes;
    }
    insertText(content, pos, attr) {
        return [];
    }
    insertEnter(pos) {
        return null;
    }
    insertFragment(frag, pos) {
        return [];
    }
    insertBlock(block, pos) {
        return false;
    }
    /**
     * 删除指定范围的内容（length 为空时删除 index 后所有内容）
     */
    delete(range, forward) {
        /** empty function */
    }
    /**
     *  合并两个 fragment
     */
    eat(frag) {
        return false;
    }
    firstPos() {
        return { index: 0, inner: null };
    }
    lastPos() {
        return { index: this.length - 1, inner: null };
    }
    nextPos(pos) {
        const newPos = (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_3__.moveRight)(pos, 1);
        return newPos.index >= this.length ? null : newPos;
    }
    prevPos(pos) {
        const newPos = (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_3__.moveRight)(pos, -1);
        return newPos.index < 0 ? null : newPos;
    }
    firstLinePos(x) {
        return null;
    }
    lastLinePos(x) {
        return null;
    }
    nextLinePos(pos) {
        return null;
    }
    prevLinePos(pos) {
        return null;
    }
    lineStartPos(pos) {
        return null;
    }
    lineEndPos(pos) {
        return null;
    }
    onPointerEnter() {
        this.isPointerHover = true;
    }
    onPointerLeave() {
        this.isPointerHover = false;
    }
    onPointerMove() {
        /** */
    }
    onPointerDown() {
        /** */
    }
    onPointerUp() {
        /** */
    }
    onPointerTap() {
        /** */
    }
    // #region IBubbleUpable methods
    bubbleUp(type, data, stack) {
        throw new Error('this method should implemented in IGetAbsolutePosDecorator');
    }
    setBubbleHandler(handler) {
        throw new Error('this method should implemented in IBubbleUpableDecorator');
    }
    // #endregion
    // #region override IAttributableDecorator method
    setOverrideDefaultAttributes(attr) {
        throw new Error('Method not implemented.');
    }
    setOverrideAttributes(attr) {
        throw new Error('Method not implemented.');
    }
    setAttributes(attr) {
        throw new Error('Method not implemented.');
    }
    compileAttributes() {
        throw new Error('Method not implemented.');
    }
    // #endregion
    // #region getSelectedElement methods
    getSelectedElement(range) {
        throw new Error('Method not implemented.');
    }
};
Fragment.typeName = 'frag';
Fragment = Fragment_1 = __decorate([
    _Common_IBubbleUpable__WEBPACK_IMPORTED_MODULE_2__.IBubbleUpableDecorator,
    _Common_IAttributable__WEBPACK_IMPORTED_MODULE_4__.IAttributableDecorator
], Fragment);



/***/ }),

/***/ "./src/Fragment/FragmentAttributes.ts":
/*!********************************************!*\
  !*** ./src/Fragment/FragmentAttributes.ts ***!
  \********************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FragmentDefaultAttributes": function() { return /* binding */ fragmentDefaultAttributes; }
/* harmony export */ });
const fragmentDefaultAttributes = {
    background: '#ffffff',
    color: '#494949',
    strike: false,
    underline: false,
};



/***/ }),

/***/ "./src/Fragment/FragmentDate.ts":
/*!**************************************!*\
  !*** ./src/Fragment/FragmentDate.ts ***!
  \**************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FragmentDate": function() { return /* binding */ FragmentDate; }
/* harmony export */ });
/* harmony import */ var _Common_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Common/util */ "./src/Common/util.ts");
/* harmony import */ var _Platform__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Platform */ "./src/Platform.ts");
/* harmony import */ var _Common_EnumTextStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Common/EnumTextStyle */ "./src/Common/EnumTextStyle.ts");
/* harmony import */ var _Fragment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./Fragment */ "./src/Fragment/Fragment.ts");
/* harmony import */ var _FragmentDateAttributes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./FragmentDateAttributes */ "./src/Fragment/FragmentDateAttributes.ts");





class FragmentDate extends _Fragment__WEBPACK_IMPORTED_MODULE_3__.Fragment {
    constructor() {
        super(...arguments);
        this.stringContent = '';
        this.defaultAttributes = _FragmentDateAttributes__WEBPACK_IMPORTED_MODULE_4__.FragmentDateDefaultAttributes;
        this.originalAttributes = null;
        this.attributes = Object.assign({}, _FragmentDateAttributes__WEBPACK_IMPORTED_MODULE_4__.FragmentDateDefaultAttributes);
    }
    get typeName() {
        return FragmentDate.typeName;
    }
    readFromOps(Op) {
        var _a, _b;
        this.setAttributes(Op.attributes);
        if ((_a = Op.attributes) === null || _a === void 0 ? void 0 : _a.hasOwnProperty('font')) {
            this.setAttributes({ font: _Common_EnumTextStyle__WEBPACK_IMPORTED_MODULE_2__.EnumFont.getFontValue(Op.attributes.font) });
        }
        this.stringContent = ((_b = this.originalAttributes) === null || _b === void 0 ? void 0 : _b.date)
            ? `⏰${new Date(this.originalAttributes.date).toDateString()}`
            : '';
        this.calMetrics();
    }
    calTotalWidth() {
        return (0,_Platform__WEBPACK_IMPORTED_MODULE_1__.getPlatform)().measureTextWidth(this.stringContent, this.attributes);
    }
    /**
     * 计算当前 fragment 的 metrics
     */
    calMetrics() {
        this.metrics = (0,_Platform__WEBPACK_IMPORTED_MODULE_1__.getPlatform)().measureTextMetrics(this.attributes);
    }
    toOp(withKey) {
        var _a;
        const fontOpValue = ((_a = this.originalAttributes) === null || _a === void 0 ? void 0 : _a.font)
            ? { font: _Common_EnumTextStyle__WEBPACK_IMPORTED_MODULE_2__.EnumFont.getFontName(this.originalAttributes.font) }
            : null;
        const op = {
            insert: 1,
            attributes: Object.assign(Object.assign(Object.assign({}, this.originalAttributes), { frag: FragmentDate.typeName }), fontOpValue),
        };
        if (withKey) {
            op.key = this.id;
        }
        return op;
    }
    toHtml() {
        return `<span style=${(0,_Common_util__WEBPACK_IMPORTED_MODULE_0__.convertFragmentAttributesToCssStyleText)(this.attributes)}>${this.stringContent}</span>`;
    }
    toText() {
        return this.stringContent;
    }
    format(attr) {
        if (attr.font && attr.hasOwnProperty('font')) {
            attr.font = _Common_EnumTextStyle__WEBPACK_IMPORTED_MODULE_2__.EnumFont.getFontValue(attr.font);
        }
        return super.format(attr);
    }
    clearFormat() {
        const defaultAttributes = Object.assign({}, _FragmentDateAttributes__WEBPACK_IMPORTED_MODULE_4__.FragmentDateDefaultAttributes);
        delete defaultAttributes.id;
        delete defaultAttributes.date;
        delete defaultAttributes.type;
        this.setAttributes(defaultAttributes);
        return this.format(defaultAttributes);
    }
    getFormat() {
        const attr = Object.assign({}, super.getFormat());
        if (attr.hasOwnProperty('font')) {
            attr.font = _Common_EnumTextStyle__WEBPACK_IMPORTED_MODULE_2__.EnumFont.getFontName(attr.font);
        }
        return attr;
    }
    compileAttributes() {
        super.compileAttributes();
        this.calMetrics();
    }
}
FragmentDate.typeName = 'date';


/***/ }),

/***/ "./src/Fragment/FragmentDateAttributes.ts":
/*!************************************************!*\
  !*** ./src/Fragment/FragmentDateAttributes.ts ***!
  \************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EnumDateType": function() { return /* binding */ EnumDateType; },
/* harmony export */   "FragmentDateDefaultAttributes": function() { return /* binding */ fragmentDateDefaultAttributes; }
/* harmony export */ });
/* harmony import */ var _Common_EnumTextStyle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Common/EnumTextStyle */ "./src/Common/EnumTextStyle.ts");
/* harmony import */ var _FragmentAttributes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./FragmentAttributes */ "./src/Fragment/FragmentAttributes.ts");


var EnumDateType;
(function (EnumDateType) {
    EnumDateType[EnumDateType["Date"] = 0] = "Date";
    EnumDateType[EnumDateType["DateTime"] = 1] = "DateTime";
})(EnumDateType || (EnumDateType = {}));
const fragmentDateDefaultAttributes = Object.assign(Object.assign({}, _FragmentAttributes__WEBPACK_IMPORTED_MODULE_1__.FragmentDefaultAttributes), { bold: false, font: _Common_EnumTextStyle__WEBPACK_IMPORTED_MODULE_0__.EnumFont.getFontValue('Default'), italic: false, size: 11, date: 0, id: 0, type: EnumDateType.Date });



/***/ }),

/***/ "./src/Fragment/FragmentImage.ts":
/*!***************************************!*\
  !*** ./src/Fragment/FragmentImage.ts ***!
  \***************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FragmentImage": function() { return /* binding */ FragmentImage; }
/* harmony export */ });
/* harmony import */ var _Fragment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Fragment */ "./src/Fragment/Fragment.ts");
/* harmony import */ var _FragmentImageAttributes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./FragmentImageAttributes */ "./src/Fragment/FragmentImageAttributes.ts");
/* harmony import */ var _Common_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Common/util */ "./src/Common/util.ts");
/* harmony import */ var _Common_IBubbleUpable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Common/IBubbleUpable */ "./src/Common/IBubbleUpable.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var FragmentImage_1;




let FragmentImage = FragmentImage_1 = class FragmentImage extends _Fragment__WEBPACK_IMPORTED_MODULE_0__.Fragment {
    constructor() {
        super(...arguments);
        this.defaultAttributes = _FragmentImageAttributes__WEBPACK_IMPORTED_MODULE_1__.FragmentImageDefaultAttributes;
        this.originalAttributes = null;
        this.attributes = Object.assign({}, _FragmentImageAttributes__WEBPACK_IMPORTED_MODULE_1__.FragmentImageDefaultAttributes);
        // #endregion
    }
    get typeName() {
        return FragmentImage_1.typeName;
    }
    readFromOps(Op) {
        const attr = Object.assign({}, Op.attributes);
        if (attr['ori-height'] !== undefined) {
            attr.oriHeight = parseInt(attr['ori-height'], 10);
            attr.height = attr.oriHeight;
        }
        if (attr['ori-width'] !== undefined) {
            attr.oriWidth = parseInt(attr['ori-width'], 10);
            attr.width = attr.oriWidth;
        }
        if (attr.height !== undefined) {
            attr.height = parseInt(attr.height, 10);
        }
        if (attr.width !== undefined) {
            attr.width = parseInt(attr.width, 10);
        }
        this.setAttributes(attr);
        this.calMetrics();
    }
    /**
     * 计算当前 fragment 的尺寸
     */
    calTotalWidth() {
        return this.attributes.width;
    }
    /**
     * 计算当前 fragment 的 metrics
     */
    calMetrics() {
        this.metrics = {
            baseline: this.attributes.height,
            bottom: this.attributes.height,
            xTop: 0,
        };
    }
    toOp(withKey) {
        var _a, _b;
        const oriHeightOpValue = ((_a = this.originalAttributes) === null || _a === void 0 ? void 0 : _a.hasOwnProperty('oriHeight'))
            ? { 'ori-height': this.originalAttributes.oriHeight }
            : null;
        const oriWidthOpValue = ((_b = this.originalAttributes) === null || _b === void 0 ? void 0 : _b.hasOwnProperty('oriWidth'))
            ? { 'ori-width': this.originalAttributes.oriWidth }
            : null;
        const op = {
            insert: 1,
            attributes: Object.assign(Object.assign(Object.assign(Object.assign({}, this.originalAttributes), { frag: FragmentImage_1.typeName }), oriHeightOpValue), oriWidthOpValue),
        };
        if (withKey) {
            op.key = this.id;
        }
        return op;
    }
    toHtml() {
        return `<img style=${(0,_Common_util__WEBPACK_IMPORTED_MODULE_2__.convertFragmentAttributesToCssStyleText)(this.attributes)} src="${this.attributes.src}"/>`;
    }
    toText() {
        return '';
    }
    compileAttributes() {
        super.compileAttributes();
        this.calMetrics();
    }
    // #region IBubbleUpable methods
    bubbleUp(type, data, stack) {
        throw new Error('this method should implemented in IGetAbsolutePosDecorator');
    }
    setBubbleHandler(handler) {
        throw new Error('this method should implemented in IBubbleUpableDecorator');
    }
};
FragmentImage.typeName = 'img';
FragmentImage = FragmentImage_1 = __decorate([
    _Common_IBubbleUpable__WEBPACK_IMPORTED_MODULE_3__.IBubbleUpableDecorator
], FragmentImage);



/***/ }),

/***/ "./src/Fragment/FragmentImageAttributes.ts":
/*!*************************************************!*\
  !*** ./src/Fragment/FragmentImageAttributes.ts ***!
  \*************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FragmentImageDefaultAttributes": function() { return /* binding */ fragmentImageDefaultAttributes; }
/* harmony export */ });
/* harmony import */ var _FragmentAttributes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./FragmentAttributes */ "./src/Fragment/FragmentAttributes.ts");

const fragmentImageDefaultAttributes = Object.assign(Object.assign({}, _FragmentAttributes__WEBPACK_IMPORTED_MODULE_0__.FragmentDefaultAttributes), { height: 0, margin: 0, oriHeight: 0, oriWidth: 0, width: 0, src: '' });



/***/ }),

/***/ "./src/Fragment/FragmentParaEnd.ts":
/*!*****************************************!*\
  !*** ./src/Fragment/FragmentParaEnd.ts ***!
  \*****************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FragmentParaEnd": function() { return /* binding */ FragmentParaEnd; }
/* harmony export */ });
/* harmony import */ var _Platform__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Platform */ "./src/Platform.ts");
/* harmony import */ var _Common_EnumTextStyle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Common/EnumTextStyle */ "./src/Common/EnumTextStyle.ts");
/* harmony import */ var _Fragment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Fragment */ "./src/Fragment/Fragment.ts");
/* harmony import */ var _FragmentParaEndAttributes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./FragmentParaEndAttributes */ "./src/Fragment/FragmentParaEndAttributes.ts");




class FragmentParaEnd extends _Fragment__WEBPACK_IMPORTED_MODULE_2__.Fragment {
    constructor() {
        super(...arguments);
        this.defaultAttributes = _FragmentParaEndAttributes__WEBPACK_IMPORTED_MODULE_3__.FragmentParaEndDefaultAttributes;
        this.attributes = Object.assign({}, _FragmentParaEndAttributes__WEBPACK_IMPORTED_MODULE_3__.FragmentParaEndDefaultAttributes);
    }
    get typeName() {
        return FragmentParaEnd.typeName;
    }
    readFromOps(Op) {
        this.calMetrics();
    }
    /**
     * 计算当前 fragment 的 metrics
     */
    calMetrics() {
        this.metrics = (0,_Platform__WEBPACK_IMPORTED_MODULE_0__.getPlatform)().measureTextMetrics({
            bold: false,
            size: this.attributes.size,
            font: _Common_EnumTextStyle__WEBPACK_IMPORTED_MODULE_1__.EnumFont.getFontValue('Default'),
        });
    }
    toOp(withKey) {
        const op = {
            insert: 1,
            attributes: { frag: FragmentParaEnd.typeName },
        };
        if (withKey) {
            op.key = this.id;
        }
        return op;
    }
    toHtml() {
        return '';
    }
    toText() {
        return '\n';
    }
    compileAttributes() {
        super.compileAttributes();
        this.calMetrics();
    }
    lastPos() {
        return { index: 0, inner: null };
    }
}
FragmentParaEnd.typeName = 'end';


/***/ }),

/***/ "./src/Fragment/FragmentParaEndAttributes.ts":
/*!***************************************************!*\
  !*** ./src/Fragment/FragmentParaEndAttributes.ts ***!
  \***************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FragmentParaEndDefaultAttributes": function() { return /* binding */ fragmentParaEndDefaultAttributes; }
/* harmony export */ });
/* harmony import */ var _FragmentAttributes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./FragmentAttributes */ "./src/Fragment/FragmentAttributes.ts");

const fragmentParaEndDefaultAttributes = Object.assign(Object.assign({}, _FragmentAttributes__WEBPACK_IMPORTED_MODULE_0__.FragmentDefaultAttributes), { size: 11 });



/***/ }),

/***/ "./src/Fragment/FragmentText.ts":
/*!**************************************!*\
  !*** ./src/Fragment/FragmentText.ts ***!
  \**************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FragmentText": function() { return /* binding */ FragmentText; }
/* harmony export */ });
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lodash/isEqual */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isEqual.js");
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_isEqual__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_toArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lodash/toArray */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/toArray.js");
/* harmony import */ var lodash_toArray__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_toArray__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Common_EnumTextStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Common/EnumTextStyle */ "./src/Common/EnumTextStyle.ts");
/* harmony import */ var _Fragment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./Fragment */ "./src/Fragment/Fragment.ts");
/* harmony import */ var _Fragment_FragmentTextAttributes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Fragment/FragmentTextAttributes */ "./src/Fragment/FragmentTextAttributes.ts");
/* harmony import */ var _Common_EnumBubbleMessage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../Common/EnumBubbleMessage */ "./src/Common/EnumBubbleMessage.ts");
/* harmony import */ var _Common_DocPos__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../Common/DocPos */ "./src/Common/DocPos.ts");
/* harmony import */ var _Platform__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../Platform */ "./src/Platform.ts");
/* harmony import */ var _Common_util__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../Common/util */ "./src/Common/util.ts");









class FragmentText extends _Fragment__WEBPACK_IMPORTED_MODULE_3__.Fragment {
    constructor() {
        super(...arguments);
        this.content = '';
        // has some content that is not part of the UCS2 code
        this.beyondUCS2 = null;
        this.unicodeChars = null;
        this.defaultAttributes = _Fragment_FragmentTextAttributes__WEBPACK_IMPORTED_MODULE_4__.FragmentTextDefaultAttributes;
        this.attributes = Object.assign({}, _Fragment_FragmentTextAttributes__WEBPACK_IMPORTED_MODULE_4__.FragmentTextDefaultAttributes);
    }
    get typeName() {
        return FragmentText.typeName;
    }
    readFromOps(Op) {
        var _a;
        this.setAttributes(Op.attributes);
        if ((_a = Op.attributes) === null || _a === void 0 ? void 0 : _a.hasOwnProperty('font')) {
            this.setAttributes({ font: _Common_EnumTextStyle__WEBPACK_IMPORTED_MODULE_2__.EnumFont.getFontValue(Op.attributes.font) });
        }
        this.calMetrics();
        this.content = Op.insert;
    }
    get length() {
        return this.content.length;
    }
    calTotalWidth() {
        return (0,_Platform__WEBPACK_IMPORTED_MODULE_7__.getPlatform)().measureTextWidth(this.content, this.attributes);
    }
    /**
     * 计算当前 fragment 的 metrics
     */
    calMetrics() {
        this.metrics = (0,_Platform__WEBPACK_IMPORTED_MODULE_7__.getPlatform)().measureTextMetrics(this.attributes);
    }
    toOp() {
        var _a;
        const fontOpValue = ((_a = this.originalAttributes) === null || _a === void 0 ? void 0 : _a.font)
            ? { font: _Common_EnumTextStyle__WEBPACK_IMPORTED_MODULE_2__.EnumFont.getFontName(this.originalAttributes.font) }
            : null;
        const res = {
            insert: this.content,
        };
        if (fontOpValue !== null || (this.originalAttributes && Object.keys(this.originalAttributes).length > 0)) {
            res.attributes = Object.assign(Object.assign({}, this.originalAttributes), fontOpValue);
        }
        return res;
    }
    toHtml(selection) {
        const textContent = selection ? this.content.substring(selection.start.index, selection.end.index) : this.content;
        if (this.attributes.link) {
            return `<a href=${this.attributes.link} style=${(0,_Common_util__WEBPACK_IMPORTED_MODULE_8__.convertFragmentAttributesToCssStyleText)(this.attributes)}>${textContent}</a>`;
        }
        else {
            return `<span style=${(0,_Common_util__WEBPACK_IMPORTED_MODULE_8__.convertFragmentAttributesToCssStyleText)(this.attributes)}>${textContent}</span>`;
        }
    }
    toText(selection) {
        if (selection) {
            return this.content.substring(selection.start.index, selection.end.index);
        }
        else {
            return this.content;
        }
    }
    /**
     * 在指定位置插入内容
     */
    insertText(content, pos, attr) {
        if (content.length === 0) {
            return [];
        }
        this.resetHasUnicodeStatue();
        if (attr) {
            let isAttrEqual = true;
            const keys = Object.keys(attr);
            for (let i = 0; i < keys.length; i++) {
                if (!lodash_isEqual__WEBPACK_IMPORTED_MODULE_0___default()(attr[keys[i]], this.attributes[keys[i]])) {
                    isAttrEqual = false;
                    break;
                }
            }
            if (isAttrEqual) {
                this.content = this.content.slice(0, pos.index) + content + this.content.slice(pos.index);
                return [this];
            }
            else {
                const res = [];
                const newContentA = this.content.slice(0, pos.index);
                const newContentB = this.content.slice(pos.index);
                if (newContentA) {
                    this.setContent(newContentA);
                    res.push(this);
                }
                const SelfConstructor = this.constructor;
                const newFrag = new SelfConstructor();
                newFrag.setContent(content);
                newFrag.setAttributes(attr);
                newFrag.calMetrics();
                res.push(newFrag);
                if (newContentB) {
                    const newFragB = new SelfConstructor();
                    newFragB.setContent(newContentB);
                    newFragB.setAttributes(this.attributes);
                    newFragB.calMetrics();
                    res.push(newFragB);
                }
                return res;
            }
        }
        else {
            this.content = this.content.slice(0, pos.index) + content + this.content.slice(pos.index);
            return [this];
        }
    }
    insertEnter(pos) {
        const newFrag = new this.constructor();
        newFrag.setContent(this.content.slice(pos.index));
        newFrag.setAttributes(this.originalAttributes);
        newFrag.calMetrics();
        this.content = this.content.slice(0, pos.index);
        this.resetHasUnicodeStatue();
        return newFrag;
    }
    insertFragment(frag, pos) {
        // 这里只有一种情况就是插入当前 fragment text 的中间某个位置，把当前的 fragment text 分割成两段
        const newFrag = new this.constructor();
        newFrag.setContent(this.content.slice(pos.index));
        newFrag.setAttributes(this.originalAttributes);
        newFrag.calMetrics();
        this.content = this.content.slice(0, pos.index);
        this.resetHasUnicodeStatue();
        return [this, frag, newFrag];
    }
    /**
     * 删除指定范围的内容（length 为空时删除 index 后所有内容）
     */
    delete(range, forward) {
        const { start, end } = range;
        let prev = '';
        let next = '';
        if ((0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_6__.compareDocPos)(range.start, range.end) === 0) {
            if (forward) {
                prev = this.content.substr(0, this.hasUnicode() ? this.calPrevPosWithUnicode(start.index) : start.index - 1);
                next = this.content.substr(end.index);
            }
            else {
                prev = this.content.substr(0, start.index);
                next = this.content.substr(this.hasUnicode() ? this.calNextPosWithUnicode(end.index) : end.index + 1);
            }
        }
        else {
            prev = this.content.substr(0, start.index);
            next = this.content.substr(end.index);
        }
        this.content = prev + next;
        super.delete(range);
        this.resetHasUnicodeStatue();
    }
    /**
     * 设置文本格式
     */
    format(attr, range) {
        if (attr.font && attr.hasOwnProperty('font')) {
            attr.font = _Common_EnumTextStyle__WEBPACK_IMPORTED_MODULE_2__.EnumFont.getFontValue(attr.font);
        }
        if (!range || (range.start.index <= 0 && range.end.index >= this.length)) {
            this.setAttributes(attr);
            return [this];
        }
        else {
            // 最复杂的时候会把当前这个 fragment text 切分为 3 段，起码也会被切成两段
            // 这里要分三种情况来处理，1、有 3 段；2、没有第一段；3、没有最后一段
            const aContent = this.content.substring(0, range.start.index);
            const bContent = this.content.substring(range.start.index, range.end.index);
            const cContent = this.content.substring(range.end.index);
            const res = [];
            const SelfConstructor = this.constructor;
            if (!aContent) {
                // 说明肯定有 b、c 两段
                const newFrag = new SelfConstructor();
                newFrag.content = cContent;
                newFrag.setAttributes(Object.assign({}, this.originalAttributes));
                newFrag.calMetrics();
                this.setAttributes(attr);
                this.content = bContent;
                this.calMetrics();
                res.push(this, newFrag);
            }
            else if (!cContent) {
                // 说明肯定有 a、b 两段
                const newFrag = new SelfConstructor();
                newFrag.content = bContent;
                newFrag.setAttributes(Object.assign(Object.assign({}, this.originalAttributes), attr));
                newFrag.calMetrics();
                this.content = aContent;
                this.calMetrics();
                res.push(this, newFrag);
            }
            else {
                // 说明 3 段都有
                const newFragB = new SelfConstructor();
                newFragB.content = bContent;
                newFragB.setAttributes(Object.assign(Object.assign({}, this.originalAttributes), attr));
                newFragB.calMetrics();
                const newFragC = new SelfConstructor();
                newFragC.content = cContent;
                newFragC.setAttributes(Object.assign({}, this.originalAttributes));
                newFragC.calMetrics();
                this.content = aContent;
                res.push(this, newFragB, newFragC);
            }
            this.resetHasUnicodeStatue();
            return res;
        }
    }
    clearFormat(range) {
        const defaultAttributes = Object.assign({}, _Fragment_FragmentTextAttributes__WEBPACK_IMPORTED_MODULE_4__.FragmentTextDefaultAttributes);
        delete defaultAttributes.link;
        delete defaultAttributes.composing;
        return this.format(defaultAttributes, range);
    }
    getFormat() {
        const attr = Object.assign({}, super.getFormat());
        if (attr.hasOwnProperty('font')) {
            attr.font = _Common_EnumTextStyle__WEBPACK_IMPORTED_MODULE_2__.EnumFont.getFontName(attr.font);
        }
        return attr;
    }
    /**
     * 重新设置当前 fragment text 的内容
     * @param content 新内容
     */
    setContent(content) {
        this.content = content;
        this.calMetrics();
        this.resetHasUnicodeStatue();
    }
    eat(frag) {
        if (frag instanceof FragmentText &&
            (lodash_isEqual__WEBPACK_IMPORTED_MODULE_0___default()(this.originalAttributes, frag.originalAttributes) ||
                this.content.length === 0 ||
                frag.content.length === 0)) {
            this.setContent(this.content + frag.content);
            return true;
        }
        else {
            return false;
        }
    }
    nextPos(pos) {
        if (this.hasUnicode()) {
            return { index: this.calNextPosWithUnicode(pos.index), inner: pos.inner };
        }
        else {
            return super.nextPos(pos);
        }
    }
    prevPos(pos) {
        if (this.hasUnicode() && pos.index > 0) {
            return { index: this.calPrevPosWithUnicode(pos.index), inner: pos.inner };
        }
        else {
            return super.prevPos(pos);
        }
    }
    onPointerEnter() {
        super.onPointerEnter();
    }
    onPointerLeave() {
        super.onPointerLeave();
    }
    onPointerTap() {
        super.onPointerTap();
        if (this.attributes.link) {
            this.bubbleUp(_Common_EnumBubbleMessage__WEBPACK_IMPORTED_MODULE_5__.BubbleMessage.OPEN_LINK, this.attributes.link);
        }
    }
    compileAttributes() {
        super.compileAttributes();
        this.calMetrics();
    }
    hasUnicode() {
        if (this.beyondUCS2 === null) {
            const unicodeChars = lodash_toArray__WEBPACK_IMPORTED_MODULE_1___default()(this.content);
            this.beyondUCS2 = unicodeChars.length !== this.content.length;
            if (this.beyondUCS2) {
                this.unicodeChars = unicodeChars;
            }
        }
        return this.beyondUCS2;
    }
    resetHasUnicodeStatue() {
        this.unicodeChars = null;
        this.beyondUCS2 = null;
    }
    calPrevPosWithUnicode(pos) {
        const unicodeChars = this.unicodeChars;
        let currentIndex = 0;
        let originalCharIndex = 0;
        while (currentIndex < unicodeChars.length) {
            originalCharIndex += unicodeChars[currentIndex].length;
            if (originalCharIndex < pos) {
                currentIndex++;
            }
            else {
                return originalCharIndex - unicodeChars[currentIndex].length;
            }
        }
        return pos;
    }
    calNextPosWithUnicode(pos) {
        const unicodeChars = this.unicodeChars;
        let currentIndex = 0;
        let originalCharIndex = 0;
        while (currentIndex < unicodeChars.length) {
            if (originalCharIndex < pos) {
                originalCharIndex += unicodeChars[currentIndex].length;
                currentIndex++;
            }
            else {
                return originalCharIndex + unicodeChars[currentIndex].length;
            }
        }
        return pos;
    }
}
FragmentText.typeName = '';


/***/ }),

/***/ "./src/Fragment/FragmentTextAttributes.ts":
/*!************************************************!*\
  !*** ./src/Fragment/FragmentTextAttributes.ts ***!
  \************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FragmentTextDefaultAttributes": function() { return /* binding */ fragmentTextDefaultAttributes; }
/* harmony export */ });
/* harmony import */ var _Common_EnumTextStyle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Common/EnumTextStyle */ "./src/Common/EnumTextStyle.ts");
/* harmony import */ var _FragmentAttributes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./FragmentAttributes */ "./src/Fragment/FragmentAttributes.ts");


const fragmentTextDefaultAttributes = Object.assign(Object.assign({}, _FragmentAttributes__WEBPACK_IMPORTED_MODULE_1__.FragmentDefaultAttributes), { bold: false, font: _Common_EnumTextStyle__WEBPACK_IMPORTED_MODULE_0__.EnumFont.getFontValue('Default'), italic: false, link: '', size: 11, composing: false });



/***/ }),

/***/ "./src/Fragment/index.ts":
/*!*******************************!*\
  !*** ./src/Fragment/index.ts ***!
  \*******************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EnumDateType": function() { return /* reexport safe */ _FragmentDateAttributes__WEBPACK_IMPORTED_MODULE_3__.EnumDateType; },
/* harmony export */   "Fragment": function() { return /* reexport safe */ _Fragment__WEBPACK_IMPORTED_MODULE_0__.Fragment; },
/* harmony export */   "FragmentDate": function() { return /* reexport safe */ _FragmentDate__WEBPACK_IMPORTED_MODULE_2__.FragmentDate; },
/* harmony export */   "FragmentDateDefaultAttributes": function() { return /* reexport safe */ _FragmentDateAttributes__WEBPACK_IMPORTED_MODULE_3__.FragmentDateDefaultAttributes; },
/* harmony export */   "FragmentDefaultAttributes": function() { return /* reexport safe */ _FragmentAttributes__WEBPACK_IMPORTED_MODULE_1__.FragmentDefaultAttributes; },
/* harmony export */   "FragmentImage": function() { return /* reexport safe */ _FragmentImage__WEBPACK_IMPORTED_MODULE_4__.FragmentImage; },
/* harmony export */   "FragmentImageDefaultAttributes": function() { return /* reexport safe */ _FragmentImageAttributes__WEBPACK_IMPORTED_MODULE_5__.FragmentImageDefaultAttributes; },
/* harmony export */   "FragmentParaEnd": function() { return /* reexport safe */ _FragmentParaEnd__WEBPACK_IMPORTED_MODULE_6__.FragmentParaEnd; },
/* harmony export */   "FragmentParaEndDefaultAttributes": function() { return /* reexport safe */ _FragmentParaEndAttributes__WEBPACK_IMPORTED_MODULE_7__.FragmentParaEndDefaultAttributes; },
/* harmony export */   "FragmentText": function() { return /* reexport safe */ _FragmentText__WEBPACK_IMPORTED_MODULE_8__.FragmentText; },
/* harmony export */   "FragmentTextDefaultAttributes": function() { return /* reexport safe */ _FragmentTextAttributes__WEBPACK_IMPORTED_MODULE_9__.FragmentTextDefaultAttributes; }
/* harmony export */ });
/* harmony import */ var _Fragment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Fragment */ "./src/Fragment/Fragment.ts");
/* harmony import */ var _FragmentAttributes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./FragmentAttributes */ "./src/Fragment/FragmentAttributes.ts");
/* harmony import */ var _FragmentDate__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./FragmentDate */ "./src/Fragment/FragmentDate.ts");
/* harmony import */ var _FragmentDateAttributes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./FragmentDateAttributes */ "./src/Fragment/FragmentDateAttributes.ts");
/* harmony import */ var _FragmentImage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./FragmentImage */ "./src/Fragment/FragmentImage.ts");
/* harmony import */ var _FragmentImageAttributes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./FragmentImageAttributes */ "./src/Fragment/FragmentImageAttributes.ts");
/* harmony import */ var _FragmentParaEnd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./FragmentParaEnd */ "./src/Fragment/FragmentParaEnd.ts");
/* harmony import */ var _FragmentParaEndAttributes__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./FragmentParaEndAttributes */ "./src/Fragment/FragmentParaEndAttributes.ts");
/* harmony import */ var _FragmentText__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./FragmentText */ "./src/Fragment/FragmentText.ts");
/* harmony import */ var _FragmentTextAttributes__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./FragmentTextAttributes */ "./src/Fragment/FragmentTextAttributes.ts");












/***/ }),

/***/ "./src/Platform.ts":
/*!*************************!*\
  !*** ./src/Platform.ts ***!
  \*************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getPlatform": function() { return /* binding */ getPlatform; },
/* harmony export */   "initPlatform": function() { return /* binding */ initPlatform; }
/* harmony export */ });
const defaultPlatform = {
    getPixelRatio: () => {
        return 1;
    },
    convertPt2Px: [],
    createTextFontString: () => '',
    measureTextWidth: () => 0,
    measureTextMetrics: () => ({
        baseline: 11,
        bottom: 11,
        xTop: 11,
    }),
    requestIdleCallback: () => 0,
    cancelIdleCallback: () => {
        /** */
    },
};
let _ = defaultPlatform;
const initPlatform = (platform) => {
    _ = platform;
};
const getPlatform = () => {
    return _;
};


/***/ }),

/***/ "./src/RenderStructure/LayoutFrame.ts":
/*!********************************************!*\
  !*** ./src/RenderStructure/LayoutFrame.ts ***!
  \********************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LayoutFrame": function() { return /* binding */ LayoutFrame; }
/* harmony export */ });
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lodash/isEqual */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isEqual.js");
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_isEqual__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_trimStart__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lodash/trimStart */ "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/trimStart.js");
/* harmony import */ var lodash_trimStart__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_trimStart__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _lib_linebreaker_linebreaker__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../lib/linebreaker/linebreaker */ "./src/lib/linebreaker/linebreaker.js");
/* harmony import */ var _lib_linebreaker_linebreaker__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_lib_linebreaker_linebreaker__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Common_LayoutPiece__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Common/LayoutPiece */ "./src/Common/LayoutPiece.ts");
/* harmony import */ var _Common_LinkedList__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Common/LinkedList */ "./src/Common/LinkedList.ts");
/* harmony import */ var _Common_util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../Common/util */ "./src/Common/util.ts");
/* harmony import */ var _Line__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./Line */ "./src/RenderStructure/Line.ts");
/* harmony import */ var _RunText__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./RunText */ "./src/RenderStructure/RunText.ts");
/* harmony import */ var _Common_EnumParagraphStyle__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../Common/EnumParagraphStyle */ "./src/Common/EnumParagraphStyle.ts");
/* harmony import */ var _Fragment_FragmentParaEnd__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../Fragment/FragmentParaEnd */ "./src/Fragment/FragmentParaEnd.ts");
/* harmony import */ var _Fragment_FragmentText__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../Fragment/FragmentText */ "./src/Fragment/FragmentText.ts");
/* harmony import */ var _LayoutFrameAttributes__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./LayoutFrameAttributes */ "./src/RenderStructure/LayoutFrameAttributes.ts");
/* harmony import */ var _Common_IPointerInteractive__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../Common/IPointerInteractive */ "./src/Common/IPointerInteractive.ts");
/* harmony import */ var _Common_EnumCursorType__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../Common/EnumCursorType */ "./src/Common/EnumCursorType.ts");
/* harmony import */ var _Common_IBubbleUpable__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../Common/IBubbleUpable */ "./src/Common/IBubbleUpable.ts");
/* harmony import */ var _Common_DocPos__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../Common/DocPos */ "./src/Common/DocPos.ts");
/* harmony import */ var _Common_IAttributable__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../Common/IAttributable */ "./src/Common/IAttributable.ts");
/* harmony import */ var _Platform__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../Platform */ "./src/Platform.ts");
/* harmony import */ var _Common_IDocPosOperator__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../Common/IDocPosOperator */ "./src/Common/IDocPosOperator.ts");
/* harmony import */ var _Common_IoC__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../Common/IoC */ "./src/Common/IoC.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var LayoutFrame_1;




















function OverrideIBubbleUpableDecorator(constructor) {
    return class LayoutFrame extends constructor {
        bubbleUp(type, data, stack) {
            if (type === 'LINE_CHANGE_SIZE') {
                this.childrenSizeChangeHandler();
                return;
            }
            super.bubbleUp(type, data, stack);
        }
    };
}
function OverrideIAttributableDecorator(constructor) {
    return class LayoutFrame extends constructor {
        setOverrideDefaultAttributes(attr) {
            this.children.forEach((fragment) => {
                fragment.setOverrideDefaultAttributes(attr);
            });
            super.setOverrideDefaultAttributes(attr);
        }
        setOverrideAttributes(attr) {
            this.children.forEach((fragment) => {
                fragment.setOverrideAttributes(attr);
            });
            super.setOverrideAttributes(attr);
        }
        compileAttributes() {
            super.compileAttributes();
            this.calcIndentWidth();
        }
    };
}
let LayoutFrame = LayoutFrame_1 = class LayoutFrame {
    constructor() {
        this.children = [];
        this.head = null;
        this.tail = null;
        this.prevSibling = null;
        this.nextSibling = null;
        this.start = 0;
        this.length = 0;
        this.x = 0;
        this.y = 0;
        this.width = 0;
        this.height = 0;
        this.maxWidth = 0;
        this.firstIndent = 0; // 首行缩进值，单位 px
        this.indentWidth = 0;
        this.lines = [];
        this.id = (0,_Common_util__WEBPACK_IMPORTED_MODULE_5__.increaseId)();
        this.attributes = Object.assign({}, _LayoutFrameAttributes__WEBPACK_IMPORTED_MODULE_11__.LayoutFrameDefaultAttributes);
        this.defaultAttributes = _LayoutFrameAttributes__WEBPACK_IMPORTED_MODULE_11__.LayoutFrameDefaultAttributes;
        this.overrideDefaultAttributes = null;
        this.originalAttributes = null;
        this.overrideAttributes = null;
        this.minBaseline = 0;
        this.minLineHeight = 0;
        this.isPointerHover = false;
    }
    readFromOps(ops) {
        this.setAttributes(ops[ops.length - 1].attributes);
        const frags = this.readOpsToFragment(ops);
        this.addAll(frags);
        this.calLength();
    }
    readOpsToFragment(ops) {
        var _a;
        const frags = [];
        for (let index = 0; index < ops.length; index++) {
            const op = ops[index];
            const typeName = ((_a = op.attributes) === null || _a === void 0 ? void 0 : _a.frag) || '';
            const FragClass = (0,_Common_IoC__WEBPACK_IMPORTED_MODULE_19__.get)(typeName);
            if (FragClass) {
                if (typeof op.insert === 'number') {
                    for (let i = 0; i < op.insert; i++) {
                        const frag = new FragClass();
                        frag.readFromOps({ insert: 1, attributes: Object.assign({}, op.attributes) });
                        frags.push(frag);
                    }
                }
                else {
                    const frag = new FragClass();
                    frag.readFromOps(op);
                    frags.push(frag);
                }
            }
            else {
                console.log('unknown fragment type: ', typeName);
            }
        }
        return frags;
    }
    destroy() {
        for (let index = 0; index < this.children.length; index++) {
            const frag = this.children[index];
            frag.destroy();
        }
        for (let index = 0; index < this.lines.length; index++) {
            const line = this.lines[index];
            line.destroy();
        }
    }
    /**
     * 给当前 layoutframe 添加一行到最后并更新当前 layoutframe 的 size
     */
    addLine(line) {
        this.lines.push(line);
        line.setBubbleHandler(this.bubbleUp.bind(this));
        const newWidth = Math.max(this.width, line.x + line.width);
        const newHeight = this.height + line.height;
        this.setSize(newHeight, newWidth);
    }
    /**
     * 绘制当前 layoutframe
     * @param ctx canvas context
     * @param x 绘制位置的 x 坐标
     * @param y 绘制位置的 y 坐标
     * @param viewHeight 整个画布的高度
     */
    draw(ctx, x, y, viewHeight) {
        for (let i = 0, l = this.lines.length; i < l; i++) {
            const currentLine = this.lines[i];
            if (y + this.y + currentLine.y + currentLine.height >= 0 && currentLine.y < viewHeight) {
                currentLine.draw(ctx, this.x + x, this.y + y);
            }
        }
        if (window.frameBorder || this.isPointerHover) {
            ctx.save();
            ctx.strokeStyle = 'blue';
            ctx.strokeRect(this.x + x, this.y + y, this.width, this.height);
            ctx.restore();
        }
    }
    /**
     * 核心排版逻辑
     */
    layout() {
        if (this.lines.length > 0) {
            for (let index = 0; index < this.lines.length; index++) {
                const line = this.lines[index];
                line.destroy();
            }
        }
        this.lines = [];
        this.addLine(new _Line__WEBPACK_IMPORTED_MODULE_6__.Line(this.firstIndent + this.indentWidth, 0, this.attributes.linespacing, this.maxWidth - this.firstIndent - this.indentWidth, this.minBaseline, this.minLineHeight));
        this.breakLines(this.calLineBreakPoint());
        const lineLength = this.lines.length;
        let align = this.attributes.align === _Common_EnumParagraphStyle__WEBPACK_IMPORTED_MODULE_8__.EnumAlign.scattered ? _Common_EnumParagraphStyle__WEBPACK_IMPORTED_MODULE_8__.EnumAlign.justify : this.attributes.align;
        // 遍历所有的 line 中的所有的 run text，如果 run text 的内容长度大于 1，且其中有中文，就要拆分这个 run text
        for (let i = 0; i < lineLength; i++) {
            const line = this.lines[i];
            for (let j = 0; j < line.children.length; j++) {
                const run = line.children[j];
                if (run instanceof _RunText__WEBPACK_IMPORTED_MODULE_7__.RunText &&
                    run.content.length > 1 &&
                    ((0,_Common_util__WEBPACK_IMPORTED_MODULE_5__.isChinese)(run.content[0]) || (0,_Common_util__WEBPACK_IMPORTED_MODULE_5__.isChinese)(run.content[run.content.length - 1]))) {
                    const newRuns = run.content.split('').map((text) => {
                        const newRun = (0,_Common_IoC__WEBPACK_IMPORTED_MODULE_19__.create)(_RunText__WEBPACK_IMPORTED_MODULE_7__.RunText.typeName, run.frag);
                        newRun.setContent(text);
                        newRun.setSize(run.height, newRun.calWidth());
                        newRun.isSpace = false;
                        return newRun;
                    });
                    line.splice(j, 1, newRuns);
                }
            }
            if (i === lineLength - 1 && this.attributes.align === _Common_EnumParagraphStyle__WEBPACK_IMPORTED_MODULE_8__.EnumAlign.justify) {
                align = _Common_EnumParagraphStyle__WEBPACK_IMPORTED_MODULE_8__.EnumAlign.left;
            }
            this.lines[i].layout(align);
            if (i === 0) {
                line.start = 0;
            }
            else {
                line.start = this.lines[i - 1].start + this.lines[i - 1].length;
            }
        }
    }
    /**
     * 设置当前 layoutframe 的最大宽度
     * @param width 宽度
     */
    setMaxWidth(width) {
        this.maxWidth = width;
    }
    /**
     * 设置当前 layoutframe 首行缩进距离
     * @param firstIndent 首行缩进距离
     */
    setFirstIndent(firstIndent) {
        this.firstIndent = firstIndent;
    }
    /**
     * 设置最小 metrics
     */
    setMinMetrics(metrics) {
        this.minBaseline = metrics.baseline;
        this.minLineHeight = metrics.bottom;
    }
    /**
     * 根据坐标获取文档中的位置
     */
    getDocumentPos(x, y, start) {
        let line = null;
        let lineIndex = 0;
        let targetX = x;
        for (const l = this.lines.length; lineIndex < l; lineIndex++) {
            line = this.lines[lineIndex];
            if ((line.y <= y && y <= line.y + line.height) ||
                (y < line.y && lineIndex === 0) ||
                (y > line.y + line.height && lineIndex === this.lines.length - 1)) {
                lineIndex++;
                break;
            }
        }
        lineIndex--;
        if (line === null) {
            return { index: 0, inner: null };
        }
        let run = null;
        let runIndex = 0;
        let runStart = 0;
        // 如果 y 坐标比行 y 坐标还小把 x 坐标改成 -1 来选中这一行的最前面一个位置
        // 如果 y 坐标比行 y + 高度 坐标还大把 x 坐标改成 行宽 + 1 来选中这一行的最后面一个位置
        if (y < line.y) {
            targetX = -1;
        }
        else if (y > line.y + line.height) {
            targetX = line.width + 1;
        }
        if (targetX <= line.x) {
            run = line.head;
        }
        else if (targetX >= line.x + line.width) {
            run = line.tail;
            runIndex = line.children.length - 1;
            runStart = line.length - run.length; // line 不可能是空的，所以这里的 run 也不可能是 null
        }
        else {
            targetX = targetX - line.x;
            for (const l = line.children.length; runIndex < l; runIndex++) {
                run = line.children[runIndex];
                const runEnd = run.x + run.width;
                if ((run.x <= targetX && targetX <= runEnd) ||
                    (run.nextSibling !== null && runEnd < targetX && targetX < run.nextSibling.x)) {
                    break;
                }
                runStart += run.length;
            }
        }
        if (run === null) {
            return { index: 0, inner: null };
        }
        const posData = run.getDocumentPos(targetX - run.x, y - line.y - run.y, start);
        posData.index += line.start + runStart;
        return posData;
    }
    /**
     * 计算指定选区的矩形区域
     */
    getSelectionRectangles(start, end) {
        const startIndex = start.index;
        const endIndex = end.index;
        const length = endIndex - startIndex + (end.inner !== null ? 1 : 0);
        const rects = [];
        for (let lineIndex = 0; lineIndex < this.lines.length; lineIndex++) {
            const line = this.lines[lineIndex];
            if (line.start + line.length < startIndex) {
                continue;
            }
            if (line.start > startIndex + length) {
                break;
            }
            const lineStart = Math.max(0, startIndex - line.start);
            const lineLength = Math.min(length, startIndex + length - line.start);
            let runStart = 0;
            let startX = 0;
            let endX = 0;
            for (let runIndex = 0; runIndex < line.children.length; runIndex++) {
                const run = line.children[runIndex];
                if (lineStart >= runStart && lineStart <= runStart + run.length) {
                    // 找到了起始位置
                    startX = run.getCoordinatePosX(lineStart - runStart) + run.x + line.x;
                }
                if (runStart + run.length === lineLength + lineStart) {
                    endX = run.x + run.width + line.x;
                }
                else if (lineLength + lineStart < runStart + run.length) {
                    // 找到了结束位置
                    endX = run.getCoordinatePosX(lineLength + lineStart - runStart) + run.x + line.x;
                    break;
                }
                endX = endX || line.width + line.x;
                runStart += run.length;
            }
            rects.push({
                x: startX + this.x,
                y: line.y + this.y,
                width: endX - startX,
                height: line.height,
            });
        }
        return rects;
    }
    /**
     * 设置当前 layoutFrame 的 y 轴位置
     * @param pos 位置信息对象
     */
    setPositionY(y, recursive = true, force = false) {
        if (force === true || this.y !== y) {
            this.y = Math.floor(y);
            if (recursive) {
                let currentBlock = this;
                let nextSibling = this.nextSibling;
                while (nextSibling !== null) {
                    nextSibling.y = Math.floor(currentBlock.y + currentBlock.height);
                    currentBlock = nextSibling;
                    nextSibling = currentBlock.nextSibling;
                }
            }
        }
    }
    /**
     * 设置起始索引
     */
    setStart(index, recursive = false, force = false) {
        if (force === true || this.start !== index) {
            this.start = index;
            if (recursive) {
                let currentFrame = this;
                let nextSibling = currentFrame.nextSibling;
                while (nextSibling !== null) {
                    nextSibling.start = currentFrame.start + currentFrame.length;
                    currentFrame = nextSibling;
                    nextSibling = currentFrame.nextSibling;
                }
            }
        }
    }
    /**
     * 输出为 delta
     */
    toOp(withKey) {
        const res = new Array(this.children.length);
        for (let index = 0; index < this.children.length; index++) {
            const element = this.children[index];
            res[index] = element.toOp(withKey);
        }
        Object.assign(res[res.length - 1].attributes, Object.assign({}, this.originalAttributes));
        return res;
    }
    /**
     * 输出为 html
     */
    toHtml(range) {
        const style = `line-height:${this.attributes.linespacing};text-align:${this.attributes.align};padding-left:${this.attributes.indent}px;`;
        const htmlContent = (0,_Common_util__WEBPACK_IMPORTED_MODULE_5__.toHtml)(this, range);
        return `<div style=${style}>${htmlContent}</div>`;
    }
    toText(range) {
        return (0,_Common_util__WEBPACK_IMPORTED_MODULE_5__.toText)(this, range);
    }
    /**
     * 在当前 layoutframe 中插入内容
     * @param content 要插入的内容
     * @param index 插入位置
     * @param hasDiffFormat 插入内容的格式和当前位置的格式是否存在不同
     */
    insertText(content, pos, attr) {
        let res = false;
        const fragIndex = (0,_Common_util__WEBPACK_IMPORTED_MODULE_5__.findChildIndexInDocPos)(pos.index, this.children, true);
        const frag = this.children[fragIndex];
        // 大概分为 3 种情况
        // 1、 text 插在两个 frag 之间
        // 2、 text 插入某个 frag，且 frag 被一分为二
        // 3、 text 插入某个 frag，但这个 frag 不会被切开
        if (!frag) {
            return res;
        }
        if (frag.start === pos.index && pos.inner === null) {
            // text 插在两个 frag 之间，此时要看 attr 是否有值，没有值就尝试在前面或后面的 frag 里面直接插入 text 内容
            // 如果不能在前面或后面的 frag 里面插入 text 就直接新建一个 fragment text
            if (attr) {
                const fragText = (0,_Common_IoC__WEBPACK_IMPORTED_MODULE_19__.create)('');
                fragText.setContent(content);
                fragText.setAttributes(attr);
                this.addBefore(fragText, frag);
                if (frag instanceof _Fragment_FragmentText__WEBPACK_IMPORTED_MODULE_10__.FragmentText && fragText.eat(frag)) {
                    this.remove(frag);
                }
                res = true;
            }
            else if (frag.prevSibling) {
                if (frag.prevSibling instanceof _Fragment_FragmentText__WEBPACK_IMPORTED_MODULE_10__.FragmentText) {
                    // 说明这个时候要跟随前面或后面 frag 的 attributes
                    const newFrags = frag.prevSibling.insertText(content, { index: frag.prevSibling.length, inner: null });
                    if (newFrags.length > 0) {
                        this.splice(fragIndex - 1, 1, newFrags);
                    }
                    res = newFrags.length > 0;
                }
                else {
                    const fragText = (0,_Common_IoC__WEBPACK_IMPORTED_MODULE_19__.create)('');
                    fragText.setContent(content);
                    this.addBefore(fragText, frag);
                    if (frag instanceof _Fragment_FragmentText__WEBPACK_IMPORTED_MODULE_10__.FragmentText && fragText.eat(frag)) {
                        this.remove(frag);
                    }
                    res = true;
                }
            }
            else if (frag instanceof _Fragment_FragmentText__WEBPACK_IMPORTED_MODULE_10__.FragmentText) {
                const newFrags = frag.insertText(content, { index: 0, inner: null });
                if (newFrags.length > 0) {
                    this.splice(fragIndex, 1, newFrags);
                }
                res = newFrags.length > 0;
            }
            else {
                const fragText = (0,_Common_IoC__WEBPACK_IMPORTED_MODULE_19__.create)('');
                fragText.setContent(content);
                this.addBefore(fragText, frag);
                res = true;
            }
        }
        else {
            const newFrags = frag.insertText(content, { index: pos.index - frag.start, inner: pos.inner }, attr);
            if (newFrags.length > 0) {
                this.splice(fragIndex, 1, newFrags);
            }
            res = newFrags.length > 0;
        }
        this.calLength();
        return res;
    }
    /**
     * 在指定位置插入一个换行符
     * @returns 返回插入位置后面的所有 fragment
     */
    insertEnter(pos, attr) {
        var _a, _b;
        const frag = (0,_Common_util__WEBPACK_IMPORTED_MODULE_5__.findChildInDocPos)(pos.index, this.children, true);
        // 大概分为 3 种情况
        // 1、enter 插在两个 frag 之间，此时直接切分当前 frame
        // 2、enter 插入某个 frag，且 frag 被一分为二
        // 3、enter 插入某个 frag，但这个 frag 不会被切开
        if (!frag) {
            return null;
        }
        const SelfConstructor = this.constructor;
        if (frag.start === pos.index) {
            // enter 插在两个 frag 之间，此时直接切分当前 frame
            // 此时取 frag 前（优先）或后的 frag 的样式重新构建一个新的 frame
            const fragEnd = (0,_Common_IoC__WEBPACK_IMPORTED_MODULE_19__.create)(_Fragment_FragmentParaEnd__WEBPACK_IMPORTED_MODULE_9__.FragmentParaEnd.typeName);
            const fragEndAttr = Object.assign(Object.assign(Object.assign({}, (_a = this.tail) === null || _a === void 0 ? void 0 : _a.attributes), (_b = frag.prevSibling) === null || _b === void 0 ? void 0 : _b.attributes), attr);
            fragEnd.setAttributes(fragEndAttr);
            fragEnd.calMetrics();
            if (frag.start === 0) {
                this.addAtIndex(fragEnd, 0);
            }
            else {
                this.addBefore(fragEnd, frag);
            }
            const splitFrags = this.removeAllFrom(fragEnd.nextSibling);
            const layoutFrame = new SelfConstructor();
            layoutFrame.setAttributes(Object.assign(Object.assign({}, this.originalAttributes), attr));
            layoutFrame.addAll(splitFrags);
            layoutFrame.calLength();
            this.calLength();
            return layoutFrame;
        }
        else {
            const newFrag = frag.insertEnter({ index: pos.index - frag.start, inner: pos.inner });
            if (newFrag) {
                // enter 插入某个 frag，且 frag 被一分为二
                const fragEnd = (0,_Common_IoC__WEBPACK_IMPORTED_MODULE_19__.create)(_Fragment_FragmentParaEnd__WEBPACK_IMPORTED_MODULE_9__.FragmentParaEnd.typeName);
                const fragEndAttr = Object.assign(Object.assign({}, frag.originalAttributes), attr);
                fragEnd.setAttributes(fragEndAttr);
                fragEnd.calMetrics();
                const splitFrags = this.removeAllFrom(frag.nextSibling);
                this.addAfter(fragEnd, frag);
                const layoutFrame = new SelfConstructor();
                layoutFrame.setAttributes(Object.assign(Object.assign({}, this.originalAttributes), attr));
                layoutFrame.addLast(newFrag);
                layoutFrame.addAll(splitFrags);
                layoutFrame.calLength();
                this.calLength();
                return layoutFrame;
            }
            else {
                // enter 插入某个 frag，但这个 frag 不会被切开
                return null;
            }
        }
    }
    /**
     * 在指定位置插入一整个 fragment
     * @param pos 插入 fragment 的位置
     */
    insertFragment(frag, pos) {
        // 大概分为两种情况
        // 1、插在两个 fragment 之间
        // 2、插入某个 fragment
        const targetFragIndex = (0,_Common_util__WEBPACK_IMPORTED_MODULE_5__.findChildIndexInDocPos)(pos.index, this.children, true);
        const targetFrag = this.children[targetFragIndex];
        if (targetFragIndex < 0) {
            return;
        }
        if (targetFrag.start === pos.index && pos.inner === null) {
            // 说明是插在两个 fragment 之间，此时需要考虑合并
            this.addBefore(frag, targetFrag);
            this.mergeFragment();
        }
        else {
            // 插入某个 fragment
            const newFrags = targetFrag.insertFragment(frag, (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_15__.getRelativeDocPos)(targetFrag.start, pos));
            if (newFrags.length) {
                this.splice(targetFragIndex, 1, newFrags);
            }
        }
        this.calLength();
    }
    /**
     * 尝试在指定位置插入 block，
     */
    tryInsertBlock(block, pos) {
        // 大概分为两种情况
        // 1、插在两个 fragment 之间
        // 2、插入某个 fragment
        const targetFragIndex = (0,_Common_util__WEBPACK_IMPORTED_MODULE_5__.findChildIndexInDocPos)(pos.index, this.children, true);
        const targetFrag = this.children[targetFragIndex];
        if (targetFragIndex < 0) {
            return false;
        }
        if (targetFrag.start === pos.index && pos.inner === null) {
            // block 插在两个 frag 之间，此时直接切分当前 frame
            return false;
        }
        else {
            // block 插入某个 fragment 就要看这个 fragment 能不能正常插入一个 block
            return targetFrag.insertBlock(block, (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_15__.getRelativeDocPos)(targetFrag.start, pos));
        }
    }
    /**
     * 删除当前 layoutframe 中的指定内容
     */
    delete(range, forward) {
        (0,_Common_util__WEBPACK_IMPORTED_MODULE_5__.deleteRange)(this, range, forward);
        this.mergeFragment();
        this.calLength();
    }
    /**
     * 给指定范围的文档内容设置格式
     */
    format(attr, range) {
        this.formatSelf(attr);
        let returnStart = null;
        let returnEnd = null;
        if (range) {
            const startChildIndex = (0,_Common_util__WEBPACK_IMPORTED_MODULE_5__.findChildIndexInDocPos)(range.start.index, this.children, true);
            const startChild = this.children[startChildIndex];
            let endChildIndex = (0,_Common_util__WEBPACK_IMPORTED_MODULE_5__.findChildIndexInDocPos)(range.end.index, this.children, true);
            let endChild = this.children[endChildIndex];
            if (!startChild || !endChild) {
                return;
            }
            if (startChild !== endChild &&
                endChild.prevSibling &&
                endChild.start === range.end.index &&
                range.end.inner === null) {
                endChild = endChild.prevSibling;
                endChildIndex--;
            }
            // 尝试合并属性相同的 child
            returnStart = startChild.prevSibling || this.head;
            returnEnd = endChild.nextSibling || this.tail;
            if (startChild === endChild) {
                const newFrags = startChild.format(attr, {
                    start: (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_15__.getRelativeDocPos)(startChild.start, range.start),
                    end: (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_15__.getRelativeDocPos)(endChild.start, range.end),
                });
                if (newFrags.length > 0) {
                    this.splice(startChildIndex, 1, newFrags);
                }
            }
            else {
                let currentFragIndex = endChildIndex;
                let currentFrag = endChild;
                while (currentFrag) {
                    let newFrags = [];
                    if (currentFrag === startChild) {
                        if (currentFrag.start === range.start.index && range.start.inner === null) {
                            newFrags = currentFrag.format(attr);
                        }
                        else {
                            newFrags = currentFrag.format(attr, {
                                start: { index: range.start.index - currentFrag.start, inner: range.start.inner },
                                end: { index: currentFrag.start + currentFrag.length, inner: null },
                            });
                        }
                        if (newFrags.length > 0) {
                            this.splice(currentFragIndex, 1, newFrags);
                        }
                        break;
                    }
                    else if (currentFrag === endChild) {
                        if (currentFrag.start + currentFrag.length === range.end.index && range.end.inner === null) {
                            newFrags = currentFrag.format(attr);
                        }
                        else {
                            newFrags = currentFrag.format(attr, {
                                start: { index: 0, inner: null },
                                end: { index: range.end.index - currentFrag.start, inner: range.end.inner },
                            });
                        }
                    }
                    else {
                        newFrags = currentFrag.format(attr);
                    }
                    if (newFrags.length > 0) {
                        this.splice(currentFragIndex, 1, newFrags);
                    }
                    currentFrag = currentFrag.prevSibling;
                    currentFragIndex--;
                }
            }
        }
        else {
            returnStart = this.head;
            returnEnd = this.tail;
            for (let index = this.children.length - 1; index >= 0; index--) {
                const frag = this.children[index];
                const newFrags = frag.format(attr);
                if (newFrags.length > 0) {
                    this.splice(index, 1, newFrags);
                }
            }
        }
        // 设置了格式之后开始尝试合并当前 frame 里面的 fragment
        if (returnStart && returnEnd) {
            let currentFrag = returnStart;
            while (currentFrag === null || currentFrag === void 0 ? void 0 : currentFrag.nextSibling) {
                if (currentFrag.eat(currentFrag.nextSibling)) {
                    this.remove(currentFrag.nextSibling);
                }
                else {
                    currentFrag = currentFrag.nextSibling;
                }
            }
        }
    }
    /**
     * 清除选区范围内容的格式
     */
    clearFormat(range) {
        this.setAttributes(_LayoutFrameAttributes__WEBPACK_IMPORTED_MODULE_11__.LayoutFrameDefaultAttributes);
        let returnStart = null;
        let returnEnd = null;
        if (range) {
            const startChildIndex = (0,_Common_util__WEBPACK_IMPORTED_MODULE_5__.findChildIndexInDocPos)(range.start.index, this.children, true);
            const startChild = this.children[startChildIndex];
            let endChildIndex = (0,_Common_util__WEBPACK_IMPORTED_MODULE_5__.findChildIndexInDocPos)(range.end.index, this.children, true);
            let endChild = this.children[endChildIndex];
            if (!startChild || !endChild) {
                return;
            }
            if (startChild !== endChild &&
                endChild.prevSibling &&
                endChild.start === range.end.index &&
                range.end.inner === null) {
                endChild = endChild.prevSibling;
                endChildIndex--;
            }
            // 尝试合并属性相同的 child
            returnStart = startChild.prevSibling || this.head;
            returnEnd = endChild.nextSibling || this.tail;
            if (startChild === endChild) {
                const newFrags = startChild.clearFormat({
                    start: (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_15__.getRelativeDocPos)(startChild.start, range.start),
                    end: (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_15__.getRelativeDocPos)(endChild.start, range.end),
                });
                if (newFrags.length > 0) {
                    this.splice(startChildIndex, 1, newFrags);
                }
            }
            else {
                let currentFragIndex = endChildIndex;
                let currentFrag = endChild;
                while (currentFrag) {
                    let newFrags = [];
                    if (currentFrag === startChild) {
                        if (currentFrag.start === range.start.index && range.start.inner === null) {
                            newFrags = currentFrag.clearFormat();
                        }
                        else {
                            newFrags = currentFrag.clearFormat({
                                start: { index: range.start.index - currentFrag.start, inner: range.start.inner },
                                end: { index: currentFrag.start + currentFrag.length, inner: null },
                            });
                        }
                        if (newFrags.length > 0) {
                            this.splice(currentFragIndex, 1, newFrags);
                        }
                        break;
                    }
                    else if (currentFrag === endChild) {
                        if (currentFrag.start + currentFrag.length === range.end.index && range.end.inner === null) {
                            newFrags = currentFrag.clearFormat();
                        }
                        else {
                            newFrags = currentFrag.clearFormat({
                                start: { index: 0, inner: null },
                                end: { index: range.end.index - currentFrag.start, inner: range.end.inner },
                            });
                        }
                    }
                    else {
                        newFrags = currentFrag.clearFormat();
                    }
                    if (newFrags.length > 0) {
                        this.splice(currentFragIndex, 1, newFrags);
                    }
                    currentFrag = currentFrag.prevSibling;
                    currentFragIndex--;
                }
            }
        }
        else {
            returnStart = this.head;
            returnEnd = this.tail;
            for (let index = this.children.length - 1; index >= 0; index--) {
                const frag = this.children[index];
                const newFrags = frag.clearFormat();
                if (newFrags.length > 0) {
                    this.splice(index, 1, newFrags);
                }
            }
        }
        // 设置了格式之后开始尝试合并当前 frame 里面的 fragment
        if (returnStart && returnEnd) {
            let currentFrag = returnStart;
            while (currentFrag === null || currentFrag === void 0 ? void 0 : currentFrag.nextSibling) {
                if (currentFrag.eat(currentFrag.nextSibling)) {
                    this.remove(currentFrag.nextSibling);
                }
                else {
                    currentFrag = currentFrag.nextSibling;
                }
            }
        }
    }
    /**
     * 获取指定选区中所含格式
     */
    getFormat(range) {
        const res = range ? (0,_Common_util__WEBPACK_IMPORTED_MODULE_5__.getFormat)(this, [range], 'left') : (0,_Common_util__WEBPACK_IMPORTED_MODULE_5__.getFormat)(this);
        (0,_Common_util__WEBPACK_IMPORTED_MODULE_5__.collectAttributes)(this.attributes, res);
        return res;
    }
    /**
     * 设置缩进
     * @param increase true:  增加缩进 false: 减少缩进
     */
    setIndent(increase) {
        const currentIndent = this.attributes.indent;
        const step = increase ? 1 : -1;
        let newIndent = currentIndent + step;
        newIndent = Math.min(newIndent, 8);
        newIndent = Math.max(newIndent, 0);
        if (currentIndent !== newIndent) {
            this.setAttributes({
                indent: newIndent,
            });
            this.calcIndentWidth();
            return true;
        }
        return false;
    }
    /**
     * 合并两个 layoutframe
     */
    eat(frame) {
        const oldTail = this.tail;
        this.addAll(frame.children);
        if (oldTail instanceof _Fragment_FragmentText__WEBPACK_IMPORTED_MODULE_10__.FragmentText &&
            oldTail.nextSibling instanceof _Fragment_FragmentText__WEBPACK_IMPORTED_MODULE_10__.FragmentText &&
            lodash_isEqual__WEBPACK_IMPORTED_MODULE_0___default()(oldTail.attributes, oldTail.nextSibling.attributes)) {
            oldTail.content = oldTail.content + oldTail.nextSibling.content;
            this.remove(oldTail.nextSibling);
        }
        this.calLength();
    }
    /**
     * 计算当前 layoutframe 的长度
     */
    calLength() {
        this.length = 0;
        for (let index = 0; index < this.children.length; index++) {
            this.length += this.children[index].length;
        }
    }
    /**
     * 搜索
     */
    search(keywords) {
        const res = [];
        const currentFragmentText = [];
        for (let i = 0, l = this.children.length; i < l; i++) {
            const currentFrag = this.children[i];
            if (currentFrag instanceof _Fragment_FragmentText__WEBPACK_IMPORTED_MODULE_10__.FragmentText) {
                currentFragmentText.push(currentFrag);
            }
            else if (currentFragmentText.length > 0) {
                // 说明上一批 fragment text 已经确定，开始处理
                const batTextContent = currentFragmentText.map((ft) => ft.content).join('');
                const searchPosRes = (0,_Common_util__WEBPACK_IMPORTED_MODULE_5__.searchTextString)(keywords, batTextContent);
                if (searchPosRes.length > 0) {
                    for (let j = 0; j < searchPosRes.length; j++) {
                        searchPosRes[j] += currentFragmentText[0].start;
                        const pos = searchPosRes[j];
                        const rects = this.getSelectionRectangles({ index: pos, inner: null }, { index: pos + keywords.length, inner: null });
                        res.push({
                            pos: {
                                index: pos,
                                inner: null,
                            },
                            rects,
                        });
                    }
                }
                // 已经处理完 currentFragmentText，清空 currentFragmentText
                currentFragmentText.length = 0;
            }
        }
        // 每个 layoutFrame 结尾都是 FragmentParaEnd， 所以到这里 currentFragmentText 里的长度应该是 0
        return res;
    }
    getChildrenStackByPos(x, y) {
        const child = (0,_Common_util__WEBPACK_IMPORTED_MODULE_5__.findRectChildInPos)(x, y, this.lines);
        let res;
        if (child) {
            res = child.getChildrenStackByPos(x - child.x, y - child.y);
            res.unshift(this);
        }
        else {
            res = [this];
        }
        return res;
    }
    getCursorType() {
        return _Common_EnumCursorType__WEBPACK_IMPORTED_MODULE_13__.EnumCursorType.Default;
    }
    enterBuffer(ctx, x, y, viewHeight) {
        for (let i = 0, l = this.lines.length; i < l; i++) {
            const currentLine = this.lines[i];
            currentLine.enterBuffer(ctx, this.x + x, this.y + y);
        }
    }
    leaveBuffer() {
        for (let i = 0, l = this.lines.length; i < l; i++) {
            const currentLine = this.lines[i];
            currentLine.leaveBuffer();
        }
    }
    enterViewport(ctx, x, y, viewHeight) {
        for (let i = 0, l = this.lines.length; i < l; i++) {
            const currentLine = this.lines[i];
            currentLine.enterViewport(ctx, this.x + x, this.y + y);
        }
    }
    leaveViewport() {
        for (let i = 0, l = this.lines.length; i < l; i++) {
            const currentLine = this.lines[i];
            currentLine.leaveViewport();
        }
    }
    // #region IBubbleUpable methods
    bubbleUp(type, data, stack) {
        throw new Error('this method should implemented in IBubbleUpableDecorator');
    }
    setBubbleHandler(handler) {
        throw new Error('this method should implemented in IBubbleUpableDecorator');
    }
    // #endregion
    // #region IDocPosOperator methods
    firstPos() {
        throw new Error('this method should implemented in IDosPosOperatorHDecorator');
    }
    lastPos() {
        throw new Error('this method should implemented in IDosPosOperatorHDecorator');
    }
    nextPos(pos) {
        throw new Error('this method should implemented in IDosPosOperatorHDecorator');
    }
    prevPos(pos) {
        throw new Error('this method should implemented in IDosPosOperatorHDecorator');
    }
    firstLinePos(x) {
        if (this.lines.length > 0) {
            return this.getDocumentPos(x, this.lines[0].y + this.lines[0].height / 2, false);
        }
        else {
            return null;
        }
    }
    lastLinePos(x) {
        if (this.lines.length > 0) {
            return this.getDocumentPos(x, this.lines[this.lines.length - 1].y + this.lines[this.lines.length - 1].height / 2, false);
        }
        else {
            return null;
        }
    }
    nextLinePos(pos, x) {
        const sourceLineIndex = this.findSelectionTargetLineIndex(pos, x);
        if (sourceLineIndex !== null && sourceLineIndex < this.lines.length - 1) {
            const targetLine = this.lines[sourceLineIndex + 1];
            return this.getDocumentPos(x, targetLine.y + targetLine.height / 2, false);
        }
        return null;
    }
    prevLinePos(pos, x) {
        const sourceLineIndex = this.findSelectionTargetLineIndex(pos, x);
        if (sourceLineIndex !== null && sourceLineIndex > 0) {
            const targetLine = this.lines[sourceLineIndex - 1];
            return this.getDocumentPos(x, targetLine.y + targetLine.height / 2, false);
        }
        return null;
    }
    lineStartPos(pos, y) {
        const startIndex = pos.index;
        for (let lineIndex = this.lines.length - 1; lineIndex >= 0; lineIndex--) {
            const line = this.lines[lineIndex];
            if (line.start <= startIndex &&
                line.start + line.length >= startIndex &&
                line.y <= y &&
                line.y + line.height >= y &&
                line.head) {
                // 找到了指定的行
                return { index: line.start, inner: null };
            }
        }
        return null;
    }
    lineEndPos(pos, y) {
        const startIndex = pos.index;
        for (let lineIndex = this.lines.length - 1; lineIndex >= 0; lineIndex--) {
            const line = this.lines[lineIndex];
            if (line.start <= startIndex &&
                line.start + line.length >= startIndex &&
                line.y <= y &&
                line.y + line.height >= y &&
                line.tail) {
                // 找到了指定的行
                if (line !== this.lines[this.lines.length - 1]) {
                    return { index: line.start + line.length, inner: null };
                }
                else {
                    return this.lastPos();
                }
            }
        }
        return null;
    }
    // #endregion
    // #region IPointerInteractive methods
    onPointerEnter(x, y, targetStack, currentTargetIndex) {
        throw new Error('Need IPointerInteractiveDecorator to implement.');
    }
    onPointerLeave() {
        throw new Error('Need IPointerInteractiveDecorator to implement.');
    }
    onPointerMove(x, y, targetStack, currentTargetIndex) {
        throw new Error('Need IPointerInteractiveDecorator to implement.');
    }
    onPointerDown(x, y) {
        throw new Error('Need IPointerInteractiveDecorator to implement.');
    }
    onPointerUp(x, y) {
        throw new Error('Need IPointerInteractiveDecorator to implement.');
    }
    onPointerTap(x, y) {
        throw new Error('Need IPointerInteractiveDecorator to implement.');
    }
    // #endregion
    // #region override LinkedList method
    afterAdd(nodes) {
        nodes.forEach((node) => {
            node.setOverrideDefaultAttributes(this.overrideDefaultAttributes);
            node.setOverrideAttributes(this.overrideAttributes);
            node.setBubbleHandler(this.bubbleUp.bind(this));
        });
    }
    afterRemove(nodes) {
        nodes.forEach((node) => {
            node.setOverrideDefaultAttributes(null);
            node.setOverrideAttributes(null);
            node.setBubbleHandler(null);
        });
    }
    addLast(node) {
        throw new Error('Method not implemented.');
    }
    addAfter(node, target) {
        throw new Error('Method not implemented.');
    }
    addBefore(node, target) {
        throw new Error('Method not implemented.');
    }
    addAtIndex(node, index) {
        throw new Error('Method not implemented.');
    }
    addAll(nodes) {
        throw new Error('Method not implemented.');
    }
    removeAll() {
        throw new Error('Method not implemented.');
    }
    remove(node) {
        throw new Error('Method not implemented.');
    }
    removeAllFrom(node) {
        throw new Error('Method not implemented.');
    }
    splice(start, deleteCount, nodes) {
        throw new Error('Method not implemented.');
    }
    findIndex(node) {
        throw new Error('Method not implemented.');
    }
    // #endregion
    // #region override IAttributable method
    setOverrideDefaultAttributes(attr) {
        throw new Error('Method not implemented.');
    }
    setOverrideAttributes(attr) {
        throw new Error('Method not implemented.');
    }
    setAttributes(attr) {
        throw new Error('Method not implemented.');
    }
    compileAttributes() {
        throw new Error('Method not implemented.');
    }
    // #endregion
    // #region getSelectedElement methods
    getSelectedElement(range) {
        const res = [];
        res.push([this]);
        const startChild = (0,_Common_util__WEBPACK_IMPORTED_MODULE_5__.findChildInDocPos)(range.start.index, this.children, true);
        const endChild = (0,_Common_util__WEBPACK_IMPORTED_MODULE_5__.findChildInDocPos)(range.end.index, this.children, true);
        if (startChild && endChild) {
            if (startChild === endChild) {
                res.push([[startChild]]);
            }
            else {
                const span = [];
                let currentFrag = startChild;
                while (currentFrag) {
                    span.push(currentFrag);
                    currentFrag = currentFrag.nextSibling;
                }
                res.push([span]);
            }
        }
        return res;
    }
    // #endregion
    /**
     * 计算当前 layoutframe 缩进距离
     */
    calcIndentWidth() {
        this.indentWidth = this.attributes.indent > 0 ? this.attributes.indent * 20 + 6 : 0;
    }
    childrenSizeChangeHandler() {
        const size = this.calSize();
        this.setSize(size.height, size.width);
    }
    /**
     * 计算断行点，计算当前 layoutframe 的内容中哪里可以断行
     */
    calLineBreakPoint() {
        const res = [];
        // 已经获得了段落的所有数据，准备开始排版
        // 从 0 开始遍历 所有 fragment，如果是 fragment text 就拿到文字内容，直到遇到非 fragment text
        // 这里非 fragment text 的 fragment 应该肯定是会分配一个单独的 run 的
        // 则前面的一系列 fragment text 拿到所以文字内容一起进行 line break
        // 遍历所有的 break
        // 先找出这个 break 是属于哪个 fragment text 的
        // 如果某个 break 完整的包含于某个 fragment text 中，则直接度量这个 break 的长度并尝试插入当前的 line
        // 如果某个 break 不是完整包含于某个 fragment text 说明这个， break 是跨 fragment text 的
        // 则遍历这个 break 中的每个字符判断其属于哪个 fragment text，并将属同一个 fragment text 的字符放置于一个 run 中，并度量其长度
        // 将这个 break 的所有 run 的长度求和后看能不能插入当前 line
        const currentFragmentText = [];
        for (let i = 0, l = this.children.length; i < l; i++) {
            const currentFrag = this.children[i];
            if (currentFrag instanceof _Fragment_FragmentText__WEBPACK_IMPORTED_MODULE_10__.FragmentText) {
                currentFragmentText.push(currentFrag);
            }
            else {
                // 说明上一批 fragment text 已经确定，开始处理
                res.push(...this.constructLayoutPieces(currentFragmentText));
                // 已经处理完 currentFragmentText，清空 currentFragmentText
                currentFragmentText.length = 0;
                // 如果不是 fragment text，则作为单独的 run 插入当前 line
                const piece = new _Common_LayoutPiece__WEBPACK_IMPORTED_MODULE_3__.LayoutPiece(true);
                piece.frags = [{ frag: currentFrag, start: 0, end: 1 }];
                piece.calTotalWidth();
                res.push(piece);
            }
        }
        // 每个 frame 最后都会有一个 FragmentParaEnd
        // 所以到这里 currentFragmentText.length 应该肯定是 0
        return res;
    }
    /**
     * 给当前 layoutframe 设置格式
     */
    formatSelf(attr) {
        this.setAttributes(attr);
    }
    /**
     * 根据第三方的算法将 fragment text 的内容拆成可以折行的内容片段（piece）
     * 后续会根据这些内容片段来把内容拆到行里面
     */
    constructLayoutPieces(frags) {
        if (frags.length === 0) {
            return [];
        }
        const res = [];
        const totalString = frags.map((frag) => frag.content).join('');
        // 然后开始计算断行点
        const breaker = new (_lib_linebreaker_linebreaker__WEBPACK_IMPORTED_MODULE_2___default())(totalString);
        let breakStart = frags[0].start;
        let bk = breaker.nextBreak();
        let last = 0;
        while (bk) {
            const word = totalString.slice(last, bk.position);
            last = bk.position;
            bk = breaker.nextBreak();
            // 先处理开头的空格
            const noLeadSpaceWord = lodash_trimStart__WEBPACK_IMPORTED_MODULE_1___default()(word);
            let leadSpaceCount = word.length - noLeadSpaceWord.length;
            const leadSpaceCountTemp = leadSpaceCount;
            if (leadSpaceCount > 0) {
                const piece = new _Common_LayoutPiece__WEBPACK_IMPORTED_MODULE_3__.LayoutPiece(false);
                piece.isSpace = true;
                piece.text = '';
                while (leadSpaceCount > 0) {
                    piece.text += ' ';
                    leadSpaceCount--;
                }
                piece.frags = this.getFragsForLayoutPiece(frags, piece, breakStart);
                piece.calTotalWidth();
                res.push(piece);
                breakStart += leadSpaceCountTemp;
            }
            const finalWord = noLeadSpaceWord.trim();
            let spaceCount = noLeadSpaceWord.length - finalWord.length;
            if (finalWord.length > 0) {
                const piece = new _Common_LayoutPiece__WEBPACK_IMPORTED_MODULE_3__.LayoutPiece(false);
                piece.isSpace = false;
                piece.text = finalWord;
                const layoutPieceFrags = this.getFragsForLayoutPiece(frags, piece, breakStart);
                piece.frags = layoutPieceFrags;
                piece.calTotalWidth();
                res.push(piece);
            }
            breakStart += finalWord.length;
            if (spaceCount > 0) {
                const spaceCountTemp = spaceCount;
                const piece = new _Common_LayoutPiece__WEBPACK_IMPORTED_MODULE_3__.LayoutPiece(false);
                piece.isSpace = true;
                piece.text = '';
                while (spaceCount > 0) {
                    piece.text += ' ';
                    spaceCount--;
                }
                piece.frags = this.getFragsForLayoutPiece(frags, piece, breakStart);
                piece.calTotalWidth();
                res.push(piece);
                breakStart += spaceCountTemp;
            }
        }
        return res;
    }
    /**
     * 计算某个 layout piece 覆盖了那些 fragment text
     */
    getFragsForLayoutPiece(frags, piece, start) {
        const res = [];
        for (let i = 0, l = frags.length; i < l; i++) {
            const frag = frags[i];
            if (!(frag.start + frag.length - 1 < start || frag.start >= start + piece.text.length)) {
                res.push({
                    start: Math.max(start, frag.start) - start,
                    end: Math.min(start + piece.text.length, frag.start + frag.length) - start,
                    frag,
                });
            }
        }
        return res;
    }
    /**
     * 将折行算法拆出来的内容片段分行
     */
    breakLines(pieces) {
        /**
         * 遍历所有的 piece
         * 如果当前 piece 能放入 tail line，就插入此行，这里还要看这个 piece 是几个 fragment
         * 否则新建行再看能否插入
         * 如能则进入下一个循环
         * 如不能，则看能否拆分当前 piece，
         * 不能则强行插入此行并创建新行，然后进入下一个循环
         * 能拆分，则依次计算 piece 中所有字符宽度
         * 然后为每一行尽可能放入更多内容
         */
        for (let i = 0, l = pieces.length; i < l; i++) {
            let tailLine = this.lines[this.lines.length - 1];
            const freeSpace = Math.max(this.maxWidth - tailLine.x - tailLine.width, 0);
            const currentPiece = pieces[i];
            if (currentPiece.totalWidth <= freeSpace || currentPiece.isSpace) {
                if (currentPiece.isHolder) {
                    const run = (0,_Common_IoC__WEBPACK_IMPORTED_MODULE_19__.createRunByFragment)(currentPiece.frags[0].frag);
                    const size = run.calSize();
                    run.setSize(size.height, size.width);
                    tailLine.addLast(run);
                }
                else if (currentPiece.frags.length === 1) {
                    const run = (0,_Common_IoC__WEBPACK_IMPORTED_MODULE_19__.create)(_RunText__WEBPACK_IMPORTED_MODULE_7__.RunText.typeName, currentPiece.frags[0].frag);
                    run.setContent(currentPiece.text);
                    run.setSize(run.calHeight(), currentPiece.totalWidth);
                    run.isSpace = currentPiece.isSpace;
                    tailLine.addLast(run);
                }
                else {
                    for (let index = 0, fl = currentPiece.frags.length; index < fl; index++) {
                        const frag = currentPiece.frags[index];
                        const run = (0,_Common_IoC__WEBPACK_IMPORTED_MODULE_19__.create)(_RunText__WEBPACK_IMPORTED_MODULE_7__.RunText.typeName, frag.frag);
                        run.setContent(currentPiece.text.substring(frag.start, frag.end));
                        run.setSize(run.calHeight(), currentPiece.fragWidth[index]);
                        run.isSpace = currentPiece.isSpace;
                        tailLine.addLast(run);
                    }
                }
            }
            else {
                // 如果不能把整个 piece 放入 tail line， 就看是否需要创建新行再尝试拆分这个 piece
                if (tailLine.children.length > 0) {
                    this.addLine(new _Line__WEBPACK_IMPORTED_MODULE_6__.Line(this.indentWidth, Math.floor(tailLine.y + tailLine.height), this.attributes.linespacing, this.maxWidth - this.indentWidth, this.minBaseline, this.minLineHeight));
                    i--;
                    continue;
                }
                else if (currentPiece.isHolder) {
                    // 如果是空行就看这个 piece 是不是 holder，是 holder 直接插入，加新行，进入下一个循环
                    const run = (0,_Common_IoC__WEBPACK_IMPORTED_MODULE_19__.createRunByFragment)(currentPiece.frags[0].frag);
                    const size = run.calSize();
                    run.setSize(size.height, size.width);
                    tailLine.addLast(run);
                    this.addLine(new _Line__WEBPACK_IMPORTED_MODULE_6__.Line(this.indentWidth, Math.floor(tailLine.y + tailLine.height), this.attributes.linespacing, this.maxWidth - this.indentWidth, this.minBaseline, this.minLineHeight));
                    continue;
                }
                // 这里用一个嵌套循环来尝试拆分 piece，外层循环拆 piece 中的 frag，内层循环拆某个 frag 中的字符
                let fragIndex = 0;
                while (fragIndex < currentPiece.frags.length) {
                    let lineFreeSpace = this.maxWidth - tailLine.x - tailLine.width;
                    const currentFrag = currentPiece.frags[fragIndex];
                    if (currentPiece.fragWidth[fragIndex] <= lineFreeSpace) {
                        // 如果拆分 frag 后 frag 可以插入就插入并进入下一个循环
                        const run = (0,_Common_IoC__WEBPACK_IMPORTED_MODULE_19__.create)(_RunText__WEBPACK_IMPORTED_MODULE_7__.RunText.typeName, currentFrag.frag);
                        run.setContent(currentPiece.text.substring(currentFrag.start, currentFrag.end));
                        run.setSize(run.calHeight(), currentPiece.fragWidth[fragIndex]);
                        run.isSpace = currentPiece.isSpace;
                        tailLine.addLast(run);
                        lineFreeSpace -= currentPiece.fragWidth[fragIndex];
                    }
                    else {
                        // 如果拆分后 frag 不能插入，就再拆分这个 frag 到字符，再尝试插入
                        let charStartIndex = 0;
                        while (currentFrag.start + charStartIndex < currentFrag.end) {
                            for (let length = currentFrag.end - currentFrag.start - charStartIndex; length > 0; length--) {
                                const text = currentPiece.text.substr(currentFrag.start + charStartIndex, length);
                                const charPieceWidth = (0,_Platform__WEBPACK_IMPORTED_MODULE_17__.getPlatform)().measureTextWidth(text, currentFrag.frag.attributes);
                                if (charPieceWidth <= lineFreeSpace) {
                                    // 如果空间足够就插入
                                    const run = (0,_Common_IoC__WEBPACK_IMPORTED_MODULE_19__.create)(_RunText__WEBPACK_IMPORTED_MODULE_7__.RunText.typeName, currentFrag.frag);
                                    run.setContent(text);
                                    run.setSize(run.calHeight(), charPieceWidth);
                                    run.isSpace = currentPiece.isSpace;
                                    tailLine.addLast(run);
                                    lineFreeSpace -= charPieceWidth;
                                    charStartIndex += length;
                                    // 如果这个 frag 已经处理完了，就 break 进去下一个 frag 的循环
                                    // 如果这个 frag 还没处理完，就创建新 line 继续处理这个 frag 剩下的内容
                                    if (currentFrag.start + charStartIndex < currentFrag.end) {
                                        // 说明还有没有处理完的部分
                                        tailLine = new _Line__WEBPACK_IMPORTED_MODULE_6__.Line(this.indentWidth, Math.floor(tailLine.y + tailLine.height), this.attributes.linespacing, this.maxWidth - this.indentWidth, this.minBaseline, this.minLineHeight);
                                        this.addLine(tailLine);
                                        lineFreeSpace = this.maxWidth - tailLine.x - tailLine.width;
                                    }
                                    break;
                                }
                                else if (length === 1) {
                                    // 如果当前只有一个字符，就看是不是空行，是空行就强行插入这个字符，否则创建新行重新跑循环
                                    if (tailLine.children.length === 0) {
                                        const run = (0,_Common_IoC__WEBPACK_IMPORTED_MODULE_19__.create)(_RunText__WEBPACK_IMPORTED_MODULE_7__.RunText.typeName, currentFrag.frag);
                                        run.setContent(text);
                                        run.setSize(run.calHeight(), charPieceWidth);
                                        run.isSpace = currentPiece.isSpace;
                                        tailLine.addLast(run);
                                        charStartIndex += 1;
                                    }
                                    else {
                                        tailLine = new _Line__WEBPACK_IMPORTED_MODULE_6__.Line(this.indentWidth, Math.floor(tailLine.y + tailLine.height), this.attributes.linespacing, this.maxWidth - this.indentWidth, this.minBaseline, this.minLineHeight);
                                        this.addLine(tailLine);
                                        // 这里要重新计算 length 和 lineFreeSpace
                                        length = currentFrag.end - charStartIndex + 2;
                                        lineFreeSpace = this.maxWidth - tailLine.x - tailLine.width;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                    fragIndex++;
                }
            }
        }
    }
    /**
     * 设置当前 layoutframe 的 size
     */
    setSize(height, width) {
        this.width = width;
        this.height = height;
    }
    mergeFragment() {
        if (this.children.length < 2) {
            return false;
        }
        let res = false;
        for (let index = this.children.length - 2; index >= 0; index--) {
            const currentFrag = this.children[index];
            const nextFrag = this.children[index + 1];
            if (currentFrag.eat(nextFrag)) {
                this.remove(nextFrag);
                res = true;
            }
        }
        return res;
    }
    /**
     * 遍历所有的行计算当前 layoutframe 的 size
     */
    calSize() {
        let newWidth = 0;
        let newHeight = 0;
        this.lines.forEach((item) => {
            newWidth = Math.max(newWidth, item.x + item.width);
        });
        const lastLine = this.lines[this.lines.length - 1];
        newHeight = lastLine.y + lastLine.height;
        return {
            width: newWidth,
            height: newHeight,
        };
    }
    findSelectionTargetLineIndex(pos, x) {
        const possibleLineIndex = [];
        const startIndex = pos.index;
        for (let lineIndex = this.lines.length - 1; lineIndex >= 0; lineIndex--) {
            const line = this.lines[lineIndex];
            if (line.start < startIndex && line.start + line.length > startIndex) {
                // 找到了指定的行
                return lineIndex;
            }
            else if (line.start === startIndex || line.start + line.length === startIndex) {
                possibleLineIndex.push(lineIndex);
            }
        }
        if (possibleLineIndex.length === 1) {
            return possibleLineIndex[0];
        }
        else if (possibleLineIndex.length > 1) {
            const offsets = possibleLineIndex.map((lineIndex) => {
                const line = this.lines[lineIndex];
                return Math.abs(line.start === startIndex ? line.x - x : line.x + line.width - x);
            });
            let currentOffset = Infinity;
            let currentIndex = 0;
            offsets.forEach((offset, index) => {
                if (offset < currentOffset) {
                    currentIndex = index;
                    currentOffset = offset;
                }
            });
            return possibleLineIndex[currentIndex];
        }
        return null;
    }
};
LayoutFrame.typeName = 'frame';
LayoutFrame = LayoutFrame_1 = __decorate([
    OverrideIBubbleUpableDecorator,
    _Common_IBubbleUpable__WEBPACK_IMPORTED_MODULE_14__.IBubbleUpableDecorator,
    _Common_LinkedList__WEBPACK_IMPORTED_MODULE_4__.ILinkedListDecorator,
    _Common_IPointerInteractive__WEBPACK_IMPORTED_MODULE_12__.IPointerInteractiveDecorator,
    OverrideIAttributableDecorator,
    _Common_IAttributable__WEBPACK_IMPORTED_MODULE_16__.IAttributableDecorator,
    _Common_IDocPosOperator__WEBPACK_IMPORTED_MODULE_18__.IDosPosOperatorHDecorator
], LayoutFrame);



/***/ }),

/***/ "./src/RenderStructure/LayoutFrameAttributes.ts":
/*!******************************************************!*\
  !*** ./src/RenderStructure/LayoutFrameAttributes.ts ***!
  \******************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LayoutFrameDefaultAttributes": function() { return /* binding */ layoutFrameDefaultAttributes; }
/* harmony export */ });
/* harmony import */ var _Common_EnumParagraphStyle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Common/EnumParagraphStyle */ "./src/Common/EnumParagraphStyle.ts");

const layoutFrameDefaultAttributes = {
    align: _Common_EnumParagraphStyle__WEBPACK_IMPORTED_MODULE_0__.EnumAlign.left,
    indent: 0,
    linespacing: 1.7,
};



/***/ }),

/***/ "./src/RenderStructure/Line.ts":
/*!*************************************!*\
  !*** ./src/RenderStructure/Line.ts ***!
  \*************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Line": function() { return /* binding */ Line; }
/* harmony export */ });
/* harmony import */ var _Common_LinkedList__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Common/LinkedList */ "./src/Common/LinkedList.ts");
/* harmony import */ var _Common_EnumParagraphStyle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Common/EnumParagraphStyle */ "./src/Common/EnumParagraphStyle.ts");
/* harmony import */ var _Fragment_FragmentAttributes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Fragment/FragmentAttributes */ "./src/Fragment/FragmentAttributes.ts");
/* harmony import */ var _Fragment_FragmentText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Fragment/FragmentText */ "./src/Fragment/FragmentText.ts");
/* harmony import */ var _RunText__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./RunText */ "./src/RenderStructure/RunText.ts");
/* harmony import */ var _Common_util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../Common/util */ "./src/Common/util.ts");
/* harmony import */ var _Common_EnumCursorType__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../Common/EnumCursorType */ "./src/Common/EnumCursorType.ts");
/* harmony import */ var _Common_IBubbleUpable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../Common/IBubbleUpable */ "./src/Common/IBubbleUpable.ts");
/* harmony import */ var _Common_EnumBubbleMessage__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../Common/EnumBubbleMessage */ "./src/Common/EnumBubbleMessage.ts");
/* harmony import */ var _Common_IPointerInteractive__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../Common/IPointerInteractive */ "./src/Common/IPointerInteractive.ts");
/* harmony import */ var _Platform__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../Platform */ "./src/Platform.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};











let Line = class Line {
    constructor(x, y, linespacing, maxWidth, minBaseline = 0, minHeight = 0) {
        this.children = [];
        this.head = null;
        this.tail = null;
        this.start = 0;
        this.length = 0;
        this.width = 0;
        this.height = 0;
        this.baseline = 0;
        this.linespacing = 1.7;
        this.maxWidth = 0;
        this.minBaseline = 0;
        this.minHeight = 0;
        this.backgroundList = [];
        this.underlineList = [];
        this.strikeList = [];
        this.composingUnderline = [];
        this.isPointerHover = false;
        this.x = x;
        this.y = y;
        this.linespacing = linespacing;
        this.maxWidth = maxWidth;
        this.minBaseline = minBaseline;
        this.minHeight = minHeight;
    }
    destroy() {
        for (let index = 0; index < this.children.length; index++) {
            const run = this.children[index];
            run.destroy();
        }
    }
    /**
     * 给当前行添加一个 run
     */
    afterAdd(nodes) {
        let newBaseline = this.baseline;
        let newHeight = this.height;
        let newWidth = this.width;
        nodes.forEach((node) => {
            var _a, _b, _c, _d, _e, _f;
            newWidth = newWidth + node.width;
            const ls = node.solidHeight ? 1 : this.linespacing;
            const runHeight = node instanceof _RunText__WEBPACK_IMPORTED_MODULE_4__.RunText ? (0,_Platform__WEBPACK_IMPORTED_MODULE_10__.getPlatform)().convertPt2Px[(_b = (_a = node.frag) === null || _a === void 0 ? void 0 : _a.attributes.size) !== null && _b !== void 0 ? _b : 0] : node.height;
            newHeight = Math.max(newHeight, runHeight * ls);
            newBaseline = Math.max(newBaseline, (newHeight - ((_d = (_c = node.frag) === null || _c === void 0 ? void 0 : _c.metrics.bottom) !== null && _d !== void 0 ? _d : 0)) / 2 + ((_f = (_e = node.frag) === null || _e === void 0 ? void 0 : _e.metrics.baseline) !== null && _f !== void 0 ? _f : 0));
            this.length += node.length;
            node.setBubbleHandler(this.bubbleUp.bind(this));
        });
        this.setBaseline(newBaseline);
        this.setSize(newHeight, newWidth);
    }
    afterRemove(nodes) {
        // afterRemove 的时候不用重新计算 line 的高度和 baseline 了
        // 因为这个地方只有 line 本身排版时的 splice 操作会触发
        // 文档内容变化时会重新生成新的 line
        nodes.forEach((node) => {
            this.length -= node.length;
            node.setBubbleHandler(null);
        });
    }
    /**
     * 绘制一行内容
     * @param ctx ICanvasContext
     * @param x 绘制位置的 x 坐标
     * @param y 绘制位置的 y 坐标
     */
    draw(ctx, x, y) {
        // 先画背景色
        this.backgroundList.forEach((item) => {
            ctx.fillStyle = item.background;
            ctx.fillRect(item.start + this.x + x, this.y + y, item.end - item.start, this.height);
        });
        // 再画内容
        for (let i = 0, l = this.children.length; i < l; i++) {
            this.children[i].draw(ctx, this.x + x, this.y + y, this.baseline);
        }
        ctx.lineWidth = 1;
        // 画下划线
        this.underlineList.forEach((item) => {
            ctx.beginPath();
            ctx.moveTo(item.start + this.x + x, item.posY + y);
            ctx.lineTo(item.end + this.x + x, item.posY + y);
            ctx.strokeStyle = item.color;
            ctx.stroke();
        });
        // 画输入法输入过程中字符内容的下划线
        if (this.composingUnderline.length > 0) {
            const oldLineWidth = ctx.lineWidth;
            ctx.lineWidth = 1.5;
            this.composingUnderline.forEach((item) => {
                ctx.beginPath();
                ctx.moveTo(item.start + this.x + x, item.posY + y);
                ctx.lineTo(item.end + this.x + x, item.posY + y);
                ctx.strokeStyle = '#67aef9';
                ctx.stroke();
            });
            ctx.lineWidth = oldLineWidth;
        }
        // 画删除线
        this.strikeList.forEach((item) => {
            ctx.beginPath();
            ctx.moveTo(item.start + this.x + x, item.posY + y);
            ctx.lineTo(item.end + this.x + x, item.posY + y);
            ctx.strokeStyle = item.color;
            ctx.stroke();
        });
        // 最后绘制调试信息
        if (window.lineBorder || this.isPointerHover) {
            ctx.save();
            ctx.strokeStyle = 'red';
            ctx.strokeRect(this.x + x, this.y + y, this.width, this.height);
            ctx.restore();
        }
    }
    /**
     * 对当前行排版
     */
    layout(align) {
        // line 的布局算法需要计算出此 line 中每个 run 的具体位置
        // 注意每行最后一个 run 如果是空格或者 RunParaEnd，这个 run 是不占位置的
        // 同时还需要计算此 line 中每一段背景色、下划线、删除线的起始位置
        var _a;
        let startX = 0;
        let spaceWidth = 0;
        switch (align) {
            case _Common_EnumParagraphStyle__WEBPACK_IMPORTED_MODULE_1__.EnumAlign.left:
            case _Common_EnumParagraphStyle__WEBPACK_IMPORTED_MODULE_1__.EnumAlign.scattered:
                startX = 0;
                break;
            case _Common_EnumParagraphStyle__WEBPACK_IMPORTED_MODULE_1__.EnumAlign.justify: {
                let spaceCount = this.children.length - 1;
                if ((_a = this.tail) === null || _a === void 0 ? void 0 : _a.isSpace) {
                    spaceCount--;
                }
                const totalContentWidth = this.children.reduce((totalWidth, cur, index) => {
                    if (cur.isSpace && index === this.children.length - 1) {
                        return totalWidth;
                    }
                    else {
                        return totalWidth + cur.width;
                    }
                }, 0);
                spaceWidth = (this.maxWidth - totalContentWidth) / spaceCount;
                startX = 0;
                break;
            }
            case _Common_EnumParagraphStyle__WEBPACK_IMPORTED_MODULE_1__.EnumAlign.center: {
                const totalContentWidth = this.children.reduce((totalWidth, cur, index) => {
                    if (cur.isSpace && index === this.children.length - 1) {
                        return totalWidth;
                    }
                    else {
                        return totalWidth + cur.width;
                    }
                }, 0);
                startX = (this.maxWidth - totalContentWidth) / 2;
                break;
            }
            case _Common_EnumParagraphStyle__WEBPACK_IMPORTED_MODULE_1__.EnumAlign.right: {
                const totalContentWidth = this.children.reduce((totalWidth, cur, index) => {
                    if (cur.isSpace && index === this.children.length - 1) {
                        return totalWidth;
                    }
                    else {
                        return totalWidth + cur.width;
                    }
                }, 0);
                startX = this.maxWidth - totalContentWidth;
                break;
            }
        }
        let backgroundStart = false;
        let backgroundRange = { start: startX, end: 0, background: '' };
        const underlinePosY = this.y + this.baseline + 2;
        let underlineStart = false;
        let underlineRange = { start: startX, end: 0, posY: this.calClearPosY(underlinePosY), color: '' };
        let composingUnderlineStart = false;
        let composingUnderlineRange = { start: startX, end: 0, posY: this.calClearPosY(underlinePosY) };
        let strikeStart = false;
        let strikeRange = { start: startX, end: 0, posY: 0.5, color: '' };
        let strikeFrag = null;
        let currentRun = this.head;
        while (currentRun === null || currentRun === void 0 ? void 0 : currentRun.frag) {
            currentRun.y = this.baseline - currentRun.frag.metrics.baseline;
            currentRun.x = Math.min(this.maxWidth, currentRun.prevSibling === null ? startX : currentRun.prevSibling.x + currentRun.prevSibling.width + spaceWidth);
            // 如果是分散对齐的话，要把前面一个 run 的宽度调大一点，以免 run 之间有间隙
            if (align === _Common_EnumParagraphStyle__WEBPACK_IMPORTED_MODULE_1__.EnumAlign.justify && currentRun.prevSibling) {
                currentRun.prevSibling.setSize(currentRun.prevSibling.height, currentRun.x - currentRun.prevSibling.x);
            }
            if (backgroundStart) {
                if (currentRun.frag.attributes.background !== backgroundRange.background) {
                    backgroundRange.end = currentRun.x;
                    this.backgroundList.push(backgroundRange);
                    backgroundStart = false;
                    backgroundRange = { start: startX, end: 0, background: '' };
                    if (currentRun.frag.attributes.background !== _Fragment_FragmentAttributes__WEBPACK_IMPORTED_MODULE_2__.FragmentDefaultAttributes.background) {
                        backgroundRange.start = currentRun.x;
                        backgroundRange.background = currentRun.frag.attributes.background;
                        backgroundStart = true;
                    }
                }
            }
            else if (currentRun.frag.attributes.background !== _Fragment_FragmentAttributes__WEBPACK_IMPORTED_MODULE_2__.FragmentDefaultAttributes.background) {
                backgroundRange.start = currentRun.x;
                backgroundRange.background = currentRun.frag.attributes.background;
                backgroundStart = true;
            }
            if (underlineStart) {
                if (currentRun.frag.attributes.color !== underlineRange.color || !currentRun.frag.attributes.underline) {
                    underlineRange.end = currentRun.x;
                    this.underlineList.push(underlineRange);
                    underlineStart = false;
                    underlineRange = { start: startX, end: 0, posY: this.calClearPosY(underlinePosY), color: '' };
                    if (currentRun.frag.attributes.underline !== _Fragment_FragmentAttributes__WEBPACK_IMPORTED_MODULE_2__.FragmentDefaultAttributes.underline) {
                        underlineRange.start = currentRun.x;
                        underlineRange.color = currentRun.frag.attributes.color;
                        underlineStart = true;
                    }
                }
            }
            else if (currentRun.frag.attributes.underline !== _Fragment_FragmentAttributes__WEBPACK_IMPORTED_MODULE_2__.FragmentDefaultAttributes.underline) {
                underlineRange.start = currentRun.x;
                underlineRange.color = currentRun.frag.attributes.color;
                underlineStart = true;
            }
            if (composingUnderlineStart) {
                if (!(currentRun.frag instanceof _Fragment_FragmentText__WEBPACK_IMPORTED_MODULE_3__.FragmentText) || !currentRun.frag.attributes.composing) {
                    composingUnderlineRange.end = currentRun.x;
                    this.composingUnderline.push(composingUnderlineRange);
                    composingUnderlineStart = false;
                    composingUnderlineRange = { start: startX, end: 0, posY: this.calClearPosY(underlinePosY) };
                }
            }
            else if (currentRun.frag.attributes.composing) {
                composingUnderlineRange.start = currentRun.x;
                composingUnderlineStart = true;
            }
            if (strikeStart) {
                if (currentRun.frag !== strikeFrag) {
                    strikeRange.end = currentRun.x;
                    this.strikeList.push(strikeRange);
                    strikeStart = false;
                    strikeFrag = null;
                    strikeRange = { start: startX, end: 0, posY: 0.5, color: '' };
                    if (currentRun.frag.attributes.strike !== _Fragment_FragmentAttributes__WEBPACK_IMPORTED_MODULE_2__.FragmentDefaultAttributes.strike) {
                        strikeRange.start = currentRun.x;
                        strikeRange.color = currentRun.frag.attributes.color;
                        strikeRange.posY = this.calClearPosY(this.y + this.baseline - (currentRun.frag.metrics.baseline - currentRun.frag.metrics.xTop) / 2);
                        strikeStart = true;
                        strikeFrag = currentRun.frag;
                    }
                }
            }
            else if (currentRun.frag.attributes.strike !== _Fragment_FragmentAttributes__WEBPACK_IMPORTED_MODULE_2__.FragmentDefaultAttributes.strike) {
                strikeRange.start = currentRun.x;
                strikeRange.color = currentRun.frag.attributes.color;
                strikeRange.posY = this.calClearPosY(this.y + this.baseline - (currentRun.frag.metrics.baseline - currentRun.frag.metrics.xTop) / 2);
                strikeStart = true;
                strikeFrag = currentRun.frag;
            }
            currentRun = currentRun.nextSibling;
        }
        if (backgroundStart) {
            backgroundRange.end = this.tail.x + this.tail.width;
            this.backgroundList.push(backgroundRange);
        }
        if (underlineStart) {
            underlineRange.end = this.tail.x + this.tail.width;
            this.underlineList.push(underlineRange);
        }
        if (composingUnderlineStart) {
            composingUnderlineRange.end = this.tail.x + this.tail.width;
            this.composingUnderline.push(composingUnderlineRange);
        }
        if (strikeStart) {
            strikeRange.end = this.tail.x + this.tail.width;
            this.strikeList.push(strikeRange);
        }
        if (this.tail !== null) {
            this.setSize(this.height, this.tail.x + this.tail.width);
        }
    }
    getChildrenStackByPos(x, y) {
        const res = [this];
        const child = (0,_Common_util__WEBPACK_IMPORTED_MODULE_5__.findRectChildInPos)(x, y, this.children, false);
        if (child) {
            res.push(child);
        }
        return res;
    }
    getCursorType() {
        return _Common_EnumCursorType__WEBPACK_IMPORTED_MODULE_6__.EnumCursorType.Default;
    }
    enterBuffer(ctx, x, y) {
        for (let i = 0, l = this.children.length; i < l; i++) {
            const run = this.children[i];
            run.enterBuffer(ctx, this.x + x, this.y + y);
        }
    }
    leaveBuffer() {
        for (let i = 0, l = this.children.length; i < l; i++) {
            const run = this.children[i];
            run.leaveBuffer();
        }
    }
    enterViewport(ctx, x, y) {
        for (let i = 0, l = this.children.length; i < l; i++) {
            const run = this.children[i];
            run.enterViewport(ctx, this.x + x, this.y + y);
        }
    }
    leaveViewport() {
        for (let i = 0, l = this.children.length; i < l; i++) {
            const run = this.children[i];
            run.leaveViewport();
        }
    }
    // #region ILinkedList methods
    addLast(node) {
        throw new Error('Method not implemented.');
    }
    addAfter(node, target) {
        throw new Error('Method not implemented.');
    }
    addBefore(node, target) {
        throw new Error('Method not implemented.');
    }
    addAtIndex(node, index) {
        throw new Error('Method not implemented.');
    }
    addAll(nodes) {
        throw new Error('Method not implemented.');
    }
    removeAll() {
        throw new Error('Method not implemented.');
    }
    remove(node) {
        throw new Error('Method not implemented.');
    }
    removeAllFrom(node) {
        throw new Error('Method not implemented.');
    }
    splice(start, deleteCount, nodes) {
        return [];
    }
    findIndex(node) {
        throw new Error('Method not implemented.');
    }
    // #endregion
    // #region IPointerInteractive methods
    onPointerEnter(x, y, targetStack, currentTargetIndex) {
        throw new Error('Need IPointerInteractiveDecorator to implement.');
    }
    onPointerLeave() {
        throw new Error('Need IPointerInteractiveDecorator to implement.');
    }
    onPointerMove(x, y, targetStack, currentTargetIndex) {
        throw new Error('Need IPointerInteractiveDecorator to implement.');
    }
    onPointerDown(x, y) {
        throw new Error('Need IPointerInteractiveDecorator to implement.');
    }
    onPointerUp(x, y) {
        throw new Error('Need IPointerInteractiveDecorator to implement.');
    }
    onPointerTap(x, y) {
        throw new Error('Need IPointerInteractiveDecorator to implement.');
    }
    // #endregion
    // #region IBubbleUpable methods
    bubbleUp(type, data, stack) {
        throw new Error('this method should implemented in IBubbleUpableDecorator');
    }
    setBubbleHandler(handler) {
        throw new Error('this method should implemented in IBubbleUpableDecorator');
    }
    // #endregion
    /**
     * 设置当前行的 size 并触发 LINE_CHANGE_SIZE 事件
     */
    setSize(height, width) {
        this.width = width;
        this.height = Math.max(this.minHeight, height);
        this.bubbleUp(_Common_EnumBubbleMessage__WEBPACK_IMPORTED_MODULE_8__.BubbleMessage.LINE_CHANGE_SIZE, { width: this.width, height: this.height }, [this]);
    }
    /**
     * 设置当前行的 baseline 位置
     */
    setBaseline(baseline) {
        this.baseline = Math.max(baseline, this.minBaseline);
    }
    /**
     * 根据原始 y 坐标计算出一个可以在高分屏上清晰绘制的 y 坐标
     * @param posY 原始 y 坐标
     */
    calClearPosY(posY) {
        // 在高分屏上，如果 y 坐标时一个整数，在这个坐标上绘制一条水平方向的直线
        // 这条直接就是模糊的，所以需要向下取整让加上 0.5 使得这条直线变清晰
        return Math.floor(posY) + 0.5;
    }
};
Line = __decorate([
    _Common_IBubbleUpable__WEBPACK_IMPORTED_MODULE_7__.IBubbleUpableDecorator,
    _Common_LinkedList__WEBPACK_IMPORTED_MODULE_0__.ILinkedListDecorator,
    _Common_IPointerInteractive__WEBPACK_IMPORTED_MODULE_9__.IPointerInteractiveDecorator
], Line);



/***/ }),

/***/ "./src/RenderStructure/Run.ts":
/*!************************************!*\
  !*** ./src/RenderStructure/Run.ts ***!
  \************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Run": function() { return /* binding */ Run; }
/* harmony export */ });
/* harmony import */ var _Common_EnumCursorType__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Common/EnumCursorType */ "./src/Common/EnumCursorType.ts");

class Run {
    constructor() {
        this.x = 0;
        this.y = 0;
        this.width = 0;
        this.height = 0;
        this.solidHeight = false; // 固定高度，只该元素实际占用高度不受 line 元素的 行高等条件影响
        this.prevSibling = null;
        this.nextSibling = null;
        this.isSpace = false; // 标记当前 run 是否为空格或 RunParaEnd
        this.length = 1;
        this.isPointerHover = false;
    }
    destroy() {
        this.prevSibling = null;
        this.nextSibling = null;
    }
    /**
     * 指定 run 的尺寸(这个尺寸和 run 的内容是无关的)
     */
    setSize(height, width) {
        this.width = width;
        this.height = height;
    }
    /**
     * 根据自身内容计算出能包含自身内容的最小尺寸
     */
    calSize() {
        return {
            height: this.calHeight(),
            width: this.calWidth(),
        };
    }
    setPosition(x, y) {
        this.x = x;
        this.y = y;
    }
    getCoordinatePosX(index) {
        return index === 0 ? 0 : this.width;
    }
    getCursorType() {
        return _Common_EnumCursorType__WEBPACK_IMPORTED_MODULE_0__.EnumCursorType.Default;
    }
    enterBuffer(ctx, x, y) { }
    leaveBuffer() { }
    enterViewport(ctx, x, y) { }
    leaveViewport() { }
    onPointerEnter(x, y) {
        this.isPointerHover = true;
        this.frag.onPointerEnter();
    }
    onPointerLeave() {
        this.isPointerHover = false;
        this.frag.onPointerLeave();
    }
    onPointerMove(x, y) {
        this.frag.onPointerMove();
    }
    onPointerDown(x, y) {
        this.frag.onPointerDown();
    }
    onPointerUp(x, y) {
        this.frag.onPointerUp();
    }
    onPointerTap(x, y) {
        this.frag.onPointerTap();
    }
}
Run.typeName = 'run';


/***/ }),

/***/ "./src/RenderStructure/RunDate.ts":
/*!****************************************!*\
  !*** ./src/RenderStructure/RunDate.ts ***!
  \****************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RunDate": function() { return /* binding */ RunDate; }
/* harmony export */ });
/* harmony import */ var _Run__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Run */ "./src/RenderStructure/Run.ts");
/* harmony import */ var _Platform__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Platform */ "./src/Platform.ts");
/* harmony import */ var _Common_IBubbleUpable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Common/IBubbleUpable */ "./src/Common/IBubbleUpable.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



const dateColor = '#70b1e7';
let RunDate = class RunDate extends _Run__WEBPACK_IMPORTED_MODULE_0__.Run {
    constructor(frag) {
        super();
        this.frag = frag;
        this.content = frag.stringContent;
        this.height = this.calHeight();
    }
    /**
     *  绘制 RunDate
     * @param ctx 绘图 api 接口
     */
    draw(ctx, x, y, baseline) {
        // 绘制文本内容
        ctx.font = (0,_Platform__WEBPACK_IMPORTED_MODULE_1__.getPlatform)().createTextFontString(this.frag.attributes);
        ctx.fillStyle = dateColor;
        ctx.fillText(this.content, this.x + x, baseline + y);
        if (window.runBorder) {
            ctx.strokeStyle = 'green';
            ctx.strokeRect(this.x + x, this.y + y, this.width, this.height);
        }
    }
    /**
     * 计算当前 RunDate 高度
     */
    calHeight() {
        this.height = (0,_Platform__WEBPACK_IMPORTED_MODULE_1__.getPlatform)().convertPt2Px[this.frag.attributes.size];
        return this.height;
    }
    /**
     * 计算当前 RunDate 宽度
     */
    calWidth() {
        this.width = (0,_Platform__WEBPACK_IMPORTED_MODULE_1__.getPlatform)().measureTextWidth(this.content, this.frag.attributes);
        return this.width;
    }
    getDocumentPos(x, y, start) {
        if (x < this.width / 2) {
            return { index: 0, inner: null };
        }
        else {
            return { index: 1, inner: null };
        }
    }
    // #region IBubbleUpable methods
    bubbleUp(type, data, stack) {
        throw new Error('this method should implemented in IBubbleUpableDecorator');
    }
    setBubbleHandler(handler) {
        throw new Error('this method should implemented in IBubbleUpableDecorator');
    }
};
RunDate.typeName = 'run-date';
RunDate = __decorate([
    _Common_IBubbleUpable__WEBPACK_IMPORTED_MODULE_2__.IBubbleUpableDecorator
], RunDate);



/***/ }),

/***/ "./src/RenderStructure/RunImage.ts":
/*!*****************************************!*\
  !*** ./src/RenderStructure/RunImage.ts ***!
  \*****************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RunImage": function() { return /* binding */ RunImage; }
/* harmony export */ });
/* harmony import */ var _Run__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Run */ "./src/RenderStructure/Run.ts");
/* harmony import */ var _Common_IBubbleUpable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Common/IBubbleUpable */ "./src/Common/IBubbleUpable.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let RunImage = class RunImage extends _Run__WEBPACK_IMPORTED_MODULE_0__.Run {
    constructor(frag) {
        super();
        this.solidHeight = true;
        this.frag = frag;
    }
    /**
     * 绘制当前图片
     */
    draw(ctx, x, y) {
        console.log('RunImage.draw not implemented.');
    }
    /**
     * 计算高度
     */
    calHeight() {
        this.height = this.frag.attributes.height;
        return this.height;
    }
    /**
     * 计算宽度
     */
    calWidth() {
        this.width = this.frag.attributes.width;
        return this.width;
    }
    /**
     * 获取坐标在文档中的位置
     */
    getDocumentPos(x, y, start) {
        if (x < this.width / 2) {
            return { index: 0, inner: null };
        }
        else {
            return { index: 1, inner: null };
        }
    }
    // #region IBubbleUpable methods
    bubbleUp(type, data, stack) {
        throw new Error('this method should implemented in IBubbleUpableDecorator');
    }
    setBubbleHandler(handler) {
        throw new Error('this method should implemented in IBubbleUpableDecorator');
    }
};
RunImage.typeName = 'run-image';
RunImage = __decorate([
    _Common_IBubbleUpable__WEBPACK_IMPORTED_MODULE_1__.IBubbleUpableDecorator
], RunImage);



/***/ }),

/***/ "./src/RenderStructure/RunParaEnd.ts":
/*!*******************************************!*\
  !*** ./src/RenderStructure/RunParaEnd.ts ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RunParaEnd": function() { return /* binding */ RunParaEnd; }
/* harmony export */ });
/* harmony import */ var _Run__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Run */ "./src/RenderStructure/Run.ts");
/* harmony import */ var _Platform__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Platform */ "./src/Platform.ts");
/* harmony import */ var _Common_IBubbleUpable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Common/IBubbleUpable */ "./src/Common/IBubbleUpable.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



let RunParaEnd = class RunParaEnd extends _Run__WEBPACK_IMPORTED_MODULE_0__.Run {
    constructor(frag) {
        super();
        this.isSpace = true;
        this.frag = frag;
        this.height = this.calHeight();
    }
    /**
     * 绘制 paraEnd 的方法，这是个空方法，paraEnd 不需要绘制
     */
    draw() {
        // para end 不需要绘制内容
    }
    /**
     * 计算当前 paraEnd 高度
     */
    calHeight() {
        this.height = (0,_Platform__WEBPACK_IMPORTED_MODULE_1__.getPlatform)().convertPt2Px[this.frag.attributes.size];
        return this.height;
    }
    /**
     * 计算当前 paraEnd 宽度
     */
    calWidth() {
        this.width = 5;
        return this.width;
    }
    getDocumentPos(x, y, start) {
        return { index: 0, inner: null };
    }
    // #region IBubbleUpable methods
    bubbleUp(type, data, stack) {
        throw new Error('this method should implemented in IBubbleUpableDecorator');
    }
    setBubbleHandler(handler) {
        throw new Error('this method should implemented in IBubbleUpableDecorator');
    }
};
RunParaEnd.typeName = 'run-paraend';
RunParaEnd = __decorate([
    _Common_IBubbleUpable__WEBPACK_IMPORTED_MODULE_2__.IBubbleUpableDecorator
], RunParaEnd);



/***/ }),

/***/ "./src/RenderStructure/RunText.ts":
/*!****************************************!*\
  !*** ./src/RenderStructure/RunText.ts ***!
  \****************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RunText": function() { return /* binding */ RunText; }
/* harmony export */ });
/* harmony import */ var _Run__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Run */ "./src/RenderStructure/Run.ts");
/* harmony import */ var _Common_EnumCursorType__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Common/EnumCursorType */ "./src/Common/EnumCursorType.ts");
/* harmony import */ var _Platform__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Platform */ "./src/Platform.ts");
/* harmony import */ var _Common_IBubbleUpable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Common/IBubbleUpable */ "./src/Common/IBubbleUpable.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




let RunText = class RunText extends _Run__WEBPACK_IMPORTED_MODULE_0__.Run {
    constructor(frag, textContent) {
        super();
        this.content = '';
        this.frag = frag;
        this.setContent(textContent !== null && textContent !== void 0 ? textContent : this.frag.content);
    }
    setContent(textContent) {
        this.content = textContent;
        this.length = textContent.length;
        this.height = this.calHeight();
        this.isSpace = this.content === ' ';
    }
    /**
     * 绘制当前 RunText
     */
    draw(ctx, x, y, baseline) {
        // 绘制文本内容
        if (this.prevSibling === null || this.prevSibling.frag !== this.frag) {
            ctx.font = (0,_Platform__WEBPACK_IMPORTED_MODULE_2__.getPlatform)().createTextFontString(this.frag.attributes);
            if (this.frag.attributes.link.length === 0) {
                ctx.fillStyle = this.frag.attributes.color;
            }
            else {
                ctx.fillStyle = '#70b1e7';
            }
        }
        ctx.fillText(this.content, this.x + x, baseline + y);
        if (window.runBorder) {
            ctx.strokeStyle = 'green';
            ctx.strokeRect(this.x + x, this.y + y, this.width, this.height);
        }
    }
    calHeight() {
        this.height = this.frag.metrics.bottom;
        return this.height;
    }
    calWidth() {
        this.width = (0,_Platform__WEBPACK_IMPORTED_MODULE_2__.getPlatform)().measureTextWidth(this.content, this.frag.attributes);
        return this.width;
    }
    getDocumentPos(x, y, start) {
        // 按说 run 的 length 不会是 0，所以这里就先不管 length === 0 的场景了
        if (this.length === 1) {
            if (x < this.width / 2) {
                return { index: 0, inner: null };
            }
            else {
                return { index: 1, inner: null };
            }
        }
        else if (this.length > 1) {
            const widthArray = [0];
            for (let l = 1; l <= this.content.length; l++) {
                const subContent = this.content.substr(0, l);
                const subContentWidth = (0,_Platform__WEBPACK_IMPORTED_MODULE_2__.getPlatform)().measureTextWidth(subContent, this.frag.attributes);
                widthArray.push(subContentWidth);
                if (subContentWidth >= x) {
                    const currentWidth = subContentWidth - widthArray[l - 1];
                    if (x - widthArray[l - 1] < currentWidth / 2) {
                        if (l === 1) {
                            return { index: 0, inner: null };
                        }
                        else {
                            return { index: l - 1, inner: null };
                        }
                    }
                    else {
                        return { index: l, inner: null };
                    }
                }
            }
            return { index: this.content.length, inner: null };
        }
        else {
            return { index: 0, inner: null };
        }
    }
    getCoordinatePosX(index) {
        if (index === 0) {
            return 0;
        }
        return (0,_Platform__WEBPACK_IMPORTED_MODULE_2__.getPlatform)().measureTextWidth(this.content.substr(0, index), this.frag.attributes);
    }
    getCursorType() {
        if (this.frag.attributes.link.length === 0) {
            return _Common_EnumCursorType__WEBPACK_IMPORTED_MODULE_1__.EnumCursorType.Text;
        }
        else {
            return _Common_EnumCursorType__WEBPACK_IMPORTED_MODULE_1__.EnumCursorType.Pointer;
        }
    }
    // #region IBubbleUpable methods
    bubbleUp(type, data, stack) {
        throw new Error('this method should implemented in IBubbleUpableDecorator');
    }
    setBubbleHandler(handler) {
        throw new Error('this method should implemented in IBubbleUpableDecorator');
    }
};
RunText.typeName = 'run-text';
RunText = __decorate([
    _Common_IBubbleUpable__WEBPACK_IMPORTED_MODULE_3__.IBubbleUpableDecorator
], RunText);



/***/ }),

/***/ "./src/RenderStructure/index.ts":
/*!**************************************!*\
  !*** ./src/RenderStructure/index.ts ***!
  \**************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LayoutFrame": function() { return /* reexport safe */ _LayoutFrame__WEBPACK_IMPORTED_MODULE_0__.LayoutFrame; },
/* harmony export */   "LayoutFrameDefaultAttributes": function() { return /* reexport safe */ _LayoutFrameAttributes__WEBPACK_IMPORTED_MODULE_1__.LayoutFrameDefaultAttributes; },
/* harmony export */   "Line": function() { return /* reexport safe */ _Line__WEBPACK_IMPORTED_MODULE_2__.Line; },
/* harmony export */   "Run": function() { return /* reexport safe */ _Run__WEBPACK_IMPORTED_MODULE_3__.Run; },
/* harmony export */   "RunDate": function() { return /* reexport safe */ _RunDate__WEBPACK_IMPORTED_MODULE_4__.RunDate; },
/* harmony export */   "RunImage": function() { return /* reexport safe */ _RunImage__WEBPACK_IMPORTED_MODULE_5__.RunImage; },
/* harmony export */   "RunParaEnd": function() { return /* reexport safe */ _RunParaEnd__WEBPACK_IMPORTED_MODULE_6__.RunParaEnd; },
/* harmony export */   "RunText": function() { return /* reexport safe */ _RunText__WEBPACK_IMPORTED_MODULE_7__.RunText; }
/* harmony export */ });
/* harmony import */ var _LayoutFrame__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./LayoutFrame */ "./src/RenderStructure/LayoutFrame.ts");
/* harmony import */ var _LayoutFrameAttributes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./LayoutFrameAttributes */ "./src/RenderStructure/LayoutFrameAttributes.ts");
/* harmony import */ var _Line__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Line */ "./src/RenderStructure/Line.ts");
/* harmony import */ var _Run__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./Run */ "./src/RenderStructure/Run.ts");
/* harmony import */ var _RunDate__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./RunDate */ "./src/RenderStructure/RunDate.ts");
/* harmony import */ var _RunImage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./RunImage */ "./src/RenderStructure/RunImage.ts");
/* harmony import */ var _RunParaEnd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./RunParaEnd */ "./src/RenderStructure/RunParaEnd.ts");
/* harmony import */ var _RunText__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./RunText */ "./src/RenderStructure/RunText.ts");










/***/ }),

/***/ "./src/Service/CodeBlockService.ts":
/*!*****************************************!*\
  !*** ./src/Service/CodeBlockService.ts ***!
  \*****************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CodeBlockService": function() { return /* binding */ CodeBlockService; }
/* harmony export */ });
/* harmony import */ var quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! quill-delta-enhanced */ "quill-delta-enhanced");
/* harmony import */ var quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Block_CodeBlock__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Block/CodeBlock */ "./src/Block/CodeBlock.ts");
/* harmony import */ var _Service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Service */ "./src/Service/Service.ts");



class CodeBlockService extends _Service__WEBPACK_IMPORTED_MODULE_2__.Service {
    constructor(doc, stack, contentService, paragraphService) {
        super(doc);
        this.stack = stack;
        this.contentService = contentService;
        this.paragraphService = paragraphService;
    }
    /**
     * 设置引用块
     */
    setCodeBlock(range) {
        let diffDelta = new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())();
        range.forEach((r) => {
            const blocks = this.contentService.getBlocksInRange(r);
            const codeBlocks = blocks.filter((blk) => blk instanceof _Block_CodeBlock__WEBPACK_IMPORTED_MODULE_1__.CodeBlock);
            if (codeBlocks.length === blocks.length) {
                // 如果所有的 block 都是 codeBlock 就取消所有的 codeBlock
                this.paragraphService.setParagraph(range);
            }
            else {
                const oldOps = [];
                // 如果存在不是 codeBlock 的 block，就把他设置成 codeBlock，注意这里可能还需要合并前后的 codeBlock
                let startCodeBlock;
                if (blocks[0].prevSibling instanceof _Block_CodeBlock__WEBPACK_IMPORTED_MODULE_1__.CodeBlock) {
                    startCodeBlock = blocks[0].prevSibling;
                    oldOps.push(...startCodeBlock.toOp(true));
                }
                else {
                    startCodeBlock = new _Block_CodeBlock__WEBPACK_IMPORTED_MODULE_1__.CodeBlock();
                    this.doc.addBefore(startCodeBlock, blocks[0]);
                }
                for (let blocksIndex = 0; blocksIndex < blocks.length; blocksIndex++) {
                    const element = blocks[blocksIndex];
                    oldOps.push(...element.toOp(true));
                    const frames = element.getAllLayoutFrames();
                    if (frames.length) {
                        startCodeBlock.addAll(frames);
                        this.doc.remove(element);
                    }
                }
                if (startCodeBlock.nextSibling instanceof _Block_CodeBlock__WEBPACK_IMPORTED_MODULE_1__.CodeBlock) {
                    oldOps.push(...startCodeBlock.nextSibling.toOp(true));
                    const frames = startCodeBlock.nextSibling.removeAll();
                    startCodeBlock.addAll(frames);
                    this.doc.remove(startCodeBlock.nextSibling);
                }
                startCodeBlock.needLayout = true;
                let startIndex = 0;
                let startPositionY = 0;
                if (startCodeBlock.prevSibling) {
                    startIndex = startCodeBlock.prevSibling.start + startCodeBlock.prevSibling.length;
                    startPositionY = startCodeBlock.prevSibling.y + startCodeBlock.prevSibling.height;
                }
                startCodeBlock.setStart(startIndex, true, true, true);
                startCodeBlock.setPositionY(startPositionY, false, true);
                const diff = new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())(oldOps).diff(new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())(startCodeBlock.toOp(true)));
                const res = new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())();
                if (startCodeBlock.start > 0) {
                    res.retain(startCodeBlock.start);
                }
                diffDelta = diffDelta.compose(res.concat(diff));
            }
        });
        if (diffDelta === null || diffDelta === void 0 ? void 0 : diffDelta.ops.length) {
            this.stack.pushDiff(diffDelta);
        }
    }
}


/***/ }),

/***/ "./src/Service/ContentService.ts":
/*!***************************************!*\
  !*** ./src/Service/ContentService.ts ***!
  \***************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ContentService": function() { return /* binding */ ContentService; },
/* harmony export */   "ContentServiceEventNames": function() { return /* binding */ ContentServiceEventNames; }
/* harmony export */ });
/* harmony import */ var quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! quill-delta-enhanced */ "quill-delta-enhanced");
/* harmony import */ var quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Document_Document__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Document/Document */ "./src/Document/Document.ts");
/* harmony import */ var _Common_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Common/util */ "./src/Common/util.ts");
/* harmony import */ var _Common_DocPos__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Common/DocPos */ "./src/Common/DocPos.ts");
/* harmony import */ var _Block_BlockCommon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Block/BlockCommon */ "./src/Block/BlockCommon.ts");
/* harmony import */ var _SelectionService__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./SelectionService */ "./src/Service/SelectionService.ts");
/* harmony import */ var _Block_ListItem__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../Block/ListItem */ "./src/Block/ListItem.ts");
/* harmony import */ var _Service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./Service */ "./src/Service/Service.ts");








var ContentServiceEventNames;
(function (ContentServiceEventNames) {
    ContentServiceEventNames["AFTER_APPLY"] = "AFTER_APPLY";
})(ContentServiceEventNames || (ContentServiceEventNames = {}));
class ContentService extends _Service__WEBPACK_IMPORTED_MODULE_7__.Service {
    constructor(doc, stack, selector) {
        super(doc);
        this.compositionStartOps = [];
        this.compositionStartPos = null;
        this.compositionEndPos = null;
        this.stack = stack;
        this.selector = selector;
    }
    reset() {
        this.compositionStartOps = [];
        this.compositionStartPos = null;
        this.compositionEndPos = null;
    }
    input(content, format) {
        let finalDelta = new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())();
        const selection = this.selector.getSelection();
        if (selection && selection.length > 0) {
            for (let index = selection.length - 1; index >= 0; index--) {
                const range = selection[index];
                if ((0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_3__.compareDocPos)(range.start, range.end) !== 0) {
                    const diff = this.doc.delete([range]);
                    finalDelta = finalDelta.compose(diff);
                }
            }
            const insertPos = selection[0].start;
            const insertDiff = this.doc.insertText(content, insertPos, format);
            finalDelta = finalDelta.compose(insertDiff);
            this.pushDelta(finalDelta);
            const newPos = (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_3__.moveRight)(insertPos, content.length);
            this.selector.setSelection([{ start: newPos, end: newPos }], _SelectionService__WEBPACK_IMPORTED_MODULE_5__.EnumSelectionSource.Input);
        }
    }
    delete(forward, range) {
        const selection = range || this.selector.getSelection();
        if (selection && selection.length > 0) {
            let finalDelta = new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())();
            for (let index = selection.length - 1; index >= 0; index--) {
                const range = selection[index];
                const diff = this.doc.delete([range], forward);
                finalDelta = finalDelta.compose(diff);
            }
            if (finalDelta.ops.length > 0) {
                this.pushDelta(finalDelta);
                const newPos = (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_3__.transformDocPos)(selection[0].start, finalDelta);
                this.selector.setSelection([{ start: newPos, end: newPos }], _SelectionService__WEBPACK_IMPORTED_MODULE_5__.EnumSelectionSource.Input);
            }
            return finalDelta;
        }
    }
    startComposition(selection) {
        // 先删除所有选区内容
        const toDeleteRange = selection.filter((r) => (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_3__.compareDocPos)(r.start, r.end) !== 0);
        this.delete(true, toDeleteRange);
        const targetBlock = (0,_Common_util__WEBPACK_IMPORTED_MODULE_2__.findChildInDocPos)(selection[0].start.index, this.doc.children, true);
        if (targetBlock) {
            this.compositionStartOps = targetBlock.toOp(true);
            this.compositionStartPos = (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_3__.cloneDocPos)(selection[0].start);
            this.compositionEndPos = (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_3__.cloneDocPos)(selection[0].start);
        }
    }
    updateComposition(pos, content, attr) {
        if (this.compositionStartPos && pos) {
            if ((0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_3__.compareDocPos)(this.compositionStartPos, pos) !== 0) {
                this.doc.delete([
                    {
                        start: this.compositionStartPos,
                        end: pos,
                    },
                ]);
            }
            this.doc.insertText(content, this.compositionStartPos, Object.assign(Object.assign({}, attr), { composing: true }));
            this.compositionEndPos = (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_3__.moveDocPos)(this.compositionStartPos, content.length);
            this.selector.setSelection([
                {
                    start: (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_3__.cloneDocPos)(this.compositionEndPos),
                    end: (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_3__.cloneDocPos)(this.compositionEndPos),
                },
            ], _SelectionService__WEBPACK_IMPORTED_MODULE_5__.EnumSelectionSource.Input);
        }
    }
    endComposition(finalContent) {
        if (this.compositionStartPos && this.compositionEndPos) {
            this.doc.delete([
                {
                    start: this.compositionStartPos,
                    end: this.compositionEndPos,
                },
            ]);
            this.doc.insertText(finalContent, this.compositionStartPos);
            const targetBlock = (0,_Common_util__WEBPACK_IMPORTED_MODULE_2__.findChildInDocPos)(this.compositionStartPos.index, this.doc.children, true);
            if (targetBlock) {
                const diff = new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())(this.compositionStartOps).diff(new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())(targetBlock.toOp(true)));
                const res = new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())();
                if (targetBlock.start > 0) {
                    res.retain(targetBlock.start);
                }
                this.compositionStartOps = [];
                this.compositionStartPos = null;
                this.compositionEndPos = null;
                this.pushDelta(res.concat(diff));
            }
        }
    }
    format(attr, range) {
        const selection = range || this.selector.getSelection();
        if (selection) {
            const diff = this.doc.format(attr, selection);
            if (diff) {
                this.pushDelta(diff);
            }
        }
    }
    clearFormat(range) {
        const selection = range || this.selector.getSelection();
        if (selection) {
            const diff = this.doc.clearFormat(selection);
            if (diff) {
                this.pushDelta(diff);
            }
        }
    }
    getFormat(ranges) {
        return this.doc.getFormat(ranges);
    }
    /**
     * 添加链接
     */
    setLink(url, range) {
        const selection = range || this.selector.getSelection();
        if (selection) {
            selection.forEach((r) => {
                if ((0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_3__.compareDocPos)(r.start, r.end) === 0) {
                    // 如果没有选区就先插入一段文本
                    this.doc.insertText(url, r.start);
                }
                this.doc.format({ link: url }, [r]);
            });
        }
    }
    /**
     * 设置缩进
     * @param increase true:  增加缩进 false: 减少缩进
     */
    setIndent(increase, range) {
        const selection = range || this.selector.getSelection();
        selection.forEach((r) => {
            const startBlock = (0,_Common_util__WEBPACK_IMPORTED_MODULE_2__.findChildInDocPos)(r.start.index, this.doc.children, true);
            const endBlock = (0,_Common_util__WEBPACK_IMPORTED_MODULE_2__.findChildInDocPos)(r.start.index, this.doc.children, true);
            const blockCommons = [];
            let currentBlock = startBlock;
            while (currentBlock) {
                if (currentBlock instanceof _Block_BlockCommon__WEBPACK_IMPORTED_MODULE_4__.BlockCommon) {
                    blockCommons.push(currentBlock);
                }
                if (currentBlock === endBlock) {
                    break;
                }
                currentBlock = currentBlock.nextSibling;
            }
            if (blockCommons.length <= 0) {
                return new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())();
            }
            const oldOps = [];
            const newOps = [];
            for (let i = 0; i < blockCommons.length; i++) {
                const element = blockCommons[i];
                oldOps.push(...element.toOp(true));
                blockCommons[i].setIndent(increase);
                newOps.push(...element.toOp(true));
            }
            const diff = new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())(oldOps).diff(new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())(newOps));
            const res = new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())();
            if (blockCommons[0].start > 0) {
                res.retain(blockCommons[0].start);
            }
            this.pushDelta(res.concat(diff));
        });
    }
    insertFragment(frag, range) {
        let finalDelta;
        const selection = range || this.selector.getSelection();
        if (selection.length === 0) {
            return;
        }
        else if (selection.length > 1 || (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_3__.compareDocPos)(selection[0].start, selection[0].end) !== 0) {
            finalDelta = this.doc.delete(selection, true);
        }
        const insertPos = selection[0].start;
        finalDelta = finalDelta !== null && finalDelta !== void 0 ? finalDelta : new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())();
        const diff = this.doc.insertFragment(frag, insertPos);
        if (diff) {
            finalDelta = finalDelta.compose(diff);
        }
        this.pushDelta(finalDelta);
        this.selector.setSelection([{ start: insertPos, end: insertPos }], _SelectionService__WEBPACK_IMPORTED_MODULE_5__.EnumSelectionSource.Input);
    }
    insertBlock(block, range) {
        let finalDelta;
        const selection = range || this.selector.getSelection();
        if (selection.length === 0) {
            return;
        }
        else if (selection.length > 1 || (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_3__.compareDocPos)(selection[0].start, selection[0].end) !== 0) {
            finalDelta = this.doc.delete(selection, true);
        }
        const insertPos = selection[0].start;
        finalDelta = finalDelta !== null && finalDelta !== void 0 ? finalDelta : new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())();
        const diff = this.doc.insertBlock(block, insertPos);
        if (diff) {
            finalDelta = finalDelta.compose(diff);
        }
        this.pushDelta(finalDelta);
        this.selector.setSelection([{ start: insertPos, end: insertPos }], _SelectionService__WEBPACK_IMPORTED_MODULE_5__.EnumSelectionSource.Input);
    }
    applyChanges(delta) {
        const oldBlocks = [];
        const newBlocks = [];
        let currentIndex = 0;
        let lastOpPos = 0;
        let currentBat = { startIndex: 0, endIndex: 0, ops: [] };
        for (let index = 0; index < delta.ops.length; index++) {
            const op = delta.ops[index];
            if (op.retain !== undefined) {
                if (typeof op.retain === 'number') {
                    if (op.attributes === undefined) {
                        currentIndex += op.retain;
                        const newCurrentBlockIndex = (0,_Common_util__WEBPACK_IMPORTED_MODULE_2__.findChildIndexInDocPos)(currentIndex, this.doc.children);
                        if (newCurrentBlockIndex !== currentBat.endIndex) {
                            const { oldBlocks: oldB, newBlocks: newB } = this.applyBat(currentBat);
                            oldBlocks.push(...oldB);
                            newBlocks.push(...newB);
                            const baseOps = [];
                            if (currentIndex - this.doc.children[newCurrentBlockIndex].start) {
                                baseOps.push({ retain: currentIndex - this.doc.children[newCurrentBlockIndex].start });
                            }
                            lastOpPos = currentIndex;
                            currentBat = { startIndex: newCurrentBlockIndex, endIndex: newCurrentBlockIndex, ops: baseOps };
                        }
                    }
                    else {
                        if (currentIndex - lastOpPos > 0) {
                            currentBat.ops.push({ retain: currentIndex - lastOpPos });
                        }
                        currentBat.ops.push(op);
                        currentIndex += op.retain;
                        lastOpPos = currentIndex;
                        currentBat.endIndex = (0,_Common_util__WEBPACK_IMPORTED_MODULE_2__.findChildIndexInDocPos)(currentIndex, this.doc.children);
                    }
                }
                else {
                    if (currentIndex - lastOpPos > 0) {
                        currentBat.ops.push({ retain: currentIndex - lastOpPos });
                    }
                    currentBat.ops.push(op);
                    currentIndex += 1;
                    lastOpPos = currentIndex;
                    currentBat.endIndex = (0,_Common_util__WEBPACK_IMPORTED_MODULE_2__.findChildIndexInDocPos)(currentIndex, this.doc.children);
                }
            }
            else if (op.insert !== undefined) {
                if (currentIndex - lastOpPos > 0) {
                    currentBat.ops.push({ retain: currentIndex - lastOpPos });
                }
                currentBat.ops.push(op);
                lastOpPos = currentIndex;
            }
            else if (op.delete !== undefined) {
                if (currentIndex - lastOpPos > 0) {
                    currentBat.ops.push({ retain: currentIndex - lastOpPos });
                }
                currentBat.ops.push(op);
                currentIndex += op.delete;
                lastOpPos = currentIndex;
                currentBat.endIndex = (0,_Common_util__WEBPACK_IMPORTED_MODULE_2__.findChildIndexInDocPos)(currentIndex, this.doc.children);
            }
        }
        // 循环完了之后把 currentBat 里面没处理的都处理掉
        if (currentBat.ops.length > 0) {
            const { oldBlocks: oldB, newBlocks: newB } = this.applyBat(currentBat);
            oldBlocks.push(...oldB);
            newBlocks.push(...newB);
        }
        this.emit(ContentServiceEventNames.AFTER_APPLY, { oldBlocks, newBlocks });
        // 最后触发重绘
        this.doc.em.emit(_Document_Document__WEBPACK_IMPORTED_MODULE_1__.DocumentEvent.DOCUMENT_CHANGE_CONTENT);
    }
    getBlocksInRange(range) {
        const startBlock = (0,_Common_util__WEBPACK_IMPORTED_MODULE_2__.findChildInDocPos)(range.start.index, this.doc.children, true);
        const endBlock = (0,_Common_util__WEBPACK_IMPORTED_MODULE_2__.findChildInDocPos)(range.end.index, this.doc.children, true);
        const blocks = [];
        let currentBlock = startBlock;
        while (currentBlock) {
            blocks.push(currentBlock);
            if (currentBlock === endBlock) {
                break;
            }
            currentBlock = currentBlock.nextSibling;
        }
        return blocks;
    }
    pushDelta(diff) {
        if (diff.ops.length > 0) {
            this.stack.pushDiff(diff);
        }
    }
    // 记录当前的 block
    // 如果是 retain 数字，看当前 block 是否发生变化，没有变化就继续，有变化就处理前一批
    // 如果是 retain delta，追加操作到当前批
    // 如果是 insert，追加操作到当前批
    // 如果是 delete, 追加操作到当前批且更新当前 block
    applyBat(data) {
        var _a, _b;
        if (data.ops.length === 0) {
            return {
                oldBlocks: [],
                newBlocks: [],
            };
        }
        const affectedListId = new Set();
        const oldBlocks = this.doc.children.slice(data.startIndex, data.endIndex + 1);
        const oldOps = [];
        // 看一下有没有 list item，有的话要记录一下
        for (let i = 0; i < oldBlocks.length; i++) {
            const oldBlock = oldBlocks[i];
            if (oldBlock instanceof _Block_ListItem__WEBPACK_IMPORTED_MODULE_6__.ListItem) {
                affectedListId.add(oldBlock.attributes.listId);
            }
            oldOps.push(...oldBlock.toOp(false));
        }
        const opDelta = new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())(data.ops);
        const newOps = new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())(oldOps).compose(opDelta).ops;
        // 去掉最前面的 retain 操作
        while (newOps.length > 0 && typeof newOps[0].retain === 'number') {
            newOps.shift();
        }
        const newBlocks = this.doc.readDeltaToBlocks(new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())(newOps));
        // 看一下新 block 有没有 list item，有的话要记录一下
        for (let i = 0; i < newBlocks.length; i++) {
            const newBlock = newBlocks[i];
            if (newBlock instanceof _Block_ListItem__WEBPACK_IMPORTED_MODULE_6__.ListItem) {
                affectedListId.add(newBlock.attributes.listId);
            }
        }
        // 替换
        this.doc.splice(data.startIndex, data.endIndex + 1 - data.startIndex, newBlocks);
        // 尝试合并 block
        const mergeStart = (_a = newBlocks[0].prevSibling) !== null && _a !== void 0 ? _a : newBlocks[0];
        const mergeEnd = (_b = newBlocks[newBlocks.length - 1].nextSibling) !== null && _b !== void 0 ? _b : newBlocks[newBlocks.length - 1];
        this.doc.tryMerge(mergeStart, mergeEnd);
        // 设置 start 和 y 坐标
        newBlocks[0].setStart(oldBlocks[0].start, true, true, true);
        newBlocks[0].setPositionY(oldBlocks[0].y, false, true);
        // 还要对选区进行 transform
        this.selector.applyChanges(opDelta);
        return {
            oldBlocks,
            newBlocks,
        };
    }
}


/***/ }),

/***/ "./src/Service/HistoryStackService.ts":
/*!********************************************!*\
  !*** ./src/Service/HistoryStackService.ts ***!
  \********************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HistoryStackService": function() { return /* binding */ HistoryStackService; },
/* harmony export */   "HistoryStackServiceEvent": function() { return /* binding */ HistoryStackServiceEvent; }
/* harmony export */ });
/* harmony import */ var quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! quill-delta-enhanced */ "quill-delta-enhanced");
/* harmony import */ var quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Service */ "./src/Service/Service.ts");


var HistoryStackServiceEvent;
(function (HistoryStackServiceEvent) {
    HistoryStackServiceEvent["HISTORY_STACK_CHANGE"] = "HISTORY_STACK_CHANGE";
})(HistoryStackServiceEvent || (HistoryStackServiceEvent = {}));
class HistoryStackService extends _Service__WEBPACK_IMPORTED_MODULE_1__.Service {
    constructor() {
        super(...arguments);
        this.canRedo = false;
        this.canUndo = false;
        this.delta = null;
        this.currentIndex = -1;
        this.stack = [];
        this.compositing = false;
        this.compositionStack = [];
    }
    reset() {
        this.canRedo = false;
        this.canUndo = false;
        this.delta = null;
        this.currentIndex = -1;
        this.stack.length = 0;
        this.compositing = false;
        this.compositionStack.length = 0;
    }
    setInitDelta(delta) {
        this.delta = delta;
    }
    pushDiff(diff) {
        if (this.delta && diff && diff.ops.length > 0) {
            const command = {
                redo: diff,
                undo: diff.invert(this.delta),
            };
            if (this.compositing) {
                this.compositionStack.push(command);
            }
            else {
                this.stack.splice(this.currentIndex + 1);
                this.stack.push(command);
                this.currentIndex = this.stack.length - 1;
                this.setRedoUndoStatus();
                this.delta = this.delta.compose(diff);
            }
        }
    }
    startComposition() {
        this.compositing = true;
    }
    endComposition() {
        this.compositing = false;
        if (this.delta && this.compositionStack.length > 0) {
            let redo = new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())();
            let undo = new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())();
            this.compositionStack.forEach((item) => {
                redo = redo.compose(item.redo);
                undo = undo.compose(item.undo);
            });
            this.compositionStack.length = 0;
            this.stack.splice(this.currentIndex + 1);
            this.stack.push({ redo, undo });
            this.currentIndex = this.stack.length - 1;
            this.setRedoUndoStatus();
            this.delta = this.delta.compose(redo);
        }
    }
    /**
     * 获取重做下一步操作的 delta
     */
    redo() {
        const redoItem = this.stack[this.currentIndex + 1];
        let delta;
        if (redoItem) {
            this.currentIndex++;
            delta = redoItem.redo;
        }
        else {
            delta = null;
        }
        this.setRedoUndoStatus();
        return delta;
    }
    /**
     * 获取撤销上一步操作的 delta
     */
    undo() {
        const undoItem = this.stack[this.currentIndex];
        let delta;
        if (undoItem) {
            this.currentIndex--;
            delta = undoItem.undo;
        }
        else {
            delta = null;
        }
        this.setRedoUndoStatus();
        return delta;
    }
    /**
     * 根据远端的 change 来 rebase stack 中所有操作
     * @param change 远端的 change
     */
    rebase(change) {
        for (let index = 0; index < this.stack.length; index++) {
            const command = this.stack[index];
            command.redo = change.transform(command.redo);
            command.undo = change.transform(command.undo);
        }
    }
    /**
     * 获取 redo undo 状态
     */
    setRedoUndoStatus() {
        const newRedo = !!this.stack[this.currentIndex + 1];
        const newUndo = !!this.stack[this.currentIndex];
        if (newRedo !== this.canRedo) {
            this.canRedo = newRedo;
        }
        if (newUndo !== this.canUndo) {
            this.canUndo = newUndo;
        }
        this.emit(HistoryStackServiceEvent.HISTORY_STACK_CHANGE, {
            canRedo: newRedo,
            canUndo: newUndo,
            stackDepth: this.stack.length,
            current: this.currentIndex,
        });
    }
}


/***/ }),

/***/ "./src/Service/ListService.ts":
/*!************************************!*\
  !*** ./src/Service/ListService.ts ***!
  \************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ListService": function() { return /* binding */ ListService; }
/* harmony export */ });
/* harmony import */ var quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! quill-delta-enhanced */ "quill-delta-enhanced");
/* harmony import */ var quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Common_EnumBubbleMessage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Common/EnumBubbleMessage */ "./src/Common/EnumBubbleMessage.ts");
/* harmony import */ var _Common_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Common/util */ "./src/Common/util.ts");
/* harmony import */ var _Common_EnumListStyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Common/EnumListStyle */ "./src/Common/EnumListStyle.ts");
/* harmony import */ var _Block_ListItem__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Block/ListItem */ "./src/Block/ListItem.ts");
/* harmony import */ var _ContentService__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./ContentService */ "./src/Service/ContentService.ts");
/* harmony import */ var _Service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./Service */ "./src/Service/Service.ts");







class ListService extends _Service__WEBPACK_IMPORTED_MODULE_6__.Service {
    constructor(doc, stack, contentService) {
        super(doc);
        this.stack = stack;
        this.contentService = contentService;
        this.contentService.on(_ContentService__WEBPACK_IMPORTED_MODULE_5__.ContentServiceEventNames.AFTER_APPLY, this.onDocContentAfterApply.bind(this));
        this.doc.em.on(_Common_EnumBubbleMessage__WEBPACK_IMPORTED_MODULE_1__.BubbleMessage.NEED_LAYOUT_LISTITEM, this.onNeedLayoutListitem.bind(this));
    }
    /**
     * 设置列表
     */
    setList(listType, range) {
        const targetRange = range;
        const affectedListId = new Set();
        let finalDelta = new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())();
        targetRange.forEach((r) => {
            const blocks = this.contentService.getBlocksInRange(r);
            if (blocks.length <= 0) {
                return new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())();
            }
            let startIndex = 0;
            let startPositionY = 0;
            if (blocks[0].prevSibling) {
                startIndex = blocks[0].prevSibling.start + blocks[0].prevSibling.length;
                startPositionY = blocks[0].prevSibling.y + blocks[0].prevSibling.height;
            }
            let startListItem;
            const newListId = (0,_Common_util__WEBPACK_IMPORTED_MODULE_2__.increaseId)();
            const oldOps = [];
            for (let blockIndex = 0; blockIndex < blocks.length; blockIndex++) {
                const block = blocks[blockIndex];
                oldOps.push(...block.toOp(true));
                if (block instanceof _Block_ListItem__WEBPACK_IMPORTED_MODULE_4__.ListItem) {
                    // 如果本身就是 listitem 就直接改 listType，并且统一 listId
                    affectedListId.add(block.attributes.listId);
                    block.format({
                        listType,
                        listId: newListId,
                    });
                    block.needLayout = true;
                    if (blockIndex === 0) {
                        startListItem = block;
                    }
                }
                else {
                    // 如果本身不是 listitem，就把他的每一个 frame 拆出来构建一个 listitem
                    const frames = block.getAllLayoutFrames();
                    for (let frameIndex = 0; frameIndex < frames.length; frameIndex++) {
                        const frame = frames[frameIndex];
                        const listItemOriginAttributes = {};
                        switch (listType) {
                            case _Common_EnumListStyle__WEBPACK_IMPORTED_MODULE_3__.EnumListType.ol1:
                                listItemOriginAttributes['list-type'] = 'decimal';
                            // fall through
                            case _Common_EnumListStyle__WEBPACK_IMPORTED_MODULE_3__.EnumListType.ol2:
                                listItemOriginAttributes['list-type'] = 'ckj-decimal';
                            // fall through
                            case _Common_EnumListStyle__WEBPACK_IMPORTED_MODULE_3__.EnumListType.ol3:
                                listItemOriginAttributes['list-type'] = 'upper-decimal';
                                listItemOriginAttributes.listId = newListId;
                                break;
                            case _Common_EnumListStyle__WEBPACK_IMPORTED_MODULE_3__.EnumListType.ul1:
                                listItemOriginAttributes['list-type'] = 'decimal';
                            // fall through
                            case _Common_EnumListStyle__WEBPACK_IMPORTED_MODULE_3__.EnumListType.ul2:
                                listItemOriginAttributes['list-type'] = 'ring';
                            // fall through
                            case _Common_EnumListStyle__WEBPACK_IMPORTED_MODULE_3__.EnumListType.ul3:
                                listItemOriginAttributes['list-type'] = 'arrow';
                                listItemOriginAttributes.listId = newListId;
                                break;
                            default:
                                listItemOriginAttributes['list-type'] = 'decimal';
                                listItemOriginAttributes.listId = newListId;
                                break;
                        }
                        const newListItem = new _Block_ListItem__WEBPACK_IMPORTED_MODULE_4__.ListItem();
                        newListItem.addAll([frame]);
                        newListItem.setAttributes(listItemOriginAttributes);
                        this.doc.addBefore(newListItem, block);
                        if (blockIndex === 0 && frameIndex === 0) {
                            startListItem = newListItem;
                        }
                    }
                    this.doc.remove(block);
                }
            }
            startListItem.setStart(startIndex, true, true, true);
            startListItem.setPositionY(startPositionY, false, true);
            const newBlocks = this.contentService.getBlocksInRange(r);
            const newOps = this.doc.getBlocksOps(newBlocks);
            const diff = new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())(oldOps).diff(new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())(newOps));
            const res = new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())();
            if (startListItem.start > 0) {
                res.retain(startListItem.start);
            }
            finalDelta = finalDelta.compose(res.concat(diff));
        });
        if (finalDelta.ops.length > 0) {
            this.stack.pushDiff(finalDelta);
        }
    }
    /**
     * 将指定 list id 的 listitem 标记为需要排版
     * @param listIds list id
     */
    markListItemToLayout(listIds) {
        if (listIds.size > 0) {
            for (let blockIndex = 0; blockIndex < this.doc.children.length; blockIndex++) {
                const element = this.doc.children[blockIndex];
                if (element instanceof _Block_ListItem__WEBPACK_IMPORTED_MODULE_4__.ListItem && listIds.has(element.attributes.listId)) {
                    element.needLayout = true;
                }
            }
        }
    }
    onNeedLayoutListitem(listId) {
        const ids = new Set();
        ids.add(listId);
        this.markListItemToLayout(ids);
    }
    onDocContentAfterApply(data) {
        const affectedListId = new Set();
        for (let index = 0; index < data.oldBlocks.length; index++) {
            const block = data.oldBlocks[index];
            if (block instanceof _Block_ListItem__WEBPACK_IMPORTED_MODULE_4__.ListItem) {
                affectedListId.add(block.attributes.listId);
            }
        }
        for (let index = 0; index < data.newBlocks.length; index++) {
            const block = data.newBlocks[index];
            if (block instanceof _Block_ListItem__WEBPACK_IMPORTED_MODULE_4__.ListItem) {
                affectedListId.add(block.attributes.listId);
            }
        }
        this.markListItemToLayout(affectedListId);
    }
}


/***/ }),

/***/ "./src/Service/ParagraphService.ts":
/*!*****************************************!*\
  !*** ./src/Service/ParagraphService.ts ***!
  \*****************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ParagraphService": function() { return /* binding */ ParagraphService; }
/* harmony export */ });
/* harmony import */ var quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! quill-delta-enhanced */ "quill-delta-enhanced");
/* harmony import */ var quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Block_Paragraph__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Block/Paragraph */ "./src/Block/Paragraph.ts");
/* harmony import */ var _Service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Service */ "./src/Service/Service.ts");



class ParagraphService extends _Service__WEBPACK_IMPORTED_MODULE_2__.Service {
    constructor(doc, stack, contentService) {
        super(doc);
        this.stack = stack;
        this.contentService = contentService;
    }
    /**
     * 设置普通段落
     */
    setParagraph(range) {
        let finalDelta = new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())();
        range.forEach((r) => {
            const blocks = this.contentService.getBlocksInRange(r);
            if (blocks.length <= 0) {
                return;
            }
            let startIndex = 0;
            let startPositionY = 0;
            if (blocks[0].prevSibling) {
                startIndex = blocks[0].prevSibling.start + blocks[0].prevSibling.length;
                startPositionY = blocks[0].prevSibling.y + blocks[0].prevSibling.height;
            }
            let startParagraph = null;
            let lastParagraph = null;
            const oldOps = [];
            for (let blocksIndex = 0; blocksIndex < blocks.length; blocksIndex++) {
                oldOps.push(...blocks[blocksIndex].toOp(true));
                const frames = blocks[blocksIndex].getAllLayoutFrames();
                for (let framesIndex = 0; framesIndex < frames.length; framesIndex++) {
                    const frame = frames[framesIndex];
                    const newParagraph = new _Block_Paragraph__WEBPACK_IMPORTED_MODULE_1__.Paragraph();
                    newParagraph.addLast(frame);
                    this.doc.addBefore(newParagraph, blocks[blocksIndex]);
                    lastParagraph = newParagraph;
                    if (blocksIndex === 0 && framesIndex === 0) {
                        startParagraph = newParagraph;
                    }
                }
                this.doc.remove(blocks[blocksIndex]);
            }
            if (startParagraph && lastParagraph) {
                startParagraph.setStart(startIndex, true, true, true);
                startParagraph.setPositionY(startPositionY, false, true);
                const newBlocks = this.contentService.getBlocksInRange(r);
                const newOps = this.doc.getBlocksOps(newBlocks);
                const diff = new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())(oldOps).diff(new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())(newOps));
                const res = new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())();
                if (newBlocks[0].start > 0) {
                    res.retain(newBlocks[0].start);
                }
                const resDelta = res.concat(diff);
                finalDelta = finalDelta.compose(resDelta);
            }
        });
        if (finalDelta.ops.length > 0) {
            this.stack.pushDiff(finalDelta);
        }
    }
}


/***/ }),

/***/ "./src/Service/QuoteBlockService.ts":
/*!******************************************!*\
  !*** ./src/Service/QuoteBlockService.ts ***!
  \******************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QuoteBlockService": function() { return /* binding */ QuoteBlockService; }
/* harmony export */ });
/* harmony import */ var quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! quill-delta-enhanced */ "quill-delta-enhanced");
/* harmony import */ var quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Block_QuoteBlock__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Block/QuoteBlock */ "./src/Block/QuoteBlock.ts");
/* harmony import */ var _Service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Service */ "./src/Service/Service.ts");



class QuoteBlockService extends _Service__WEBPACK_IMPORTED_MODULE_2__.Service {
    constructor(doc, stack, contentService, paragraphService) {
        super(doc);
        this.stack = stack;
        this.contentService = contentService;
        this.paragraphService = paragraphService;
    }
    /**
     * 设置引用块
     */
    setQuoteBlock(range) {
        let diffDelta = new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())();
        range.forEach((r) => {
            const blocks = this.contentService.getBlocksInRange(r);
            const quoteBlocks = blocks.filter((blk) => blk instanceof _Block_QuoteBlock__WEBPACK_IMPORTED_MODULE_1__.QuoteBlock);
            if (quoteBlocks.length === blocks.length) {
                // 如果所有的 block 都是 quoteblock 就取消所有的 quoteblock
                this.paragraphService.setParagraph(range);
            }
            else {
                const oldOps = [];
                // 如果存在不是 quoteblock 的 block，就把他设置成 quoteblock，注意这里可能还需要合并前后的 quoteblock
                let startQuoteBlock;
                if (blocks[0].prevSibling instanceof _Block_QuoteBlock__WEBPACK_IMPORTED_MODULE_1__.QuoteBlock) {
                    startQuoteBlock = blocks[0].prevSibling;
                    oldOps.push(...startQuoteBlock.toOp(true));
                }
                else {
                    startQuoteBlock = new _Block_QuoteBlock__WEBPACK_IMPORTED_MODULE_1__.QuoteBlock();
                    this.doc.addBefore(startQuoteBlock, blocks[0]);
                }
                for (let blocksIndex = 0; blocksIndex < blocks.length; blocksIndex++) {
                    const element = blocks[blocksIndex];
                    oldOps.push(...element.toOp(true));
                    const frames = element.getAllLayoutFrames();
                    if (frames.length) {
                        startQuoteBlock.addAll(frames);
                        this.doc.remove(element);
                    }
                }
                if (startQuoteBlock.nextSibling instanceof _Block_QuoteBlock__WEBPACK_IMPORTED_MODULE_1__.QuoteBlock) {
                    oldOps.push(...startQuoteBlock.nextSibling.toOp(true));
                    const frames = startQuoteBlock.nextSibling.removeAll();
                    startQuoteBlock.addAll(frames);
                    this.doc.remove(startQuoteBlock.nextSibling);
                }
                startQuoteBlock.needLayout = true;
                let startIndex = 0;
                let startPositionY = 0;
                if (startQuoteBlock.prevSibling) {
                    startIndex = startQuoteBlock.prevSibling.start + startQuoteBlock.prevSibling.length;
                    startPositionY = startQuoteBlock.prevSibling.y + startQuoteBlock.prevSibling.height;
                }
                startQuoteBlock.setStart(startIndex, true, true, true);
                startQuoteBlock.setPositionY(startPositionY, false, true);
                const diff = new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())(oldOps).diff(new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())(startQuoteBlock.toOp(true)));
                const res = new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())();
                if (startQuoteBlock.start > 0) {
                    res.retain(startQuoteBlock.start);
                }
                diffDelta = diffDelta.compose(res.concat(diff));
            }
        });
        if (diffDelta === null || diffDelta === void 0 ? void 0 : diffDelta.ops.length) {
            this.stack.pushDiff(diffDelta);
        }
    }
}


/***/ }),

/***/ "./src/Service/SearchService.ts":
/*!**************************************!*\
  !*** ./src/Service/SearchService.ts ***!
  \**************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SearchService": function() { return /* binding */ SearchService; },
/* harmony export */   "SearchServiceEvent": function() { return /* binding */ SearchServiceEvent; }
/* harmony export */ });
/* harmony import */ var _Document_Document__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Document/Document */ "./src/Document/Document.ts");
/* harmony import */ var quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! quill-delta-enhanced */ "quill-delta-enhanced");
/* harmony import */ var quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Service */ "./src/Service/Service.ts");
// 搜索结果会经常因为一些外部事件而变化，已知有以下事件会导致搜索结果的自动变化
// 手动触发搜索，手动 replace，文档内容被当前用户修改，文档完成 layout 或文档完成 idleLayout



var SearchServiceEvent;
(function (SearchServiceEvent) {
    SearchServiceEvent["SEARCH_NEED_DRAW"] = "SEARCH_NEED_DRAW";
    SearchServiceEvent["SEARCH_RESULT_CHANGE"] = "SEARCH_RESULT_CHANGE";
})(SearchServiceEvent || (SearchServiceEvent = {}));
class SearchService extends _Service__WEBPACK_IMPORTED_MODULE_2__.Service {
    constructor(doc) {
        super(doc);
        this.searchKeywords = '';
        this.searchResults = [];
        this.searchResultCurrentIndex = undefined;
        this.onDocumentLayout = ({ hasLayout, ctx, scrollTop, viewHeight, }) => {
            // 如果当前处于搜索状态，就判断文档内容重新排版过就重新搜索，否则只重绘搜索结果
            if (this.searchKeywords.length > 0) {
                if (hasLayout) {
                    // 如果有内容排版过，就立刻重新搜索一次，这样本次绘制的就是最新的正确内容
                    // 这里如果放到下一帧再绘制搜索结果，搜索结果会闪烁，用户体验不好
                    this.search(this.searchKeywords, true);
                }
                if (this.searchResults.length > 0) {
                    this.draw(ctx, scrollTop, viewHeight);
                }
            }
        };
        this.onDocumentIdleLayout = ({ hasLayout }) => {
            // idle layout
            // 如果当前处于搜索状态，就判断文档内容重新排版过就重新搜索，否则只重绘搜索结果
            if (this.searchKeywords.length > 0 && hasLayout) {
                // 这里重新搜索但不触发绘制逻辑，因为这里是可视区域外的内容，暂时不用绘制
                this.search(this.searchKeywords, true);
            }
        };
        this.onDocumentFastDraw = ({ ctx, scrollTop, viewHeight, }) => {
            // fast draw
            // 如果当前处于搜索状态，就判断文档内容重新排版过就重新搜索，否则只重绘搜索结果
            if (this.searchKeywords.length > 0 && this.searchResults.length > 0) {
                this.draw(ctx, scrollTop, viewHeight);
            }
        };
        this.doc.em.addListener(_Document_Document__WEBPACK_IMPORTED_MODULE_0__.DocumentEvent.DOCUMENT_AFTER_LAYOUT, this.onDocumentLayout);
        this.doc.em.addListener(_Document_Document__WEBPACK_IMPORTED_MODULE_0__.DocumentEvent.DOCUMENT_AFTER_IDLE_LAYOUT, this.onDocumentIdleLayout);
        this.doc.em.addListener(_Document_Document__WEBPACK_IMPORTED_MODULE_0__.DocumentEvent.DOCUMENT_AFTER_DRAW, this.onDocumentFastDraw);
    }
    reset() {
        this.searchKeywords = '';
        this.searchResults.length = 0;
        this.searchResultCurrentIndex = undefined;
    }
    getSearchResult() {
        return this.searchResults;
    }
    search(keywords, keepIndex = false) {
        var _a;
        this.searchKeywords = keywords;
        this.searchResults = this.doc.search(keywords);
        if (this.searchResults.length > 0) {
            if (keepIndex) {
                const oldIndex = (_a = this.searchResultCurrentIndex) !== null && _a !== void 0 ? _a : 0;
                this.searchResultCurrentIndex = Math.min(oldIndex, this.searchResults.length - 1);
            }
            else {
                this.searchResultCurrentIndex = 0;
            }
        }
        else {
            this.searchResultCurrentIndex = undefined;
        }
        this.emit(SearchServiceEvent.SEARCH_RESULT_CHANGE, this.searchResults, this.searchResultCurrentIndex);
        return this.searchResults;
    }
    /**
     * 指定当前搜索结果的索引（在搜索结果中点击‘上一项’、‘下一项’的时候用）
     */
    setSearchResultCurrentIndex(index) {
        this.searchResultCurrentIndex = Math.max(0, index);
        this.searchResultCurrentIndex = Math.min(this.searchResults.length - 1, this.searchResultCurrentIndex);
    }
    /**
     * 清除搜索状态
     */
    clearSearch() {
        this.searchResults.length = 0;
        this.searchKeywords = '';
        this.searchResultCurrentIndex = undefined;
        this.emit(SearchServiceEvent.SEARCH_RESULT_CHANGE, this.searchResults, this.searchResultCurrentIndex);
    }
    nextSearchResult() {
        let res = null;
        if (this.searchResults.length > 0) {
            this.searchResultCurrentIndex = this.searchResultCurrentIndex || 0;
            let newIndex = this.searchResultCurrentIndex + 1;
            if (newIndex >= this.searchResults.length) {
                newIndex = 0;
            }
            this.setSearchResultCurrentIndex(newIndex);
            const targetResult = this.searchResults[newIndex];
            res = {
                index: newIndex,
                res: targetResult,
            };
        }
        else {
            res = null;
        }
        this.emit(SearchServiceEvent.SEARCH_RESULT_CHANGE, this.searchResults, this.searchResultCurrentIndex);
        this.emit(SearchServiceEvent.SEARCH_NEED_DRAW);
        return res;
    }
    prevSearchResult() {
        let res = null;
        if (this.searchResults.length > 0) {
            this.searchResultCurrentIndex = this.searchResultCurrentIndex || 0;
            let newIndex = this.searchResultCurrentIndex - 1;
            if (newIndex < 0) {
                newIndex = this.searchResults.length - 1;
            }
            this.setSearchResultCurrentIndex(newIndex);
            const targetResult = this.searchResults[newIndex];
            res = {
                index: newIndex,
                res: targetResult,
            };
        }
        else {
            res = null;
        }
        this.emit(SearchServiceEvent.SEARCH_RESULT_CHANGE, this.searchResults, this.searchResultCurrentIndex);
        this.emit(SearchServiceEvent.SEARCH_NEED_DRAW);
        return res;
    }
    replace(replaceWords, all = false) {
        if (typeof this.searchResultCurrentIndex === 'number' && this.searchResults.length > 0) {
            const toReplaceResults = all ? this.searchResults : [this.searchResults[this.searchResultCurrentIndex]];
            const res = this.doc.replace(toReplaceResults, this.searchKeywords.length, replaceWords);
            // 替换之后要重新搜索
            this.search(this.searchKeywords, true);
            return res;
        }
        else {
            return new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_1___default())();
        }
    }
    draw(ctx, scrollTop, viewHeight) {
        const startIndex = this.findStartSearchResult(this.searchResults, scrollTop);
        ctx.drawSearchResult(this.searchResults, scrollTop, scrollTop + viewHeight, startIndex, this.searchResultCurrentIndex);
    }
    /**
     * 查找从第几个结果开始绘制搜索结果
     */
    findStartSearchResult(searchResults, scrollTop) {
        let low = 0;
        let high = searchResults.length - 1;
        let mid = Math.floor((low + high) / 2);
        while (high > low + 1) {
            const midValue = searchResults[mid].rects[0].y;
            if (midValue <= scrollTop) {
                low = mid;
            }
            else if (midValue > scrollTop) {
                high = mid;
            }
            mid = Math.floor((low + high) / 2);
        }
        for (; mid >= 0; mid--) {
            if (searchResults[mid].rects[0].y + searchResults[mid].rects[0].height < scrollTop) {
                break;
            }
        }
        mid = Math.max(mid, 0);
        return mid;
    }
}


/***/ }),

/***/ "./src/Service/SelectionService.ts":
/*!*****************************************!*\
  !*** ./src/Service/SelectionService.ts ***!
  \*****************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EnumSelectionSource": function() { return /* binding */ EnumSelectionSource; },
/* harmony export */   "SelectionService": function() { return /* binding */ SelectionService; },
/* harmony export */   "SelectionServiceEvent": function() { return /* binding */ SelectionServiceEvent; }
/* harmony export */ });
/* harmony import */ var binary_search_bounds__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! binary-search-bounds */ "binary-search-bounds");
/* harmony import */ var binary_search_bounds__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(binary_search_bounds__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Document_Document__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Document/Document */ "./src/Document/Document.ts");
/* harmony import */ var _Common_DocPos__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Common/DocPos */ "./src/Common/DocPos.ts");
/* harmony import */ var _Common_util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Common/util */ "./src/Common/util.ts");
/* harmony import */ var _Service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./Service */ "./src/Service/Service.ts");





var SelectionServiceEvent;
(function (SelectionServiceEvent) {
    SelectionServiceEvent["CHANGE_SELECTION"] = "CHANGE_SELECTION";
})(SelectionServiceEvent || (SelectionServiceEvent = {}));
var EnumSelectionSource;
(function (EnumSelectionSource) {
    EnumSelectionSource[EnumSelectionSource["Empty"] = 0] = "Empty";
    EnumSelectionSource[EnumSelectionSource["Mouse"] = 1] = "Mouse";
    EnumSelectionSource[EnumSelectionSource["Keyboard"] = 2] = "Keyboard";
    EnumSelectionSource[EnumSelectionSource["Input"] = 3] = "Input";
})(EnumSelectionSource || (EnumSelectionSource = {}));
class SelectionService extends _Service__WEBPACK_IMPORTED_MODULE_4__.Service {
    constructor(doc) {
        super(doc);
        this.selection = [];
        this.lastSelection = [];
        this.selectionSource = EnumSelectionSource.Empty;
        this.mouseSelecting = false; // 用鼠标创建选区的过程中
        this.keyboardSelecting = false; // 用键盘操作创建选区的过程中
        this.selectionStartTemp = null;
        this.selectionEndTemp = null;
        this.selectionStart = null;
        this.selectionEnd = null;
        // 记录用户通过交互（键盘、鼠标）建立时，选区的开始结束位置的坐标信息
        this.selectionStartPos = null;
        this.selectionEndPos = null;
        this.selectionStartPosTemp = null;
        this.selectionEndPosTemp = null;
        this.keyboardSelectStartPos = null;
        // 光标模式比较特殊，不能简单通过 calSelectionRectangle 计算，所以单独记录
        this.cursorPos = null;
        this.keyboardVerticalMoveXPos = null;
        this.onDocumentLayout = ({ ctx, scrollTop, viewHeight, }) => {
            if (this.isCursorStatus()) {
                // 需要更新光标状态
                const cursorPos = this.calSelectionRectangles(this.selection);
                this.setCursorPos(cursorPos[0]);
            }
            else {
                this.draw(ctx, scrollTop, viewHeight);
            }
        };
        this.onDocumentFastDraw = ({ ctx, scrollTop, viewHeight, }) => {
            if (!this.isCursorStatus()) {
                this.draw(ctx, scrollTop, viewHeight);
            }
        };
        this.doc.em.addListener(_Document_Document__WEBPACK_IMPORTED_MODULE_1__.DocumentEvent.DOCUMENT_AFTER_LAYOUT, this.onDocumentLayout);
        this.doc.em.addListener(_Document_Document__WEBPACK_IMPORTED_MODULE_1__.DocumentEvent.DOCUMENT_AFTER_DRAW, this.onDocumentFastDraw);
    }
    reset() {
        this.selection = [];
        this.lastSelection = [];
        this.selectionSource = EnumSelectionSource.Empty;
        this.mouseSelecting = false; // 用鼠标创建选区的过程中
        this.keyboardSelecting = false; // 用键盘操作创建选区的过程中
        this.selectionStartTemp = null;
        this.selectionEndTemp = null;
        this.selectionStart = null;
        this.selectionEnd = null;
        // 记录用户通过交互（键盘、鼠标）建立时，选区的开始结束位置的坐标信息
        this.selectionStartPos = null;
        this.selectionEndPos = null;
        this.selectionStartPosTemp = null;
        this.selectionEndPosTemp = null;
        this.keyboardSelectStartPos = null;
        // 光标模式比较特殊，不能简单通过 calSelectionRectangle 计算，所以单独记录
        this.cursorPos = null;
        this.keyboardVerticalMoveXPos = null;
    }
    getSelection() {
        return this.selection;
    }
    setSelection(ranges, source) {
        this.changeSelectionSource(ranges.length > 0 ? source !== null && source !== void 0 ? source : this.selectionSource : EnumSelectionSource.Empty);
        this.selection = ranges;
        this.lastSelection = ranges;
        this.emit(SelectionServiceEvent.CHANGE_SELECTION, this.selection);
    }
    clearSelection() {
        this.selection = [];
        this.emit(SelectionServiceEvent.CHANGE_SELECTION, this.selection);
        return this.lastSelection;
    }
    /**
     * 恢复选区，一般用在编辑器建立选区后失焦然后又重新获得焦点时
     */
    restoreSelection() {
        this.setSelection(this.lastSelection);
    }
    changeSelectionSource(source) {
        this.selectionSource = source;
    }
    startMouseSelection(x, y) {
        const docPos = this.doc.getDocumentPos(x, y, true);
        if (docPos) {
            this.changeSelectionSource(EnumSelectionSource.Mouse);
            this.mouseSelecting = true;
            this.selectionStartTemp = docPos;
            this.selectionEndTemp = this.selectionStartTemp;
            this.selectionStartPosTemp = { x, y };
            this.keyboardVerticalMoveXPos = null;
        }
    }
    updateMouseSelection(x, y) {
        if (this.mouseSelecting) {
            this.changeSelectionSource(EnumSelectionSource.Mouse);
            this.selectionEndTemp = this.doc.getDocumentPos(x, y);
            this.selectionEndPosTemp = { x, y };
            this.orderSelectionPoint();
            const selection = this.calSelection();
            if (selection) {
                this.selectionEndPos = { x, y };
                this.setSelection(selection, EnumSelectionSource.Mouse);
                this.keyboardVerticalMoveXPos = null;
            }
        }
    }
    endMouseSelection(x, y) {
        if (this.mouseSelecting) {
            this.changeSelectionSource(EnumSelectionSource.Mouse);
            this.mouseSelecting = false;
            this.selectionEndTemp = this.doc.getDocumentPos(x, y);
            this.selectionEndPosTemp = { x, y };
            this.orderSelectionPoint();
            const selection = this.calSelection();
            if (selection) {
                this.selectionEndPos = { x, y };
                if (selection.length === 1 && (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_2__.compareDocPos)(selection[0].start, selection[0].end) === 0) {
                    // 说明是光标模式，要立刻计算光标的位置信息
                    const cursorPos = this.calSelectionRectangles(selection).filter((rect) => (0,_Common_util__WEBPACK_IMPORTED_MODULE_3__.hasIntersection)(rect.y, rect.y + rect.height, y, y));
                    if (cursorPos.length === 1) {
                        this.setCursorPos(cursorPos[0]);
                    }
                    else {
                        this.cursorPos = null;
                    }
                }
                else {
                    this.cursorPos = null;
                }
                this.setSelection(selection, EnumSelectionSource.Mouse);
                this.keyboardVerticalMoveXPos = null;
            }
        }
    }
    updateKeyboardSelection() { }
    getSelectionRectangles() {
        // 如果是光标模式要特殊处理
        if ((this.selectionSource === EnumSelectionSource.Keyboard || this.selectionSource === EnumSelectionSource.Mouse) &&
            this.isCursorStatus() &&
            this.cursorPos !== null) {
            return [this.cursorPos];
        }
        else {
            return this.calSelectionRectangles(this.selection);
        }
    }
    applyChanges(delta) {
        // 先把当前的选区转成 delta，然后 transform，再把处理好的 delta 转成选区
        if (this.selection.length > 0) {
            const newSelection = this.selection.map((range) => {
                const newPosStart = (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_2__.transformDocPos)(range.start, delta);
                const newPosEnd = (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_2__.transformDocPos)(range.end, delta);
                return {
                    start: newPosStart,
                    end: newPosEnd,
                };
            });
            this.setSelection(newSelection);
        }
    }
    cursorMoveUp() {
        var _a;
        if (this.selection.length > 0 && this.selectionStartPos) {
            this.startKeyboardSelection();
            const currentPos = this.selection[0].start;
            this.keyboardVerticalMoveXPos = this.keyboardVerticalMoveXPos || this.selectionStartPos.x;
            const newPos = (_a = this.doc.prevLinePos(currentPos, this.keyboardVerticalMoveXPos)) !== null && _a !== void 0 ? _a : currentPos;
            // 此时肯定是光标模式，所以需要更新 selectionStartPos 和 selectionEndPos
            const selection = { start: newPos, end: newPos };
            const rects = this.calSelectionRectangles([selection]);
            if (rects.length === 1) {
                this.setCursorPos(rects[0]);
                this.setSelection([selection], EnumSelectionSource.Keyboard);
            }
            else {
                let targetRect = null;
                for (let index = 0; index < rects.length; index++) {
                    const rect = rects[index];
                    if (!targetRect ||
                        Math.abs(targetRect.x - this.keyboardVerticalMoveXPos) > Math.abs(rect.x - this.keyboardVerticalMoveXPos)) {
                        targetRect = rect;
                    }
                }
                if (targetRect) {
                    this.setCursorPos(targetRect);
                    this.setSelection([selection], EnumSelectionSource.Keyboard);
                }
            }
        }
    }
    cursorMoveDown() {
        var _a;
        if (this.selection.length > 0 && this.selectionEndPos) {
            this.startKeyboardSelection();
            const currentPos = this.selection[0].end;
            this.keyboardVerticalMoveXPos = this.keyboardVerticalMoveXPos || this.selectionEndPos.x;
            const newPos = (_a = this.doc.nextLinePos(currentPos, this.keyboardVerticalMoveXPos)) !== null && _a !== void 0 ? _a : currentPos;
            // 此时肯定是光标模式，所以需要更新 selectionEndPos 和 selectionEndPos
            const selection = { start: newPos, end: newPos };
            const rects = this.calSelectionRectangles([selection]);
            if (rects.length === 1) {
                this.setCursorPos(rects[0]);
                this.setSelection([selection], EnumSelectionSource.Keyboard);
            }
            else {
                let targetRect = null;
                for (let index = 0; index < rects.length; index++) {
                    const rect = rects[index];
                    if (!targetRect ||
                        Math.abs(targetRect.x - this.keyboardVerticalMoveXPos) > Math.abs(rect.x - this.keyboardVerticalMoveXPos)) {
                        targetRect = rect;
                    }
                }
                if (targetRect) {
                    this.setCursorPos(targetRect);
                    this.setSelection([selection], EnumSelectionSource.Keyboard);
                }
            }
        }
    }
    cursorMoveLeft() {
        var _a;
        if (this.selection.length > 0) {
            this.startKeyboardSelection();
            const currentPos = this.selection[0].start;
            const newPos = (_a = this.doc.prevPos(currentPos)) !== null && _a !== void 0 ? _a : currentPos;
            const selection = { start: newPos, end: newPos };
            const cursorPos = this.calSelectionRectangles([selection]);
            if (cursorPos.length > 0) {
                this.setCursorPos(cursorPos[0]);
                this.setSelection([selection], EnumSelectionSource.Keyboard);
                this.keyboardVerticalMoveXPos = null;
            }
        }
    }
    cursorMoveRight() {
        var _a;
        if (this.selection.length > 0) {
            this.startKeyboardSelection();
            const currentPos = this.selection[this.selection.length - 1].end;
            const newPos = (_a = this.doc.nextPos(currentPos)) !== null && _a !== void 0 ? _a : currentPos;
            const selection = { start: newPos, end: newPos };
            const cursorPos = this.calSelectionRectangles([selection]);
            if (cursorPos.length > 0) {
                this.setCursorPos(cursorPos[0]);
                this.setSelection([selection], EnumSelectionSource.Keyboard);
                this.keyboardVerticalMoveXPos = null;
            }
        }
    }
    cursorMoveToLineStart() {
        var _a;
        if (this.selection.length > 0 && this.selectionStartPos) {
            this.startKeyboardSelection();
            const currentPos = this.selection[0].start;
            const newPos = (_a = this.doc.lineStartPos(currentPos, this.selectionStartPos.y)) !== null && _a !== void 0 ? _a : currentPos;
            const selection = { start: newPos, end: newPos };
            const cursorPos = this.calSelectionRectangles([selection]).filter((rect) => (0,_Common_util__WEBPACK_IMPORTED_MODULE_3__.hasIntersection)(rect.y, rect.y + rect.height, this.selectionStartPos.y, this.selectionStartPos.y));
            if (cursorPos.length === 1) {
                this.setCursorPos(cursorPos[0]);
                this.setSelection([selection], EnumSelectionSource.Keyboard);
                this.keyboardVerticalMoveXPos = null;
            }
        }
    }
    cursorMoveToLineEnd() {
        var _a;
        if (this.selection.length > 0 && this.selectionEndPos) {
            this.startKeyboardSelection();
            const currentPos = this.selection[this.selection.length - 1].end;
            const newPos = (_a = this.doc.lineEndPos(currentPos, this.selectionEndPos.y)) !== null && _a !== void 0 ? _a : currentPos;
            const selection = { start: newPos, end: newPos };
            const cursorPos = this.calSelectionRectangles([selection]).filter((rect) => (0,_Common_util__WEBPACK_IMPORTED_MODULE_3__.hasIntersection)(rect.y, rect.y + rect.height, this.selectionEndPos.y, this.selectionEndPos.y));
            if (cursorPos.length === 1) {
                this.setCursorPos(cursorPos[0]);
                this.setSelection([selection], EnumSelectionSource.Keyboard);
                this.keyboardVerticalMoveXPos = null;
            }
        }
    }
    startKeyboardSelection() {
        // if (this.selectionSource !== EnumSelectionSource.Keyboard) {
        //   const rects = this.getSelectionRectangles()
        //   if (rects.length > 0) {
        //     const { x: startX, y: startY } = rects[0]
        //     const { x: endX, y: endY } = rects[rects.length - 1]
        //     this.keyboardSelectStartPos = {
        //       start: { x: startX, y: startY },
        //       end: { x: endX, y: endY },
        //     }
        //   }
        // }
    }
    calSelectionRectangles(selections, startBlock, endBlock) {
        const targetStartBlock = startBlock || this.doc.head || undefined;
        const targetEndBlock = endBlock || this.doc.tail || undefined;
        if (!targetStartBlock || !targetEndBlock) {
            return [];
        }
        const selectionRectangles = [];
        for (let index = 0; index < selections.length; index++) {
            const selection = selections[index];
            const startRetain = selection.start.index;
            const endRetain = selection.end.index;
            if ((0,_Common_util__WEBPACK_IMPORTED_MODULE_3__.hasIntersection)(targetStartBlock.start, targetEndBlock.start + targetEndBlock.length, startRetain, endRetain)) {
                let currentBlock = targetStartBlock;
                while (currentBlock) {
                    if ((0,_Common_util__WEBPACK_IMPORTED_MODULE_3__.hasIntersection)(currentBlock.start, currentBlock.start + currentBlock.length, startRetain, endRetain + 1)) {
                        selectionRectangles.push(...currentBlock.getSelectionRectangles((0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_2__.getRelativeDocPos)(currentBlock.start, selection.start), (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_2__.getRelativeDocPos)(currentBlock.start, selection.end)));
                    }
                    if (currentBlock !== targetEndBlock) {
                        currentBlock = currentBlock.nextSibling;
                    }
                    else {
                        currentBlock = null;
                    }
                }
            }
        }
        return selectionRectangles;
    }
    draw(ctx, scrollTop, viewHeight) {
        // 先计算出可视区域有哪些 block，再看这些 block 是否在选区范围内，如果在就计算选区矩形区域，就绘制
        if (this.selection.length === 0) {
            return;
        }
        const startBlock = (0,_Common_util__WEBPACK_IMPORTED_MODULE_3__.findRectChildInPosY)(scrollTop, this.doc.children);
        const endBlock = (0,_Common_util__WEBPACK_IMPORTED_MODULE_3__.findRectChildInPosY)(scrollTop + viewHeight, this.doc.children);
        if (startBlock && endBlock) {
            const selectionRectangles = this.calSelectionRectangles(this.selection, startBlock, endBlock);
            if (selectionRectangles.length > 0) {
                ctx.drawSelectionArea(selectionRectangles, scrollTop, scrollTop + viewHeight, 0);
            }
        }
    }
    /**
     * 对选区的端点进行排序，使靠前的点始终在 start 靠后的点始终在 end
     */
    orderSelectionPoint() {
        if (!this.selectionStartTemp || !this.selectionEndTemp) {
            return;
        }
        if ((0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_2__.compareDocPos)(this.selectionStartTemp, this.selectionEndTemp) === 1) {
            this.selectionStart = this.selectionEndTemp;
            this.selectionEnd = this.selectionStartTemp;
            this.selectionStartPos = this.selectionEndPosTemp;
            this.selectionEndPos = this.selectionStartPosTemp;
        }
        else {
            this.selectionStart = this.selectionStartTemp;
            this.selectionEnd = this.selectionEndTemp;
            this.selectionStartPos = this.selectionStartPosTemp;
            this.selectionEndPos = this.selectionEndPosTemp;
        }
    }
    /**
     * 计算实际的选区范围
     */
    calSelection() {
        if (!this.selectionStart || !this.selectionEnd) {
            return null;
        }
        // 先查找 selectionStart 在哪个 block 内
        const firstPosStart = this.selectionStart.index;
        const fakeTargetStart = {
            start: firstPosStart,
        };
        const startBlockIndex = binary_search_bounds__WEBPACK_IMPORTED_MODULE_0___default().le(this.doc.children, fakeTargetStart, (a, b) => {
            return a.start - b.start;
        });
        // 再查找 selectionEnd 在哪个 block 内
        const firstPosEnd = this.selectionEnd.index;
        const fakeTargetEnd = {
            start: firstPosEnd,
        };
        const endBlockIndex = binary_search_bounds__WEBPACK_IMPORTED_MODULE_0___default().le(this.doc.children, fakeTargetEnd, (a, b) => {
            return a.start - b.start;
        });
        // 再开始计算实际选区
        if (startBlockIndex === endBlockIndex) {
            // 如果开始位置和结束位置落在同一个 block 中
            const targetBlock = this.doc.children[startBlockIndex];
            const targetBlockStart = (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_2__.getRelativeDocPos)(targetBlock.start, this.selectionStart);
            const targetBlockEnd = (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_2__.getRelativeDocPos)(targetBlock.start, this.selectionEnd);
            const childrenSelection = targetBlock.correctSelectionPos(targetBlockStart, targetBlockEnd);
            return childrenSelection.map((selection) => {
                const start = (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_2__.cloneDocPos)(selection.start);
                const end = (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_2__.cloneDocPos)(selection.end);
                if (start) {
                    start.index += targetBlock.start;
                }
                if (end) {
                    end.index += targetBlock.start;
                }
                return { start, end };
            });
        }
        else {
            // 如果开始位置和结束位置落在不同的 block 中，分别计算最终的计算开始位置和结束位置
            const startTargetBlock = this.doc.children[startBlockIndex];
            const targetBlockStart = (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_2__.getRelativeDocPos)(startTargetBlock.start, this.selectionStart);
            const finalStart = startTargetBlock.correctSelectionPos(targetBlockStart, null)[0].start;
            finalStart.index += startTargetBlock.start;
            const endTargetBlock = this.doc.children[endBlockIndex];
            const targetBlockEnd = (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_2__.getRelativeDocPos)(endTargetBlock.start, this.selectionEnd);
            const finalEnd = endTargetBlock.correctSelectionPos(null, targetBlockEnd)[0].end;
            finalEnd.index += endTargetBlock.start;
            return [
                {
                    start: finalStart,
                    end: finalEnd,
                },
            ];
        }
    }
    /**
     * 去掉重复的 range
     */
    distinctRanges(ranges) {
        // 对所有的 range 按先 start 后 end 的顺序排序
        // 然后遍历一遍去掉重复的
        const res = ranges.sort((a, b) => {
            const startCompareRes = (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_2__.compareDocPos)(a.start, b.start);
            if (startCompareRes === 0) {
                return (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_2__.compareDocPos)(a.end, b.end);
            }
            else {
                return startCompareRes;
            }
        });
        for (let index = res.length - 1; index > 0; index--) {
            const current = res[index];
            const prev = res[index - 1];
            if ((0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_2__.compareDocPos)(current.start, prev.start) === 0 && (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_2__.compareDocPos)(current.end, prev.end) === 0) {
                res.splice(index, 1);
            }
        }
        return res;
    }
    /**
     * 记录光标的位置信息
     */
    setCursorPos(pos) {
        this.cursorPos = pos;
        this.selectionStartPos = { y: pos.y + pos.height / 2, x: pos.x };
        this.selectionEndPos = { y: pos.y + pos.height / 2, x: pos.x };
    }
    isCursorStatus() {
        return this.selection.length === 1 && (0,_Common_DocPos__WEBPACK_IMPORTED_MODULE_2__.compareDocPos)(this.selection[0].start, this.selection[0].end) === 0;
    }
}


/***/ }),

/***/ "./src/Service/Service.ts":
/*!********************************!*\
  !*** ./src/Service/Service.ts ***!
  \********************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Service": function() { return /* binding */ Service; }
/* harmony export */ });
/* harmony import */ var eventemitter3__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! eventemitter3 */ "eventemitter3");
/* harmony import */ var eventemitter3__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(eventemitter3__WEBPACK_IMPORTED_MODULE_0__);

class Service extends (eventemitter3__WEBPACK_IMPORTED_MODULE_0___default()) {
    constructor(doc) {
        super();
        this.doc = doc;
    }
    reset() { }
}


/***/ }),

/***/ "./src/Service/TableService.ts":
/*!*************************************!*\
  !*** ./src/Service/TableService.ts ***!
  \*************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TableService": function() { return /* binding */ TableService; }
/* harmony export */ });
/* harmony import */ var quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! quill-delta-enhanced */ "quill-delta-enhanced");
/* harmony import */ var quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Service */ "./src/Service/Service.ts");


class TableService extends _Service__WEBPACK_IMPORTED_MODULE_1__.Service {
    constructor(doc, stack) {
        super(doc);
        this.modifyStatus = new Map();
        this.stack = stack;
    }
    startModify(table) {
        this.modifyStatus.set(table, new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())(table.toOp(true)));
    }
    updateModifyRowHeight(row, height) {
        row.setHeightAttribute(height);
    }
    updateModifyColumnWidth(table, leftColumnIndex, leftWidth, rightColumnIndex, rightWidth) {
        table.setColWidth(leftWidth, leftColumnIndex);
        table.setColWidth(rightWidth, rightColumnIndex);
        table.needLayout = true;
        table.children.forEach((row) => {
            // 把受影响的 cell 也置为需要排版
            for (let index = 0; index < row.children.length; index++) {
                const cell = row.children[index];
                if ((cell.GridColPos <= leftColumnIndex && leftColumnIndex <= cell.GridColPos + cell.attributes.colSpan - 1) ||
                    (cell.GridColPos <= rightColumnIndex && rightColumnIndex <= cell.GridColPos + cell.attributes.colSpan - 1)) {
                    cell.setNeedToLayout();
                }
            }
        });
    }
    updateLastColumnWidth(table, newColWidth, newTableWidth) {
        table.setColWidth(newColWidth, table.attributes.colWidth.length - 1);
        table.setWidth(newTableWidth);
        table.needLayout = true;
        table.children.forEach((row) => {
            if (row.tail) {
                row.tail.setNeedToLayout();
            }
        });
    }
    endModify(table) {
        const oldDelta = this.modifyStatus.get(table);
        if (oldDelta) {
            const newDelta = new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())(table.toOp(true));
            const diff = oldDelta.diff(newDelta);
            const res = new (quill_delta_enhanced__WEBPACK_IMPORTED_MODULE_0___default())();
            if (table.start > 0) {
                res.retain(table.start);
            }
            if (diff.ops.length > 0) {
                this.stack.pushDiff(res.concat(diff));
            }
            this.modifyStatus.delete(table);
        }
    }
}


/***/ }),

/***/ "./src/Service/index.ts":
/*!******************************!*\
  !*** ./src/Service/index.ts ***!
  \******************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CodeBlockService": function() { return /* reexport safe */ _CodeBlockService__WEBPACK_IMPORTED_MODULE_5__.CodeBlockService; },
/* harmony export */   "ContentService": function() { return /* reexport safe */ _ContentService__WEBPACK_IMPORTED_MODULE_0__.ContentService; },
/* harmony export */   "ContentServiceEventNames": function() { return /* reexport safe */ _ContentService__WEBPACK_IMPORTED_MODULE_0__.ContentServiceEventNames; },
/* harmony export */   "EnumSelectionSource": function() { return /* reexport safe */ _SelectionService__WEBPACK_IMPORTED_MODULE_7__.EnumSelectionSource; },
/* harmony export */   "HistoryStackService": function() { return /* reexport safe */ _HistoryStackService__WEBPACK_IMPORTED_MODULE_1__.HistoryStackService; },
/* harmony export */   "HistoryStackServiceEvent": function() { return /* reexport safe */ _HistoryStackService__WEBPACK_IMPORTED_MODULE_1__.HistoryStackServiceEvent; },
/* harmony export */   "ListService": function() { return /* reexport safe */ _ListService__WEBPACK_IMPORTED_MODULE_2__.ListService; },
/* harmony export */   "ParagraphService": function() { return /* reexport safe */ _ParagraphService__WEBPACK_IMPORTED_MODULE_3__.ParagraphService; },
/* harmony export */   "QuoteBlockService": function() { return /* reexport safe */ _QuoteBlockService__WEBPACK_IMPORTED_MODULE_4__.QuoteBlockService; },
/* harmony export */   "SearchService": function() { return /* reexport safe */ _SearchService__WEBPACK_IMPORTED_MODULE_6__.SearchService; },
/* harmony export */   "SearchServiceEvent": function() { return /* reexport safe */ _SearchService__WEBPACK_IMPORTED_MODULE_6__.SearchServiceEvent; },
/* harmony export */   "SelectionService": function() { return /* reexport safe */ _SelectionService__WEBPACK_IMPORTED_MODULE_7__.SelectionService; },
/* harmony export */   "SelectionServiceEvent": function() { return /* reexport safe */ _SelectionService__WEBPACK_IMPORTED_MODULE_7__.SelectionServiceEvent; },
/* harmony export */   "Service": function() { return /* reexport safe */ _Service__WEBPACK_IMPORTED_MODULE_8__.Service; },
/* harmony export */   "TableService": function() { return /* reexport safe */ _TableService__WEBPACK_IMPORTED_MODULE_9__.TableService; }
/* harmony export */ });
/* harmony import */ var _ContentService__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ContentService */ "./src/Service/ContentService.ts");
/* harmony import */ var _HistoryStackService__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./HistoryStackService */ "./src/Service/HistoryStackService.ts");
/* harmony import */ var _ListService__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./ListService */ "./src/Service/ListService.ts");
/* harmony import */ var _ParagraphService__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./ParagraphService */ "./src/Service/ParagraphService.ts");
/* harmony import */ var _QuoteBlockService__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./QuoteBlockService */ "./src/Service/QuoteBlockService.ts");
/* harmony import */ var _CodeBlockService__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./CodeBlockService */ "./src/Service/CodeBlockService.ts");
/* harmony import */ var _SearchService__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./SearchService */ "./src/Service/SearchService.ts");
/* harmony import */ var _SelectionService__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./SelectionService */ "./src/Service/SelectionService.ts");
/* harmony import */ var _Service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./Service */ "./src/Service/Service.ts");
/* harmony import */ var _TableService__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./TableService */ "./src/Service/TableService.ts");












/***/ }),

/***/ "./src/lib/linebreaker/classes.js":
/*!****************************************!*\
  !*** ./src/lib/linebreaker/classes.js ***!
  \****************************************/
/***/ (function(__unused_webpack_module, exports) {

// The following break classes are handled by the pair table
exports.OP = 0 // Opening punctuation
exports.CL = 1 // Closing punctuation
exports.CP = 2 // Closing parenthesis
exports.QU = 3 // Ambiguous quotation
exports.GL = 4 // Glue
exports.NS = 5 // Non-starters
exports.EX = 6 // Exclamation/Interrogation
exports.SY = 7 // Symbols allowing break after
exports.IS = 8 // Infix separator
exports.PR = 9 // Prefix
exports.PO = 10 // Postfix
exports.NU = 11 // Numeric
exports.AL = 12 // Alphabetic
exports.HL = 13 // Hebrew Letter
exports.ID = 14 // Ideographic
exports.IN = 15 // Inseparable characters
exports.HY = 16 // Hyphen
exports.BA = 17 // Break after
exports.BB = 18 // Break before
exports.B2 = 19 // Break on either side (but not pair)
exports.ZW = 20 // Zero-width space
exports.CM = 21 // Combining marks
exports.WJ = 22 // Word joiner
exports.H2 = 23 // Hangul LV
exports.H3 = 24 // Hangul LVT
exports.JL = 25 // Hangul L Jamo
exports.JV = 26 // Hangul V Jamo
exports.JT = 27 // Hangul T Jamo
exports.RI = 28 // Regional Indicator
exports.EB = 29 // Emoji Base
exports.EM = 30 // Emoji Modifier
exports.ZWJ = 31 // Zero Width Joiner
exports.CB = 32 // Contingent break

// The following break classes are not handled by the pair table
exports.AI = 33 // Ambiguous (Alphabetic or Ideograph)
exports.BK = 34 // Break (mandatory)
exports.CJ = 35 // Conditional Japanese Starter
exports.CR = 36 // Carriage return
exports.LF = 37 // Line feed
exports.NL = 38 // Next line
exports.SA = 39 // South-East Asian
exports.SG = 40 // Surrogates
exports.SP = 41 // Space
exports.XX = 42 // Unknown


/***/ }),

/***/ "./src/lib/linebreaker/linebreaker.js":
/*!********************************************!*\
  !*** ./src/lib/linebreaker/linebreaker.js ***!
  \********************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const UnicodeTrie = __webpack_require__(/*! unicode-trie */ "unicode-trie")
const base64 = __webpack_require__(/*! base64-js */ "base64-js")
const { BK, CR, LF, NL, SG, WJ, SP, ZWJ, BA, HY, NS, AI, AL, CJ, HL, RI, SA, XX } = __webpack_require__(/*! ./classes */ "./src/lib/linebreaker/classes.js")
const { DI_BRK, IN_BRK, CI_BRK, CP_BRK, PR_BRK, pairTable } = __webpack_require__(/*! ./pairs */ "./src/lib/linebreaker/pairs.js")

const data = base64.toByteArray(
  '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',
)
const classTrie = new UnicodeTrie(data)

const mapClass = function (c) {
  switch (c) {
    case AI:
      return AL

    case SA:
    case SG:
    case XX:
      return AL

    case CJ:
      return NS

    default:
      return c
  }
}

const mapFirst = function (c) {
  switch (c) {
    case LF:
    case NL:
      return BK

    case SP:
      return WJ

    default:
      return c
  }
}

class Break {
  constructor(position, required = false) {
    this.position = position
    this.required = required
  }
}

class LineBreaker {
  constructor(string) {
    this.string = string
    this.pos = 0
    this.lastPos = 0
    this.curClass = null
    this.nextClass = null
    this.LB8a = false
    this.LB21a = false
    this.LB30a = 0
  }

  nextCodePoint() {
    const code = this.string.charCodeAt(this.pos++)
    const next = this.string.charCodeAt(this.pos)

    // If a surrogate pair
    if (0xd800 <= code && code <= 0xdbff && 0xdc00 <= next && next <= 0xdfff) {
      this.pos++
      return (code - 0xd800) * 0x400 + (next - 0xdc00) + 0x10000
    }

    return code
  }

  nextCharClass() {
    return mapClass(classTrie.get(this.nextCodePoint()))
  }

  getSimpleBreak() {
    // handle classes not handled by the pair table
    switch (this.nextClass) {
      case SP:
        return false

      case BK:
      case LF:
      case NL:
        this.curClass = BK
        return false

      case CR:
        this.curClass = CR
        return false
    }

    return null
  }

  getPairTableBreak(lastClass) {
    // if not handled already, use the pair table
    let shouldBreak = false
    switch (pairTable[this.curClass][this.nextClass]) {
      case DI_BRK: // Direct break
        shouldBreak = true
        break

      case IN_BRK: // possible indirect break
        shouldBreak = lastClass === SP
        break

      case CI_BRK:
        shouldBreak = lastClass === SP
        if (!shouldBreak) {
          shouldBreak = false
          return shouldBreak
        }
        break

      case CP_BRK: // prohibited for combining marks
        if (lastClass !== SP) {
          return shouldBreak
        }
        break

      case PR_BRK:
        break
    }

    if (this.LB8a) {
      shouldBreak = false
    }

    // Rule LB21a
    if (this.LB21a && (this.curClass === HY || this.curClass === BA)) {
      shouldBreak = false
      this.LB21a = false
    } else {
      this.LB21a = this.curClass === HL
    }

    // Rule LB30a
    if (this.curClass === RI) {
      this.LB30a++
      if (this.LB30a == 2 && this.nextClass === RI) {
        shouldBreak = true
        this.LB30a = 0
      }
    } else {
      this.LB30a = 0
    }

    this.curClass = this.nextClass

    return shouldBreak
  }

  nextBreak() {
    // get the first char if we're at the beginning of the string
    if (this.curClass == null) {
      let firstClass = this.nextCharClass()
      this.curClass = mapFirst(firstClass)
      this.nextClass = firstClass
      this.LB8a = firstClass === ZWJ
      this.LB30a = 0
    }

    while (this.pos < this.string.length) {
      this.lastPos = this.pos
      const lastClass = this.nextClass
      this.nextClass = this.nextCharClass()

      // explicit newline
      if (this.curClass === BK || (this.curClass === CR && this.nextClass !== LF)) {
        this.curClass = mapFirst(mapClass(this.nextClass))
        return new Break(this.lastPos, true)
      }

      let shouldBreak = this.getSimpleBreak()

      if (shouldBreak === null) {
        shouldBreak = this.getPairTableBreak(lastClass)
      }

      // Rule LB8a
      this.LB8a = this.nextClass === ZWJ

      if (shouldBreak) {
        return new Break(this.lastPos)
      }
    }

    if (this.lastPos < this.string.length) {
      this.lastPos = this.string.length
      return new Break(this.string.length)
    }

    return null
  }
}

module.exports = LineBreaker


/***/ }),

/***/ "./src/lib/linebreaker/pairs.js":
/*!**************************************!*\
  !*** ./src/lib/linebreaker/pairs.js ***!
  \**************************************/
/***/ (function(__unused_webpack_module, exports) {

let CI_BRK, CP_BRK, DI_BRK, IN_BRK, PR_BRK
exports.DI_BRK = DI_BRK = 0 // Direct break opportunity
exports.IN_BRK = IN_BRK = 1 // Indirect break opportunity
exports.CI_BRK = CI_BRK = 2 // Indirect break opportunity for combining marks
exports.CP_BRK = CP_BRK = 3 // Prohibited break for combining marks
exports.PR_BRK = PR_BRK = 4 // Prohibited break

// Based on example pair table from https://www.unicode.org/reports/tr14/tr14-37.html#Table2
// - ZWJ special processing for LB8a of Revision 41
// - CB manually added as per Rule LB20
// - CL, CP, NS, SY, IS, PR, PO, HY, BA, B2 and RI manually adjusted as per LB22 of Revision 45
exports.pairTable = [
  //OP   , CL    , CP    , QU    , GL    , NS    , EX    , SY    , IS    , PR    , PO    , NU    , AL    , HL    , ID    , IN    , HY    , BA    , BB    , B2    , ZW    , CM    , WJ    , H2    , H3    , JL    , JV    , JT    , RI    , EB    , EM    , ZWJ   , CB
  [
    PR_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    CP_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
  ], // OP
  [
    DI_BRK,
    PR_BRK,
    PR_BRK,
    IN_BRK,
    IN_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    IN_BRK,
    IN_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    DI_BRK,
    DI_BRK,
    PR_BRK,
    CI_BRK,
    PR_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    DI_BRK,
  ], // CL
  [
    DI_BRK,
    PR_BRK,
    PR_BRK,
    IN_BRK,
    IN_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    DI_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    DI_BRK,
    DI_BRK,
    PR_BRK,
    CI_BRK,
    PR_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    DI_BRK,
  ], // CP
  [
    PR_BRK,
    PR_BRK,
    PR_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    PR_BRK,
    CI_BRK,
    PR_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
  ], // QU
  [
    IN_BRK,
    PR_BRK,
    PR_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    PR_BRK,
    CI_BRK,
    PR_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
  ], // GL
  [
    DI_BRK,
    PR_BRK,
    PR_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    DI_BRK,
    DI_BRK,
    PR_BRK,
    CI_BRK,
    PR_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    DI_BRK,
  ], // NS
  [
    DI_BRK,
    PR_BRK,
    PR_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    DI_BRK,
    DI_BRK,
    PR_BRK,
    CI_BRK,
    PR_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    DI_BRK,
  ], // EX
  [
    DI_BRK,
    PR_BRK,
    PR_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    DI_BRK,
    IN_BRK,
    DI_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    DI_BRK,
    DI_BRK,
    PR_BRK,
    CI_BRK,
    PR_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    DI_BRK,
  ], // SY
  [
    DI_BRK,
    PR_BRK,
    PR_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    DI_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    DI_BRK,
    DI_BRK,
    PR_BRK,
    CI_BRK,
    PR_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    DI_BRK,
  ], // IS
  [
    IN_BRK,
    PR_BRK,
    PR_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    DI_BRK,
    DI_BRK,
    PR_BRK,
    CI_BRK,
    PR_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    DI_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    DI_BRK,
  ], // PR
  [
    IN_BRK,
    PR_BRK,
    PR_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    DI_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    DI_BRK,
    DI_BRK,
    PR_BRK,
    CI_BRK,
    PR_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    DI_BRK,
  ], // PO
  [
    IN_BRK,
    PR_BRK,
    PR_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    DI_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    DI_BRK,
    DI_BRK,
    PR_BRK,
    CI_BRK,
    PR_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    DI_BRK,
  ], // NU
  [
    IN_BRK,
    PR_BRK,
    PR_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    DI_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    DI_BRK,
    DI_BRK,
    PR_BRK,
    CI_BRK,
    PR_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    DI_BRK,
  ], // AL
  [
    IN_BRK,
    PR_BRK,
    PR_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    DI_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    DI_BRK,
    DI_BRK,
    PR_BRK,
    CI_BRK,
    PR_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    DI_BRK,
  ], // HL
  [
    DI_BRK,
    PR_BRK,
    PR_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    DI_BRK,
    IN_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    DI_BRK,
    DI_BRK,
    PR_BRK,
    CI_BRK,
    PR_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    DI_BRK,
  ], // ID
  [
    DI_BRK,
    PR_BRK,
    PR_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    DI_BRK,
    DI_BRK,
    PR_BRK,
    CI_BRK,
    PR_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    DI_BRK,
  ], // IN
  [
    DI_BRK,
    PR_BRK,
    PR_BRK,
    IN_BRK,
    DI_BRK,
    IN_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    DI_BRK,
    DI_BRK,
    PR_BRK,
    CI_BRK,
    PR_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    DI_BRK,
  ], // HY
  [
    DI_BRK,
    PR_BRK,
    PR_BRK,
    IN_BRK,
    DI_BRK,
    IN_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    DI_BRK,
    DI_BRK,
    PR_BRK,
    CI_BRK,
    PR_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    DI_BRK,
  ], // BA
  [
    IN_BRK,
    PR_BRK,
    PR_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    PR_BRK,
    CI_BRK,
    PR_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    DI_BRK,
  ], // BB
  [
    DI_BRK,
    PR_BRK,
    PR_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    DI_BRK,
    PR_BRK,
    PR_BRK,
    CI_BRK,
    PR_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    DI_BRK,
  ], // B2
  [
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    PR_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
  ], // ZW
  [
    IN_BRK,
    PR_BRK,
    PR_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    DI_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    DI_BRK,
    DI_BRK,
    PR_BRK,
    CI_BRK,
    PR_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    DI_BRK,
  ], // CM
  [
    IN_BRK,
    PR_BRK,
    PR_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    PR_BRK,
    CI_BRK,
    PR_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
  ], // WJ
  [
    DI_BRK,
    PR_BRK,
    PR_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    DI_BRK,
    IN_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    DI_BRK,
    DI_BRK,
    PR_BRK,
    CI_BRK,
    PR_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    IN_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    DI_BRK,
  ], // H2
  [
    DI_BRK,
    PR_BRK,
    PR_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    DI_BRK,
    IN_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    DI_BRK,
    DI_BRK,
    PR_BRK,
    CI_BRK,
    PR_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    DI_BRK,
  ], // H3
  [
    DI_BRK,
    PR_BRK,
    PR_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    DI_BRK,
    IN_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    DI_BRK,
    DI_BRK,
    PR_BRK,
    CI_BRK,
    PR_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    DI_BRK,
  ], // JL
  [
    DI_BRK,
    PR_BRK,
    PR_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    DI_BRK,
    IN_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    DI_BRK,
    DI_BRK,
    PR_BRK,
    CI_BRK,
    PR_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    IN_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    DI_BRK,
  ], // JV
  [
    DI_BRK,
    PR_BRK,
    PR_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    DI_BRK,
    IN_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    DI_BRK,
    DI_BRK,
    PR_BRK,
    CI_BRK,
    PR_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    DI_BRK,
  ], // JT
  [
    DI_BRK,
    PR_BRK,
    PR_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    DI_BRK,
    DI_BRK,
    PR_BRK,
    CI_BRK,
    PR_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    DI_BRK,
  ], // RI
  [
    DI_BRK,
    PR_BRK,
    PR_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    DI_BRK,
    IN_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    DI_BRK,
    DI_BRK,
    PR_BRK,
    CI_BRK,
    PR_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    IN_BRK,
    DI_BRK,
  ], // EB
  [
    DI_BRK,
    PR_BRK,
    PR_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    DI_BRK,
    IN_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    DI_BRK,
    DI_BRK,
    PR_BRK,
    CI_BRK,
    PR_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    DI_BRK,
  ], // EM
  [
    IN_BRK,
    PR_BRK,
    PR_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    DI_BRK,
    IN_BRK,
    IN_BRK,
    IN_BRK,
    DI_BRK,
    DI_BRK,
    PR_BRK,
    CI_BRK,
    PR_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    DI_BRK,
  ], // ZWJ
  [
    DI_BRK,
    PR_BRK,
    PR_BRK,
    IN_BRK,
    IN_BRK,
    DI_BRK,
    PR_BRK,
    PR_BRK,
    PR_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    PR_BRK,
    CI_BRK,
    PR_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    DI_BRK,
    IN_BRK,
    DI_BRK,
  ], // CB
]


/***/ }),

/***/ "base64-js":
/*!****************************!*\
  !*** external "base64-js" ***!
  \****************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_base64_js__;

/***/ }),

/***/ "binary-search-bounds":
/*!***************************************!*\
  !*** external "binary-search-bounds" ***!
  \***************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_binary_search_bounds__;

/***/ }),

/***/ "eventemitter3":
/*!********************************!*\
  !*** external "eventemitter3" ***!
  \********************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_eventemitter3__;

/***/ }),

/***/ "lodash":
/*!*************************!*\
  !*** external "lodash" ***!
  \*************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_lodash__;

/***/ }),

/***/ "prismjs":
/*!**************************!*\
  !*** external "prismjs" ***!
  \**************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_prismjs__;

/***/ }),

/***/ "quill-delta-enhanced":
/*!***************************************!*\
  !*** external "quill-delta-enhanced" ***!
  \***************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_quill_delta_enhanced__;

/***/ }),

/***/ "unicode-trie":
/*!*******************************!*\
  !*** external "unicode-trie" ***!
  \*******************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_unicode_trie__;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	!function() {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	!function() {
/******/ 		__webpack_require__.nmd = function(module) {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";
/*!**********************!*\
  !*** ./src/index.ts ***!
  \**********************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Block": function() { return /* reexport safe */ _Block__WEBPACK_IMPORTED_MODULE_0__.Block; },
/* harmony export */   "BlockCommon": function() { return /* reexport safe */ _Block__WEBPACK_IMPORTED_MODULE_0__.BlockCommon; },
/* harmony export */   "BubbleMessage": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.BubbleMessage; },
/* harmony export */   "CodeBlock": function() { return /* reexport safe */ _Block__WEBPACK_IMPORTED_MODULE_0__.CodeBlock; },
/* harmony export */   "CodeBlockDefaultAttributes": function() { return /* reexport safe */ _Block__WEBPACK_IMPORTED_MODULE_0__.CodeBlockDefaultAttributes; },
/* harmony export */   "CodeBlockService": function() { return /* reexport safe */ _Service__WEBPACK_IMPORTED_MODULE_6__.CodeBlockService; },
/* harmony export */   "CodeHighlightTheme": function() { return /* reexport safe */ _Block__WEBPACK_IMPORTED_MODULE_0__.CodeHighlightTheme; },
/* harmony export */   "ContentService": function() { return /* reexport safe */ _Service__WEBPACK_IMPORTED_MODULE_6__.ContentService; },
/* harmony export */   "ContentServiceEventNames": function() { return /* reexport safe */ _Service__WEBPACK_IMPORTED_MODULE_6__.ContentServiceEventNames; },
/* harmony export */   "DefaultTheme": function() { return /* reexport safe */ _Block__WEBPACK_IMPORTED_MODULE_0__.DefaultTheme; },
/* harmony export */   "DocContent": function() { return /* reexport safe */ _Document__WEBPACK_IMPORTED_MODULE_2__.DocContent; },
/* harmony export */   "Document": function() { return /* reexport safe */ _Document__WEBPACK_IMPORTED_MODULE_2__.Document; },
/* harmony export */   "DocumentEvent": function() { return /* reexport safe */ _Document__WEBPACK_IMPORTED_MODULE_2__.DocumentEvent; },
/* harmony export */   "EnumAlign": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.EnumAlign; },
/* harmony export */   "EnumCellVerticalAlign": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.EnumCellVerticalAlign; },
/* harmony export */   "EnumCursorType": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.EnumCursorType; },
/* harmony export */   "EnumDateType": function() { return /* reexport safe */ _Fragment__WEBPACK_IMPORTED_MODULE_3__.EnumDateType; },
/* harmony export */   "EnumFont": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.EnumFont; },
/* harmony export */   "EnumIntersectionType": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.EnumIntersectionType; },
/* harmony export */   "EnumListType": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.EnumListType; },
/* harmony export */   "EnumSelectionSource": function() { return /* reexport safe */ _Service__WEBPACK_IMPORTED_MODULE_6__.EnumSelectionSource; },
/* harmony export */   "EnumTitle": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.EnumTitle; },
/* harmony export */   "Fragment": function() { return /* reexport safe */ _Fragment__WEBPACK_IMPORTED_MODULE_3__.Fragment; },
/* harmony export */   "FragmentDate": function() { return /* reexport safe */ _Fragment__WEBPACK_IMPORTED_MODULE_3__.FragmentDate; },
/* harmony export */   "FragmentDateDefaultAttributes": function() { return /* reexport safe */ _Fragment__WEBPACK_IMPORTED_MODULE_3__.FragmentDateDefaultAttributes; },
/* harmony export */   "FragmentDefaultAttributes": function() { return /* reexport safe */ _Fragment__WEBPACK_IMPORTED_MODULE_3__.FragmentDefaultAttributes; },
/* harmony export */   "FragmentImage": function() { return /* reexport safe */ _Fragment__WEBPACK_IMPORTED_MODULE_3__.FragmentImage; },
/* harmony export */   "FragmentImageDefaultAttributes": function() { return /* reexport safe */ _Fragment__WEBPACK_IMPORTED_MODULE_3__.FragmentImageDefaultAttributes; },
/* harmony export */   "FragmentParaEnd": function() { return /* reexport safe */ _Fragment__WEBPACK_IMPORTED_MODULE_3__.FragmentParaEnd; },
/* harmony export */   "FragmentParaEndDefaultAttributes": function() { return /* reexport safe */ _Fragment__WEBPACK_IMPORTED_MODULE_3__.FragmentParaEndDefaultAttributes; },
/* harmony export */   "FragmentText": function() { return /* reexport safe */ _Fragment__WEBPACK_IMPORTED_MODULE_3__.FragmentText; },
/* harmony export */   "FragmentTextDefaultAttributes": function() { return /* reexport safe */ _Fragment__WEBPACK_IMPORTED_MODULE_3__.FragmentTextDefaultAttributes; },
/* harmony export */   "HistoryStackService": function() { return /* reexport safe */ _Service__WEBPACK_IMPORTED_MODULE_6__.HistoryStackService; },
/* harmony export */   "HistoryStackServiceEvent": function() { return /* reexport safe */ _Service__WEBPACK_IMPORTED_MODULE_6__.HistoryStackServiceEvent; },
/* harmony export */   "IAttributableDecorator": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.IAttributableDecorator; },
/* harmony export */   "IBubbleUpableDecorator": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.IBubbleUpableDecorator; },
/* harmony export */   "IDosPosOperatorHDecorator": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.IDosPosOperatorHDecorator; },
/* harmony export */   "IDosPosOperatorVDecorator": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.IDosPosOperatorVDecorator; },
/* harmony export */   "ILinkedListDecorator": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.ILinkedListDecorator; },
/* harmony export */   "IPointerInteractiveDecorator": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.IPointerInteractiveDecorator; },
/* harmony export */   "ISelectedElementGettableDecorator": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.ISelectedElementGettableDecorator; },
/* harmony export */   "LayoutFrame": function() { return /* reexport safe */ _RenderStructure__WEBPACK_IMPORTED_MODULE_5__.LayoutFrame; },
/* harmony export */   "LayoutFrameDefaultAttributes": function() { return /* reexport safe */ _RenderStructure__WEBPACK_IMPORTED_MODULE_5__.LayoutFrameDefaultAttributes; },
/* harmony export */   "LayoutPiece": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.LayoutPiece; },
/* harmony export */   "Line": function() { return /* reexport safe */ _RenderStructure__WEBPACK_IMPORTED_MODULE_5__.Line; },
/* harmony export */   "ListItem": function() { return /* reexport safe */ _Block__WEBPACK_IMPORTED_MODULE_0__.ListItem; },
/* harmony export */   "ListItemDefaultAttributes": function() { return /* reexport safe */ _Block__WEBPACK_IMPORTED_MODULE_0__.ListItemDefaultAttributes; },
/* harmony export */   "ListService": function() { return /* reexport safe */ _Service__WEBPACK_IMPORTED_MODULE_6__.ListService; },
/* harmony export */   "Paragraph": function() { return /* reexport safe */ _Block__WEBPACK_IMPORTED_MODULE_0__.Paragraph; },
/* harmony export */   "ParagraphDefaultAttributes": function() { return /* reexport safe */ _Block__WEBPACK_IMPORTED_MODULE_0__.ParagraphDefaultAttributes; },
/* harmony export */   "ParagraphService": function() { return /* reexport safe */ _Service__WEBPACK_IMPORTED_MODULE_6__.ParagraphService; },
/* harmony export */   "QUOTE_BLOCK_CONTENT_COLOR": function() { return /* reexport safe */ _Block__WEBPACK_IMPORTED_MODULE_0__.QUOTE_BLOCK_CONTENT_COLOR; },
/* harmony export */   "QuoteBlock": function() { return /* reexport safe */ _Block__WEBPACK_IMPORTED_MODULE_0__.QuoteBlock; },
/* harmony export */   "QuoteBlockService": function() { return /* reexport safe */ _Service__WEBPACK_IMPORTED_MODULE_6__.QuoteBlockService; },
/* harmony export */   "Run": function() { return /* reexport safe */ _RenderStructure__WEBPACK_IMPORTED_MODULE_5__.Run; },
/* harmony export */   "RunDate": function() { return /* reexport safe */ _RenderStructure__WEBPACK_IMPORTED_MODULE_5__.RunDate; },
/* harmony export */   "RunImage": function() { return /* reexport safe */ _RenderStructure__WEBPACK_IMPORTED_MODULE_5__.RunImage; },
/* harmony export */   "RunParaEnd": function() { return /* reexport safe */ _RenderStructure__WEBPACK_IMPORTED_MODULE_5__.RunParaEnd; },
/* harmony export */   "RunText": function() { return /* reexport safe */ _RenderStructure__WEBPACK_IMPORTED_MODULE_5__.RunText; },
/* harmony export */   "SearchService": function() { return /* reexport safe */ _Service__WEBPACK_IMPORTED_MODULE_6__.SearchService; },
/* harmony export */   "SearchServiceEvent": function() { return /* reexport safe */ _Service__WEBPACK_IMPORTED_MODULE_6__.SearchServiceEvent; },
/* harmony export */   "SelectionService": function() { return /* reexport safe */ _Service__WEBPACK_IMPORTED_MODULE_6__.SelectionService; },
/* harmony export */   "SelectionServiceEvent": function() { return /* reexport safe */ _Service__WEBPACK_IMPORTED_MODULE_6__.SelectionServiceEvent; },
/* harmony export */   "Service": function() { return /* reexport safe */ _Service__WEBPACK_IMPORTED_MODULE_6__.Service; },
/* harmony export */   "Table": function() { return /* reexport safe */ _Block__WEBPACK_IMPORTED_MODULE_0__.Table; },
/* harmony export */   "TableCell": function() { return /* reexport safe */ _Block__WEBPACK_IMPORTED_MODULE_0__.TableCell; },
/* harmony export */   "TableCellBubbleMessage": function() { return /* reexport safe */ _Block__WEBPACK_IMPORTED_MODULE_0__.TableCellBubbleMessage; },
/* harmony export */   "TableCellDefaultAttributes": function() { return /* reexport safe */ _Block__WEBPACK_IMPORTED_MODULE_0__.TableCellDefaultAttributes; },
/* harmony export */   "TableDefaultAttributes": function() { return /* reexport safe */ _Block__WEBPACK_IMPORTED_MODULE_0__.TableDefaultAttributes; },
/* harmony export */   "TableRow": function() { return /* reexport safe */ _Block__WEBPACK_IMPORTED_MODULE_0__.TableRow; },
/* harmony export */   "TableRowDefaultAttributes": function() { return /* reexport safe */ _Block__WEBPACK_IMPORTED_MODULE_0__.TableRowDefaultAttributes; },
/* harmony export */   "TableService": function() { return /* reexport safe */ _Service__WEBPACK_IMPORTED_MODULE_6__.TableService; },
/* harmony export */   "bind": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.bind; },
/* harmony export */   "calListItemTitle": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.calListItemTitle; },
/* harmony export */   "calListTypeFromChangeData": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.calListTypeFromChangeData; },
/* harmony export */   "clearFormat": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.clearFormat; },
/* harmony export */   "cloneDocPos": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.cloneDocPos; },
/* harmony export */   "codeHighlightThemeRegistrar": function() { return /* reexport safe */ _Block__WEBPACK_IMPORTED_MODULE_0__.codeHighlightThemeRegistrar; },
/* harmony export */   "collectAttributes": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.collectAttributes; },
/* harmony export */   "compareDocPos": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.compareDocPos; },
/* harmony export */   "convertFragmentAttributesToCssStyleText": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.convertFragmentAttributesToCssStyleText; },
/* harmony export */   "convertTo26": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.convertTo26; },
/* harmony export */   "convertToRoman": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.convertToRoman; },
/* harmony export */   "create": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.create; },
/* harmony export */   "createRunByFragment": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.createRunByFragment; },
/* harmony export */   "deleteRange": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.deleteRange; },
/* harmony export */   "documentPosToJSON": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.documentPosToJSON; },
/* harmony export */   "findChildInDocPos": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.findChildInDocPos; },
/* harmony export */   "findChildIndexInDocPos": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.findChildIndexInDocPos; },
/* harmony export */   "findChildrenByRange": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.findChildrenByRange; },
/* harmony export */   "findHalf": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.findHalf; },
/* harmony export */   "findRectChildInPos": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.findRectChildInPos; },
/* harmony export */   "findRectChildInPosY": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.findRectChildInPosY; },
/* harmony export */   "format": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.format; },
/* harmony export */   "get": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.get; },
/* harmony export */   "getDefaultDocContentDelta": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.getDefaultDocContentDelta; },
/* harmony export */   "getFormat": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.getFormat; },
/* harmony export */   "getPlatform": function() { return /* reexport safe */ _Platform__WEBPACK_IMPORTED_MODULE_4__.getPlatform; },
/* harmony export */   "getRelativeDocPos": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.getRelativeDocPos; },
/* harmony export */   "getSelectedElement": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.getSelectedElement; },
/* harmony export */   "hasIntersection": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.hasIntersection; },
/* harmony export */   "hasModify": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.hasModify; },
/* harmony export */   "increaseId": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.increaseId; },
/* harmony export */   "initPlatform": function() { return /* reexport safe */ _Platform__WEBPACK_IMPORTED_MODULE_4__.initPlatform; },
/* harmony export */   "isChinese": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.isChinese; },
/* harmony export */   "isPointInRectangle": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.isPointInRectangle; },
/* harmony export */   "jsonToDocumentPos": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.jsonToDocumentPos; },
/* harmony export */   "mapRunToFragment": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.mapRunToFragment; },
/* harmony export */   "moveDocPos": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.moveDocPos; },
/* harmony export */   "moveRight": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.moveRight; },
/* harmony export */   "numberToChinese": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.numberToChinese; },
/* harmony export */   "searchTextString": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.searchTextString; },
/* harmony export */   "setDefaultDocContentDelta": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.setDefaultDocContentDelta; },
/* harmony export */   "toHtml": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.toHtml; },
/* harmony export */   "toText": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.toText; },
/* harmony export */   "transformDocPos": function() { return /* reexport safe */ _Common__WEBPACK_IMPORTED_MODULE_1__.transformDocPos; }
/* harmony export */ });
/* harmony import */ var _Block__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Block */ "./src/Block/index.ts");
/* harmony import */ var _Common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Common */ "./src/Common/index.ts");
/* harmony import */ var _Document__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Document */ "./src/Document/index.ts");
/* harmony import */ var _Fragment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./Fragment */ "./src/Fragment/index.ts");
/* harmony import */ var _Platform__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./Platform */ "./src/Platform.ts");
/* harmony import */ var _RenderStructure__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./RenderStructure */ "./src/RenderStructure/index.ts");
/* harmony import */ var _Service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./Service */ "./src/Service/index.ts");








}();
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=index.js.map